export default [
  {
    postleitzahl: 1010,
    orte: ['Wien,Innere Stadt'],
  },
  {
    postleitzahl: 1020,
    orte: ['Wien,Landstraße', 'Wien,Leopoldstadt'],
  },
  {
    postleitzahl: 1030,
    orte: ['Wien,Landstraße'],
  },
  {
    postleitzahl: 1040,
    orte: ['Wien,Wieden'],
  },
  {
    postleitzahl: 1050,
    orte: ['Wien,Margareten'],
  },
  {
    postleitzahl: 1060,
    orte: ['Wien,Mariahilf'],
  },
  {
    postleitzahl: 1070,
    orte: ['Wien,Neubau'],
  },
  {
    postleitzahl: 1080,
    orte: ['Wien,Josefstadt'],
  },
  {
    postleitzahl: 1090,
    orte: ['Wien,Alsergrund', 'Wien,Währing'],
  },
  {
    postleitzahl: 1100,
    orte: ['Wien,Favoriten'],
  },
  {
    postleitzahl: 1110,
    orte: ['Wien,Simmering'],
  },
  {
    postleitzahl: 1120,
    orte: ['Wien,Meidling'],
  },
  {
    postleitzahl: 1130,
    orte: ['Wien,Hietzing'],
  },
  {
    postleitzahl: 1140,
    orte: [
      'Mauerbach',
      'Purkersdorf',
      'Weidlingbach',
      'Wien,Hietzing',
      'Wien,Ottakring',
      'Wien,Penzing',
    ],
  },
  {
    postleitzahl: 1150,
    orte: ['Wien,Rudolfsheim-Fünfhaus'],
  },
  {
    postleitzahl: 1160,
    orte: ['Wien,Hernals', 'Wien,Ottakring'],
  },
  {
    postleitzahl: 1170,
    orte: ['Weidlingbach', 'Wien,Hernals', 'Wien,Ottakring'],
  },
  {
    postleitzahl: 1180,
    orte: ['Wien,Währing'],
  },
  {
    postleitzahl: 1190,
    orte: ['Weidling', 'Wien,Döbling'],
  },
  {
    postleitzahl: 1200,
    orte: ['Wien,Brigittenau'],
  },
  {
    postleitzahl: 1210,
    orte: [
      'Langenzersdorf',
      'Wien,Döbling',
      'Wien,Donaustadt',
      'Wien,Favoriten',
      'Wien,Floridsdorf',
    ],
  },
  {
    postleitzahl: 1220,
    orte: ['Wien,Donaustadt'],
  },
  {
    postleitzahl: 1230,
    orte: ['Perchtoldsdorf', 'Wien,Hietzing', 'Wien,Liesing'],
  },
  {
    postleitzahl: 1300,
    orte: ['Mannswörth'],
  },
  {
    postleitzahl: 2000,
    orte: [
      'Oberolberndorf',
      'Oberzögersdorf',
      'Stockerau',
      'Unterzögersdorf',
      'Zissersdorf',
    ],
  },
  {
    postleitzahl: 2002,
    orte: [
      'Füllersdorf',
      'Geitzendorf',
      'Großmugl',
      'Herzogbirbaum',
      'Nursch',
      'Ottendorf',
      'Ringendorf',
      'Roseldorf',
      'Steinabrunn',
    ],
  },
  {
    postleitzahl: 2003,
    orte: ['Haselbach', 'Leitzersdorf', 'Stockerau', 'Wiesen', 'Wollmannsberg'],
  },
  {
    postleitzahl: 2004,
    orte: ['Bruderndorf', 'Niederfellabrunn', 'Niederhollabrunn', 'Streitdorf'],
  },
  {
    postleitzahl: 2011,
    orte: [
      'Hatzenbach',
      'Höbersdorf',
      'Oberhautzental',
      'Obermallebarn',
      'Senning',
      'Sierndorf',
      'Unterhautzental',
      'Untermallebarn',
      'Unterparschenbrunn',
    ],
  },
  {
    postleitzahl: 2013,
    orte: [
      'Bergau',
      'Eitzersthal',
      'Furth',
      'Göllersdorf',
      'Großstelzendorf',
      'Obergrub',
      'Oberparschenbrunn',
      'Porrau',
      'Schönborn',
      'Untergrub',
      'Viendorf',
      'Wischathal',
    ],
  },
  {
    postleitzahl: 2014,
    orte: ['Breitenwaida', 'Dietersdorf', 'Hollabrunn', 'Kleedorf', 'Puch'],
  },
  {
    postleitzahl: 2020,
    orte: [
      'Aspersdorf',
      'Groß',
      'Hollabrunn',
      'Kleinstelzendorf',
      'Kleinstetteldorf',
      'Magersdorf',
      'Mariathal',
      'Mittergrabern',
      'Oberfellabrunn',
      'Obergrabern',
      'Puch',
      'Raschala',
      'Schöngrabern',
      'Sonnberg',
      'Suttenbrunn',
      'Wieselsfeld',
      'Windpassing',
      'Wolfsbrunn',
    ],
  },
  {
    postleitzahl: 2022,
    orte: ['Immendorf', 'Schalladorf'],
  },
  {
    postleitzahl: 2023,
    orte: ['Haslach', 'Kleinweikersdorf', 'Nappersdorf', 'Oberstinkenbrunn'],
  },
  {
    postleitzahl: 2024,
    orte: ['Mailberg'],
  },
  {
    postleitzahl: 2031,
    orte: [
      'Altenmarkt im Thale',
      'Eggendorf im Thale',
      'Hollabrunn',
      'Weyerburg',
    ],
  },
  {
    postleitzahl: 2032,
    orte: [
      'Enzersdorf im Thale',
      'Glaswein',
      'Kleinkadolz',
      'Oedenkirchenwald',
    ],
  },
  {
    postleitzahl: 2033,
    orte: ['Dürnleis', 'Kammersdorf', 'Kleinsierndorf'],
  },
  {
    postleitzahl: 2034,
    orte: ['Diepolz', 'Großharras'],
  },
  {
    postleitzahl: 2041,
    orte: [
      'Aschendorf',
      'Grund',
      'Hart',
      'Hetzmannsdorf',
      'Maria Roggendorf',
      'Wullersdorf',
    ],
  },
  {
    postleitzahl: 2042,
    orte: [
      'Großnondorf',
      'Grund',
      'Guntersdorf',
      'Kalladorf',
      'Ober-Steinabrunn',
    ],
  },
  {
    postleitzahl: 2051,
    orte: [
      'Deinzendorf',
      'Dietmannsdorf',
      'Platt',
      'Watzelsdorf',
      'Zellerndorf',
    ],
  },
  {
    postleitzahl: 2052,
    orte: ['Karlsdorf', 'Pernersdorf', 'Pfaffendorf'],
  },
  {
    postleitzahl: 2053,
    orte: ['Jetzelsdorf', 'Peigarten', 'Ragelsdorf'],
  },
  {
    postleitzahl: 2054,
    orte: [
      'Alberndorf im Pulkautal',
      'Auggenthal',
      'Haugsdorf',
      'Kleinhaugsdorf',
    ],
  },
  {
    postleitzahl: 2061,
    orte: ['Hadres', 'Obritz', 'Untermarkersdorf'],
  },
  {
    postleitzahl: 2062,
    orte: ['Großkadolz', 'Seefeld'],
  },
  {
    postleitzahl: 2063,
    orte: ['Zwingendorf'],
  },
  {
    postleitzahl: 2064,
    orte: ['Wulzeshofen'],
  },
  {
    postleitzahl: 2070,
    orte: ['Mitterretzbach', 'Obernalb', 'Oberretzbach', 'Retz', 'Unternalb'],
  },
  {
    postleitzahl: 2073,
    orte: ['Obermarkersdorf', 'Pillersdorf', 'Schrattenthal', 'Waitzendorf'],
  },
  {
    postleitzahl: 2074,
    orte: ['Kleinhöflein', 'Kleinriedenthal', 'Unterretzbach'],
  },
  {
    postleitzahl: 2081,
    orte: ['Hofern', 'Niederfladnitz', 'Oberfladnitz'],
  },
  {
    postleitzahl: 2082,
    orte: ['Hardegg', 'Merkersdorf'],
  },
  {
    postleitzahl: 2083,
    orte: ['Heufurth', 'Pleissing', 'Waschbach'],
  },
  {
    postleitzahl: 2084,
    orte: [
      'Fronsburg',
      'Obermixnitz',
      'Prutzendorf',
      'Rassingdorf',
      'Starrein',
      'Untermixnitz',
      'Weitersfeld',
    ],
  },
  {
    postleitzahl: 2091,
    orte: ['Hessendorf', 'Langau', 'Oberhöflein'],
  },
  {
    postleitzahl: 2092,
    orte: ['Felling', 'Mallersbach', 'Riegersburg'],
  },
  {
    postleitzahl: 2093,
    orte: [
      'Fugnitz',
      'Geras',
      'Goggitsch',
      'Kottaun',
      'Pfaffenreith',
      'Trautmannsdorf',
    ],
  },
  {
    postleitzahl: 2094,
    orte: [
      'Eibenstein',
      'Pingendorf',
      'Sieghartsreith',
      'Unterpfaffendorf',
      'Wollmersdorf',
      'Zettlitz',
      'Zissersdorf',
    ],
  },
  {
    postleitzahl: 2095,
    orte: [
      'Autendorf',
      'Drosendorf Altstadt',
      'Drosendorf Stadt',
      'Elsern',
      'Heinrichsreith',
      'Oberthürnau',
      'Primmersdorf',
      'Trabersdorf',
      'Unterthürnau',
      'Wolfsbach',
    ],
  },
  {
    postleitzahl: 2100,
    orte: [
      'Bisamberg',
      'Korneuburg',
      'Langenzersdorf',
      'Leobendorf',
      'Stetten',
      'Tresdorf',
    ],
  },
  {
    postleitzahl: 2102,
    orte: [
      'Bisamberg',
      'Flandorf',
      'Hagenbrunn',
      'Klein-Engersdorf',
      'Langenzersdorf',
    ],
  },
  {
    postleitzahl: 2103,
    orte: ['Langenzersdorf'],
  },
  {
    postleitzahl: 2104,
    orte: ['Spillern'],
  },
  {
    postleitzahl: 2105,
    orte: ['Kleinwilfersdorf', 'Leobendorf', 'Oberrohrbach', 'Unterrohrbach'],
  },
  {
    postleitzahl: 2111,
    orte: [
      'Harmannsdorf',
      'Kleinrötz',
      'Leobendorf',
      'Mollmannsdorf',
      'Obergänserndorf',
      'Rückersdorf',
      'Seebarn',
      'Tresdorf',
    ],
  },
  {
    postleitzahl: 2112,
    orte: ['Hetzmannsdorf', 'Lerchenau', 'Ritzendorf', 'Würnitz'],
  },
  {
    postleitzahl: 2113,
    orte: ['Karnabrunn', 'Lachsfeld', 'Naglern', 'Wetzleinsdorf'],
  },
  {
    postleitzahl: 2114,
    orte: [
      'Großrußbach',
      'Hipples',
      'Hornsburg',
      'Kleinebersdorf',
      'Weinsteig',
    ],
  },
  {
    postleitzahl: 2115,
    orte: [
      'Dörfles',
      'Ernstbrunn',
      'Gebmanns',
      'Helfens',
      'Kleinsitzendorf',
      'Maisbirbaum',
      'Merkersdorf',
      'Simonsfeld',
      'Steinbach',
      'Thomasl',
    ],
  },
  {
    postleitzahl: 2116,
    orte: ['Au', 'Klement', 'Niederleis', 'Nodendorf'],
  },
  {
    postleitzahl: 2120,
    orte: ['Obersdorf', 'Wolkersdorf im Weinviertel'],
  },
  {
    postleitzahl: 2122,
    orte: [
      'Münichsthal',
      'Pfösing',
      'Riedenthal',
      'Schleinbach',
      'Ulrichskirchen',
    ],
  },
  {
    postleitzahl: 2123,
    orte: [
      'Hautzendorf',
      'Kronberg',
      'Schleinbach',
      'Traunfeld',
      'Unterolberndorf',
      'Wolfpassing an der Hochleithen',
    ],
  },
  {
    postleitzahl: 2124,
    orte: ['Niederkreuzstetten', 'Oberkreuzstetten'],
  },
  {
    postleitzahl: 2125,
    orte: ['Bogenneusiedl', 'Neubau', 'Niederkreuzstetten', 'Streifing'],
  },
  {
    postleitzahl: 2126,
    orte: [
      'Eggersdorf',
      'Garmanns',
      'Grafensulz',
      'Herrnleis',
      'Ladendorf',
      'Pürstendorf',
    ],
  },
  {
    postleitzahl: 2130,
    orte: [
      'Ebendorf',
      'Eibesthal',
      'Hobersdorf',
      'Hörersdorf',
      'Hüttendorf',
      'Kettlasbrunn',
      'Lanzendorf',
      'Mistelbach',
      'Paasdorf',
      'Siebenhirten',
    ],
  },
  {
    postleitzahl: 2132,
    orte: ['Frättingsdorf', 'Hörersdorf'],
  },
  {
    postleitzahl: 2133,
    orte: [
      'Fallbach',
      'Friebritz',
      'Hagenberg',
      'Hagendorf',
      'Loosdorf',
      'Ungerndorf',
    ],
  },
  {
    postleitzahl: 2134,
    orte: [
      'Enzersdorf bei Staatz',
      'Ernsdorf bei Staatz',
      'Staatz-Kautendorf',
      'Waltersdorf bei Staatz',
      'Wultendorf',
    ],
  },
  {
    postleitzahl: 2135,
    orte: [
      'Altruppersdorf',
      'Kirchstetten',
      'Kottingneusiedl',
      'Neudorf im Weinviertel',
      'Zlabern',
    ],
  },
  {
    postleitzahl: 2136,
    orte: [
      'Hanfthal',
      'Laa an der Thaya',
      'Neudorf im Weinviertel',
      'Rothenseehof',
      'Ruhhof',
    ],
  },
  {
    postleitzahl: 2141,
    orte: ['Ameis', 'Föllim'],
  },
  {
    postleitzahl: 2143,
    orte: ['Althöflein', 'Ginzersdorf', 'Großkrut', 'Harrersdorf'],
  },
  {
    postleitzahl: 2144,
    orte: ['Altlichtenwarth'],
  },
  {
    postleitzahl: 2145,
    orte: ['Hausbrunn'],
  },
  {
    postleitzahl: 2151,
    orte: [
      'Altmanns',
      'Asparn an der Zaya',
      'Michelstetten',
      'Olgersdorf',
      'Schletz',
    ],
  },
  {
    postleitzahl: 2152,
    orte: [
      'Eichenbrunn',
      'Gnadendorf',
      'Pyhra',
      'Röhrabrunn',
      'Wenzersdorf',
      'Zwentendorf',
    ],
  },
  {
    postleitzahl: 2153,
    orte: [
      'Oberschoderlee',
      'Patzenthal',
      'Patzmannsdorf',
      'Stronegg',
      'Stronsdorf',
      'Unterschoderlee',
    ],
  },
  {
    postleitzahl: 2154,
    orte: ['Altenmarkt', 'Gaubitsch', 'Kleinbaumgarten', 'Unterstinkenbrunn'],
  },
  {
    postleitzahl: 2161,
    orte: ['Poysbrunn'],
  },
  {
    postleitzahl: 2162,
    orte: ['Falkenstein'],
  },
  {
    postleitzahl: 2163,
    orte: ['Guttenbrunn', 'Ottenthal', 'Pottenhofen'],
  },
  {
    postleitzahl: 2164,
    orte: ['Alt-Prerau', 'Neuruppersdorf', 'Wildendürnbach'],
  },
  {
    postleitzahl: 2165,
    orte: ['Drasenhofen', 'Kleinschweinbarth', 'Steinebrunn', 'Stützenhofen'],
  },
  {
    postleitzahl: 2170,
    orte: [
      'Ketzelsdorf',
      'Kleinhadersdorf',
      'Poysdorf',
      'Walterskirchen',
      'Wetzelsdorf',
      'Wilhelmsdorf',
    ],
  },
  {
    postleitzahl: 2171,
    orte: ['Herrnbaumgarten'],
  },
  {
    postleitzahl: 2172,
    orte: ['Schrattenberg'],
  },
  {
    postleitzahl: 2181,
    orte: ['Dobermannsdorf'],
  },
  {
    postleitzahl: 2182,
    orte: ['Dobermannsdorf', 'Palterndorf'],
  },
  {
    postleitzahl: 2183,
    orte: ['Neusiedl an der Zaya', 'St. Ulrich'],
  },
  {
    postleitzahl: 2184,
    orte: ['Hauskirchen', 'Prinzendorf an der Zaya'],
  },
  {
    postleitzahl: 2185,
    orte: [
      'Ebersdorf an der Zaya',
      'Prinzendorf an der Zaya',
      'Rannersdorf an der Zaya',
    ],
  },
  {
    postleitzahl: 2191,
    orte: ['Atzelsdorf', 'Gaweinstal', 'Höbersbrunn', 'Pellendorf', 'Schrick'],
  },
  {
    postleitzahl: 2192,
    orte: ['Kettlasbrunn'],
  },
  {
    postleitzahl: 2193,
    orte: ['Bullendorf', 'Erdberg', 'Hobersdorf', 'Wilfersdorf'],
  },
  {
    postleitzahl: 2201,
    orte: ['Gerasdorf', 'Hagenbrunn', 'Seyring'],
  },
  {
    postleitzahl: 2202,
    orte: [
      'Enzersfeld im Weinviertel',
      'Hagenbrunn',
      'Königsbrunn im Weinviertel',
    ],
  },
  {
    postleitzahl: 2203,
    orte: ['Eibesbrunn', 'Großebersdorf', 'Manhartsbrunn', 'Putzing'],
  },
  {
    postleitzahl: 2211,
    orte: ['Pillichsdorf'],
  },
  {
    postleitzahl: 2212,
    orte: ['Großengersdorf'],
  },
  {
    postleitzahl: 2213,
    orte: ['Bockfließ'],
  },
  {
    postleitzahl: 2214,
    orte: ['Auersthal'],
  },
  {
    postleitzahl: 2215,
    orte: ['Raggendorf'],
  },
  {
    postleitzahl: 2221,
    orte: ['Groß-Schweinbarth'],
  },
  {
    postleitzahl: 2222,
    orte: ['Bad Pirawarth', 'Kollnbrunn'],
  },
  {
    postleitzahl: 2223,
    orte: ['Hohenruppersdorf', 'Klein-Harras', 'Martinsdorf'],
  },
  {
    postleitzahl: 2224,
    orte: ['Erdpreß', 'Nexing', 'Niedersulz', 'Obersulz'],
  },
  {
    postleitzahl: 2225,
    orte: [
      'Blumenthal',
      'Eichhorn',
      'Gaiselberg',
      'Gösting',
      'Großinzersdorf',
      'Loidesthal',
      'Maustrenk',
      'Windisch Baumgarten',
      'Zistersdorf',
    ],
  },
  {
    postleitzahl: 2230,
    orte: ['Gänserndorf'],
  },
  {
    postleitzahl: 2231,
    orte: ['Bockfließ', 'Strasshof an der Nordbahn'],
  },
  {
    postleitzahl: 2232,
    orte: ['Aderklaa', 'Deutsch-Wagram', 'Parbasdorf'],
  },
  {
    postleitzahl: 2241,
    orte: ['Schönkirchen-Reyersdorf'],
  },
  {
    postleitzahl: 2242,
    orte: ['Prottes'],
  },
  {
    postleitzahl: 2243,
    orte: ['Klein-Harras', 'Matzen'],
  },
  {
    postleitzahl: 2244,
    orte: ['Spannberg'],
  },
  {
    postleitzahl: 2245,
    orte: ['Götzendorf', 'Velm'],
  },
  {
    postleitzahl: 2251,
    orte: ['Ebenthal'],
  },
  {
    postleitzahl: 2252,
    orte: ['Ollersdorf'],
  },
  {
    postleitzahl: 2253,
    orte: ['Dörfles', 'Stripfing', 'Tallesbrunn', 'Weikendorf'],
  },
  {
    postleitzahl: 2261,
    orte: ['Angern an der March', 'Mannersdorf an der March', 'Stillfried'],
  },
  {
    postleitzahl: 2262,
    orte: ['Grub an der March', 'Stillfried'],
  },
  {
    postleitzahl: 2263,
    orte: ['Dürnkrut', 'Waidendorf'],
  },
  {
    postleitzahl: 2264,
    orte: ['Jedenspeigen', 'Sierndorf an der March'],
  },
  {
    postleitzahl: 2265,
    orte: ['Drösing', 'Waltersdorf an der March'],
  },
  {
    postleitzahl: 2272,
    orte: ['Niederabsdorf', 'Ringelsdorf'],
  },
  {
    postleitzahl: 2273,
    orte: ['Hohenau an der March'],
  },
  {
    postleitzahl: 2274,
    orte: ['Rabensburg'],
  },
  {
    postleitzahl: 2275,
    orte: ['Bernhardsthal'],
  },
  {
    postleitzahl: 2276,
    orte: ['Katzelsdorf', 'Reintal'],
  },
  {
    postleitzahl: 2280,
    orte: ['Glinzendorf'],
  },
  {
    postleitzahl: 2281,
    orte: ['Pysdorf', 'Raasdorf'],
  },
  {
    postleitzahl: 2282,
    orte: ['Großhofen', 'Markgrafneusiedl'],
  },
  {
    postleitzahl: 2283,
    orte: ['Obersiebenbrunn'],
  },
  {
    postleitzahl: 2284,
    orte: ['Untersiebenbrunn'],
  },
  {
    postleitzahl: 2285,
    orte: ['Breitstetten', 'Leopoldsdorf im Marchfelde'],
  },
  {
    postleitzahl: 2286,
    orte: ['Fuchsenbigl', 'Haringsee', 'Straudorf'],
  },
  {
    postleitzahl: 2291,
    orte: ['Lassee', 'Schönfeld im Marchfeld'],
  },
  {
    postleitzahl: 2292,
    orte: ['Engelhartstetten', 'Groißenbrunn', 'Loimersdorf', 'Stopfenreuth'],
  },
  {
    postleitzahl: 2293,
    orte: ['Marchegg', 'Schönfeld im Marchfeld'],
  },
  {
    postleitzahl: 2294,
    orte: ['Breitensee', 'Groißenbrunn', 'Marchegg', 'Markthof', 'Schloßhof'],
  },
  {
    postleitzahl: 2295,
    orte: ['Baumgarten an der March', 'Oberweiden', 'Zwerndorf'],
  },
  {
    postleitzahl: 2301,
    orte: [
      'Andlersdorf',
      'Franzensdorf',
      'Groß-Enzersdorf',
      'Matzneusiedl',
      'Mühlleiten',
      'Oberhausen',
      'Probstdorf',
      'Rutzendorf',
      'Schönau an der Donau',
      'Wittau',
    ],
  },
  {
    postleitzahl: 2304,
    orte: [
      'Mannsdorf an der Donau',
      'Orth an der Donau',
      'Wagram an der Donau',
    ],
  },
  {
    postleitzahl: 2305,
    orte: ['Eckartsau', 'Kopfstetten', 'Pframa', 'Witzelsdorf'],
  },
  {
    postleitzahl: 2320,
    orte: [
      'Kledering',
      'Mannswörth',
      'Rannersdorf',
      'Rauchenwarth',
      'Schwechat',
    ],
  },
  {
    postleitzahl: 2322,
    orte: ['Zwölfaxing'],
  },
  {
    postleitzahl: 2325,
    orte: ['Gutenhof', 'Himberg', 'Pellendorf', 'Velm'],
  },
  {
    postleitzahl: 2326,
    orte: ['Lanzendorf', 'Maria-Lanzendorf'],
  },
  {
    postleitzahl: 2331,
    orte: ['Vösendorf'],
  },
  {
    postleitzahl: 2332,
    orte: ['Hennersdorf'],
  },
  {
    postleitzahl: 2333,
    orte: ['Leopoldsdorf'],
  },
  {
    postleitzahl: 2334,
    orte: ['Vösendorf'],
  },
  {
    postleitzahl: 2340,
    orte: ['Mödling'],
  },
  {
    postleitzahl: 2344,
    orte: ['Maria Enzersdorf'],
  },
  {
    postleitzahl: 2345,
    orte: ['Brunn am Gebirge', 'Perchtoldsdorf'],
  },
  {
    postleitzahl: 2351,
    orte: ['Biedermannsdorf', 'Laxenburg', 'Wiener Neudorf'],
  },
  {
    postleitzahl: 2352,
    orte: ['Gumpoldskirchen'],
  },
  {
    postleitzahl: 2353,
    orte: ['Gumpoldskirchen', 'Guntramsdorf'],
  },
  {
    postleitzahl: 2361,
    orte: ['Laxenburg'],
  },
  {
    postleitzahl: 2362,
    orte: ['Biedermannsdorf'],
  },
  {
    postleitzahl: 2371,
    orte: ['Hinterbrühl', 'Wassergspreng', 'Weissenbach bei Mödling'],
  },
  {
    postleitzahl: 2372,
    orte: ['Gießhübl'],
  },
  {
    postleitzahl: 2380,
    orte: ['Perchtoldsdorf'],
  },
  {
    postleitzahl: 2381,
    orte: ['Laab im Walde', 'Wolfsgraben'],
  },
  {
    postleitzahl: 2384,
    orte: ['Breitenfurt bei Wien'],
  },
  {
    postleitzahl: 2391,
    orte: ['Kaltenleutgeben'],
  },
  {
    postleitzahl: 2392,
    orte: [
      'Dornbach',
      'Grub',
      'Gruberau',
      'Stangau',
      'Sulz im Wienerwald',
      'Wöglerin',
    ],
  },
  {
    postleitzahl: 2393,
    orte: ['Kaltenleutgeben', 'Sittendorf', 'Sparbach'],
  },
  {
    postleitzahl: 2401,
    orte: ['Fischamend'],
  },
  {
    postleitzahl: 2402,
    orte: ['Haslau an der Donau', 'Maria Ellend'],
  },
  {
    postleitzahl: 2403,
    orte: ['Regelsbrunn', 'Scharndorf', 'Wildungsmauer'],
  },
  {
    postleitzahl: 2404,
    orte: ['Petronell-Carnuntum'],
  },
  {
    postleitzahl: 2405,
    orte: ['Bad Deutsch-Altenburg', 'Hundsheim'],
  },
  {
    postleitzahl: 2410,
    orte: ['Hainburg an der Donau'],
  },
  {
    postleitzahl: 2412,
    orte: ['Wolfsthal'],
  },
  {
    postleitzahl: 2413,
    orte: ['Berg', 'Edelstal'],
  },
  {
    postleitzahl: 2421,
    orte: ['Kittsee'],
  },
  {
    postleitzahl: 2422,
    orte: ['Pama / Bijelo Selo'],
  },
  {
    postleitzahl: 2423,
    orte: ['Deutsch Jahrndorf'],
  },
  {
    postleitzahl: 2424,
    orte: ['Zurndorf'],
  },
  {
    postleitzahl: 2425,
    orte: ['Nickelsdorf'],
  },
  {
    postleitzahl: 2431,
    orte: ['Enzersdorf an der Fischa', 'Klein-Neusiedl', 'Margarethen am Moos'],
  },
  {
    postleitzahl: 2432,
    orte: ['Schwadorf'],
  },
  {
    postleitzahl: 2433,
    orte: ['Margarethen am Moos'],
  },
  {
    postleitzahl: 2434,
    orte: ['Götzendorf an der Leitha', 'Pischelsdorf', 'Sandberg', 'Sommerein'],
  },
  {
    postleitzahl: 2435,
    orte: [
      'Ebergassing',
      'Götzendorf an der Leitha',
      'Pischelsdorf',
      'Wienerherberg',
    ],
  },
  {
    postleitzahl: 2440,
    orte: [
      'Gramatneusiedl',
      'Mitterndorf an der Fischa',
      'Moosbrunn',
      'Reisenberg',
    ],
  },
  {
    postleitzahl: 2441,
    orte: ['Gramatneusiedl', 'Mitterndorf an der Fischa', 'Moosbrunn'],
  },
  {
    postleitzahl: 2442,
    orte: ['Ebreichsdorf', 'Schranawand', 'Unterwaltersdorf'],
  },
  {
    postleitzahl: 2443,
    orte: ['Deutsch-Brodersdorf', 'Leithaprodersdorf', 'Loretto', 'Stotzing'],
  },
  {
    postleitzahl: 2444,
    orte: ['Seibersdorf'],
  },
  {
    postleitzahl: 2451,
    orte: ['Au am Leithaberge', 'Hof am Leithaberge'],
  },
  {
    postleitzahl: 2452,
    orte: ['Mannersdorf am Leithagebirge', 'Reisenberg', 'Wasenbruck'],
  },
  {
    postleitzahl: 2453,
    orte: ['Sommerein'],
  },
  {
    postleitzahl: 2454,
    orte: ['Sarasdorf', 'Trautmannsdorf an der Leitha'],
  },
  {
    postleitzahl: 2460,
    orte: ['Bruck an der Leitha', 'Bruckneudorf', 'Kaisersteinbruch'],
  },
  {
    postleitzahl: 2462,
    orte: ['Kaisersteinbruch', 'Königshof', 'Wilfleinsdorf'],
  },
  {
    postleitzahl: 2463,
    orte: ['Gallbrunn', 'Sarasdorf', 'Stixneusiedl'],
  },
  {
    postleitzahl: 2464,
    orte: ['Arbesthal', 'Göttlesbrunn'],
  },
  {
    postleitzahl: 2465,
    orte: ['Höflein'],
  },
  {
    postleitzahl: 2471,
    orte: [
      'Gerhaus',
      'Hollern',
      'Pachfurth',
      'Parndorf / Pandrof',
      'Rohrau',
      'Schönabrunn',
    ],
  },
  {
    postleitzahl: 2472,
    orte: ['Prellenkirchen'],
  },
  {
    postleitzahl: 2473,
    orte: ['Deutsch-Haslau', 'Potzneusiedl'],
  },
  {
    postleitzahl: 2474,
    orte: ['Gattendorf'],
  },
  {
    postleitzahl: 2475,
    orte: ['Neudorf / Novo Selo'],
  },
  {
    postleitzahl: 2481,
    orte: ['Achau'],
  },
  {
    postleitzahl: 2482,
    orte: ['Münchendorf'],
  },
  {
    postleitzahl: 2483,
    orte: ['Ebreichsdorf', 'Weigelsdorf'],
  },
  {
    postleitzahl: 2485,
    orte: ['Wampersdorf', 'Wimpassing an der Leitha'],
  },
  {
    postleitzahl: 2486,
    orte: ['Landegg', 'Pottendorf', 'Siegersdorf'],
  },
  {
    postleitzahl: 2490,
    orte: ['Ebenfurth', 'Haschendorf'],
  },
  {
    postleitzahl: 2491,
    orte: [
      'Hornstein / Vorištan',
      'Neufeld an der Leitha',
      'Steinbrunn / Štikapron',
      'Zillingdorf-Bergwerk',
    ],
  },
  {
    postleitzahl: 2492,
    orte: ['Eggendorf', 'Zillingdorf-Bergwerk', 'Zillingdorf'],
  },
  {
    postleitzahl: 2493,
    orte: ['Eggendorf', 'Lichtenwörth'],
  },
  {
    postleitzahl: 2500,
    orte: ['Alland', 'Baden', 'Schwechatbach', 'Siegenfeld'],
  },
  {
    postleitzahl: 2504,
    orte: ['Sooß'],
  },
  {
    postleitzahl: 2511,
    orte: ['Einöde', 'Pfaffstätten'],
  },
  {
    postleitzahl: 2512,
    orte: ['Oeynhausen', 'Traiskirchen', 'Tribuswinkel'],
  },
  {
    postleitzahl: 2514,
    orte: ['Möllersdorf', 'Oeynhausen', 'Traiskirchen', 'Wienersdorf'],
  },
  {
    postleitzahl: 2521,
    orte: ['Trumau'],
  },
  {
    postleitzahl: 2522,
    orte: ['Oberwaltersdorf'],
  },
  {
    postleitzahl: 2523,
    orte: ['Tattendorf'],
  },
  {
    postleitzahl: 2524,
    orte: ['Teesdorf'],
  },
  {
    postleitzahl: 2525,
    orte: ['Günselsdorf', 'Schönau an der Triesting'],
  },
  {
    postleitzahl: 2531,
    orte: ['Gaaden'],
  },
  {
    postleitzahl: 2532,
    orte: [
      'Füllenberg',
      'Heiligenkreuz',
      'Preinsfeld',
      'Sattelbach',
      'Schwechatbach',
    ],
  },
  {
    postleitzahl: 2533,
    orte: ['Glashütten', 'Klausen-Leopoldsdorf', 'Pfalzau'],
  },
  {
    postleitzahl: 2534,
    orte: [
      'Alland',
      'Glashütten',
      'Groisbach',
      'Holzschlag',
      'Maria Raisenmarkt',
      'Mayerling',
      'Preinsfeld',
      'Sattelbach',
      'Schwechatbach',
      'Untermeierhof',
      'Windhaag',
    ],
  },
  {
    postleitzahl: 2540,
    orte: ['Bad Vöslau', 'Gainfarn', 'Großau', 'Kottingbrunn'],
  },
  {
    postleitzahl: 2542,
    orte: ['Kottingbrunn'],
  },
  {
    postleitzahl: 2544,
    orte: ['Dornau', 'Enzesfeld-Lindabrunn', 'Leobersdorf', 'Siebenhaus'],
  },
  {
    postleitzahl: 2551,
    orte: ['Enzesfeld-Lindabrunn'],
  },
  {
    postleitzahl: 2552,
    orte: ['Enzesfeld-Lindabrunn', 'Hirtenberg'],
  },
  {
    postleitzahl: 2560,
    orte: [
      'Aigen',
      'Alkersdorf',
      'Berndorf',
      'Grillenberg',
      'Hernstein',
      'Kleinfeld',
      'Neusiedl',
      'Pöllau',
    ],
  },
  {
    postleitzahl: 2563,
    orte: ['Pottenstein'],
  },
  {
    postleitzahl: 2564,
    orte: [
      'Aggsbach',
      'Dürntal',
      'Ebeltal',
      'Eberbach',
      'Fahrafeld',
      'Furth',
      'Hof',
      'Maierhof',
      'Neuhaus',
      'Niemtal',
      'Pottenstein',
      'Steinwandgraben',
      'Sulzbach',
      'Weissenbach an der Triesting',
    ],
  },
  {
    postleitzahl: 2565,
    orte: [
      'Gadenweith',
      'Holzschlag',
      'Kienberg',
      'Maria Raisenmarkt',
      'Neuhaus',
      'Nöstach',
      'Rohrbach',
      'Schwarzensee',
      'Schwechatbach',
      'Weissenbach an der Triesting',
    ],
  },
  {
    postleitzahl: 2571,
    orte: [
      'Altenmarkt an der Triesting',
      'Klein-Mariazell',
      'Nöstach',
      'Sulzbach',
      'Thenneberg',
      'Weissenbach an der Triesting',
    ],
  },
  {
    postleitzahl: 2572,
    orte: [
      'Gerichtsberg',
      'Höfnergraben',
      'Kaumberg',
      'Laabach',
      'Obertriesting',
      'St. Corona am Schöpfl',
      'Steinbachtal',
      'Untertriesting',
    ],
  },
  {
    postleitzahl: 2601,
    orte: ['Eggendorf', 'Großmittel', 'Sollenau'],
  },
  {
    postleitzahl: 2602,
    orte: ['Blumau-Neurißhof', 'Schönau an der Triesting', 'Sollenau'],
  },
  {
    postleitzahl: 2603,
    orte: ['Felixdorf', 'Haschendorf', 'Matzendorf'],
  },
  {
    postleitzahl: 2604,
    orte: ['Eggendorf', 'Theresienfeld'],
  },
  {
    postleitzahl: 2620,
    orte: [
      'Diepolz',
      'Flatz',
      'Gramatl',
      'Hafning',
      'Lindgrub',
      'Loipersbach',
      'Mollram',
      'Natschbach',
      'Neunkirchen',
      'Ober-Danegg',
      'Peisching',
      'Raglitz',
      'Ramplach',
      'Reith',
      'St. Lorenzen am Steinfelde',
      'Straßhof',
      'Ternitz',
      'Unter-Danegg',
      'Wartmannstetten',
      'Weibnitz',
    ],
  },
  {
    postleitzahl: 2624,
    orte: ['Breitenau', 'Neusiedl am Steinfeld'],
  },
  {
    postleitzahl: 2625,
    orte: ['Guntrams', 'Schwarzau am Steinfeld'],
  },
  {
    postleitzahl: 2630,
    orte: [
      'Buchbach',
      'Bürg',
      'Gasteil',
      'Grafenbach',
      'Holzweg',
      'Liesling',
      'Pottschach',
      'Putzmannsdorf',
      'Sieding',
      'Ternitz',
      'Thann',
      'Vöstenhof',
    ],
  },
  {
    postleitzahl: 2631,
    orte: ['Gadenweith', 'Sieding', 'Stixenstein', 'Ternitz', 'Thann'],
  },
  {
    postleitzahl: 2632,
    orte: [
      'Altendorf',
      'Göttschach',
      'Grafenbach',
      'Köttlach',
      'Ober-Danegg',
      'Penk',
      'Putzmannsdorf',
      'St. Valentin-Landschach',
      'Wimpassing im Schwarzatale',
    ],
  },
  {
    postleitzahl: 2640,
    orte: [
      'Abfaltersbach',
      'Aue',
      'Berglach',
      'Eichberg',
      'Enzenreith',
      'Gasteil',
      'Gloggnitz',
      'Graben',
      'Hart',
      'Heufeld',
      'Hilzmannsdorf',
      'Köttlach',
      'Kranichberg',
      'Liesling',
      'Loitzmannsdorf',
      'Pettenbach',
      'Prigglitz',
      'Raach am Hochgebirge',
      'Saloder',
      'Schlagl',
      'Schmidsdorf',
      'Schönstadl',
      'Sonnleiten',
      'Stuppach',
      'Stuppachgraben',
      'Syhrn',
      'Tachenberg',
      'Thürmannsdorf',
      'Wartenstein',
      'Weißenbach',
      'Wörth',
    ],
  },
  {
    postleitzahl: 2641,
    orte: ['Breitenstein', 'Greis', 'Schottwien'],
  },
  {
    postleitzahl: 2650,
    orte: [
      'Geyerhof',
      'Kreuzberg',
      'Küb',
      'Mühlhof',
      'Payerbach',
      'Pettenbach',
      'Schmidsdorf',
      'Werning',
    ],
  },
  {
    postleitzahl: 2651,
    orte: [
      'Breitenstein',
      'Dörfl',
      'Edlach an der Rax',
      'Griesleiten',
      'Großau',
      'Grünsting',
      'Hinterleiten',
      'Hirschwang an der Rax',
      'Kleinau',
      'Mayerhöfen',
      'Oberland',
      'Prein an der Rax',
      'Preinrotte',
      'Reichenau an der Rax',
      'Sonnleiten',
      'Thonberg',
    ],
  },
  {
    postleitzahl: 2661,
    orte: ['Graben', 'Schwarzau im Gebirge'],
  },
  {
    postleitzahl: 2662,
    orte: [
      'Gegend',
      'Graben',
      'Preintal',
      'Schwarzau im Gebirge',
      'Steinbruch',
      'Trauch',
      'Vois',
    ],
  },
  {
    postleitzahl: 2663,
    orte: ['Innerhalbach', 'Rohr im Gebirge'],
  },
  {
    postleitzahl: 2671,
    orte: ['Gloggnitz', 'Küb', 'Pettenbach', 'Schmidsdorf'],
  },
  {
    postleitzahl: 2673,
    orte: ['Breitenstein', 'Kreuzberg', 'Semmering-Kurort'],
  },
  {
    postleitzahl: 2680,
    orte: ['Semmering-Kurort', 'Steinhaus am Semmering'],
  },
  {
    postleitzahl: 2700,
    orte: [
      'Bad Fischau',
      'Katzelsdorf',
      'Lichtenwörth',
      'Weikersdorf am Steinfelde',
      'Wiener Neustadt',
    ],
  },
  {
    postleitzahl: 2721,
    orte: ['Bad Fischau', 'Brunn an der Schneebergbahn'],
  },
  {
    postleitzahl: 2722,
    orte: ['Emmerberg', 'Netting', 'Weikersdorf am Steinfelde', 'Winzendorf'],
  },
  {
    postleitzahl: 2723,
    orte: ['Emmerberg', 'Gaaden', 'Muthmannsdorf', 'Stollhof'],
  },
  {
    postleitzahl: 2724,
    orte: ['Gaaden', 'Maiersdorf', 'Oberhöflein', 'Stollhof', 'Waldegg'],
  },
  {
    postleitzahl: 2731,
    orte: [
      'Dörfles',
      'Gerasdorf am Steinfeld',
      'Neusiedl am Steinfeld',
      'Saubersdorf',
      'St. Egyden am Steinfeld',
      'Urschendorf',
      'Winzendorf',
    ],
  },
  {
    postleitzahl: 2732,
    orte: [
      'Hettmannsdorf',
      'Oberhöflein',
      'Raglitz',
      'Rothengrub',
      'Strelzhof',
      'Unterhöflein',
      'Willendorf',
      'Wolfsohl',
      'Würflach',
      'Zweiersdorf',
    ],
  },
  {
    postleitzahl: 2733,
    orte: [
      'Greith',
      'Grünbach am Schneeberg',
      'Gutenmann',
      'Hornungstal',
      'Neusiedl am Walde',
      'Oberhöflein',
      'Puchberg am Schneeberg',
      'Rosental',
      'Schrattenbach',
      'Unterhöflein',
    ],
  },
  {
    postleitzahl: 2734,
    orte: ['Gutenmann', 'Puchberg am Schneeberg'],
  },
  {
    postleitzahl: 2751,
    orte: ['Hölles', 'Matzendorf', 'Steinabrückl', 'Wiener Neustadt'],
  },
  {
    postleitzahl: 2752,
    orte: ['Steinabrückl', 'Wiener Neustadt', 'Wöllersdorf'],
  },
  {
    postleitzahl: 2753,
    orte: ['Dreistetten', 'Markt Piesting', 'Ober-Piesting', 'Wopfing'],
  },
  {
    postleitzahl: 2754,
    orte: ['Dürnbach', 'Peisching', 'Waldegg', 'Wopfing'],
  },
  {
    postleitzahl: 2755,
    orte: ['Oed'],
  },
  {
    postleitzahl: 2761,
    orte: [
      'Feichtenbach',
      'Miesenbach',
      'Puchberg am Schneeberg',
      'Reichental',
      'Waidmannsfeld',
    ],
  },
  {
    postleitzahl: 2763,
    orte: [
      'Feichtenbach',
      'Kreuth',
      'Muggendorf',
      'Neusiedl',
      'Pernitz',
      'Schallhof',
      'Thal',
    ],
  },
  {
    postleitzahl: 2770,
    orte: [
      'Gutenstein',
      'Hintergschaid',
      'Klostertal',
      'Längapiesting',
      'Steinapiesting',
      'Urgersbach',
      'Vorderbruck',
      'Zellenbach',
    ],
  },
  {
    postleitzahl: 2801,
    orte: ['Eichbüchl', 'Katzelsdorf'],
  },
  {
    postleitzahl: 2802,
    orte: [
      'Bromberg',
      'Hackbichl',
      'Hochwolkersdorf (Dorf)',
      'Hochwolkersdorf (Zerstreut)',
      'Rosenbrunn',
      'Schlatten',
      'Schleinz',
      'Schwarzenbach',
    ],
  },
  {
    postleitzahl: 2803,
    orte: ['Schwarzenbach', 'Wiesmath'],
  },
  {
    postleitzahl: 2811,
    orte: ['Schlatten', 'Wiesmath'],
  },
  {
    postleitzahl: 2812,
    orte: [
      'Blumau',
      'Gleichenbach',
      'Grohdorf',
      'Hollenthon',
      'Horndorf',
      'Kirchschlag in der Buckligen Welt',
      'Landsee',
      'Lehen',
      'Mittereck',
      'Obereck',
      'Spratzau',
      'Spratzeck',
      'Stang',
      'Stickelberg',
      'Untereck',
      'Winkl',
    ],
  },
  {
    postleitzahl: 2813,
    orte: [
      'Amlos',
      'Feichten',
      'Kaltenberg',
      'Kühbach',
      'Lichtenegg',
      'Maierhöfen',
      'Pengersdorf',
      'Pesendorf',
      'Pregart',
      'Pürahöfen',
      'Purgstall',
      'Ransdorf',
      'Sauerbichl',
      'Schlag',
      'Schlagergraben',
      'Spratzau',
      'Tafern',
      'Thal',
      'Thernberg',
      'Wäschau',
      'Wieden',
    ],
  },
  {
    postleitzahl: 2821,
    orte: [
      'Frohsdorf',
      'Haderswörth',
      'Kleinwolkersdorf',
      'Lanzenkirchen',
      'Ofenbach',
      'Schleinz',
      'Walpersbach',
    ],
  },
  {
    postleitzahl: 2822,
    orte: [
      'Bad Erlach',
      'Bromberg',
      'Brunn bei Pitten',
      'Föhrenau',
      'Inzenhof',
      'Klingfurth',
      'Linsberg',
      'Schlatten',
      'Schwarzau am Steinfeld',
      'Walpersbach',
    ],
  },
  {
    postleitzahl: 2823,
    orte: [
      'Brunn bei Pitten',
      'Inzenhof',
      'Leiding',
      'Pitten',
      'Sautern',
      'Weinberg',
    ],
  },
  {
    postleitzahl: 2824,
    orte: ['Schiltern', 'Seebenstein'],
  },
  {
    postleitzahl: 2831,
    orte: [
      'Gleißenfeld',
      'Grimmenstein',
      'Haßbach',
      'Kirchau',
      'Kulm',
      'Reitersberg',
      'Scheiblingkirchen',
      'Sollgraben',
      'Steyersberg',
      'Thann',
      'Warth',
      'Witzelsberg',
    ],
  },
  {
    postleitzahl: 2832,
    orte: ['Thernberg'],
  },
  {
    postleitzahl: 2833,
    orte: [
      'Bad Erlach',
      'Breitenbuch',
      'Bromberg',
      'Michelbach',
      'Schlag',
      'Schlatten',
      'Thernberg',
    ],
  },
  {
    postleitzahl: 2840,
    orte: [
      'Edlitz',
      'Grimmenstein',
      'Hochegg',
      'Hütten',
      'Königsberg',
      'Petersbaumgarten',
      'Sauerbichl',
      'Warth',
    ],
  },
  {
    postleitzahl: 2842,
    orte: ['Edlitz', 'Königsberg', 'Pregart', 'Thomasberg'],
  },
  {
    postleitzahl: 2851,
    orte: [
      'Aigen',
      'Kampichl',
      'Krumbach',
      'Kulma',
      'Thomasberg',
      'Tiefenbach',
    ],
  },
  {
    postleitzahl: 2852,
    orte: [
      'Aschau im Burgenland',
      'Burgerschlag',
      'Dreihütten',
      'Elsenau',
      'Götzendorf',
      'Grametschlag',
      'Gschaidt',
      'Harmannsdorf',
      'Hattmannsdorf',
      'Hochneukirchen',
      'Kirchschlagl',
      'Krumbach',
      'Loipersdorf',
      'Maltern',
      'Offenegg',
      'Pichl',
      'Stübegg',
      'Ulrichsdorf',
      'Züggen',
    ],
  },
  {
    postleitzahl: 2853,
    orte: [
      'Aigen',
      'Almen',
      'Bad Schönau',
      'Kirchschlag in der Buckligen Welt',
      'Krumbach',
      'Leitenviertel',
      'Maierhöfen',
      'Schlägen',
      'Schützenkasten',
      'Wenigreith',
    ],
  },
  {
    postleitzahl: 2860,
    orte: [
      'Aigen',
      'Kirchschlag in der Buckligen Welt',
      'Lembach',
      'Stang',
      'Straß',
      'Thomasdorf',
      'Ungerbach',
    ],
  },
  {
    postleitzahl: 2870,
    orte: [
      'Aspang Markt',
      'Außeraigen',
      'Grottendorf',
      'Guggendorf',
      'Hoffeld',
      'Höll',
      'Inneraigen',
      'Kampichl',
      'Königsberg',
      'Kulma',
      'Langegg',
      'Maierhöfen',
      'Molzegg',
      'Neustift am Alpenwalde',
      'Neustift am Hartberg',
      'Neuwald',
      'Sonneck',
      'St. Corona am Wechsel',
      'Stübegg',
    ],
  },
  {
    postleitzahl: 2871,
    orte: [
      'Guggendorf',
      'Kampichl',
      'Knolln',
      'Krumbach',
      'Maierhöfen',
      'Pichl',
      'Schlag',
      'Stübegg',
      'Zöbern',
    ],
  },
  {
    postleitzahl: 2872,
    orte: ['Langegg', 'Mönichkirchen', 'Neustift am Alpenwalde', 'Schaueregg'],
  },
  {
    postleitzahl: 2873,
    orte: ['Feistritz am Wechsel', 'Grottendorf', 'Höll'],
  },
  {
    postleitzahl: 2880,
    orte: [
      'Alpeltal',
      'Hasleiten',
      'Kirchberg am Wechsel',
      'Kranichberg',
      'Lehen',
      'Molzegg',
      'Ofenbach',
      'Otterthal',
      'St. Corona am Wechsel',
      'Steyersberg',
    ],
  },
  {
    postleitzahl: 2881,
    orte: ['Lehen', 'Molzegg', 'Trattenbach'],
  },
  {
    postleitzahl: 3001,
    orte: ['Hainbuch', 'Mauerbach', 'Steinbach', 'Tulbingerkogel'],
  },
  {
    postleitzahl: 3002,
    orte: ['Purkersdorf'],
  },
  {
    postleitzahl: 3003,
    orte: ['Gablitz'],
  },
  {
    postleitzahl: 3004,
    orte: [
      'Flachberg',
      'Gablitz',
      'Irenental',
      'Ollern',
      'Reichersberg',
      'Ried am Riederberg',
      'Riederberg',
      'Weinzierl',
    ],
  },
  {
    postleitzahl: 3011,
    orte: ['Irenental', 'Purkersdorf', 'Untertullnerbach'],
  },
  {
    postleitzahl: 3012,
    orte: ['Pressbaum', 'Purkersdorf', 'Wolfsgraben'],
  },
  {
    postleitzahl: 3013,
    orte: ['Irenental', 'Pressbaum', 'Tullnerbach-Lawies', 'Untertullnerbach'],
  },
  {
    postleitzahl: 3021,
    orte: [
      'Au am Kraking',
      'Irenental',
      'Pfalzau',
      'Pressbaum',
      'Rekawinkel',
      'Tullnerbach-Lawies',
      'Wolfsgraben',
    ],
  },
  {
    postleitzahl: 3031,
    orte: ['Pressbaum', 'Rekawinkel'],
  },
  {
    postleitzahl: 3032,
    orte: [
      'Eichgraben',
      'Furth',
      'Gschaid',
      'Hinterleiten',
      'Hutten',
      'Ottenheim',
      'Rekawinkel',
      'Stein',
      'Unter Oberndorf',
      'Winkl',
    ],
  },
  {
    postleitzahl: 3033,
    orte: [
      'Altlengbach',
      'Außerfurth',
      'Götzwiesen',
      'Großenberg',
      'Gschaid',
      'Hart',
      'Klausen-Leopoldsdorf',
      'Kleinberg',
      'Knagg',
      'Kogl',
      'Leitsberg',
      'Lengbachl',
      'Linden',
      'Maiß',
      'Öd',
      'Pfalzau',
      'Rekawinkel',
      'Steinhäusl',
    ],
  },
  {
    postleitzahl: 3034,
    orte: [
      'Au am Anzbach',
      'Burgstall',
      'Dornberg',
      'Erlaa',
      'Groß Raßberg',
      'Gschwendt',
      'Hof',
      'Hofstatt',
      'Klein Weinberg',
      'Maria Anzbach',
      'Meierhöfen',
      'Oed',
      'Pameth',
      'Unter Oberndorf',
      'Winten',
    ],
  },
  {
    postleitzahl: 3040,
    orte: [
      'Almersberg',
      'Alt-Anzing',
      'Au am Anzbach',
      'Berging',
      'Emmersdorf',
      'Großweinberg',
      'Haag bei Neulengbach',
      'Hofstatt',
      'Inprugg',
      'Langenberg',
      'Maria Anzbach',
      'Markersdorf',
      'Matzelsdorf',
      'Mosletzberg',
      'Neulengbach',
      'Obereichen',
      'Pameth',
      'Raipoltenbach',
      'Schwertfegen',
      'Tausendblum',
      'Umsee',
      'Weiding',
    ],
  },
  {
    postleitzahl: 3041,
    orte: [
      'Asperhofen',
      'Diesendorf',
      'Dörfl',
      'Erlaa',
      'Grabensee',
      'Großgraben',
      'Habersdorf',
      'Hagenau',
      'Haghöfen',
      'Johannesberg',
      'Kerschenberg',
      'Kleingraben',
      'Maierhöfen',
      'Paisling',
      'Plankenberg',
      'Siegersdorf',
      'Starzing',
      'Weinzierl',
      'Wimmersdorf',
    ],
  },
  {
    postleitzahl: 3042,
    orte: [
      'Anzing',
      'Egelsee',
      'Gotthartsberg',
      'Grub',
      'Gumperding',
      'Holzleiten',
      'Jetzing',
      'Mittermoos',
      'Pöding',
      'Untermoos',
      'Waltendorf',
      'Würmla',
    ],
  },
  {
    postleitzahl: 3051,
    orte: [
      'Gottleitsberg',
      'Haagen',
      'Hocheichberg',
      'Leitsberg',
      'Ludmerfeld',
      'Nest',
      'Oberndorf',
      'St. Christophen',
      'Unterdambach',
      'Unterthurm',
    ],
  },
  {
    postleitzahl: 3052,
    orte: [
      'Almerberg',
      'Altlengbach',
      'Aschberg',
      'Audorf',
      'Außermanzing',
      'Barbaraholz',
      'Eck',
      'Gießhübl',
      'Gumpersberg',
      'Höfer',
      'Innerfurth',
      'Innermanzing',
      'Kienberg',
      'Maiß',
      'Mannersdorf',
      'Manzing',
      'Neustift',
      'Oberkühberg',
      'Ödengraben',
      'Pamet',
      'Pyrath',
      'Schoderleh',
      'Unterkühberg',
    ],
  },
  {
    postleitzahl: 3053,
    orte: [
      'Bonnleiten',
      'Brand',
      'Eck',
      'Gern',
      'Gföhl',
      'Klamm',
      'Klausen-Leopoldsdorf',
      'Laaben',
      'Pamet',
      'Pyrath',
      'Stollberg',
      'Wöllersdorf',
    ],
  },
  {
    postleitzahl: 3061,
    orte: [
      'Doppel',
      'Ollersbach',
      'Schönfeld',
      'Theißl',
      'Unterwolfsbach',
      'Wolfersdorf',
    ],
  },
  {
    postleitzahl: 3062,
    orte: [
      'Aschberg',
      'Doppel',
      'Fuchsberg',
      'Gstockert',
      'Hinterholz',
      'Kirchstetten',
      'Ober-Wolfsbach',
      'Paltram',
      'Pettenau',
      'Senning',
      'Sichelbach',
      'Totzenbach',
      'Waasen',
    ],
  },
  {
    postleitzahl: 3071,
    orte: [
      'Bauland',
      'Berg',
      'Blindorf',
      'Böheimkirchen',
      'Braunsberg',
      'Diemannsberg',
      'Dorfern',
      'Dürnhag',
      'Fahrafeld',
      'Furth',
      'Gemersdorf',
      'Grub',
      'Hinterberg',
      'Hinterholz',
      'Hub',
      'Kirchweg',
      'Kollersberg',
      'Lanzendorf',
      'Mechters',
      'Perersdorf',
      'Plosdorf',
      'Reith',
      'Röhrenbach',
      'Schildberg',
      'Siebenhirten',
      'Untergrafendorf',
      'Untertiefenbach',
      'Weinzettl',
      'Weisching',
      'Wiesen',
      'Zell',
    ],
  },
  {
    postleitzahl: 3072,
    orte: [
      'Außerkasten',
      'Baumgarten bei Kasten',
      'Damberg',
      'Dörfl bei Kasten',
      'Gwörth',
      'Hochgschaid',
      'Hummelberg bei Kasten',
      'Kasten bei Böheimkirchen',
      'Kirchsteig',
      'Lanzendorf bei Kasten',
      'Lielach',
      'Mitterfeld',
      'St. Christophen',
      'Stallbach',
      'Steinabruck',
      'Wallenreith',
    ],
  },
  {
    postleitzahl: 3073,
    orte: [
      'Bonnleiten',
      'Buchbach',
      'Dachsbach',
      'Eck',
      'Freiling',
      'Hendelgraben',
      'Hochgschaid',
      'Hochstraß',
      'Hof',
      'Mayerhöfen',
      'Pyrath',
      'Sonnleiten',
      'Stössing',
    ],
  },
  {
    postleitzahl: 3074,
    orte: [
      'Finsteregg',
      'Gstetten',
      'Hochstraß',
      'Kleindurlas',
      'Kronberg',
      'Kropfsdorf',
      'Mayerhöfen',
      'Michelbach Dorf',
      'Michelbach Markt',
      'Untergoin',
    ],
  },
  {
    postleitzahl: 3100,
    orte: [
      'Altmannsdorf',
      'Hafing',
      'Harland',
      'Hart',
      'Nadelbach',
      'Oberwagram',
      'Oberzwischenbrunn',
      'Ochsenburg',
      'Pummersdorf',
      'Ratzersdorf an der Traisen',
      'Schwadorf',
      'Spratzern',
      'St. Pölten',
      'Stattersdorf',
      'Teufelhof',
      'Unterwagram',
      'Unterzwischenbrunn',
      'Viehofen',
      'Völtendorf',
      'Waitzendorf',
      'Windpassing',
      'Witzendorf',
    ],
  },
  {
    postleitzahl: 3104,
    orte: ['Altmannsdorf', 'Brunn', 'Harland', 'St. Pölten', 'Stattersdorf'],
  },
  {
    postleitzahl: 3105,
    orte: ['Oberradlberg', 'Unterradlberg'],
  },
  {
    postleitzahl: 3107,
    orte: ['Ragelsdorf', 'St. Pölten', 'Viehofen', 'Weitern'],
  },
  {
    postleitzahl: 3109,
    orte: ['St. Pölten'],
  },
  {
    postleitzahl: 3110,
    orte: [
      'Afing',
      'Dietersberg',
      'Enikelberg',
      'Flinsbach',
      'Gabersdorf',
      'Goldegg',
      'Griechenberg',
      'Neidling',
      'Pultendorf',
      'Watzelsdorf',
      'Wernersdorf',
    ],
  },
  {
    postleitzahl: 3121,
    orte: [
      'Dreihöf',
      'Hausenbach',
      'Heitzing',
      'Karlstetten',
      'Lauterbach',
      'Obermamau',
      'Rosenthal',
      'Schaubing',
      'Untermamau',
      'Weyersdorf',
      'Wieshöf',
    ],
  },
  {
    postleitzahl: 3122,
    orte: [
      'Aichberg',
      'Besenbuch',
      'Bichl',
      'Bittersbach',
      'Dürnbach',
      'Gansbach',
      'Geyersberg',
      'Hessendorf',
      'Himberg',
      'Kicking',
      'Krapfenberg',
      'Lottersberg',
      'Maierhöfen',
      'Nesselstauden',
      'Nonnenhöfen',
      'Oed',
      'Pinnenhöfen',
      'Scheiblwies',
      'Schwaigbichl',
      'Viehausen',
      'Wolfenreith',
    ],
  },
  {
    postleitzahl: 3123,
    orte: [
      'Angern',
      'Diendorf',
      'Doppel',
      'Eitzendorf',
      'Flinsdorf',
      'Fugging',
      'Greiling',
      'Großhain',
      'Großrust',
      'Grünz',
      'Heinigstetten',
      'Hofstetten',
      'Kleinhain',
      'Kleinrust',
      'Landhausen',
      'Mittermerking',
      'Neustift',
      'Obermerking',
      'Obritzberg',
      'Pfaffing',
      'Schweinern',
      'Thallern',
      'Untermerking',
      'Winzing',
      'Zagging',
    ],
  },
  {
    postleitzahl: 3124,
    orte: [
      'Ambach',
      'Hausheim',
      'Landersdorf',
      'Oberwölbling',
      'Ratzersdorf',
      'Unterwölbling',
      'Wetzlarn',
    ],
  },
  {
    postleitzahl: 3125,
    orte: [
      'Absdorf',
      'Anzenhof',
      'Kuffern',
      'Noppendorf',
      'Rottersdorf',
      'Statzendorf',
      'Weidling',
    ],
  },
  {
    postleitzahl: 3130,
    orte: [
      'Angern',
      'Ederding',
      'Einöd',
      'Herzogenburg',
      'Oberndorf in der Ebene',
      'Oberwinden',
      'Ossarn',
      'St. Andrä an der Traisen',
      'Unterwinden',
      'Wielandsthal',
      'Wiesing',
    ],
  },
  {
    postleitzahl: 3131,
    orte: [
      'Anzenberg',
      'Getzersdorf',
      'Inzersdorf ob der Traisen',
      'Walpersdorf',
      'Wetzmannsthal',
    ],
  },
  {
    postleitzahl: 3133,
    orte: [
      'Frauendorf',
      'Gemeinlebarn',
      'Hilpersdorf',
      'Oberndorf am Gebirge',
      'St. Georgen an der Traisen',
      'Stollhofen',
      'Traismauer',
      'Wagram ob der Traisen',
      'Waldlesberg',
    ],
  },
  {
    postleitzahl: 3134,
    orte: [
      'Franzhausen',
      'Fräuleinmühle',
      'Neusiedl',
      'Nußdorf ob der Traisen',
      'Reichersdorf',
      'Ried',
      'Theyern',
    ],
  },
  {
    postleitzahl: 3140,
    orte: [
      'Maria Jeutendorf',
      'Mauterheim',
      'Pengersdorf',
      'Pottenbrunn',
      'St. Pölten',
      'Unterradlberg',
      'Wasserburg',
      'Zwerndorf',
    ],
  },
  {
    postleitzahl: 3141,
    orte: [
      'Etzersdorf',
      'Kapelln',
      'Katzenberg',
      'Mitterau',
      'Mitterkilling',
      'Oberkilling',
      'Obermiesting',
      'Panzing',
      'Pönning',
      'Rapoltendorf',
      'Rassing',
      'Thalheim',
      'Unterau',
      'Unterkilling',
      'Untermiesting',
    ],
  },
  {
    postleitzahl: 3142,
    orte: [
      'Grunddorf',
      'Gunnersdorf',
      'Haselbach',
      'Langmannersdorf',
      'Murstetten',
      'Obermoos',
      'Perschling',
      'Weißenkirchen an der Perschling',
      'Wieselbruck',
      'Winkling',
    ],
  },
  {
    postleitzahl: 3143,
    orte: [
      'Adeldorf',
      'Blindorf',
      'Brunn',
      'Ebersreith',
      'Egelsee',
      'Fahra',
      'Gattring-Raking',
      'Getzersdorf',
      'Heuberg',
      'Nützling',
      'Oberburbach',
      'Obergrub',
      'Oberloitzenberg',
      'Obertiefenbach',
      'Perersdorf',
      'Pyhra',
      'Reichenhag',
      'Reichgrüben',
      'Schauching',
      'Schnabling',
      'Unterburbach',
      'Unterloitzenberg',
      'Weinzettl',
      'Wieden',
      'Zuleithen',
    ],
  },
  {
    postleitzahl: 3144,
    orte: [
      'Aigen',
      'Atzling',
      'Auern',
      'Baumgarten',
      'Fahrafeld',
      'Hinterholz',
      'Hummelberg bei Hinterholz',
      'Perschenegg',
      'Pyhra',
      'Steinbach',
      'Wald',
      'Windhag',
      'Zell',
    ],
  },
  {
    postleitzahl: 3150,
    orte: [
      'Aigelsbach',
      'Schwarzenbach an der Gölsen',
      'Steinwandleiten',
      'Wilhelmsburg',
    ],
  },
  {
    postleitzahl: 3151,
    orte: [
      'Dörfl',
      'Eggendorf',
      'Ganzendorf',
      'Hart',
      'Kreisberg',
      'Mühlgang',
      'Ochsenburg',
      'Reitzersdorf',
      'Spratzern',
      'St. Georgen am Steinfelde',
      'St. Pölten',
      'Steinfeld',
      'Wetzersdorf',
      'Wolfenberg',
      'Wörth',
    ],
  },
  {
    postleitzahl: 3153,
    orte: [
      'Eschenau',
      'Laimergraben',
      'Rotheau',
      'Sonnleitgraben',
      'Steubach',
      'Wehrabach',
    ],
  },
  {
    postleitzahl: 3160,
    orte: ['Maierhöfen', 'Steinwandleiten', 'Traisen'],
  },
  {
    postleitzahl: 3161,
    orte: [
      'Außer-Wiesenbach',
      'Inner-Wiesenbach',
      'Kerschenbach',
      'Kropfsdorf',
      'Maierhöfen',
      'Obergegend',
      'Pfenningbach',
      'Schwarzenbach an der Gölsen',
      'St. Veit an der Gölsen',
      'Steinwandleiten',
      'Traisenort',
      'Wiesenfeld',
      'Wobach',
    ],
  },
  {
    postleitzahl: 3162,
    orte: ['Obergegend', 'Rainfeld'],
  },
  {
    postleitzahl: 3163,
    orte: [
      'Außerhalbach',
      'Bernreit',
      'Durlaß',
      'Obergegend',
      'Prünst',
      'Rohrbach an der Gölsen',
    ],
  },
  {
    postleitzahl: 3170,
    orte: [
      'Bernau',
      'Gegend Egg',
      'Gerichtsberg',
      'Gerstbach',
      'Gölsen',
      'Gstettl',
      'Hainfeld',
      'Heugraben',
      'Kasberg',
      'Kaufmannberg',
      'Landstal',
      'Ob der Kirche',
      'Ramsau',
      'Vollberg',
    ],
  },
  {
    postleitzahl: 3171,
    orte: ['Außerhalbach', 'Ebenwald', 'Innerhalbach', 'Kleinzell'],
  },
  {
    postleitzahl: 3172,
    orte: [
      'Fahrabach',
      'Gaupmannsgraben',
      'Haraseck',
      'Kieneck',
      'Oberhöhe',
      'Oberried',
      'Ramsau',
      'Schneidbach',
      'Unterried',
    ],
  },
  {
    postleitzahl: 3180,
    orte: [
      'Dörfl',
      'Freiland',
      'Hintereben',
      'Jungherrntal',
      'Lilienfeld',
      'Marktl',
      'Schrambach',
      'Stangental',
      'Vordereben',
      'Zögersbach',
    ],
  },
  {
    postleitzahl: 3183,
    orte: ['Freiland', 'Innerfahrafeld', 'Lehenrotte', 'Türnitz'],
  },
  {
    postleitzahl: 3184,
    orte: ['Lehenrotte', 'Türnitz'],
  },
  {
    postleitzahl: 3192,
    orte: [
      'Andersbach',
      'Ebenwald',
      'Furthof',
      'Hofamt',
      'Hohenberg',
      'Innerfahrafeld',
    ],
  },
  {
    postleitzahl: 3193,
    orte: ['Kernhof', 'Mitterbach', 'St. Aegyd am Neuwalde'],
  },
  {
    postleitzahl: 3195,
    orte: ['Kernhof', 'Lahnsattel', 'St. Aegyd am Neuwalde', 'Ulreichsberg'],
  },
  {
    postleitzahl: 3200,
    orte: [
      'Badendorf',
      'Baumgarten',
      'Ebersdorf',
      'Fridau',
      'Gasten',
      'Gattmannsdorf',
      'Gröben',
      'Grub',
      'Kotting',
      'Kuning',
      'Neustift',
      'Ober-Grafendorf',
      'Reitzing',
      'Rennersdorf',
      'Ritzersdorf',
      'Wantendorf',
      'Willersdorf',
    ],
  },
  {
    postleitzahl: 3202,
    orte: [
      'Aigelsbach',
      'Grünau',
      'Grünsbach',
      'Hofstetten',
      'Kammerhof',
      'Mainburg',
      'Plambach',
      'Plambacheck',
    ],
  },
  {
    postleitzahl: 3203,
    orte: [
      'Deutschbach',
      'Dorf-Au',
      'Königsbach',
      'Laach',
      'Mainburg',
      'Plambach',
      'Rabenstein an der Pielach',
      'Röhrenbach',
      'Steinklamm',
      'Tradigist',
      'Warth',
    ],
  },
  {
    postleitzahl: 3204,
    orte: [
      'Hohenbrand',
      'Kirchberg an der Pielach',
      'Kirchberggegend',
      'Rehgrabengegend',
      'Schloßgegend',
      'Schroffengegend',
      'Schwerbachgegend',
      'Soisgegend',
      'Tradigistdorf',
      'Tradigistgegend',
    ],
  },
  {
    postleitzahl: 3205,
    orte: [
      'Dietmannsdorf',
      'Eck',
      'Edlitz',
      'Engelsdorf',
      'Grub',
      'Klangen',
      'Luberg',
      'Mühlhofen',
      'Oed',
      'Waasen',
      'Weinburg',
    ],
  },
  {
    postleitzahl: 3211,
    orte: [
      'Dobersnigg',
      'Hammerlmühlgegend',
      'Loich',
      'Loicheckgegend',
      'Oedgegend',
      'Rehgrabengegend',
      'Schroffengegend',
      'Schwarzengrabengegend',
      'Siedlung',
    ],
  },
  {
    postleitzahl: 3212,
    orte: [
      'Brunnrotte',
      'Finzenebengegend',
      'Frankenfels',
      'Grabschifterwald',
      'Guttenhofgegend',
      'Haslaurotte',
      'Hofrotte',
      'Loicheckgegend',
      'Obertal',
      'Schwarzenbachgegend',
      'Seerotte',
      'Staudachgegend',
      'Steinrotte',
      'Taschlgrabenrotte',
      'Weißenbach',
    ],
  },
  {
    postleitzahl: 3213,
    orte: ['Frankenfels', 'Hollenstein'],
  },
  {
    postleitzahl: 3214,
    orte: [
      'Anger',
      'Bergrotte',
      'Brandeben',
      'Brandgegend',
      'Buchberg',
      'Frankenfels',
      'Kreuztanne',
      'Laubenbach',
      'Puchenstuben',
      'Sulzbichl',
      'Waldgegend',
      'Wohlfahrtsschlag',
    ],
  },
  {
    postleitzahl: 3221,
    orte: ['Gösing an der Mariazeller Bahn', 'Waldgegend'],
  },
  {
    postleitzahl: 3222,
    orte: [
      'Annarotte',
      'Haupttürnitzrotte',
      'Langseitenrotte',
      'Lassingrotte',
      'Ulreichsberg',
    ],
  },
  {
    postleitzahl: 3223,
    orte: [
      'Gösing an der Mariazeller Bahn',
      'Josefsrotte',
      'Langseitenrotte',
      'Lassingrotte',
      'Mitterbach-Seerotte',
      'Schaflahn',
      'Trübenbach-Gaming',
    ],
  },
  {
    postleitzahl: 3224,
    orte: ['Josefsrotte', 'Mitterbach-Seerotte'],
  },
  {
    postleitzahl: 3231,
    orte: [
      'Eigendorf',
      'Feilendorf',
      'Kainratsdorf',
      'Kleinsierning',
      'Linsberg',
      'Oberhofen',
      'Rammersdorf',
      'Saudorf',
      'St. Margarethen an der Sierning',
      'Türnau',
      'Unterradl',
      'Wieden',
      'Wilhersdorf',
    ],
  },
  {
    postleitzahl: 3232,
    orte: [
      'Bischofstetten',
      'Buchgraben',
      'Dörfl',
      'Großa',
      'Grünwies',
      'Haag',
      'Haberg',
      'Hanau',
      'Hintergrub',
      'Mitterschildbach',
      'Neubing',
      'Niederbauern',
      'Oberschildbach',
      'Oberweg',
      'Rametzhofen',
      'Strohdorf',
      'Tonach',
      'Unterschildbach',
      'Unterweg',
      'Winkelsdorf',
      'Zauching',
    ],
  },
  {
    postleitzahl: 3233,
    orte: [
      'Braunöd',
      'Bühren',
      'Christenberg',
      'Dörfl',
      'Dornhof',
      'Feld',
      'Fleischessen',
      'Fohra',
      'Fohrafeld',
      'Freyen',
      'Gartling',
      'Glosbach',
      'Graben bei Haag',
      'Graben',
      'Grünsbach',
      'Guglberg',
      'Hauersdorf',
      'Haxenöd',
      'Heinrichsberg',
      'Hohenbrand',
      'Hummelbach',
      'Kettenreith',
      'Kilb',
      'Kohlenberg',
      'Laach',
      'Maierhöfen',
      'Mallau',
      'Massendorf',
      'Niederhofen',
      'Oberneuberg',
      'Panschach',
      'Petersberg',
      'Rametzberg',
      'Ranzenbach',
      'Ruttersdorf',
      'Schlögelsbach',
      'Schützen',
      'Sierning',
      'Taubenwang',
      'Teufelsdorf',
      'Umbach',
      'Unterneuberg',
      'Volkersdorf',
      'Waasen bei Kilb',
      'Wiesenöd',
      'Wötzling',
    ],
  },
  {
    postleitzahl: 3240,
    orte: [
      'Aichen',
      'Altenhofen',
      'Anzenbach',
      'Artlehen',
      'Bodendorf',
      'Busendorf',
      'Dorna',
      'Fohra',
      'Fritzberg',
      'Gries',
      'Großaigen',
      'Grub bei Kilb',
      'Hagberg',
      'Hörgstberg',
      'Hörsdorf',
      'Kälberhart',
      'Kleinaigen',
      'Kleinzell',
      'Lehen',
      'Loipersdorf',
      'Loitsbach',
      'Loitsdorf',
      'Mank',
      'Münichhofen',
      'Nacht',
      'Oberschmidbach',
      'Pichlreit',
      'Pölla',
      'Poppendorf',
      'Ritzenberg',
      'Rührsdorf',
      'Simonsberg',
      'St. Frein',
      'St. Haus',
      'Strannersdorf',
      'Unterschmidbach',
      'Wies',
      'Wolfsmath',
      'Wolkersdorf',
    ],
  },
  {
    postleitzahl: 3241,
    orte: [
      'Außerreith',
      'Furth',
      'Hochstraß',
      'Innerreith',
      'Kimming',
      'Kirnberg an der Mank',
      'Kroisbach',
      'Maierhöfen',
      'Obergraben',
      'Oberndorf an der Melk',
      'Oed an der Mank',
      'Pöllaberg',
      'Ranitzhof',
      'Sattlehen',
      'Strohhof',
      'Untergraben',
      'Wolfsbach',
      'Wolfsmath',
    ],
  },
  {
    postleitzahl: 3242,
    orte: [
      'Altendorf',
      'Bach',
      'Dachsberg',
      'Fischbach',
      'Gärtenberg',
      'Großmaierhof',
      'Haberleiten',
      'Hinterberg',
      'Hinterholz',
      'Hinterleiten',
      'Kleinmaierhof',
      'Mühlgraben',
      'Oberndorf an der Melk',
      'Panholz',
      'Plankenstein',
      'Ramsau',
      'Reinöd',
      'Rosenbichl',
      'Schwaighof',
      'Sonnleithen',
      'St. Gotthard',
      'Steingrub',
      'Straß bei Texing',
      'Texing',
      'Walzberg',
      'Weißenbach',
    ],
  },
  {
    postleitzahl: 3243,
    orte: [
      'Aichbach',
      'Altenhofen',
      'Apfaltersbach',
      'Au',
      'Brandstatt bei Au',
      'Brandstatt bei Oed',
      'Dangelsbach',
      'Diesendorf',
      'Eisguggen',
      'Eselsteiggraben',
      'Fachelberg',
      'Gassen',
      'Geigenberg',
      'Grillenreith',
      'Grimmegg',
      'Großweichselbach',
      'Grub bei Harbach',
      'Haindorf',
      'Harbach',
      'Haslach',
      'Hochstraß',
      'Hofstetten',
      'Hohenreith',
      'Hörgerstall',
      'Hub an der Mank',
      'Kerndl',
      'Kleinweichselbach',
      'Kühberg',
      'Lachau',
      'Lehenleiten',
      'Lunzen',
      'Oed bei Haslach',
      'Pöllendorf',
      'Pühra',
      'Reith bei Vornholz',
      'Reith bei Weichselbach',
      'Rinn',
      'Ritzengrub',
      'Rottenhof',
      'Sandeben',
      'Schönbuch',
      'Schweining',
      'Seimetzbach',
      'St. Leonhard am Forst',
      'Steghof',
      'Steinbach',
      'Straß',
      'Thal',
      'Urbach',
      'Vornholz',
      'Wegscheid',
      'Wolfsbach',
    ],
  },
  {
    postleitzahl: 3244,
    orte: [
      'Anzenberg',
      'Baulanden',
      'Brunnwiesen',
      'Etzen',
      'Fittenberg',
      'Fohregg',
      'Geretzbach',
      'Graben',
      'Grabenegg',
      'Grub',
      'Hofstetten',
      'Hohentann',
      'Hub',
      'Kagelsberg',
      'Kalcha',
      'Koth',
      'Kronberg',
      'Kühberg',
      'Lasserthal',
      'Lehen',
      'Naspern',
      'Ockert',
      'Oed',
      'Rainberg',
      'Riegers',
      'Rottenhof',
      'Ruprechtshofen',
      'Schlatten',
      'Simhof',
      'Sinhof',
      'Weghof',
      'Wies',
      'Zinsenhof',
      'Zwerbach',
    ],
  },
  {
    postleitzahl: 3250,
    orte: [
      'Bauxberg',
      'Berging',
      'Bodensdorf',
      'Brandstetten',
      'Brunning',
      'Dürnbach',
      'Forst am Berg',
      'Galtbrunn',
      'Großa',
      'Grub',
      'Gumprechtsfelden',
      'Haag',
      'Hart',
      'Holzhäuseln',
      'Kaswinkel',
      'Kratzenberg',
      'Krügling',
      'Laimstetten',
      'Marbach an der Kleinen Erlauf',
      'Moos',
      'Mühling',
      'Neumühl',
      'Oed am Seichten Graben',
      'Plaika',
      'Schadendorf',
      'Sill',
      'Ströblitz',
      'Unteretzerstetten',
      'Wechling',
      'Weinzierl',
      'Wieselburg',
    ],
  },
  {
    postleitzahl: 3251,
    orte: [
      'Ameishaufen',
      'Edelbach bei Purgstall',
      'Erb',
      'Feichsen',
      'Föhrenhain',
      'Gaisberg',
      'Galtbrunn',
      'Gimpering',
      'Gumprechtsfelden',
      'Haag',
      'Harmersdorf',
      'Heidegrund',
      'Hochrieß',
      'Höfl',
      'Koth',
      'Kroißenberg',
      'Mayerhof',
      'Nottendorf',
      'Öd bei Purgstall',
      'Petzelsdorf',
      'Pögling',
      'Purgstall',
      'Reichersau',
      'Rogatsboden',
      'Schauboden',
      'Sölling',
      'Söllingerwald',
      'Stock',
      'Unternberg',
      'Weigstatt',
      'Weinberg',
      'Zehnbach',
    ],
  },
  {
    postleitzahl: 3252,
    orte: [
      'Dürnbach',
      'Oed beim Roten Kreuz',
      'Pellendorf',
      'Petzenkirchen',
      'Reisenhof',
    ],
  },
  {
    postleitzahl: 3253,
    orte: [
      'Arb',
      'Erlauf',
      'Harlanden',
      'Knocking',
      'Maierhofen',
      'Niederndorf',
      'Ofling',
      'Steinwand',
      'Wolfring',
    ],
  },
  {
    postleitzahl: 3254,
    orte: ['Bergland'],
  },
  {
    postleitzahl: 3261,
    orte: [
      'Altenhof',
      'Amesbach',
      'Brandstatt',
      'Dürnbach',
      'Edelbach',
      'Edla',
      'Ernegg',
      'Etzerstetten',
      'Felberach',
      'Figelsberg',
      'Götzwang',
      'Haberg',
      'Hausberg',
      'Kerschenberg',
      'Klein-Erlauf',
      'Kleinreith',
      'Knolling',
      'Loising',
      'Lonitzberg',
      'Oberstampfing',
      'Ochsenbach',
      'Oed bei Ernegg',
      'Oedt',
      'Reith bei Weinberg',
      'Schollödt',
      'Schönegg',
      'Steinakirchen am Forst',
      'Stetten',
      'Straß',
      'Stritzling',
      'Thorwarting',
      'Thurhofglasen',
      'Unterstampfing',
      'Windpassing',
      'Wolfpassing',
      'Zarnsdorf',
      'Zehetgrub',
      'Zehethof',
    ],
  },
  {
    postleitzahl: 3262,
    orte: [
      'Berg',
      'Ewixen',
      'Griesperwarth',
      'Grieswang',
      'Höfling',
      'Hofweid',
      'Kaisitzberg',
      'Lehmgstetten',
      'Mitterberg',
      'Nebetenberg',
      'Pyhrafeld',
      'Reidlingberg',
      'Reidlingdorf',
      'Reitering',
      'Schlott',
      'Straß',
      'Thurhofwang',
      'Wang',
    ],
  },
  {
    postleitzahl: 3263,
    orte: [
      'Franzenreith',
      'Graben',
      'Hinterleiten',
      'Hochkoglberg',
      'Mitterberg',
      'Perwarth',
      'Puchberg bei Randegg',
      'Randegg',
      'Schliefau',
      'St. Leonhard am Wald',
      'Steinholz',
    ],
  },
  {
    postleitzahl: 3264,
    orte: [
      'Brettl-Gaming',
      'Buchberg',
      'Franzenreith',
      'Gresten',
      'Hinterleiten',
      'Kerschenberg',
      'Oberamt',
      'Obergut',
      'Reinsberg',
      'Robitzboden',
      'Schadneramt',
      'Schaitten',
      'Unteramt',
      'Ybbsbachamt',
    ],
  },
  {
    postleitzahl: 3270,
    orte: ['Gärtenberg', 'Scheibbs'],
  },
  {
    postleitzahl: 3281,
    orte: ['Furth', 'Hörmannsberg', 'Oberndorf an der Melk'],
  },
  {
    postleitzahl: 3282,
    orte: [
      'Ahornleiten',
      'Bach',
      'Bichl',
      'Dachsberg',
      'Forsthub',
      'Gärtenberg',
      'Gries',
      'Kandelsberg',
      'Kreuzfeld',
      'Kröll',
      'Maierhof',
      'Mitteröd',
      'Oedwies',
      'Schießer',
      'St. Georgen an der Leys',
      'Wiesmühl',
      'Windhag',
      'Zwickelsberg',
    ],
  },
  {
    postleitzahl: 3283,
    orte: [
      'Anger',
      'Gabel',
      'Gärtenberg',
      'Gnadenberg',
      'Grafenmühl',
      'Gruft',
      'Hochreith',
      'Hollenstein',
      'Kreuztanne',
      'St. Anton an der Jeßnitz',
      'Wohlfahrtsschlag',
    ],
  },
  {
    postleitzahl: 3291,
    orte: ['Kienberg'],
  },
  {
    postleitzahl: 3292,
    orte: ['Anger', 'Gaming'],
  },
  {
    postleitzahl: 3293,
    orte: ['Gaming', 'Lunz am See'],
  },
  {
    postleitzahl: 3294,
    orte: ['Grünau', 'Langau', 'Neuhaus-Langau', 'Taschelbach-Langau'],
  },
  {
    postleitzahl: 3295,
    orte: ['Lackenhof', 'Nestelberg-Lackenhof'],
  },
  {
    postleitzahl: 3300,
    orte: [
      'Amstetten',
      'Ardagger Stift',
      'Greinsfurth',
      'Haag Dorf',
      'Mauer bei Amstetten',
      'Winklarn',
    ],
  },
  {
    postleitzahl: 3304,
    orte: [
      'Hart',
      'Hermannsdorf',
      'Krahof',
      'Leutzmannsdorf',
      'Matzendorf',
      'St. Georgen am Ybbsfelde',
    ],
  },
  {
    postleitzahl: 3311,
    orte: ['Amstetten', 'Zeillern'],
  },
  {
    postleitzahl: 3312,
    orte: ['Oed', 'Öhling'],
  },
  {
    postleitzahl: 3313,
    orte: ['Igelschwang', 'Ried', 'Schweinberg', 'Wallsee'],
  },
  {
    postleitzahl: 3314,
    orte: [
      'Au',
      'Limbach',
      'Ottendorf',
      'Ramsau',
      'Strengberg',
      'Thürnbuch',
      'Wolfsbach',
    ],
  },
  {
    postleitzahl: 3321,
    orte: ['Ardagger Markt', 'Ardagger Stift', 'Kollmitzberg', 'Stephanshart'],
  },
  {
    postleitzahl: 3322,
    orte: ['Hainstetten', 'Seisenegg', 'Viehdorf'],
  },
  {
    postleitzahl: 3323,
    orte: [
      'Berghof',
      'Freyenstein',
      'Hößgang',
      'Kleinwolfstein',
      'Nabegg',
      'Neustadtl-Markt',
      'Neustadtl-Umgebung',
      'Schaltberg',
      'Windpassing',
    ],
  },
  {
    postleitzahl: 3324,
    orte: ['Euratsfeld'],
  },
  {
    postleitzahl: 3325,
    orte: ['Edelbach', 'Ferschnitz', 'Straß'],
  },
  {
    postleitzahl: 3331,
    orte: ['Biberbach', 'Hilm', 'Kematen', 'Sonntagberg'],
  },
  {
    postleitzahl: 3332,
    orte: [
      'Baichberg',
      'Biberbach',
      'Gleiß',
      'Rosenau am Sonntagberg',
      'Sonntagberg',
    ],
  },
  {
    postleitzahl: 3333,
    orte: ['Biberbach', 'Böhlerwerk', 'Bruckbach', 'Rotte Wühr', 'Sonntagberg'],
  },
  {
    postleitzahl: 3334,
    orte: [
      'Breitenau',
      'Gaflenz',
      'Großgschnaidt',
      'Kleingschnaidt',
      'Lindau',
      'Oberland',
      'Pettendorf',
    ],
  },
  {
    postleitzahl: 3335,
    orte: ['Breitenau', 'Kleinreifling', 'Lindau', 'Neudorf', 'Weyer'],
  },
  {
    postleitzahl: 3340,
    orte: [
      'Graben',
      'Konradsheim',
      'Kreilhof',
      'Rien',
      'Schwarzenberg',
      'Sonntagberg',
      'St. Georgen in der Klaus',
      'St. Leonhard am Wald',
      'Steinholz',
      'Waidhofen an der Ybbs',
      'Windhag',
      'Wirts',
      'Zell-Arzberg',
      'Zell-Markt',
    ],
  },
  {
    postleitzahl: 3341,
    orte: [
      'Großprolling',
      'Haselgraben',
      'Hubberg',
      'Kleinprolling',
      'Knieberg',
      'Maisberg',
      'Oberamt',
      'Prochenberg',
      'Schadneramt',
      'Schwarzenbach',
      'Schwarzenberg',
      'Schwarzois',
      'Ybbsitz',
      'Zogelsgraben',
    ],
  },
  {
    postleitzahl: 3342,
    orte: [
      'Graben',
      'Gstadt',
      'Hauslehen',
      'Ofenberg',
      'Schwarzenbach',
      'Strubb',
      'Thann',
    ],
  },
  {
    postleitzahl: 3343,
    orte: [
      'Berg',
      'Dornleiten',
      'Garnberg',
      'Grießau',
      'Hohenlehen',
      'Hollenstein an der Ybbs',
      'Krenngraben',
      'Oberkirchen',
      'Oisberg',
      'Sattel',
      'Thalbauer',
      'Thomasberg',
      'Walcherbauer',
      'Wenten',
    ],
  },
  {
    postleitzahl: 3344,
    orte: ['Hochau', 'Kogelsbach', 'Königsbergau', 'St. Georgen am Reith'],
  },
  {
    postleitzahl: 3345,
    orte: [
      'Eisenwiesen',
      'Göstling an der Ybbs',
      'Großegg',
      'Hochreit',
      'Königsberg',
      'Lassing',
      'Mendling',
      'Oberkogelsbach',
      'Pernegg',
      'Steinbachmauer',
      'Stixenlehen',
      'Strohmarkt',
      'Ybbssteinbach',
    ],
  },
  {
    postleitzahl: 3350,
    orte: ['Haag', 'St. Johann in Engstetten', 'St. Valentin'],
  },
  {
    postleitzahl: 3351,
    orte: ['Weistrach'],
  },
  {
    postleitzahl: 3352,
    orte: [
      'Hohenreith',
      'Kürnberg',
      'St. Johann in Engstetten',
      'St. Michael am Bruckbach',
      'St. Peter in der Au-Dorf',
      'St. Peter in der Au-Markt',
    ],
  },
  {
    postleitzahl: 3353,
    orte: ['Biberbach', 'Seitenstetten'],
  },
  {
    postleitzahl: 3354,
    orte: ['Ottendorf', 'Wolfsbach'],
  },
  {
    postleitzahl: 3355,
    orte: ['Ertl'],
  },
  {
    postleitzahl: 3361,
    orte: [
      'Abetzberg',
      'Aschbach-Dorf',
      'Aschbach-Markt',
      'Biberbach',
      'Kematen',
      'Krenstetten',
      'Mauer bei Amstetten',
      'Mitterhausleiten',
      'Oberaschbach',
      'Öhling',
    ],
  },
  {
    postleitzahl: 3362,
    orte: ['Mauer bei Amstetten', 'Öhling'],
  },
  {
    postleitzahl: 3363,
    orte: ['Hausmening', 'Neufurth', 'Ulmerfeld', 'Winklarn'],
  },
  {
    postleitzahl: 3364,
    orte: [
      'Amesleiten',
      'Graben',
      'Kornberg',
      'Neuhofen an der Ybbs',
      'Perbersdorf',
      'Scherbling',
      'Schindau',
      'Toberstetten',
    ],
  },
  {
    postleitzahl: 3365,
    orte: ['Allhartsberg'],
  },
  {
    postleitzahl: 3370,
    orte: [
      'Donaudorf',
      'Göttsbach',
      'Neumarkt an der Ybbs',
      'Sarling',
      'Waasen',
      'Ybbs an der Donau',
    ],
  },
  {
    postleitzahl: 3371,
    orte: [
      'Breitenschollen',
      'Buch',
      'Dörfl',
      'Fischerberg',
      'Hofa',
      'Keppelberg',
      'Köchling',
      'Krottenthal',
      'Linden',
      'Neumarkt an der Ybbs',
      'Schönegg',
    ],
  },
  {
    postleitzahl: 3372,
    orte: ['Atzelsdorf', 'Blindenmarkt', 'Ferschnitz', 'Hubertendorf'],
  },
  {
    postleitzahl: 3373,
    orte: ['Kemmelbach', 'Ströblitz', 'Winden', 'Wolfsberg'],
  },
  {
    postleitzahl: 3374,
    orte: ['Diedersdorf', 'Sarling', 'Säusenstein', 'Ybbs an der Donau'],
  },
  {
    postleitzahl: 3375,
    orte: ['Annastift', 'Holzern', 'Krummnußbaum', 'Neustift', 'Wallenbach'],
  },
  {
    postleitzahl: 3376,
    orte: ['Ennsbach', 'Karlsbach', 'St. Martin am Ybbsfelde'],
  },
  {
    postleitzahl: 3380,
    orte: [
      'Ornding',
      'Pöchlarn',
      'Rampersdorf',
      'Röhrapoint',
      'Steinwand',
      'Wörth',
    ],
  },
  {
    postleitzahl: 3381,
    orte: ['Golling', 'Hinterleiten', 'Neuda', 'Sittenberg', 'Wolfring'],
  },
  {
    postleitzahl: 3382,
    orte: [
      'Albrechtsberg an der Pielach',
      'Anzendorf',
      'Eckartsberg',
      'Groß-Schollach',
      'Klein-Schollach',
      'Lanzing',
      'Lerchfeld',
      'Loosdorf',
      'Mauer bei Melk',
      'Merkendorf',
      'Neubach',
      'Neuhofen',
      'Pfaffing bei Mauer',
      'Roggendorf',
      'Rohr',
      'Schallaburg',
      'Sitzenthal',
      'Sooß',
      'Steinparz',
      'Thal',
      'Umbach',
      'Ursprung',
    ],
  },
  {
    postleitzahl: 3383,
    orte: [
      'Arnersdorf',
      'Atzing',
      'Diendorf',
      'Grub',
      'Hainberg',
      'Harmersdorf',
      'Hösing',
      'Hürm',
      'Inning',
      'Kronaberg',
      'Löbersdorf',
      'Maxenbach',
      'Mitterradl',
      'Murschratten',
      'Neustift bei Sooß',
      'Ober-Siegendorf',
      'Ober-Thurnhofen',
      'Oberhaag',
      'Oberradl',
      'Pöttendorf',
      'Scharagraben',
      'Schlatzendorf',
      'Seeben',
      'Unter-Siegendorf',
      'Unter-Thurnhofen',
      'Unterhaag',
    ],
  },
  {
    postleitzahl: 3384,
    orte: [
      'Eibelsau',
      'Eidletzberg',
      'Groß Sierning',
      'Haindorf',
      'Haunoldstein',
      'Knetzersdorf',
      'Mannersdorf',
      'Mitterndorf',
      'Nenndorf',
      'Osterburg',
      'Pielachhäuser',
      'Pottschollach',
      'Winkel',
    ],
  },
  {
    postleitzahl: 3385,
    orte: [
      'Distelburg',
      'Eggsdorf',
      'Friesing',
      'Gerersdorf',
      'Grillenhöfe',
      'Hetzersdorf',
      'Hofing',
      'Loipersdorf',
      'Markersdorf an der Pielach',
      'Matzersdorf',
      'Mitterau',
      'Nenndorf',
      'Poppendorf',
      'Prinzersdorf',
      'Salau',
      'Stainingsdorf',
      'Uttendorf',
      'Völlerndorf',
      'Weitendorf',
      'Wultendorf',
    ],
  },
  {
    postleitzahl: 3386,
    orte: [
      'Doppel',
      'Eichberg',
      'Hafnerbach',
      'Hengstberg',
      'Hohenegg',
      'Korning',
      'Obergraben',
      'Oed',
      'Pfaffing',
      'Pielachhaag',
      'Rannersdorf',
      'Sasendorf',
      'Stein',
      'Thal',
      'Untergraben',
      'Weghof',
      'Weinzierl',
      'Wimpassing an der Pielach',
      'Windschnur',
      'Würmling',
      'Zendorf',
    ],
  },
  {
    postleitzahl: 3390,
    orte: [
      'Bergern',
      'Freiningau',
      'Großpriel',
      'Kollapriel',
      'Maierhöfen',
      'Melk',
      'Pielach',
      'Pielachberg',
      'Pöverding',
      'Roggendorf',
      'Rosenfeld',
      'Schrattenbruck',
      'Spielberg',
      'Winden',
    ],
  },
  {
    postleitzahl: 3392,
    orte: [
      'Berging',
      'Gerolding',
      'Heitzing',
      'Hohenwarth',
      'Hub',
      'Neu-Gerolding',
      'Nölling',
      'Schönbühel an der Donau',
    ],
  },
  {
    postleitzahl: 3393,
    orte: [
      'Anzenberg',
      'Arb',
      'Einsiedl',
      'Gassen',
      'Hofstetten',
      'Mannersdorf',
      'Matzleinsdorf',
      'Zelking',
    ],
  },
  {
    postleitzahl: 3400,
    orte: [
      'Kierling',
      'Klosterneuburg',
      'Kritzendorf',
      'Maria Gugging',
      'Mauerbach',
      'Weidling',
      'Weidlingbach',
    ],
  },
  {
    postleitzahl: 3413,
    orte: ['Hintersdorf', 'Kierling', 'Kirchbach'],
  },
  {
    postleitzahl: 3420,
    orte: ['Klosterneuburg', 'Kritzendorf'],
  },
  {
    postleitzahl: 3421,
    orte: ['Höflein an der Donau'],
  },
  {
    postleitzahl: 3422,
    orte: ['Altenberg', 'Greifenstein', 'Hadersfeld', 'Wördern'],
  },
  {
    postleitzahl: 3423,
    orte: ['St. Andrä vor dem Hagenthale', 'Wördern'],
  },
  {
    postleitzahl: 3424,
    orte: ['Wolfpassing', 'Zeiselmauer'],
  },
  {
    postleitzahl: 3425,
    orte: ['Langenlebarn-Oberaigen', 'Langenlebarn-Unteraigen'],
  },
  {
    postleitzahl: 3426,
    orte: ['Muckendorf an der Donau', 'Wipfing'],
  },
  {
    postleitzahl: 3430,
    orte: [
      'Chorherrn',
      'Eggendorf am Wagram',
      'Frauenhofen',
      'Katzelsdorf',
      'Mollersdorf',
      'Neuaigen',
      'Nitzing',
      'Staasdorf',
      'Starnwörth',
      'Trübensee',
      'Tulln an der Donau',
    ],
  },
  {
    postleitzahl: 3433,
    orte: ['Königstetten'],
  },
  {
    postleitzahl: 3434,
    orte: ['Katzelsdorf', 'Ollern', 'Tulbing', 'Tulbingerkogel', 'Wilfersdorf'],
  },
  {
    postleitzahl: 3435,
    orte: [
      'Bärndorf',
      'Dürnrohr',
      'Erpersdorf',
      'Kleinschönbichl',
      'Langenschönbichl',
      'Neusiedl',
      'Pischelsdorf',
      'Zwentendorf an der Donau',
    ],
  },
  {
    postleitzahl: 3441,
    orte: [
      'Abstetten',
      'Baumgarten am Tullnerfeld',
      'Dietersdorf',
      'Einsiedl',
      'Freundorf',
      'Gollarn',
      'Judenau',
      'Pixendorf',
      'Ranzelsdorf',
      'Zöfing',
    ],
  },
  {
    postleitzahl: 3442,
    orte: ['Asparn', 'Kronau', 'Langenrohr', 'Langenschönbichl'],
  },
  {
    postleitzahl: 3443,
    orte: [
      'Dornberg',
      'Elsbach',
      'Geigelberg',
      'Gerersdorf',
      'Hagenau',
      'Henzing',
      'Irenental',
      'Kogl',
      'Kracking',
      'Kreuth',
      'Kronstein',
      'Öpping',
      'Penzing',
      'Pressbaum',
      'Rappoltenkirchen',
      'Röhrenbach',
      'Sieghartskirchen',
      'Wagendorf',
    ],
  },
  {
    postleitzahl: 3451,
    orte: [
      'Atzelsdorf',
      'Michelhausen',
      'Plankenberg',
      'Rust im Tullnerfeld',
      'Siegersdorf',
      'Spital',
      'Streithofen',
    ],
  },
  {
    postleitzahl: 3452,
    orte: [
      'Atzenbrugg',
      'Diendorf',
      'Ebersdorf',
      'Hankenfeld',
      'Heiligeneich',
      'Hütteldorf',
      'Michelndorf',
      'Mitterndorf',
      'Moosbierbaum',
      'Saladorf',
      'Tautendorf',
      'Trasdorf',
      'Watzendorf',
      'Weinzierl',
    ],
  },
  {
    postleitzahl: 3454,
    orte: [
      'Adletzberg',
      'Ahrenberg',
      'Baumgarten',
      'Buttendorf',
      'Eggendorf',
      'Gutenbrunn',
      'Hasendorf',
      'Heiligenkreuz',
      'Kaindorf',
      'Maria Ponsee',
      'Neustift',
      'Oberbierbaum',
      'Oberhameten',
      'Pottschall',
      'Preuwitz',
      'Reidling',
      'Sitzenberg',
      'Thallern',
      'Unterhameten',
    ],
  },
  {
    postleitzahl: 3462,
    orte: [
      'Absdorf',
      'Bierbaum am Kleebühel',
      'Frauendorf an der Au',
      'Hippersdorf',
      'Utzenlaa',
    ],
  },
  {
    postleitzahl: 3463,
    orte: ['Eggendorf am Wagram', 'Starnwörth', 'Stetteldorf am Wagram'],
  },
  {
    postleitzahl: 3464,
    orte: [
      'Eggendorf am Wagram',
      'Gaisruck',
      'Goldgeben',
      'Hausleiten',
      'Perzendorf',
      'Pettendorf',
      'Schmida',
      'Seitzersdorf-Wolfpassing',
      'Zaina',
    ],
  },
  {
    postleitzahl: 3465,
    orte: ['Königsbrunn am Wagram', 'Unterstockstall'],
  },
  {
    postleitzahl: 3470,
    orte: [
      'Dörfl',
      'Engelmannsbrunn',
      'Kirchberg am Wagram',
      'Mallon',
      'Mitterstockstall',
      'Neustift im Felde',
      'Oberstockstall',
      'Ottenthal',
    ],
  },
  {
    postleitzahl: 3471,
    orte: ['Großriedenthal', 'Neudegg'],
  },
  {
    postleitzahl: 3472,
    orte: ['Hohenwarth'],
  },
  {
    postleitzahl: 3473,
    orte: [
      'Bösendürnbach',
      'Mühlbach am Manhartsberg',
      'Olbersdorf',
      'Ronthal',
      'Zemling',
    ],
  },
  {
    postleitzahl: 3474,
    orte: ['Altenwörth', 'Gigging', 'Kollersdorf', 'Sachsendorf', 'Winkl'],
  },
  {
    postleitzahl: 3481,
    orte: ['Fels am Wagram', 'Thürnthal'],
  },
  {
    postleitzahl: 3482,
    orte: ['Gösing am Wagram', 'Stettenhof'],
  },
  {
    postleitzahl: 3483,
    orte: ['Feuersbrunn', 'Wagram am Wagram'],
  },
  {
    postleitzahl: 3484,
    orte: [
      'Feuersbrunn',
      'Grafenwörth',
      'Jettsdorf',
      'Seebarn am Wagram',
      'St. Johann',
    ],
  },
  {
    postleitzahl: 3485,
    orte: [
      'Donaudorf',
      'Grafenegg',
      'Grunddorf',
      'Haitzendorf',
      'Kamp',
      'Sittendorf',
    ],
  },
  {
    postleitzahl: 3491,
    orte: [
      'Diendorf am Walde',
      'Elsarn im Straßertal',
      'Obernholz',
      'Straß im Straßertale',
      'Wiedendorf',
    ],
  },
  {
    postleitzahl: 3492,
    orte: [
      'Diendorf am Kamp',
      'Engabrunn',
      'Etsdorf am Kamp',
      'Walkersdorf am Kamp',
    ],
  },
  {
    postleitzahl: 3493,
    orte: ['Hadersdorf am Kamp', 'Kammern'],
  },
  {
    postleitzahl: 3494,
    orte: [
      'Altweidling',
      'Brunn im Felde',
      'Gedersdorf',
      'Schlickendorf',
      'Stratzdorf',
      'Theiß',
    ],
  },
  {
    postleitzahl: 3495,
    orte: ['Rohrendorf bei Krems'],
  },
  {
    postleitzahl: 3500,
    orte: [
      'Egelsee',
      'Gneixendorf',
      'Imbach',
      'Krems an der Donau',
      'Landersdorf',
      'Lerchenfeld',
      'Rehberg',
      'Scheibenhof',
      'Stein an der Donau',
      'Stratzing',
    ],
  },
  {
    postleitzahl: 3506,
    orte: [
      'Angern',
      'Brunnkirchen',
      'Hollenburg',
      'Krems an der Donau',
      'Thallern',
    ],
  },
  {
    postleitzahl: 3508,
    orte: [
      'Eggendorf',
      'Höbenbach',
      'Hörfarth',
      'Krustetten',
      'Meidling',
      'Paudorf',
      'Tiefenfucha',
    ],
  },
  {
    postleitzahl: 3511,
    orte: [
      'Aigen',
      'Furth bei Göttweig',
      'Klein-Wien',
      'Oberfucha',
      'Palt',
      'Steinaweg',
      'Stift Göttweig',
    ],
  },
  {
    postleitzahl: 3512,
    orte: [
      'Baumgarten',
      'Hundsheim',
      'Mautern an der Donau',
      'Mauternbach',
      'Oberbergern',
      'Paltmühl',
      'Plaimberg',
      'Schenkenbrunn',
      'Unterbergern',
      'Wolfenreith',
    ],
  },
  {
    postleitzahl: 3521,
    orte: [
      'Felling',
      'Hohenstein',
      'Nöhagen',
      'Ober-Meisling',
      'Reichau',
      'Seeb',
      'Unter-Meisling',
    ],
  },
  {
    postleitzahl: 3522,
    orte: [
      'Allentsgschwendt',
      'Brunn am Wald',
      'Ebergersch',
      'Engelschalks',
      'Erdweis',
      'Gloden',
      'Großreinprechts',
      'Jeitendorf',
      'Kornberg',
      'Ladings',
      'Lichtenau',
      'Loiwein',
      'Obergrünbach',
      'Pallweis',
      'Scheutz',
      'Taubitz',
      'Wietzen',
      'Wurschenaigen',
    ],
  },
  {
    postleitzahl: 3524,
    orte: [
      'Grainbrunn',
      'Großnondorf',
      'Kleinhaslau',
      'Moniholz',
      'Spielleithen',
      'Voitschlag',
    ],
  },
  {
    postleitzahl: 3525,
    orte: [
      'Armschlag',
      'Heubach',
      'Lugendorf',
      'Rabenhof',
      'Sallingberg',
      'Spielleithen',
    ],
  },
  {
    postleitzahl: 3531,
    orte: [
      'Brand',
      'Gutenbrunn',
      'Niedernondorf',
      'Niederwaltenreith',
      'Werschenschlag',
      'Wiesenreith',
    ],
  },
  {
    postleitzahl: 3532,
    orte: [
      'Eisengraberamt',
      'Friedersbach',
      'Marbach im Felde',
      'Mottingeramt',
      'Niedergrünbach',
      'Ottenstein',
      'Peygarten-Ottenstein',
      'Rastenberg',
      'Rastenfeld',
      'Sperkental',
      'Zierings',
    ],
  },
  {
    postleitzahl: 3533,
    orte: [
      'Eschabruck',
      'Friedersbach',
      'Kleehof',
      'Kleinschönau',
      'Mitterreith',
      'Oberwaltenreith',
      'Wolfsberg',
    ],
  },
  {
    postleitzahl: 3541,
    orte: [
      'Imbach',
      'Meislingeramt',
      'Ostra',
      'Priel',
      'Rehberg',
      'Reichaueramt',
      'Senftenberg',
      'Senftenbergeramt',
    ],
  },
  {
    postleitzahl: 3542,
    orte: [
      'Eisenbergeramt',
      'Eisengraben',
      'Eisengraberamt',
      'Felling',
      'Garmanns',
      'Gföhl',
      'Gföhleramt',
      'Großmotten',
      'Grottendorf',
      'Jaidhof',
      'Lengenfelderamt',
      'Litschgraben',
      'Mittelbergeramt',
      'Moritzreith',
      'Neubau',
      'Rastbach',
      'Reisling',
      'Reittern',
      'Schiltingeramt',
      'Seeb',
      'Wurfenthalgraben',
    ],
  },
  {
    postleitzahl: 3543,
    orte: [
      'Eisengraberamt',
      'Krumau am Kamp',
      'Krumauer Waldhütten',
      'Mottingeramt',
      'Preinreichs',
      'Thurnberg',
      'Tiefenbach',
      'Unterdobrawaldhütten',
    ],
  },
  {
    postleitzahl: 3544,
    orte: ['Eisenberg', 'Idolsberg', 'Preinreichs', 'Thurnberg'],
  },
  {
    postleitzahl: 3550,
    orte: ['Gobelsburg', 'Langenlois', 'Mittelberg', 'Zeiselberg'],
  },
  {
    postleitzahl: 3552,
    orte: ['Droß', 'Droßeramt', 'Lengenfeld', 'Stratzing'],
  },
  {
    postleitzahl: 3553,
    orte: [
      'Mittelberg',
      'Mittelbergeramt',
      'Reith',
      'Schiltern',
      'Schiltingeramt',
    ],
  },
  {
    postleitzahl: 3561,
    orte: ['Langenlois', 'Zöbing'],
  },
  {
    postleitzahl: 3562,
    orte: [
      'Buchberger Waldhütten',
      'Mollands',
      'Schönberg-Neustift',
      'Schönberg',
      'See',
      'Stiefern',
      'Thürneustift',
    ],
  },
  {
    postleitzahl: 3564,
    orte: [
      'Altenhof',
      'Fernitz',
      'Freischling',
      'Kriegenreith',
      'Oberplank',
      'Plank am Kamp',
      'Raan',
    ],
  },
  {
    postleitzahl: 3571,
    orte: [
      'Buchberg am Kamp',
      'Gars am Kamp',
      'Kamegg',
      'Kotzendorf',
      'Loibersdorf',
      'Maiersch',
      'Nonndorf bei Gars',
      'Stallegg',
      'Tautendorf',
      'Thunau am Kamp',
      'Wolfshof',
      'Zitternberg',
    ],
  },
  {
    postleitzahl: 3572,
    orte: [
      'Eisenbergeramt',
      'Obertautendorferamt',
      'St. Leonhard am Hornerwald',
      'Untertautendorferamt',
      'Wilhalm',
      'Wolfshoferamt',
    ],
  },
  {
    postleitzahl: 3573,
    orte: ['Etzmannsdorf am Kamp', 'Rosenburg', 'Wanzenau'],
  },
  {
    postleitzahl: 3580,
    orte: [
      'Breiteneich',
      'Doberndorf',
      'Frauenhofen',
      'Groß Burgstall',
      'Grünberg',
      'Horn',
      'Mödring',
      'Mold',
      'Mörtersdorf',
      'Mühlfeld',
      'Poigen',
      'St. Bernhard',
      'Strögen',
      'Zaingrub',
    ],
  },
  {
    postleitzahl: 3591,
    orte: ['Altenburg', 'Burgerwiesen', 'Fuglau', 'Mahrersdorf', 'Steinegg'],
  },
  {
    postleitzahl: 3592,
    orte: [
      'Feinfeld',
      'Gobelsdorf',
      'Greillenstein',
      'Neubau',
      'Röhrenbach',
      'Tautendorf',
      'Winkl',
    ],
  },
  {
    postleitzahl: 3593,
    orte: [
      'Altpölla',
      'Döllersheim',
      'Franzen',
      'Germanns',
      'Kleinenzersdorf',
      'Kleinraabs',
      'Krug',
      'Neupölla',
      'Ramsau',
      'Wegscheid am Kamp',
    ],
  },
  {
    postleitzahl: 3594,
    orte: [
      'Döllersheim',
      'Franzen',
      'Kienberg',
      'Nondorf',
      'Reichhalms',
      'Schmerbach am Kamp',
      'Waldreichs',
      'Wetzlas',
    ],
  },
  {
    postleitzahl: 3595,
    orte: [
      'Atzelsdorf',
      'Brunn an der Wild',
      'Dappach',
      'Dietmannsdorf an der Wild',
      'Frankenreith',
      'Fürwald',
      'Neukirchen an der Wild',
      'St. Marein',
      'Waiden',
      'Wutzendorf',
    ],
  },
  {
    postleitzahl: 3601,
    orte: [
      'Dürnstein',
      'Dürnsteiner Waldhütten',
      'Oberloiben',
      'Rothenhof',
      'Unterloiben',
    ],
  },
  {
    postleitzahl: 3602,
    orte: ['Bacharnsdorf', 'Rossatz', 'Rossatzbach', 'Rührsdorf', 'St. Lorenz'],
  },
  {
    postleitzahl: 3610,
    orte: [
      'Joching',
      'Maigen',
      'St. Michael',
      'Stixendorf',
      'Weinzierl am Walde',
      'Weißenkirchen in der Wachau',
      'Wösendorf in der Wachau',
    ],
  },
  {
    postleitzahl: 3611,
    orte: [
      'Großheinrichschlag',
      'Habruck',
      'Himberg',
      'Lobendorf',
      'Neusiedl',
      'St. Michael',
      'Wolfenreith',
    ],
  },
  {
    postleitzahl: 3613,
    orte: [
      'Albrechtsberg an der Großen Krems',
      'Arzwiesen',
      'Attenreith',
      'Els',
      'Eppenberg',
      'Gillaus',
      'Großheinrichschlag',
      'Harrau',
      'Klein-Heinrichschlag',
      'Marbach an der Kleinen Krems',
      'Nöhagen',
      'Purkersdorf',
      'Scheutz',
    ],
  },
  {
    postleitzahl: 3620,
    orte: [
      'Benking',
      'Gut am Steg',
      'Mitterndorf',
      'Oberndorf',
      'Schwallenbach',
      'Spitz',
      'Vießling',
      'Wiesmannsreith',
    ],
  },
  {
    postleitzahl: 3621,
    orte: [
      'Bacharnsdorf',
      'Hofarnsdorf',
      'Mitterarnsdorf',
      'Oberarnsdorf',
      'St. Johann im Mauerthale',
    ],
  },
  {
    postleitzahl: 3622,
    orte: [
      'Amstall',
      'Doppl',
      'Elsarn am Jauerling',
      'Fohra',
      'Gschwendt',
      'Mühldorf',
      'Niederranna',
      'Oberranna',
      'Ötz',
      'Ötzbach',
      'Povat',
      'Runds',
      'Schoberhof',
      'Trandorf',
      'Trittings',
      'Wernhies',
    ],
  },
  {
    postleitzahl: 3623,
    orte: [
      'Bernhards',
      'Dankholz',
      'Elsenreith',
      'Ensberg',
      'Ernst',
      'Felles',
      'Gotthardschlag',
      'Günsles',
      'Heitzles',
      'Hörans',
      'Kalkgrub',
      'Koppenhof',
      'Kottes',
      'Leopolds',
      'Münichreith',
      'Pfaffenschlag',
      'Pötzles',
      'Purk',
      'Reichpolds',
      'Richterhof',
      'Singenreith',
      'Teichmanns',
      'Voirans',
      'Voitsau',
      'Weikartschlag',
    ],
  },
  {
    postleitzahl: 3631,
    orte: [
      'Bernhardshof',
      'Bernreith',
      'Eck',
      'Endlas',
      'Gaßles',
      'Jungschlag',
      'Kienings',
      'Kirchschlag',
      'Lugendorf',
      'Merkengerst',
      'Neuhof',
      'Oedwinkel',
      'Ottenschlag',
      'Pleßberg',
      'Reith',
      'Scheib',
      'Schneeberg',
    ],
  },
  {
    postleitzahl: 3632,
    orte: [
      'Aschen',
      'Bad Traunstein',
      'Biberschlag',
      'Dietmanns',
      'Gürtelberg',
      'Haselberg',
      'Hummelberg',
      'Kaltenbach',
      'Pernthon',
      'Pfaffings',
      'Prettles',
      'Schönau',
      'Spielberg',
      'Stein',
      'Walterschlag',
      'Weidenegg',
    ],
  },
  {
    postleitzahl: 3633,
    orte: [
      'Aschen',
      'Bärnkopf',
      'Dorfstadt',
      'Fichtenhöfen',
      'Großpertenschlag',
      'Grub im Thale',
      'Klein-Siegharts',
      'Kleinpertenschlag',
      'Lengau',
      'Lichtenau',
      'Lohn',
      'Pernthon',
      'Schönbach',
    ],
  },
  {
    postleitzahl: 3641,
    orte: [
      'Aggsbach Markt',
      'Groisbach',
      'Köfering',
      'Willendorf in der Wachau',
    ],
  },
  {
    postleitzahl: 3642,
    orte: [
      'Aggsbach-Dorf',
      'Aggstein',
      'Gschwendt',
      'Häusling',
      'Heitzing',
      'Kochholz',
      'Maria Langegg',
      'Ohnreith',
      'Siedelgraben',
      'Wolfstein',
    ],
  },
  {
    postleitzahl: 3643,
    orte: [
      'Aggsbach Markt',
      'Felbring',
      'Friedersdorf',
      'Gießhübl',
      'Haslarn',
      'Hinterkogel',
      'Hof',
      'Kuffarn',
      'Litzendorf',
      'Loitzendorf',
      'Maria Laach am Jauerling',
      'Nonnersdorf',
      'Schlaubing',
      'Thalham',
      'Weinberg',
      'Wiesmannsreith',
      'Zeißing',
      'Zintring',
    ],
  },
  {
    postleitzahl: 3644,
    orte: [
      'Emmersdorf an der Donau',
      'Fahnsdorf',
      'Goßam',
      'Grimsing',
      'Hain',
      'Hofamt',
      'Luberegg',
      'Mödelsdorf',
      'Pömling',
      'Rantenberg',
      'Reith',
      'Schallemmersdorf',
      'St. Georgen',
    ],
  },
  {
    postleitzahl: 3650,
    orte: [
      'Annagschmais',
      'Arndorf',
      'Aschelberg',
      'Auhof',
      'Bergern bei Pöggstall',
      'Bergern bei Würnsdorf',
      'Braunegg',
      'Brennhof',
      'Brennmühle',
      'Bruck am Ostrong',
      'Dietsam',
      'Gerersdorf',
      'Gmainhofmühle',
      'Gottsberg',
      'Grub bei Aschelberg',
      'Grub bei Neukirchen am Ostrong',
      'Gsteinert',
      'Haag',
      'Hinterfeld',
      'Höfleshof',
      'Hölltal',
      'Kehrbach',
      'Krempersbach',
      'Krumling',
      'Laas',
      'Landstetten',
      'Loibersdorf',
      'Muckendorf',
      'Mürfelndorf',
      'Neue Welt',
      'Neukirchen am Ostrong',
      'Oberbierbaum',
      'Oberdörfl',
      'Oberhohenau',
      'Oed',
      'Oscha',
      'Pöggstall',
      'Pömmerstall',
      'Prinzelndorf',
      'Reitern',
      'Riedersdorf',
      'Sading',
      'Steinbach',
      'Stockhof',
      'Straßreith',
      'Troibetsberg',
      'Troising',
      'Unterhohenau',
      'Wachtberg',
      'Weinling',
      'Weißpyhra',
      'Würnsdorf',
      'Zöbring',
    ],
  },
  {
    postleitzahl: 3652,
    orte: [
      'Aichau',
      'Ebersdorf',
      'Kaumberg',
      'Klein-Pöchlarn',
      'Lehen',
      'Leiben',
      'Losau',
      'Mampasberg',
      'Neu-Weinzierl',
      'Payerstetten',
      'St. Georgen',
      'Trennegg',
      'Urfahr',
      'Weinzierl',
      'Weitenegg',
    ],
  },
  {
    postleitzahl: 3653,
    orte: [
      'Am Schuß',
      'Eibetsberg',
      'Eitental',
      'Fahnsdorf',
      'Feistritz',
      'Filsendorf',
      'Gerersdorf',
      'Jasenegg',
      'Mannersdorf',
      'Mollenburg',
      'Mollendorf',
      'Moos',
      'Mörenz',
      'Nasting',
      'Neusiedl am Feldstein',
      'Ottenberg',
      'Rafles',
      'Robans',
      'Seiterndorf',
      'Streitwiesen',
      'Tottendorf',
      'Walkersdorf',
      'Weiten',
      'Weiterndorf',
      'Zehentegg',
      'Zogelsdorf',
    ],
  },
  {
    postleitzahl: 3654,
    orte: [
      'Afterbach',
      'Eibetsberg',
      'Feistritz',
      'Klebing',
      'Laufenegg',
      'Lehsdorf',
      'Neudorf',
      'Neusiedl bei Pfaffenhof',
      'Ottenberg',
      'Pfaffenhof',
      'Pölla',
      'Raxendorf',
      'Steinbach',
      'Zeining',
    ],
  },
  {
    postleitzahl: 3660,
    orte: ['Klein-Pöchlarn'],
  },
  {
    postleitzahl: 3661,
    orte: [
      'Artstetten',
      'Dölla',
      'Fritzelsdorf',
      'Hart',
      'Hasling',
      'Lohsdorf',
      'Nussendorf',
      'Oberndorf',
      'Pleißing',
      'Pöbring',
      'Rappoltenreith',
      'Schwarzau',
      'Unterbierbaum',
      'Unterthalheim',
    ],
  },
  {
    postleitzahl: 3662,
    orte: [
      'Edelsreith',
      'Kehrbach',
      'Kollnitz',
      'Mayerhofen',
      'Münichreith am Ostrong',
      'Pargatstetten',
      'Rappoltenreith',
    ],
  },
  {
    postleitzahl: 3663,
    orte: [
      'Am Teich',
      'Eggathon',
      'Gmaining',
      'Kälberhof',
      'Laimbach am Ostrong',
      'Staudenhäuser',
      'Stollmühle',
      'Thann',
      'Thannhof',
    ],
  },
  {
    postleitzahl: 3664,
    orte: [
      'Größenbach',
      'Holzwiese',
      'Hundsbach',
      'Kleingerungs',
      'Kleinpertholz',
      'Loitzenreith',
      'Martinsberg',
      'Mitterndorf',
      'Oed',
      'Pitzeichen',
      'Poggschlag',
      'Reitzendorf',
      'Roggenreith',
      'Thumling',
      'Walpersdorf',
      'Weixelberg',
      'Wiehalm',
    ],
  },
  {
    postleitzahl: 3665,
    orte: ['Bärnkopf', 'Edlesberg', 'Gutenbrunn', 'Oed', 'Ulrichschlag'],
  },
  {
    postleitzahl: 3671,
    orte: [
      'Auratsberg',
      'Friesenegg',
      'Granz',
      'Kracking',
      'Krummnußbaum an der Donauuferbahn',
      'Marbach an der Donau',
      'Schaufel',
    ],
  },
  {
    postleitzahl: 3672,
    orte: [
      'Hilmanger',
      'Marbach an der Donau',
      'Maria Taferl',
      'Obererla',
      'Oberthalheim',
      'Reitern',
      'Untererla',
      'Unterthalheim',
      'Wimm',
    ],
  },
  {
    postleitzahl: 3680,
    orte: ['Gottsdorf', 'Hagsdorf', 'Loja', 'Metzling', 'Persenbeug'],
  },
  {
    postleitzahl: 3681,
    orte: [
      'Am Reitern',
      'Brand',
      'Doberg',
      'Eben',
      'Fahrenbach',
      'Feldmüllerstall',
      'Forsthub',
      'Gartln',
      'Graslhof',
      'Harland',
      'Hinterhaus',
      'Hofamt Priel',
      'Holzian',
      'Kalz/Reith',
      'Klaus',
      'Kleehof',
      'Knogl',
      'Mitterberg',
      'Pemperreith',
      'Rehberg',
      'Rosenbichl',
      'Rote Säge',
      'Rottenberg',
      'Rottenhof',
      'Viehtrift',
      'Weins',
      'Ysperdorf',
    ],
  },
  {
    postleitzahl: 3683,
    orte: ['Haslau', 'Kapelleramt', 'Nächst Altenmarkt', 'Wimberg', 'Yspertal'],
  },
  {
    postleitzahl: 3684,
    orte: ['St. Oswald'],
  },
  {
    postleitzahl: 3691,
    orte: [
      'Artneramt',
      'Baumgartenberg',
      'Freigericht',
      'Gulling',
      'Mitterndorf',
      'Niederndorf',
      'Nöchling',
    ],
  },
  {
    postleitzahl: 3701,
    orte: [
      'Ameistal',
      'Baumgarten am Wagram',
      'Großweikersdorf',
      'Großwiesendorf',
      'Inkersdorf',
      'Kleinwiesendorf',
      'Oberthern',
      'Ruppersthal',
      'Tiefenthal',
      'Unterthern',
      'Zaußenberg',
    ],
  },
  {
    postleitzahl: 3702,
    orte: ['Niederrußbach', 'Oberrußbach', 'Stranzendorf'],
  },
  {
    postleitzahl: 3704,
    orte: ['Glaubendorf', 'Großwetzdorf', 'Kleinwetzdorf'],
  },
  {
    postleitzahl: 3710,
    orte: [
      'Dippersdorf',
      'Fahndorf',
      'Frauendorf an der Schmida',
      'Gettsdorf',
      'Glaubendorf',
      'Hollenstein',
      'Kiblitz',
      'Radlbrunn',
      'Rohrbach',
      'Ziersdorf',
    ],
  },
  {
    postleitzahl: 3711,
    orte: ['Ebersbrunn', 'Großmeiseldorf'],
  },
  {
    postleitzahl: 3712,
    orte: ['Eggendorf am Walde', 'Grübern', 'Maissau', 'Wilhelmsdorf'],
  },
  {
    postleitzahl: 3713,
    orte: [
      'Amelsdorf',
      'Buttendorf',
      'Gumping',
      'Harmannsdorf',
      'Kleinburgstall',
      'Matzelsdorf',
      'Reikersdorf',
      'Reinprechtspölla',
      'Sachsendorf',
    ],
  },
  {
    postleitzahl: 3714,
    orte: [
      'Braunsdorf',
      'Goggendorf',
      'Kleinkirchberg',
      'Pranhartsberg',
      'Roseldorf',
      'Sitzendorf an der Schmida',
      'Sitzenhart',
    ],
  },
  {
    postleitzahl: 3720,
    orte: [
      'Baierdorf',
      'Gaindorf',
      'Minichhofen',
      'Oberravelsbach',
      'Parisdorf',
      'Pfaffstetten',
      'Ravelsbach',
    ],
  },
  {
    postleitzahl: 3721,
    orte: ['Limberg', 'Niederschleinz', 'Oberdürnbach', 'Unterdürnbach'],
  },
  {
    postleitzahl: 3722,
    orte: ['Etzmannsdorf bei Straning', 'Straning'],
  },
  {
    postleitzahl: 3730,
    orte: [
      'Burgschleinitz',
      'Eggenburg',
      'Engelsdorf',
      'Gauderndorf',
      'Grafenberg',
      'Kattau',
      'Klein-Jetzelsdorf',
      'Klein-Reinprechtsdorf',
      'Kühnring',
      'Roggendorf',
      'Sonndorf',
      'Stoitzendorf',
      'Wartberg',
      'Zogelsdorf',
    ],
  },
  {
    postleitzahl: 3741,
    orte: [
      'Groß-Reipersdorf',
      'Leodagger',
      'Pulkau',
      'Rafing',
      'Rohrendorf an der Pulkau',
    ],
  },
  {
    postleitzahl: 3742,
    orte: ['Heinrichsdorf', 'Passendorf', 'Theras'],
  },
  {
    postleitzahl: 3743,
    orte: ['Röschitz'],
  },
  {
    postleitzahl: 3744,
    orte: ['Klein-Meiseldorf', 'Mold', 'Stockern'],
  },
  {
    postleitzahl: 3751,
    orte: [
      'Doberndorf',
      'Maigen',
      'Missingdorf',
      'Rodingersdorf',
      'Sigmundsherberg',
    ],
  },
  {
    postleitzahl: 3752,
    orte: [
      'Brugg',
      'Kainreith',
      'Nonnersdorf',
      'Purgstall',
      'Röhrawiesen',
      'Sallapulka',
      'Walkenstein',
    ],
  },
  {
    postleitzahl: 3753,
    orte: [
      'Dallein',
      'Etzelsreith',
      'Goggitsch',
      'Harth',
      'Hötzelsdorf',
      'Lehndorf',
      'Ludweishofen',
      'Nödersdorf',
      'Pernegg',
      'Posselsdorf',
      'Raisdorf',
      'Schirmannsreith',
      'Sieghartsreith',
      'Staningersdorf',
    ],
  },
  {
    postleitzahl: 3754,
    orte: [
      'Haselberg',
      'Irnfritz',
      'Klein-Ulrichschlag',
      'Nondorf an der Wild',
      'Reichharts',
      'Trabenreith',
      'Wappoltenreith',
    ],
  },
  {
    postleitzahl: 3761,
    orte: ['Dorna', 'Grub', 'Messern', 'Rothweinsdorf', 'Sitzendorf'],
  },
  {
    postleitzahl: 3762,
    orte: [
      'Blumau an der Wild',
      'Drösiedl',
      'Ludweis',
      'Oedt an der Wild',
      'Radessen',
      'Seebs',
    ],
  },
  {
    postleitzahl: 3763,
    orte: [
      'Goslarn',
      'Japons',
      'Oberthumeritz',
      'Sabatenreith',
      'Schweinburg',
      'Unterthumeritz',
      'Wenjapons',
      'Zettenreith',
    ],
  },
  {
    postleitzahl: 3800,
    orte: [
      'Breitenfeld',
      'Georgenberg',
      'Göpfritz an der Wild',
      'Merkenbrechts',
      'Scheideldorf',
      'Weinpolz',
    ],
  },
  {
    postleitzahl: 3804,
    orte: [
      'Allentsteig',
      'Bernschlag',
      'Großkainraths',
      'Reinsbach',
      'Thaua',
      'Zwinzen',
    ],
  },
  {
    postleitzahl: 3811,
    orte: [
      'Almosen',
      'Breitenfeld',
      'Kirchberg an der Wild',
      'Schönfeld an der Wild',
    ],
  },
  {
    postleitzahl: 3812,
    orte: [
      'Ellends',
      'Fistritz',
      'Groß-Siegharts',
      'Loibes',
      'Sieghartsles',
      'Waldreichs',
      'Weinern',
      'Wienings',
    ],
  },
  {
    postleitzahl: 3813,
    orte: ['Alt-Dietmanns', 'Neu-Dietmanns'],
  },
  {
    postleitzahl: 3814,
    orte: [
      'Aigen',
      'Diemschlag',
      'Drösiedl',
      'Kollmitzgraben',
      'Liebenberg',
      'Pfaffenschlag',
      'Radl',
      'Sauggern',
      'Schweinburg',
      'Tröbings',
    ],
  },
  {
    postleitzahl: 3820,
    orte: [
      'Alberndorf',
      'Koggendorf',
      'Kollmitzdörfl',
      'Liebnitz',
      'Lindau',
      'Modsiedl',
      'Mostbach',
      'Oberndorf bei Raabs',
      'Oberpfaffendorf',
      'Pommersdorf',
      'Raabs an der Thaya',
      'Reith',
      'Speisendorf',
      'Zabernreith',
      'Zemmendorf',
    ],
  },
  {
    postleitzahl: 3822,
    orte: [
      'Eggersdorf',
      'Göpfritzschlag',
      'Goschenreith',
      'Griesbach',
      'Hohenwarth',
      'Karlstein an der Thaya',
      'Münchreith an der Thaya',
      'Obergrünbach',
      'Schlader',
      'Thuma',
      'Thures',
      'Wertenau',
    ],
  },
  {
    postleitzahl: 3823,
    orte: [
      'Neuriegers',
      'Oberndorf bei Weikertschlag',
      'Rossa',
      'Unterpertholz',
      'Weikertschlag an der Thaya',
      'Wetzles',
      'Wilhelmshof',
      'Ziernreith',
    ],
  },
  {
    postleitzahl: 3824,
    orte: [
      'Großau',
      'Luden',
      'Nonndorf bei Raabs',
      'Rabesreith',
      'Schaditz',
      'Süssenbach',
    ],
  },
  {
    postleitzahl: 3830,
    orte: [
      'Altwaidhofen',
      'Brunn',
      'Buchbach',
      'Dimling',
      'Götzles',
      'Götzweis',
      'Griesbach',
      'Großgerharts',
      'Hollenbach',
      'Jarolden',
      'Jasnitz',
      'Kainraths',
      'Klein Eberharts',
      'Matzles',
      'Nonndorf',
      'Puch',
      'Pyhra',
      'Sarning',
      'Schlagles',
      'Ulrichschlag',
      'Vestenötting',
      'Vestenpoppen',
      'Waidhofen an der Thaya',
      'Wohlfahrts',
    ],
  },
  {
    postleitzahl: 3834,
    orte: [
      'Arnolz',
      'Artolz',
      'Eisenreichs',
      'Großeberharts',
      'Guttenbrunn',
      'Haslau',
      'Kleingöpfritz',
      'Pfaffenschlag bei Waidhofen a.d.Thaya',
      'Rohrbach',
      'Schwarzenberg',
      'Seyfrieds',
      'Wolfsegg',
    ],
  },
  {
    postleitzahl: 3841,
    orte: [
      'Edengans',
      'Grünau',
      'Kottschallings',
      'Lichtenberg',
      'Markl',
      'Matzlesschlag',
      'Meires',
      'Rafings',
      'Rafingsberg',
      'Waldberg',
      'Willings',
      'Windigsteig',
    ],
  },
  {
    postleitzahl: 3842,
    orte: [
      'Eggmanns',
      'Frühwärts',
      'Niederedlitz',
      'Oberedlitz',
      'Ranzles',
      'Schirnes',
      'Thaya',
    ],
  },
  {
    postleitzahl: 3843,
    orte: [
      'Dobersberg',
      'Goschenreith am Taxenbache',
      'Großharmanns',
      'Hohenau',
      'Kleinharmanns',
      'Lexnitz',
      'Merkengersch',
      'Peigarten',
      'Riegers',
      'Schuppertholz',
    ],
  },
  {
    postleitzahl: 3844,
    orte: [
      'Fratres',
      'Gilgenberg',
      'Rappolz',
      'Reibers',
      'Reinolz',
      'Rudolz',
      'Schönfeld',
      'Waldhers',
      'Waldkirchen an der Thaya',
    ],
  },
  {
    postleitzahl: 3851,
    orte: [
      'Brunn',
      'Engelbrechts',
      'Großtaxen',
      'Kautzen',
      'Kleingerharts',
      'Kleintaxen',
      'Pleßberg',
      'Reinberg-Dobersberg',
      'Tiefenbach',
    ],
  },
  {
    postleitzahl: 3852,
    orte: [
      'Garolden',
      'Gastern',
      'Immenschlag',
      'Kleinmotten',
      'Kleinzwettl',
      'Ruders',
      'Triglas',
      'Weißenbach',
      'Wiesmaden',
    ],
  },
  {
    postleitzahl: 3860,
    orte: [
      'Aalfang',
      'Altmanns',
      'Dietweis',
      'Eberweis',
      'Haslau',
      'Heidenreichstein',
      'Kleinpertholz',
      'Motten',
      'Reinberg-Heidenreichstein',
      'Seyfrieds',
      'Wielandsberg',
    ],
  },
  {
    postleitzahl: 3861,
    orte: ['Eggern', 'Reinberg-Heidenreichstein', 'Reinberg-Litschau'],
  },
  {
    postleitzahl: 3862,
    orte: ['Eisgarn', 'Groß-Radischen', 'Klein-Radischen', 'Wielings'],
  },
  {
    postleitzahl: 3863,
    orte: ['Hirschenschlag', 'Leopoldsdorf', 'Reingers'],
  },
  {
    postleitzahl: 3871,
    orte: ['Alt-Nagelberg', 'Breitensee', 'Neu-Nagelberg', 'Steinbach'],
  },
  {
    postleitzahl: 3872,
    orte: [
      'Aalfang',
      'Amaliendorf',
      'Falkendorf',
      'Kiensaß',
      'Langegg',
      'Neulangegg',
    ],
  },
  {
    postleitzahl: 3873,
    orte: ['Brand', 'Finsternau', 'Gopprechts', 'Thaures'],
  },
  {
    postleitzahl: 3874,
    orte: [
      'Gopprechts',
      'Grametten',
      'Griesbach',
      'Haugschlag',
      'Hörmanns bei Litschau',
      'Illmanns',
      'Josefsthal',
      'Litschau',
      'Loimanns',
      'Reichenbach',
      'Reitzenschlag',
      'Rottal',
      'Saaß',
      'Schandachen',
      'Schlag',
      'Schönau bei Litschau',
      'Türnau',
    ],
  },
  {
    postleitzahl: 3900,
    orte: [
      'Echsenbach',
      'Ganz',
      'Großhaselbach',
      'Hausbach',
      'Kleinreichenbach',
      'Limpfings',
      'Modlisch',
      'Schlag',
      'Schwarzenau',
      'Stögersbach',
    ],
  },
  {
    postleitzahl: 3902,
    orte: [
      'Edelprinz',
      'Eschenau',
      'Eulenbach',
      'Grafenschlag',
      'Großrupprechts',
      'Heinreichs',
      'Jaudling',
      'Jetzles',
      'Kaltenbach',
      'Kleingloms',
      'Kleinpoppen',
      'Kleinschönau',
      'Schacherdorf',
      'Schoberdorf',
      'Sparbach',
      'Stoies',
      'Vitis',
      'Wiederfeld',
    ],
  },
  {
    postleitzahl: 3903,
    orte: [
      'Echsenbach',
      'Gerweis',
      'Großkainraths',
      'Haimschlag',
      'Rieweis',
      'Wolfenstein',
    ],
  },
  {
    postleitzahl: 3910,
    orte: [
      'Böhmhöf',
      'Bösenneunzen',
      'Edelhof',
      'Frankenreith',
      'Germanns',
      'Gerotten',
      'Gradnitz',
      'Großglobnitz',
      'Großhaslau',
      'Großweißenbach',
      'Gschwendt',
      'Hörmanns',
      'Jahrings',
      'Kleinotten',
      'Koblhof',
      'Mayerhöfen',
      'Moidrams',
      'Niederglobnitz',
      'Niederstrahlbach',
      'Oberstrahlbach',
      'Ratschenhof',
      'Reichers',
      'Ritzmannshof',
      'Rohrenreith',
      'Rudmanns',
      'Schickenhof',
      'Sprögnitz',
      'Syrafeld',
      'Unterrabenthan',
      'Waldhams',
      'Zwettl Stift',
      'Zwettl-Niederösterreich',
    ],
  },
  {
    postleitzahl: 3911,
    orte: [
      'Aggsbach',
      'Annatsberg',
      'Arnreith',
      'Dietharts',
      'Grötschen',
      'Grünbach',
      'Hausbach',
      'Höhendorf',
      'Hörweix',
      'Kirchbach',
      'Kleinkamp',
      'Kleinnondorf',
      'Lembach',
      'Marbach am Walde',
      'Merzenstein',
      'Neustift',
      'Oberrabenthan',
      'Pehendorf',
      'Pfaffendorf',
      'Pirkenreith',
      'Rappottenstein',
      'Reichenbach',
      'Riebeis',
      'Ritterkamp',
      'Roiten',
      'Rottenbach',
      'Selbitz',
      'Uttissenbach',
    ],
  },
  {
    postleitzahl: 3912,
    orte: [
      'Bromberg',
      'Grafenschlag',
      'Kaltenbrunn',
      'Kleingöttfritz',
      'Kleinnondorf',
      'Langschlag',
      'Schafberg',
      'Wielands',
    ],
  },
  {
    postleitzahl: 3913,
    orte: ['Engelbrechts', 'Großgöttfritz', 'Kleinweißenbach'],
  },
  {
    postleitzahl: 3914,
    orte: [
      'Hirschenschlag',
      'Kamles',
      'Königsbach',
      'Loschberg',
      'Obernondorf',
      'Rappoltschlag',
      'Waldhausen',
    ],
  },
  {
    postleitzahl: 3920,
    orte: [
      'Aigen',
      'Albern',
      'Antenfeinhöfen',
      'Blumau',
      'Böhmsdorf',
      'Dietmanns',
      'Egres',
      'Etlas',
      'Etzen',
      'Frauendorf',
      'Freitzenschlag',
      'Griesbach',
      'Groß Gerungs',
      'Groß Meinharts',
      'Grossgundholz',
      'Haid',
      'Harruck',
      'Haselbach',
      'Häuslern',
      'Heinreichs',
      'Hypolz',
      'Josefsdorf',
      'Kinzenschlag',
      'Klein Gundholz',
      'Klein Reinprechts',
      'Klein Wetzles',
      'Kotting Nondorf',
      'Marharts',
      'Mühlbach',
      'Nonndorf',
      'Ober Neustift',
      'Ober Rosenauerwald',
      'Oberkirchen',
      'Preinreichs',
      'Raffelshöfe',
      'Reitern',
      'Schall',
      'Schönbichl',
      'Siebenberg',
      'Sitzmanns',
      'Thail',
      'Wendelgraben',
      'Wiesensfeld',
      'Wurmbrand',
    ],
  },
  {
    postleitzahl: 3921,
    orte: [
      'Bruderndorf',
      'Bruderndorferwald',
      'Fraberg',
      'Harruck',
      'Kainrathschlag',
      'Kasbach',
      'Kehrbach',
      'Kleinpertholz',
      'Kogschlag',
      'Langschlag',
      'Langschlägerwald',
      'Mittelberg',
      'Mitterschlag',
      'Münzbach',
      'Reichenauerwald',
      'Schmerbach',
      'Siebenhöf',
      'Stierberg',
      'Streith',
    ],
  },
  {
    postleitzahl: 3922,
    orte: [
      'Engelstein',
      'Friedreichs',
      'Großotten',
      'Großschönau',
      'Harmannstein',
      'Hirschenhof',
      'Mistelbach',
      'Schroffen',
      'Siebenlinden',
      'Thaures',
      'Wachtberg',
      'Watzmanns',
      'Wörnharts',
    ],
  },
  {
    postleitzahl: 3923,
    orte: [
      'Bernhards',
      'Jagenbach',
      'Purken',
      'Rothfarn',
      'Schweiggers',
      'Zweres',
    ],
  },
  {
    postleitzahl: 3924,
    orte: [
      'Guttenbrunn',
      'Kleinmeinharts',
      'Niederneustift',
      'Ober Neustift',
      'Rosenau Schloss',
      'Unterrosenauerwald',
    ],
  },
  {
    postleitzahl: 3925,
    orte: [
      'Altmelon',
      'Arbesbach',
      'Brunn',
      'Dietrichsbach',
      'Dürnberg',
      'Etlas',
      'Fichtenbach',
      'Kamp',
      'Kleinpertenschlag',
      'Komau',
      'Kronegg',
      'Leopoldstein',
      'Neumelon',
      'Neustift',
      'Perwolfs',
      'Pretrobruck',
      'Purrath',
      'Rammelhof',
      'Schönfeld',
      'Schwarzau',
    ],
  },
  {
    postleitzahl: 3931,
    orte: [
      'Gerlas',
      'Großreichenbach',
      'Kleinwolfgers',
      'Mannshalm',
      'Meinhartschlag',
      'Negers',
      'Neusiedl',
      'Perndorf',
      'Reinbolden',
      'Rieggers',
      'Rosenau Dorf',
      'Sallingstadt',
      'Schwarzenbach',
      'Schweiggers',
      'Siebenlinden',
      'Streitbach',
      'Unterwindhag',
      'Vierlings',
      'Walterschlag',
      'Windhof',
    ],
  },
  {
    postleitzahl: 3932,
    orte: [
      'Fromberg',
      'Hollenstein',
      'Kirchberg am Walde',
      'Limbach',
      'Ottenschlag',
      'Süßenbach',
      'Ullrichs',
      'Warnungs',
      'Weißenalbern',
    ],
  },
  {
    postleitzahl: 3942,
    orte: ['Hirschbach', 'Stölzles'],
  },
  {
    postleitzahl: 3943,
    orte: [
      'Anderlfabrik',
      'Ehrenhöbarten',
      'Gebharts',
      'Kleedorf',
      'Kottinghörmanns',
      'Neuniederschrems',
      'Niederschrems',
      'Schrems',
    ],
  },
  {
    postleitzahl: 3944,
    orte: ['Kurzschwarza', 'Langschwarza', 'Pürbach'],
  },
  {
    postleitzahl: 3945,
    orte: ['Groß-Höbarten', 'Hoheneich', 'Nondorf'],
  },
  {
    postleitzahl: 3950,
    orte: [
      'Breitensee',
      'Dietmanns',
      'Ehrendorf',
      'Eichberg',
      'Gmünd',
      'Grillenstein',
      'Großeibenstein',
      'Kleineibenstein',
      'Wielands',
    ],
  },
  {
    postleitzahl: 3961,
    orte: [
      'Albrechts',
      'Groß-Höbarten',
      'Groß-Neusiedl',
      'Grünbach',
      'Hörmanns bei Weitra',
      'Klein-Ruprechts',
      'Waldenstein',
      'Zehenthöf',
    ],
  },
  {
    postleitzahl: 3962,
    orte: [
      'Heinrichs bei Weitra',
      'Höhenberg',
      'Ober-Lembach',
      'Pyhrabruck',
      'Reinpolz',
      'Unterlembach',
    ],
  },
  {
    postleitzahl: 3970,
    orte: [
      'Altweitra',
      'Großwolfgers',
      'Harbach',
      'Hirschenwies',
      'Langfeld',
      'Lauterbach',
      'Maißen',
      'Oberbrühl',
      'Oberwindhag',
      'Reinprechts',
      'Schagges',
      'Schützenberg',
      'Spital',
      'St. Wolfgang',
      'Sulz',
      'Tiefenbach',
      'Ulrichs',
      'Unserfrau',
      'Unterbrühl',
      'Walterschlag',
      'Weitra',
      'Wetzles',
      'Wultschau',
    ],
  },
  {
    postleitzahl: 3971,
    orte: [
      'Anger',
      'Breitenberg',
      'Harmanschlag',
      'Joachimstal',
      'Oberlainsitz',
      'Reitgraben',
      'Rörndlwies',
      'Roßbruck',
      'Schöllbüchl',
      'Schwarzau',
      'St. Martin',
      'Zeil',
    ],
  },
  {
    postleitzahl: 3972,
    orte: [
      'Abschlag',
      'Angelbach',
      'Bad Großpertholz',
      'Hirschenstein',
      'Mühlbach',
      'Reichenau am Freiwald',
      'Scheiben',
      'Seifritz',
      'Steinbach',
      'Weikertschlag',
    ],
  },
  {
    postleitzahl: 3973,
    orte: ['Bruderndorferwald', 'Karlstift', 'Reichenauerwald'],
  },
  {
    postleitzahl: 4020,
    orte: ['Friesenegg', 'Linz', 'Zaubertal'],
  },
  {
    postleitzahl: 4030,
    orte: ['Linz'],
  },
  {
    postleitzahl: 4040,
    orte: [
      'Altlichtenberg',
      'Asberg',
      'Gramastetten',
      'Großamberg',
      'Haselgraben',
      'Hochbuchedt',
      'Kammerschlag',
      'Katzgraben',
      'Kitzelsbach',
      'Linz',
      'Mühlberg',
      'Neulichtenberg',
      'Oberbairing',
      'Plesching',
      'Pöstlingberg',
      'Türkstetten',
    ],
  },
  {
    postleitzahl: 4048,
    orte: [
      'Großamberg',
      'Oberpuchenau',
      'Pöstlingberg',
      'Puchenau',
      'Unterpuchenau',
    ],
  },
  {
    postleitzahl: 4050,
    orte: ['Neubau', 'Oedt', 'Sankt Dionysen', 'Sankt Martin', 'Traun'],
  },
  {
    postleitzahl: 4052,
    orte: [
      'Ansfelden',
      'Audorf',
      'Fleckendorf',
      'Freindorf',
      'Fürhappen',
      'Grabwinkel',
      'Kremsdorf',
      'Linz',
      'Vordermayrberg',
    ],
  },
  {
    postleitzahl: 4053,
    orte: [
      'Berg',
      'Haid',
      'Kremsdorf',
      'Moos',
      'Nettingsdorf',
      'Neuhofen an der Krems',
      'Rapperswinkel',
      'Weißenberg',
    ],
  },
  {
    postleitzahl: 4055,
    orte: [
      'Dörfl',
      'Hasenufer',
      'Köttsdorf',
      'Oberschnadt',
      'Pucking',
      'Sammersdorf',
      'Sankt Leonhard',
      'Sipbach',
      'Unterschnadt',
      'Zeitlham',
    ],
  },
  {
    postleitzahl: 4060,
    orte: [
      'Aichberg',
      'Alharting',
      'Berg',
      'Bergham',
      'Buchberg',
      'Doppl',
      'Enzenwinkl',
      'Felling',
      'Friesenegg',
      'Gaumberg',
      'Haag',
      'Hart',
      'Holzheim',
      'Imberg',
      'Jetzing',
      'Leonding',
      'Reith',
      'Rufling',
      'Sankt Isidor',
      'Staudach',
      'Untergaumberg',
      'Wilhering',
    ],
  },
  {
    postleitzahl: 4061,
    orte: [
      'Aistental',
      'Hitzing',
      'Langholzfeld',
      'Pasching',
      'Rufling',
      'Thurnharting',
      'Wagram',
    ],
  },
  {
    postleitzahl: 4062,
    orte: [
      'Aichberg',
      'Au',
      'Axberg',
      'Gumpolding',
      'Intenham',
      'Kirchberg',
      'Niederbuch',
      'Niederfeld',
      'Schauersfreiling',
      'Thening',
      'Thürnau',
    ],
  },
  {
    postleitzahl: 4063,
    orte: [
      'Aistental',
      'Breitbrunn',
      'Frindorf',
      'Gerersdorf',
      'Haid',
      'Holzleiten',
      'Hörsching',
      'Lindenlach',
      'Neubau',
      'Öhndorf',
      'Rudelsdorf',
      'Rutzing',
    ],
  },
  {
    postleitzahl: 4064,
    orte: [
      'Freiling',
      'Hausleiten',
      'Kirchstetten',
      'Mitterbachham',
      'Niederbachham',
      'Oberbachham',
      'Oberbuch',
      'Oberndorf',
      'Oftering',
      'Staudach',
      'Trindorf',
      'Unterholz',
    ],
  },
  {
    postleitzahl: 4070,
    orte: [
      'Altau',
      'Au bei Brandstatt',
      'Au bei hohen Steg',
      'Auhof',
      'Brandstatt',
      'Deinham',
      'Eferding',
      'Fraham',
      'Friedlau',
      'Goldenberg',
      'Grüben',
      'Gstocket',
      'Gstöttenau',
      'Güttlfeld',
      'Hartkirchen',
      'Hinzenbach',
      'Hörstorf',
      'Inn',
      'Kalköfen',
      'Kappelding',
      'Kleinstroheim',
      'Lahöfen',
      'Leumühle',
      'Limberg',
      'Oberhillinglah',
      'Oberrudling',
      'Oberschaden',
      'Polsenz',
      'Puchet',
      'Pupping',
      'Raffelding',
      'Ranzing',
      'Seebach',
      'Simbach',
      'Sperneck',
      'Stieglhöfen',
      'Taubenbrunn',
      'Trattwörth',
      'Unterhillinglah',
      'Unterleiten',
      'Unterrudling',
      'Unterschaden',
      'Wackersbach',
      'Wagrein',
      'Waschpoint',
      'Wörth',
    ],
  },
  {
    postleitzahl: 4072,
    orte: [
      'Aham',
      'Alkoven',
      'Annaberg',
      'Bergham',
      'Emling',
      'Forst',
      'Großhart',
      'Gstocket',
      'Hartheim',
      'Kleinhart',
      'Kranzing',
      'Oberhartheim',
      'Polsing',
      'Puchham',
      'Staudach',
      'Straß',
      'Straßham',
      'Ufer',
      'Weidach',
      'Winkeln',
    ],
  },
  {
    postleitzahl: 4073,
    orte: [
      'Appersberg',
      'Dörnbach',
      'Edramsberg',
      'Fall',
      'Hitzing',
      'Höf',
      'Katzing',
      'Lohnharting',
      'Mühlbach',
      'Reith',
      'Schönering',
      'Thalham',
      'Ufer',
      'Wilhering',
      'Winkeln',
    ],
  },
  {
    postleitzahl: 4074,
    orte: [
      'Birihub',
      'Gmeinholz',
      'Götzenberg',
      'Großstroheim',
      'Gstocket',
      'Kleinstroheim',
      'Knieparz ob der Leiten',
      'Kobling',
      'Mayrhof',
      'Mitterstroheim',
      'Reith',
      'Schaumberg',
      'Schnellersdorf',
      'Stallberg',
      'Stroheim',
      'Taubing',
      'Troß',
      'Windischdorf',
      'Wögern',
    ],
  },
  {
    postleitzahl: 4075,
    orte: ['Aumühle', 'Steinholz'],
  },
  {
    postleitzahl: 4076,
    orte: [
      'Doppl',
      'Eben',
      'Fürneredt',
      'Furth',
      'Holzwiesen',
      'Karling',
      'Kirchholz',
      'Lengau',
      'Leopoldsberg',
      'Obergrub',
      'Pernau',
      'Polsenz',
      'Sankt Marienkirchen an der Polsenz',
      'Sommersberg',
      'Unterfreundorf',
      'Untergrub',
      'Valtau',
      'Wieshof',
    ],
  },
  {
    postleitzahl: 4081,
    orte: [
      'Deinham',
      'Dorf',
      'Dunzing',
      'Gfehret',
      'Gstaltenhof',
      'Hachlham',
      'Hacking',
      'Hainbach',
      'Haizing',
      'Hart ob Hacking',
      'Hart ob Haizing',
      'Hartkirchen',
      'Hilkering',
      'Hinteraigen',
      'Hinterberg',
      'Hörmannsedt',
      'Karling',
      'Kellnering',
      'Knieparz unter der Leithen',
      'Koppl',
      'Lacken',
      'Mußbach',
      'Oed in Bergen',
      'Paching',
      'Pfaffing',
      'Poxham',
      'Rathen',
      'Reith',
      'Rienberg',
      'Schaumberg',
      'Schönleiten',
      'Senghübl',
      'Steinwand',
      'Vornholz',
      'Wolfsfurth',
      'Würting',
      'Zagl',
    ],
  },
  {
    postleitzahl: 4082,
    orte: ['Aschach an der Donau', 'Ruprechting', 'Sommerberg'],
  },
  {
    postleitzahl: 4083,
    orte: [
      'Au',
      'Bach',
      'Bäckenhof',
      'Berg',
      'Donauleiten',
      'Dorf',
      'Dunzing',
      'Eckersdorf',
      'Gemersdorf',
      'Grub',
      'Haibach ob der Donau',
      'Hinterberg',
      'Inzell',
      'Kobling',
      'Kolleck',
      'Komas',
      'Lehen',
      'Linetshub',
      'Mannsdorf',
      'Mitterberg',
      'Moos',
      'Mühlbach',
      'Obergschwendt',
      'Oberhub',
      'Oedt',
      'Pamet',
      'Parz',
      'Pichl',
      'Pühret',
      'Reith',
      'Rennersdorf',
      'Schauerdoppl',
      'Schlögen',
      'Schlögenleiten',
      'Sieberstal',
      'Sonnleiten',
      'Starz',
      'Untergschwendt',
      'Wies',
      'Wiesing',
    ],
  },
  {
    postleitzahl: 4084,
    orte: [
      'Bäckenhof',
      'Bräuleiten',
      'Dittersdorf',
      'Dörfledt',
      'Dunzing',
      'Ensfeld',
      'Ernleiten',
      'Etzing',
      'Freiling',
      'Gmein',
      'Götzling',
      'Gschwendt',
      'Hanging',
      'Hatzing',
      'Hausleithen',
      'Henzing',
      'Hollerbrunn',
      'Hölzing',
      'Holzwühr',
      'Hundsdorf',
      'Kolmhof',
      'Königsdorf',
      'Kropfleiten',
      'Löcking',
      'Löwengrub',
      'Miniberg',
      'Mitterberg',
      'Mühlgraben',
      'Parz',
      'Pötzling',
      'Riesching',
      'Sattlberg',
      'Schabetsberg',
      'Scharzeredt',
      'Scheiblberg',
      'Schmieding',
      'Sonnleiten',
      'St. Agatha',
      'Steinzen',
      'Uring',
      'Waid',
    ],
  },
  {
    postleitzahl: 4085,
    orte: [
      'Aichberg',
      'Atzersdorf',
      'Au',
      'Buchen',
      'Dankmairing',
      'Edt',
      'Erledt',
      'Freizell',
      'Graben',
      'Hundorf',
      'Kager',
      'Kling',
      'Kramesau',
      'Kühdoppl',
      'Mühlberg',
      'Niederranna',
      'Oberngrub',
      'Ort',
      'Pasching',
      'Ratzling',
      'Saulehen',
      'Schickedt',
      'Schützenedt',
      'Sittling',
      'Straß',
      'Voredt',
      'Vornwald',
      'Waldbach',
      'Waldkirchen',
      'Wesenufer',
      'Wimm',
    ],
  },
  {
    postleitzahl: 4090,
    orte: [
      'Engelhartszell',
      'Engelszell',
      'Kronschlag',
      'Maierhof',
      'Oberranna',
      'Ronthal',
      'Saag',
      'Stadl',
    ],
  },
  {
    postleitzahl: 4091,
    orte: ['Aug', 'Höll', 'Kasten', 'Rain', 'Vichtenstein', 'Wenzelberg'],
  },
  {
    postleitzahl: 4092,
    orte: [
      'Achleiten',
      'Aug',
      'Dietzendorf',
      'Esternberg',
      'Gersdorf',
      'Hütt',
      'Kiesling',
      'Kösslarn',
      'Lanzendorf',
      'Pfarrhof',
      'Pyrawang',
      'Reisdorf',
      'Riedlbach',
      'Ringlholz',
      'Schacher',
      'Schörgeneck',
      'Silbering',
      'Unteresternberg',
      'Urschendorf',
      'Weeg',
      'Wetzendorf',
      'Winterhof',
      'Zeilberg',
    ],
  },
  {
    postleitzahl: 4100,
    orte: [
      'Amberg',
      'Dürnberg',
      'Großamberg',
      'Höflein',
      'Niederottensheim',
      'Ottensheim',
      'Schlagberg',
      'Weingarten',
    ],
  },
  {
    postleitzahl: 4101,
    orte: [
      'Ach',
      'Au',
      'Audorf',
      'Bad Mühllacken',
      'Bergheim',
      'Feldkirchen an der Donau',
      'Freudenstein',
      'Gerling',
      'Hofham',
      'Lacken',
      'Mühldorf',
      'Mühlholz',
      'Oberhart',
      'Oberlandshaag',
      'Oberndorf',
      'Oberstraß',
      'Oberwallsee',
      'Pesenbach',
      'Rosenleiten',
      'Unterhart',
      'Unterlandshaag',
      'Vogging',
      'Weidet',
    ],
  },
  {
    postleitzahl: 4102,
    orte: ['Goldwörth', 'Hagenau'],
  },
  {
    postleitzahl: 4111,
    orte: ['Hamberg', 'Walding'],
  },
  {
    postleitzahl: 4112,
    orte: [
      'Eschelberg',
      'Grasbach',
      'Haselwies',
      'Limberg',
      'Maierleiten',
      'Mühlholz',
      'Oberstraß',
      'Rottenegg',
      'St. Gotthard im Mühlkreis',
      'Wieshof',
    ],
  },
  {
    postleitzahl: 4113,
    orte: [
      'Adsdorf',
      'Allersdorf',
      'Anzing',
      'Dunzendorf',
      'Erdmannsdorf',
      'Falkenbach',
      'Gerling',
      'Grub',
      'Kobling',
      'Lanzersdorf',
      'Mahring',
      'Oberhart',
      'Oberlandshaag',
      'Reith',
      'Ritzersdorf',
      'Sankt Martin im Mühlkreis',
      'Unterhart',
      'Windischberg',
      'Windorf',
    ],
  },
  {
    postleitzahl: 4114,
    orte: [
      'Exlau',
      'Falkenbach',
      'Falkenberg',
      'Neuhaus an der Donau',
      'Partenstein',
      'Plöcking',
      'Point',
      'Steining',
      'Untermühl',
    ],
  },
  {
    postleitzahl: 4115,
    orte: [
      'Am Edhügel',
      'Apfelsbach',
      'Edholz',
      'Edwiese',
      'Grünental',
      'Gumpesberg',
      'Kleinzell im Mühlkreis',
      'Ramersberg',
      'Steining',
      'Weigelsdorf',
      'Zaun',
    ],
  },
  {
    postleitzahl: 4116,
    orte: [
      'Bairach',
      'Baumgartsau',
      'Hötzeneck',
      'Pehersdorf',
      'Sankt Ulrich im Mühlkreis',
      'Simaden',
    ],
  },
  {
    postleitzahl: 4120,
    orte: [
      'Etzleinsberg',
      'Graben',
      'Langhalsen',
      'Neufelden',
      'Oberfeuchtenbach',
      'Plankenberg',
      'Pürnstein',
      'Schörgenhub',
      'Steinbruch',
      'Unterfeuchtenbach',
      'Unternberg',
      'Witzersdorf',
    ],
  },
  {
    postleitzahl: 4121,
    orte: [
      'Altenfelden',
      'Atzesberg',
      'Blumau',
      'Doppl',
      'Fraunschlag',
      'Freileben',
      'Godersdorf',
      'Haselbach',
      'Hörhag',
      'Hühnergeschrei',
      'Krondorf',
      'Langhalsen',
      'Mairhof',
      'Neufelden',
      'Neundling',
      'Oberfeuchtenbach',
      'Panholz',
      'Partenreit',
      'Starling',
      'Starz',
      'Steinerberg',
      'Stierberg',
      'Unteredt',
      'Unterfeuchtenbach',
      'Weigert',
      'Wollmannsberg',
    ],
  },
  {
    postleitzahl: 4122,
    orte: [
      'Arnreit',
      'Daim',
      'Eckersberg',
      'Etzerreit',
      'Getzing',
      'Hengstschlag',
      'Högling',
      'Hölling',
      'Humenberg',
      'Iglbach',
      'Katzenbach',
      'Liebenstein',
      'Moosham',
      'Schönberg',
      'Schörsching',
      'Stierberg',
      'Untergahleiten',
      'Wippling',
    ],
  },
  {
    postleitzahl: 4131,
    orte: [
      'Dorf',
      'Ebersdorf',
      'Graben',
      'Grafenau',
      'Grub',
      'Gumpesberg',
      'Haar',
      'Haiden',
      'Kirchberg ob der Donau',
      'Mayrhof',
      'Obermühl an der Donau',
      'Seibersdorf',
      'Stieberberg',
      'Windhag',
      'Winzberg',
      'Witzersdorf',
      'Wölfling',
      'Wolkersdorf',
    ],
  },
  {
    postleitzahl: 4132,
    orte: [
      'Atzesberg',
      'Außerhötzendorf',
      'Eiglersdorf',
      'Feichten',
      'Graben',
      'Hörbich',
      'Lampersdorf',
      'Lembach im Mühlkreis',
      'Lug',
      'Mayrhof',
      'Oberlembach',
      'Obernort',
      'Raiden',
      'Römersdorf',
      'Starz',
      'Steining',
      'Tannberg',
      'Volkersdorf',
    ],
  },
  {
    postleitzahl: 4133,
    orte: [
      'Amersdorf',
      'Dorf',
      'Grafenau',
      'Haar',
      'Harrau',
      'Kaindlsdorf',
      'Kleinobernberg',
      'Klotzing',
      'Lampersdorf',
      'Niederbumberg',
      'Niederkappel',
      'Oberbumberg',
      'Obernberg',
      'Rumersdorf',
      'Weikersdorf',
      'Witzersdorf',
    ],
  },
  {
    postleitzahl: 4134,
    orte: [
      'Berg bei Mairing',
      'Daglesbach',
      'Ebrasdorf',
      'Egnersdorf',
      'Glotzing',
      'Kaindlsdorf',
      'Kramsreith',
      'Krien',
      'Kronewittet',
      'Männersdorf',
      'Moos',
      'Neundling',
      'Ollerndorf',
      'Pernersdorf',
      'Putzleinsdorf',
      'Starz',
      'Streinesberg',
      'Vernatzgersdorf',
      'Wögerstorf',
      'Wulln',
    ],
  },
  {
    postleitzahl: 4141,
    orte: [
      'Atzgersdorf',
      'Berg bei Hamet',
      'Erdmannsdorf',
      'Haag',
      'Hamet',
      'Harrau',
      'Hinterleithen',
      'Hochetting',
      'Irnezedt',
      'Kleinstifting',
      'Krien',
      'Mairing',
      'Ollerndorf',
      'Pfarrkirchen im Mühlkreis',
      'Pollmannsdorf',
      'Scharten',
      'Schlag',
      'Schrattendoppel',
      'Spielleiten',
      'Starnberg',
      'Steinstraß',
      'Waldhäusl',
      'Weberschlag',
      'Wehrbach',
      'Wernersdorf',
      'Wurzwoll',
    ],
  },
  {
    postleitzahl: 4142,
    orte: [
      'Altenhof',
      'Eilmannsberg',
      'Emmerstorf',
      'Falkenhof',
      'Falkenstein',
      'Gerastorf',
      'Hochhaus',
      'Hofkirchen im Mühlkreis',
      'Hötzendorf',
      'Hundsfülling',
      'Marsbach',
      'Mühlholz',
      'Ratzesberg',
      'Wiesen',
    ],
  },
  {
    postleitzahl: 4143,
    orte: [
      'Dorf',
      'Eitzendorf',
      'Forstedt',
      'Großmollsberg',
      'Grub',
      'Haitzendorf',
      'Kleinmollsberg',
      'Maisreith',
      'Neustift im Mühlkreis',
      'Oberaschenberg',
      'Pühret',
      'Rannariedl',
      'Steinlacken',
      'Unteraschenberg',
    ],
  },
  {
    postleitzahl: 4144,
    orte: [
      'Albernberg',
      'Amesedt',
      'Dittmannsdorf',
      'Grettenbach',
      'Grubberg',
      'Hallschlag',
      'Hochödt',
      'Kaffring',
      'Karlsbach',
      'Konzing',
      'Oberkappel',
      'Osterwasser',
      'Pernerstorf',
      'Unholnedt',
      'Vatersreith',
      'Weberschlag',
      'Zanklbach',
      'Zinöck',
    ],
  },
  {
    postleitzahl: 4150,
    orte: [
      'Altenhofen',
      'Arbesberg',
      'Autengrub',
      'Berg',
      'Dobretshofen',
      'Fraundorf',
      'Frindorf',
      'Fürling',
      'Gattergaßling',
      'Gierling',
      'Gintersberg',
      'Gollner',
      'Grub',
      'Harrau',
      'Hauzenberg',
      'Hehenberg',
      'Hintring',
      'Hundbrenning',
      'Katzing',
      'Keppling',
      'Krien',
      'Lanzerstorf',
      'Märzing',
      'Neundling',
      'Nößlbach',
      'Perwolfing',
      'Reith',
      'Rohrbach',
      'Scheiblberg',
      'Schönberg',
      'Sexling',
      'Sprinzenstein',
      'Steineck',
      'Wandschaml',
    ],
  },
  {
    postleitzahl: 4151,
    orte: [
      'Berlesreith',
      'Dobretshofen',
      'Götzendorf',
      'Gumpenberg',
      'Gumpenmühle',
      'Haugsberg',
      'Kanten',
      'Kimmerting',
      'Liebetsberg',
      'Marbach',
      'Oberfischbach',
      'Obergahleiten',
      'Obergrünau',
      'Obermayrhof',
      'Oberneudorf',
      'Oepping',
      'Peherstorf',
      'Pitretsberg',
      'Rumerstorf',
      'Salaberg',
      'Unterfischbach',
      'Untergrünau',
    ],
  },
  {
    postleitzahl: 4152,
    orte: [
      'Altendorf',
      'Atzesberg',
      'Auerbach',
      'Dorf',
      'Eilmannsberg',
      'Fuchsberg',
      'Fürling',
      'Graben',
      'Hennerbach',
      'Hohenschlag',
      'Hörbich',
      'Innerhötzendorf',
      'Innerödt',
      'Kaffring',
      'Kickingerödt',
      'Kielesreith',
      'Krondorf',
      'Lämmerstorf',
      'Leiten',
      'Mairhof',
      'Meising',
      'Meisingerödt',
      'Mitternschlag',
      'Mühel',
      'Obernreith',
      'Oberpeilstein',
      'Ohnerstorf',
      'Pfaffenberg',
      'Pogendorf',
      'Poppen',
      'Rutzersdorf',
      'Sankt Leonhard',
      'Sarleinsbach',
      'Schinken',
      'Schölling',
      'Schwand',
      'Unternreith',
      'Weißgraben',
      'Wintersberg',
      'Wolf',
      'Wollerdorf',
    ],
  },
  {
    postleitzahl: 4153,
    orte: [
      'Berging',
      'Danneredt',
      'Diendorf',
      'Emsmannsreit',
      'Eschernhof',
      'Exenschlag',
      'Flatting',
      'Geretschlag',
      'Humeredt',
      'Kicking',
      'Kirchbach',
      'Martschlag',
      'Niederkraml',
      'Oberpeilstein',
      'Peilstein im Mühlviertel',
      'Rampetzreit',
      'Schönberg',
      'Steinberg',
      'Stierberg',
      'Vorderschiffl',
      'Vorderschlag',
      'Vordorf',
      'Weixelbaum',
    ],
  },
  {
    postleitzahl: 4154,
    orte: [
      'Albenödt',
      'Fuchsödt',
      'Hanging',
      'Haselbach',
      'Kollerschlag',
      'Lamprechtswiesen',
      'Lengau',
      'Mistlberg',
      'Mollmannsreith',
      'Raschau',
      'Sauedt',
      'Schöffgattern',
      'Schröck',
      'Stratberg',
    ],
  },
  {
    postleitzahl: 4155,
    orte: [
      'Heinrichsberg',
      'Hinterschiffl',
      'Nebelberg',
      'Stift am Grenzbach',
      'Vordernebelberg',
    ],
  },
  {
    postleitzahl: 4160,
    orte: [
      'Aigen im Mühlkreis',
      'Baureith',
      'Breitenstein',
      'Diendorf',
      'Geiselreith',
      'Grünwald',
      'Kerschbaum',
      'Natschlag',
      'Rudolfing',
      'Sankt Wolfgang',
      'Schindlau',
      'Schlägl',
      'Unterneudorf',
      'Weichsberg',
      'Winkl',
      'Wurmbrand',
      'Zaglau',
    ],
  },
  {
    postleitzahl: 4161,
    orte: [
      'Berdetschlag',
      'Dietrichschlag',
      'Erlet',
      'Fuchslug',
      'Hintenberg',
      'Kandlschlag',
      'Lichtenberg',
      'Mühlwald',
      'Ödenkirchen',
      'Salnau',
      'Schöneben',
      'Seitelschlag',
      'Sonnenwald',
      'Stangl',
      'Stollnberg',
      'Ulrichsberg',
    ],
  },
  {
    postleitzahl: 4162,
    orte: [
      'Bräuerau',
      'Hinterschiffl',
      'Hinterschlag',
      'Hochkraml',
      'Julbach',
      'Kriegwald',
      'Leithen',
      'Oberthiergrub',
      'Präuer',
      'Sagberg',
      'Seitelschlag',
      'Unterthiergrub',
    ],
  },
  {
    postleitzahl: 4163,
    orte: [
      'Freundorf',
      'Holzschlag',
      'Klaffer am Hochficht',
      'Panidorf',
      'Pfaffetschlag',
      'Schönberg',
      'Schwarzenberg am Böhmerwald',
      'Seitelschlag',
      'Vorderanger',
    ],
  },
  {
    postleitzahl: 4164,
    orte: ['Hinteranger', 'Schwarzenberg am Böhmerwald'],
  },
  {
    postleitzahl: 4170,
    orte: [
      'Almesberg',
      'Auberg',
      'Dambergschlag',
      'Damreith',
      'Felberau',
      'Frindorf',
      'Gmain',
      'Günterreith',
      'Haid',
      'Hartmannsdorf',
      'Haslach an der Mühl',
      'Herrnschlag',
      'Hinternberg',
      'Hochhausen',
      'Hörleinsödt',
      'Innenschlag',
      'Jaukenberg',
      'Keppling',
      'Laimbach',
      'Lichtenau im Mühlkreis',
      'Minihof',
      'Morau',
      'Neudorf',
      'Nößlbach',
      'Oberafiesl',
      'Obereben',
      'Oberriedl',
      'Oedt',
      'Raiden',
      'Sankt Oswald bei Haslach',
      'Sankt Stefan am Walde',
      'Sattling',
      'Schwackerreith',
      'Spielleiten',
      'Untereben',
      'Unterriedl',
      'Unterurasch',
    ],
  },
  {
    postleitzahl: 4171,
    orte: [
      'Auberg',
      'Dorf',
      'Eckerstorf',
      'Engersdorf',
      'Habring',
      'Harafl',
      'Hehenberg',
      'Hollerberg',
      'Iglbach',
      'Kasten',
      'Marbach',
      'Sankt Peter am Wimberg',
      'Simaden',
      'Strass',
      'Unterriedl',
      'Uttendorf',
    ],
  },
  {
    postleitzahl: 4172,
    orte: [
      'Penning',
      'Petersberg',
      'Sankt Johann am Wimberg',
      'Schlag',
      'Sichersdorf',
      'Steinbach',
      'Windhag',
    ],
  },
  {
    postleitzahl: 4173,
    orte: [
      'Grubdorf-Siedlung',
      'Grubdorf',
      'Haslhof',
      'Kepling',
      'Königsdorf',
      'Rammerstorf',
      'Rechberg',
      'Schindlberg',
      'St. Veit im Mühlkreis',
      'Windhag',
      'Wögersdorf',
    ],
  },
  {
    postleitzahl: 4174,
    orte: [
      'Allersdorf',
      'Baumgartsau',
      'Drautendorf',
      'Haslhof',
      'Koth',
      'Niederwaldkirchen',
      'Steinbach',
      'Uttendorf',
      'Witzersdorf',
      'Wolkersdorf',
      'Zeißendorf',
    ],
  },
  {
    postleitzahl: 4175,
    orte: [
      'Anzing',
      'Bogendorf',
      'Buchholz',
      'Eidendorf',
      'Felsleiten',
      'Freilassing',
      'Gaisberg',
      'Gerling',
      'Grasbach',
      'Herzogsdorf',
      'Hilkering',
      'Hofing',
      'Koth',
      'Mahring',
      'Mühlholz',
      'Neudorf',
      'Neußerling',
      'Oberwallsee',
      'Rammerstorf',
      'Stamering',
      'Stötten',
      'Wigretsberg',
    ],
  },
  {
    postleitzahl: 4180,
    orte: [
      'Dreiegg',
      'Glashütten',
      'Innernschlag',
      'Langzwettl',
      'Rudersbach',
      'Saumstraß',
      'Schauerleithen',
      'Schauerschlag',
      'Sonnberg',
      'Straß',
      'Zwettl an der Rodl',
    ],
  },
  {
    postleitzahl: 4181,
    orte: [
      'Amesschlag',
      'Fuchsgraben',
      'In der Au',
      'Innernschlag',
      'Königsberg',
      'Lobenstein',
      'Mitterfeld',
      'Neudorf',
      'Oberneukirchen',
      'Reindlsedt',
      'Schaffetschlag',
      'Schauerschlag',
      'Teichfeld',
      'Unterwaldschlag',
    ],
  },
  {
    postleitzahl: 4182,
    orte: [
      'Froschau',
      'Höf',
      'Königsdorf',
      'Punzing',
      'Reindlsedt',
      'Schallenberg',
      'Waxenberg',
      'Wögersdorf',
    ],
  },
  {
    postleitzahl: 4183,
    orte: [
      'Ahorn',
      'Kleintraberg',
      'Lichtmeßberg',
      'Mitterbrunnwald',
      'Oberbrunnwald',
      'Obertraberg',
      'Oberwaldschlag',
      'Traberg',
      'Unterbrunnwald',
      'Unterwaldschlag',
    ],
  },
  {
    postleitzahl: 4184,
    orte: [
      'Ahorn',
      'Altenschlag',
      'Auhäuser',
      'Dobring',
      'Geierschlag',
      'Helfenberg',
      'Köckendorf',
      'Mühlholz',
      'Neuling',
      'Neuschlag',
      'Oberafiesl',
      'Penning',
      'Piberschlag',
      'Piberstein',
      'Preßleithen',
      'Spanfeld',
      'Thurnerschlag',
      'Unterafiesl',
      'Untereben',
      'Waldhäuser',
    ],
  },
  {
    postleitzahl: 4190,
    orte: [
      'Affetschlag',
      'Amesberg',
      'Amesschlag',
      'Bad Leonfelden',
      'Böheimschlag',
      'Brunnwald',
      'Burgfried',
      'Dietrichschlag',
      'Dürnau',
      'Elmegg',
      'Farb',
      'Haid',
      'Langbruck',
      'Oberlaimbach',
      'Oberstern',
      'Oberstiftung',
      'Ortschlag',
      'Rading',
      'Roßberg',
      'Schönau',
      'Silberhartschlag',
      'Spielau',
      'Unterlaimbach',
      'Unterstern',
      'Unterstiftung',
      'Weigetschlag',
      'Weinzierl',
    ],
  },
  {
    postleitzahl: 4191,
    orte: [
      'Amesschlag',
      'Bernhardschlag',
      'Eberhardschlag',
      'Gaisschlag',
      'Geierschlag',
      'Guglwald',
      'Hinterweißenbach',
      'Schönegg',
      'Stumpten',
      'Vorderweißenbach',
    ],
  },
  {
    postleitzahl: 4192,
    orte: [
      'Hinterkönigschlag',
      'Lichtenstein',
      'Liebenschlag',
      'Oberdorf',
      'Schenkenfelden',
      'Schild',
      'Steinschild',
      'Thierberg',
      'Vorderkönigschlag',
    ],
  },
  {
    postleitzahl: 4193,
    orte: [
      'Allhut',
      'Böhmdorf',
      'Hayrl',
      'Kohlgrub',
      'Liebenthal',
      'Miesenbach',
      'Niederreichenthal',
      'Prechtleinschlag',
      'Reichenthal',
      'Schöndorf',
      'Schwarzenbach',
      'Stiftung',
      'Thierberg',
      'Vierhöf',
    ],
  },
  {
    postleitzahl: 4201,
    orte: [
      'Amberg',
      'Anger',
      'Aschlberg',
      'Berndorf',
      'Edt',
      'Eidenberg',
      'Feldsdorf',
      'Felsleiten',
      'Gramastetten',
      'Hals',
      'Hamberg',
      'Innernschlag',
      'Kammerschlag',
      'Kronabitedt',
      'Lassersdorf',
      'Lichtenhag',
      'Limberg',
      'Maierleiten',
      'Mühlberg',
      'Obergeng',
      'Schiefegg',
      'Staubgasse',
      'Stötten',
      'Türkstetten',
      'Untergeng',
      'Wieshof',
    ],
  },
  {
    postleitzahl: 4202,
    orte: [
      'Albrechtschlag',
      'Althellmonsödt',
      'Auedt',
      'Davidschlag',
      'Eben',
      'Eckartsbrunn',
      'Geitenedt',
      'Hellmonsödt',
      'Hochbuchedt',
      'Kelzendorf',
      'Kirchschlag bei Linz',
      'Kronabittedt',
      'Oberaigen',
      'Pelmberg',
      'Riedl',
      'Rohrach',
      'Rudersbach',
      'Schiefegg',
      'Sonnberg',
      'Stratreith',
      'Strich',
      'Weberndorf',
      'Weignersdorf',
      'Wildberg',
    ],
  },
  {
    postleitzahl: 4203,
    orte: [
      'Altenberg bei Linz',
      'Donach',
      'Edt',
      'Haslach',
      'Katzgraben',
      'Kitzelsbach',
      'Kulm',
      'Niederbairing',
      'Niederwinkl',
      'Oberbairing',
      'Oberkulm',
      'Oberweitrag',
      'Oberwinkl',
      'Pargfried',
      'Preising',
      'Ramersdorf',
      'Schwarzendorf',
      'Stratreith',
      'Unterweitrag',
      'Weignersedt',
      'Willersdorf',
      'Windpassing',
      'Würschendorf',
    ],
  },
  {
    postleitzahl: 4204,
    orte: [
      'Affenberg',
      'Aigen',
      'Altenbergerstraße',
      'Baumgarten',
      'Blaßberg',
      'Gusental',
      'Habruck',
      'Hadersdorf',
      'Haibach im Mühlkreis',
      'Helmetzedt',
      'Kaindorf',
      'Mistelbach',
      'Oberbaumgarten',
      'Ottenschlag im Mühlkreis',
      'Puchberg',
      'Ramberg',
      'Reichenau im Mühlkreis',
      'Renning',
      'Rohrbach',
      'Schubertweg',
      'Wintersdorf',
      'Wirth',
      'Zeil',
    ],
  },
  {
    postleitzahl: 4209,
    orte: [
      'Aigen',
      'Amberg',
      'Au',
      'Außertreffling',
      'Bach',
      'Edtsdorf',
      'Engerwitzberg',
      'Engerwitzdorf',
      'Gallusberg',
      'Gratz',
      'Haid',
      'Hohenstein',
      'Holzwiesen',
      'Innertreffling',
      'Klendorf',
      'Langwiesen',
      'Linzerberg',
      'Mittertreffling',
      'Niederkulm',
      'Niederreitern',
      'Niederthal',
      'Oberreichenbach',
      'Oberthal',
      'Schmiedgassen',
      'Schweinbach',
      'Steinreith',
      'Unterreichenbach',
      'Wolfing',
      'Zinngießing',
    ],
  },
  {
    postleitzahl: 4210,
    orte: ['Gallneukirchen', 'Niederkulm', 'Oberkulm', 'Unterweitrag'],
  },
  {
    postleitzahl: 4211,
    orte: [
      'Aich',
      'Alberndorf in der Riedmark',
      'Almesberg',
      'Berbersdorf',
      'Gerbersdorf',
      'Grasbach',
      'Greifenberg',
      'Hadersdorf',
      'Heinberg',
      'Hirschstein',
      'Kelzendorf',
      'Klamleiten',
      'Kottingersdorf',
      'Lindach',
      'Loitzendorf',
      'Luegstetten',
      'Matzelsdorf',
      'Oberndorf',
      'Oberweitersdorf',
      'Pröselsdorf',
      'Ramersdorf',
      'Riedegg',
      'Rinzendorf',
      'Schallersdorf',
      'Schlammersdorf',
      'Spattendorf',
      'Steinbach',
      'Traidendorf',
      'Veitsdorf',
      'Weikersdorf',
      'Zeurz',
    ],
  },
  {
    postleitzahl: 4212,
    orte: [
      'Achleiten',
      'Albingdorf',
      'Au',
      'Baumgarten',
      'Dingdorf',
      'Galgenau',
      'Götschka',
      'Kronast',
      'Lamm',
      'Lest',
      'Matzelsdorf',
      'Möhringdorf',
      'Neumarkt im Mühlkreis',
      'Oberzeiß',
      'Pernau',
      'Pfaffendorf',
      'Rudersdorf',
      'Sallersdorf',
      'Schall',
      'Schallersdorf',
      'Schiernersdorf',
      'Schwandtendorf',
      'Steigersdorf',
      'Stiftung',
      'Traidendorf',
      'Trölsberg',
      'Trosselsdorf',
      'Unterzeiß',
      'Willingdorf',
      'Zissingdorf',
    ],
  },
  {
    postleitzahl: 4213,
    orte: [
      'Bergen',
      'Gauschitzberg',
      'Hattmannsdorf',
      'Loibersdorf',
      'Radingdorf',
      'Reitern',
      'Unterweitersdorf',
      'Wögern',
    ],
  },
  {
    postleitzahl: 4221,
    orte: [
      'Götzelsdorf',
      'Hasenberg',
      'Holzwinden',
      'Lachstatt',
      'Pulgarn',
      'Steyregg',
    ],
  },
  {
    postleitzahl: 4222,
    orte: [
      'Denneberg',
      'Frankenberg',
      'Gusen',
      'Langenstein',
      'Sankt Georgen an der Gusen',
      'Schörgendorf',
      'Stacherlsiedlung',
      'Weingraben',
      'Zottmann',
    ],
  },
  {
    postleitzahl: 4223,
    orte: [
      'Blindendorf',
      'Bodendorf',
      'Breitenbruck',
      'Edt',
      'Greinsberg',
      'Grünau',
      'Katsdorf',
      'Lungitz',
      'Neubodendorf',
      'Nöbling',
      'Reiser',
      'Rothof',
      'Ruhstetten',
      'Schörgendorf',
      'Schwarzendorf',
      'Standorf',
      'Weidegut',
    ],
  },
  {
    postleitzahl: 4224,
    orte: [
      'Altenhaus',
      'Arnberg',
      'Doberhagen',
      'Frensdorf',
      'Friensdorf',
      'Haag',
      'Hacklberg',
      'Im Bichl',
      'Klausmühle',
      'Klingenwehr',
      'Oberer Schlossberg',
      'Obergaisbach',
      'Obervisnitz',
      'Reitling',
      'Reitlingberg',
      'Ruhstetten',
      'Scheiben',
      'Schloss Haus',
      'Schlossberg',
      'Schönreith',
      'Steinpichl',
      'Türnberg',
      'Untere Reitling',
      'Untergaisbach',
      'Untervisnitz',
      'Wartberg ob der Aist',
      'Wolfsegg',
      'Zeilerberg',
    ],
  },
  {
    postleitzahl: 4225,
    orte: [
      'Abwinden',
      'Forst',
      'Gröbetsweg',
      'Knierübl',
      'Luftenberg',
      'Pürach',
      'Statzing',
      'Steining',
    ],
  },
  {
    postleitzahl: 4230,
    orte: [
      'Aist',
      'Burbach',
      'Gaisruckdorf',
      'Gmeinerhof',
      'Greising',
      'Greisingberg',
      'Grünbichl',
      'Hagenberg im Mühlkreis',
      'Halmenberg',
      'Hohensteg',
      'Kranzlgarten',
      'Kriechmayrdorf',
      'Meitschenhof',
      'Mistlberg',
      'Pregarten',
      'Pregartsdorf',
      'Reichenstein',
      'Selker',
      'Silberbach',
      'Wörgersdorf',
      'Zudersdorf',
    ],
  },
  {
    postleitzahl: 4232,
    orte: [
      'Anitzberg',
      'Hagenberg im Mühlkreis',
      'Mahrersdorf',
      'Niederaich',
      'Oberaich',
      'Penzendorf',
      'Schmidsberg',
      'Veichter',
    ],
  },
  {
    postleitzahl: 4240,
    orte: [
      'Am Berg',
      'Freistadt',
      'Freudenthal',
      'Galgenau',
      'Gunnersdorf',
      'Harruck',
      'Lahrndorf',
      'Lest',
      'Manzenreith',
      'Marreith',
      'Mitterreith',
      'Oberschwandt',
      'Reickersdorf',
      'Sankt Peter',
      'Stadtberg',
      'Trölsberg',
      'Unterschwandt',
      'Vierhöf',
      'Walchshof',
      'Waldburg',
      'Zelletau',
    ],
  },
  {
    postleitzahl: 4242,
    orte: [
      'Auerbach',
      'Berg',
      'Gossenreith',
      'Guttenbrunn',
      'Hirschbach im Mühlkreis',
      'Hofreith',
      'Kirchberg',
      'Oberhirschgraben',
      'Pemsedt',
      'Tischberg',
      'Unterhirschgraben',
      'Vorwald',
    ],
  },
  {
    postleitzahl: 4251,
    orte: [
      'Eben',
      'Größgstötten',
      'Gugu',
      'Hacklbrunn',
      'Hundsberg',
      'Königsau',
      'Neuhof',
      'Obermarreith',
      'Pürstling',
      'Rindlberg',
      'Rothenbachl',
      'Sandl',
      'Schönberg',
      'Steinkreuz',
      'Steinwald',
      'Tafelberg',
      'Viehberg',
      'Weinviertl',
    ],
  },
  {
    postleitzahl: 4252,
    orte: [
      'Eibenberg',
      'Geierschlag',
      'Glashütten',
      'Hirschau',
      'Kienau',
      'Liebenau',
      'Liebenstein',
      'Maxldorf',
      'Monegg',
      'Neustift',
      'Reitern',
      'Schanz',
      'Schöneben',
      'Windhagmühl',
    ],
  },
  {
    postleitzahl: 4261,
    orte: [
      'Apfoltern',
      'Dreißgen',
      'Eibenstein',
      'Helbetschlag',
      'Hörschlag',
      'Kerschbaum',
      'Labach',
      'Rainbach im Mühlkreis',
      'Sonnberg',
      'Stadln',
      'Stiftung',
      'Summerau',
      'Unterpaßberg',
      'Vierzehn',
      'Zulissen',
    ],
  },
  {
    postleitzahl: 4262,
    orte: [
      'Dorf Leopoldschlag',
      'Edlbruck',
      'Eisenhut',
      'Hammern',
      'Hiltschen',
      'Leitmannsdorf',
      'Mardetschlag',
      'Markt Leopoldschlag',
      'Pramhöf',
      'Stiegersdorf',
      'Wullowitz',
    ],
  },
  {
    postleitzahl: 4263,
    orte: [
      'Elmberg',
      'Freiwalddorf',
      'Mairspindt',
      'Obernschlag',
      'Oberpaßberg',
      'Oberwindhaag',
      'Pieberschlag',
      'Plochwald',
      'Predetschlag',
      'Prendt',
      'Riemetschlag',
      'Spörbichl',
      'Unterwald',
      'Windhaag bei Freistadt',
    ],
  },
  {
    postleitzahl: 4264,
    orte: [
      'Grünbach',
      'Heinrichschlag',
      'Helbetschlag',
      'Lichtenau',
      'Mitterbach',
      'Oberrauchenödt',
      'Schlag',
      'Unterrauchenödt',
    ],
  },
  {
    postleitzahl: 4271,
    orte: [
      'Amesreith',
      'Etzelsdorf',
      'Florenthein',
      'Fünfling',
      'March',
      'Mayrhöfen',
      'Neudorf',
      'Obermarreith',
      'Oberreitern',
      'Piberschlag',
      'Reickersdorf',
      'Rosenau',
      'Sankt Oswald bei Freistadt',
      'Stiftungsberg',
      'Untermarreith',
      'Unterrauchenödt',
      'Wartberg',
      'Wippl',
      'Witzelsberg',
    ],
  },
  {
    postleitzahl: 4272,
    orte: [
      'Eipoldschlag',
      'Freudenthal',
      'Haid',
      'Harrachstal',
      'Knaußer',
      'Langfirling',
      'Markersdorf',
      'Nadelbach',
      'Rabenberg',
      'Reitern',
      'Ritzenedt',
      'Saghammer',
      'Straßreit',
      'Stumberg',
      'Waldfeld',
      'Weitersfelden',
      'Wienau',
      'Windgföll',
    ],
  },
  {
    postleitzahl: 4273,
    orte: [
      'Aglasberg',
      'Dauerbach',
      'Ebenort',
      'Enebitschlag',
      'Grafenschlag',
      'Greinerschlag',
      'Hackstock',
      'Hinterberg',
      'Hinterreith',
      'Kaltenberg',
      'Landshut',
      'Markersreith',
      'Mötlas',
      'Nadelberg',
      'Neumühl',
      'Obermühl',
      'Pieberbach',
      'Schattau',
      'Silberberg',
      'Tischberg',
      'Unterweißenbach',
      'Weidenau',
      'Wildberg',
      'Windhing',
    ],
  },
  {
    postleitzahl: 4274,
    orte: [
      'Almblick',
      'Am Berg',
      'Fürling',
      'Hofing',
      'Kaining',
      'Kollnedt',
      'Niederhofstetten',
      'Niederndorf',
      'Oberhofstetten',
      'Oberndorf',
      'Oberwolfgrub',
      'Pehersdorf',
      'Prandegg',
      'Schönau im Mühlkreis',
      'Sonnblick',
      'Steinbichl',
      'Straß',
      'Wolfgrub',
    ],
  },
  {
    postleitzahl: 4280,
    orte: [
      'Ebrixedt',
      'Haid',
      'Harlingsedt',
      'Hörzenschlag',
      'Kastendorf',
      'Königswiesen',
      'Mayrhof',
      'Mötlasberg',
      'Paroxedt',
      'Pernedt',
      'Salchenedt',
      'Schlag',
      'Stifting',
    ],
  },
  {
    postleitzahl: 4281,
    orte: [
      'Bergerriedl',
      'Eibeck',
      'Henndorf',
      'Mönchdorf',
      'Mönchwald',
      'Niederhofstetten',
      'Schreineredt',
      'Staub',
    ],
  },
  {
    postleitzahl: 4282,
    orte: [
      'Bergerriedl',
      'Hinterhütten',
      'Höfnerberg',
      'Kleinhöfnerberg',
      'Kreuzberg',
      'Lindnerberg',
      'Meislberg',
      'Mühltal',
      'Naarntal',
      'Niederhofstetten',
      'Ober Sankt Thomas',
      'Pierbach',
      'Sonnleitn',
      'Staub',
    ],
  },
  {
    postleitzahl: 4283,
    orte: [
      'Aich',
      'Bad Zell',
      'Barndorf',
      'Brawinkl',
      'Erdleiten',
      'Haselbach',
      'Hirtlhof',
      'Lanzendorf',
      'Maierhof',
      'Riegl',
      'Weberberg',
      'Zellhof',
    ],
  },
  {
    postleitzahl: 4284,
    orte: [
      'Baumgarten',
      'Fraundorf',
      'Haarland',
      'Hennberg',
      'Hinterberg',
      'Hohensteg',
      'Knollnhof',
      'Kriechbaum',
      'Lugendorf',
      'Mistlberg',
      'Schedlberg',
      'Schmierreith',
      'Stranzberg',
      'Tragwein',
      'Zudersdorf',
    ],
  },
  {
    postleitzahl: 4291,
    orte: [
      'Edelhof',
      'Edlau',
      'Elz',
      'Freidorf',
      'Galgenau',
      'Grensberg',
      'Grieb',
      'Grub',
      'Gunnersdorf',
      'Kronau',
      'Lasberg',
      'Manzenreith',
      'Miesenberg',
      'Paben',
      'Pilgersdorf',
      'Punkenhof',
      'Siegelsdorf',
      'Steinböckhof',
      'Walchshof',
      'Witzelsberg',
    ],
  },
  {
    postleitzahl: 4292,
    orte: [
      'Dörfl',
      'Elz',
      'Freidorf',
      'Harterleiten',
      'Kefermarkt',
      'Lest',
      'Miesenberg',
      'Netzberg',
      'Neustadt',
      'Pernau',
      'Siegelsdorf',
      'Wagrein',
      'Weinberg',
      'Wittinghof',
    ],
  },
  {
    postleitzahl: 4293,
    orte: [
      'Erdmannsdorf',
      'Feiblmühl',
      'Fürling',
      'Gutau',
      'Guttenbrunn',
      'Hinterberg',
      'Hundsdorf',
      'Lehen',
      'March',
      'Marreith',
      'Neustadt',
      'Nußbaum',
      'Prandegg',
      'Schallhof',
      'Schnabling',
      'Schöferhof',
      'Stampfendorf',
      'Stiftung',
      'Tannbach',
    ],
  },
  {
    postleitzahl: 4294,
    orte: [
      'Dirnberg',
      'Ennsedt',
      'Freudenthal',
      'Haid',
      'Haslach',
      'Herzogreith',
      'Langfirling',
      'Maasch',
      'Oberarzing',
      'Prandegg',
      'Promenedt',
      'Rebuledt',
      'Rehberg',
      'Reith',
      'Sankt Leonhard bei Freistadt',
      'Schwaighof',
      'Stampfendorf',
      'Stiftung',
      'Unterarzing',
      'Unterniederndorf',
      'Waltrasedt',
      'Wenigfirling',
    ],
  },
  {
    postleitzahl: 4300,
    orte: ['Ernsthofen', 'St. Valentin'],
  },
  {
    postleitzahl: 4303,
    orte: ['Erla', 'St. Pantaleon'],
  },
  {
    postleitzahl: 4310,
    orte: [
      'Albern',
      'Bernascheksiedlung',
      'Brunngraben',
      'Haid',
      'Hart',
      'Heinrichsbrunn',
      'Hinterholz',
      'Langenstein',
      'Marbach',
      'Mauthausen',
      'Oberzirking',
      'Reiferdorf',
      'Ufer',
      'Vormarkt',
    ],
  },
  {
    postleitzahl: 4311,
    orte: [
      'Aiser',
      'Aisting',
      'Am Dachsberg',
      'Doppl',
      'Haarland',
      'Josefstal',
      'Lina',
      'Niederzirking',
      'Oberwagram',
      'Poneggen',
      'Schwertberg',
      'Unterjosefstal',
      'Windegg',
      'Winden',
    ],
  },
  {
    postleitzahl: 4312,
    orte: [
      'Aistbergthal',
      'Altaist',
      'Anzendorf',
      'Blindendorf',
      'Buchholz',
      'Danndorf',
      'Frankenberg',
      'Gerersdorf',
      'Grünau',
      'Hartl',
      'Hochstraß',
      'Holzgasse',
      'Josefstal',
      'Kollnerberg',
      'Langenstein',
      'Loitzenberg',
      'Marbach',
      'Marwach',
      'Niederzirking',
      'Obenberg',
      'Oberzirking',
      'Reidl',
      'Ried in der Riedmark',
      'Rieddorf',
      'Schnellendorf',
      'Schwertberg',
      'Thal',
      'Wachsreith',
      'Waging',
      'Weigersdorf',
      'Wildberg',
      'Wimm',
      'Zeinersdorf',
    ],
  },
  {
    postleitzahl: 4320,
    orte: [
      'Aisthofen',
      'Allerheiligen im Mühlkreis',
      'Auhof',
      'Dörfl',
      'Forndorf',
      'Hochtor',
      'Judenleiten',
      'Karlingberg',
      'Kickenau',
      'Kuchlmühle',
      'Lanzenberg',
      'Lehenbrunn',
      'Mitterberg',
      'Niederlebing',
      'Oberlebing',
      'Oberwagram',
      'Perg',
      'Pergkirchen',
      'Pragtal',
      'Thurnhof',
      'Tobra',
      'Weinzierl',
      'Zeitling',
    ],
  },
  {
    postleitzahl: 4322,
    orte: [
      'Altenburg',
      'Asching',
      'Forndorf',
      'Freindorf',
      'Hochtor',
      'Holzmann',
      'Pragtal',
      'Rechberg',
      'Windhaag bei Perg',
    ],
  },
  {
    postleitzahl: 4323,
    orte: [
      'Danndorf',
      'Innernstein',
      'Kemet',
      'Mollnegg',
      'Münzbach',
      'Obergaisberg',
      'Pilgram',
      'Priehetsberg',
      'Saxenegg',
      'Sulzbach',
    ],
  },
  {
    postleitzahl: 4324,
    orte: [
      'Hiesbach',
      'Holzmann',
      'Kemet',
      'Kürnstein',
      'Puchberg',
      'Rechberg',
      'Spaten',
      'Wansch',
      'Windischhof',
      'Winkl',
    ],
  },
  {
    postleitzahl: 4331,
    orte: [
      'Baumgarten',
      'Dirnwagram',
      'Holzleiten',
      'Laab',
      'Naarn',
      'Neuhof',
      'Pratztrum',
      'Ruprechtshofen',
      'Schönau',
      'Staffling',
      'Starzing',
      'Straß',
      'Wimm',
    ],
  },
  {
    postleitzahl: 4332,
    orte: ['Aist', 'Au an der Donau', 'Naarn', 'Oberwagram', 'Sebern'],
  },
  {
    postleitzahl: 4341,
    orte: [
      'Arbing',
      'Frühstorf',
      'Groißing',
      'Hummelberg',
      'Puchberg im Machland',
      'Puchberg',
      'Roisenberg',
    ],
  },
  {
    postleitzahl: 4342,
    orte: [
      'Amesbach',
      'Au',
      'Baumgartenberg',
      'Deiming',
      'Hehenberg',
      'Hochfeld',
      'Kolbing',
      'Kühofen',
      'Lehen',
      'Mettensdorf',
      'Mühlberg',
      'Obergaisberg',
      'Obergassolding',
      'Schneckenreitstal',
      'Steindl',
      'Untergassolding',
    ],
  },
  {
    postleitzahl: 4343,
    orte: [
      'Am Bühel',
      'Gang',
      'Haid',
      'Hart',
      'Heinz Lettner-Siedlung',
      'Hofstetten',
      'Hörstorf',
      'Hütting',
      'Inzing',
      'Kaindlau',
      'Kirchstetten',
      'Labing',
      'Langacker',
      'Lehen',
      'Loa',
      'Mitterkirchen',
      'Neu Hütting',
      'Wagra',
      'Weisching',
      'Wörth',
    ],
  },
  {
    postleitzahl: 4351,
    orte: [
      'Au',
      'Dornach',
      'Eizenau',
      'Eizendorf',
      'Gewerbepark',
      'Hofkirchen',
      'Knappetsberg',
      'Letten',
      'Oberbergen',
      'Patzenhof',
      'Reitberg',
      'Saxen',
      'Saxendorf',
      'Solarpark',
      'Wetzelsdorf',
    ],
  },
  {
    postleitzahl: 4352,
    orte: [
      'Achatzberg',
      'Gauning',
      'Innernstein',
      'Klam',
      'Letten',
      'Linden',
      'Niederkalmberg',
      'Obergaisberg',
      'Oberhörnbach',
      'Oberkalmberg',
      'Sperken',
      'Untergaisberg',
      'Unterhörnbach',
    ],
  },
  {
    postleitzahl: 4360,
    orte: [
      'Dornach',
      'Grein',
      'Greinburg',
      'Herdmann',
      'Lehen',
      'Lettental',
      'Oberbergen',
      'Panholz',
      'Schönfichten',
      'Ufer',
      'Waldhausen im Strudengau',
      'Würzenberg',
    ],
  },
  {
    postleitzahl: 4362,
    orte: [
      'Bad Kreuzen',
      'Klaus',
      'Kollroßdorf',
      'Kühweid',
      'Lehen',
      'Mitterdörfl',
      'Neuaigen',
      'Oberdörfl',
      'Obereisendorf',
      'Oberkalmberg',
      'Thomasreit',
      'Thomastal',
      'Unterdörfl',
      'Wetzelstein',
      'Würzenberg',
    ],
  },
  {
    postleitzahl: 4363,
    orte: [
      'Henndorf',
      'Markt-Süd',
      'Mitter-Pabneukirchen',
      'Neudorf',
      'Nieder-Schreineredt',
      'Ober-Eisendorf',
      'Ober-Pabneukirchen',
      'Obereisendorf',
      'Pabneukirchen',
      'Riedersdorf',
      'Schreineredt',
      'Sonnleitn',
      'Thomastal',
      'Unter-Eisendorf',
      'Unter-Pabneukirchen',
      'Untermaseldorf',
      'Wetzelsberg',
    ],
  },
  {
    postleitzahl: 4364,
    orte: [
      'Am Sonnenhang',
      'Bergweg',
      'Großmaseldorf',
      'Kirchenweg',
      'Kleinmaseldorf',
      'Markt',
      'Mitter Sankt Thomas',
      'Ober Sankt Thomas',
      'Panoramaweg',
      'Puchberg',
      'Schulstraße',
      'Teichsiedlung',
      'Thomasreit',
      'Unter Sankt Thomas',
      'Untermaseldorf',
    ],
  },
  {
    postleitzahl: 4371,
    orte: [
      'Dimbach',
      'Dimbachreith',
      'Gassen',
      'Großerlau',
      'Hornberg',
      'Kleinerlau',
      'Vorderdimbach',
    ],
  },
  {
    postleitzahl: 4372,
    orte: [
      'Ebenedt',
      'Haruckstein',
      'Henndorf',
      'Kronberg',
      'Linden',
      'Marchstein',
      'Ober St. Georgen',
      'Ottenschlag',
      'St. Georgen am Walde',
      'Unter St. Georgen',
      'Unter-Sankt Georgen',
    ],
  },
  {
    postleitzahl: 4381,
    orte: [
      'Achleiten',
      'Moosbach',
      'Sankt Nikola an der Donau',
      'Sattl',
      'Struden',
    ],
  },
  {
    postleitzahl: 4382,
    orte: ['Hirschenau', 'Sarmingstein', 'Sattl', 'Waldhausen im Strudengau'],
  },
  {
    postleitzahl: 4391,
    orte: ['Waldhausen im Strudengau'],
  },
  {
    postleitzahl: 4392,
    orte: ['Forstamt', 'Waldhausen im Strudengau', 'Wimbergeramt'],
  },
  {
    postleitzahl: 4400,
    orte: [
      'Christkindl',
      'Garsten Nord',
      'Garsten',
      'Gmain',
      'Kleinraming',
      'Pergern',
      'Rosenegg',
      'Saaß',
      'Sarning',
      'St. Ulrich bei Steyr',
      'Steyr',
      'Tinsting',
      'Unterwald',
    ],
  },
  {
    postleitzahl: 4407,
    orte: [
      'Dietach',
      'Dietachdorf',
      'Stadlkirchen',
      'Steyr',
      'Thann',
      'Winkling',
    ],
  },
  {
    postleitzahl: 4421,
    orte: ['Aschach an der Steyr', 'Haagen', 'Mitteregg', 'Pieslwang', 'Saaß'],
  },
  {
    postleitzahl: 4431,
    orte: ['Haidershofen'],
  },
  {
    postleitzahl: 4432,
    orte: ['Ernsthofen'],
  },
  {
    postleitzahl: 4441,
    orte: ['Badhof', 'Penz', 'Ramingdorf', 'Wanzenöd'],
  },
  {
    postleitzahl: 4442,
    orte: [
      'Ebersegg',
      'Gmain',
      'Kleinraming',
      'Kohlergraben',
      'Kürnberg',
      'Maria Neustift',
      'St. Ulrich bei Steyr',
      'Unterwald',
    ],
  },
  {
    postleitzahl: 4443,
    orte: ['Ebersegg', 'Hohenreith', 'Maria Neustift', 'Neustiftgraben'],
  },
  {
    postleitzahl: 4451,
    orte: [
      'Buchholz',
      'Garsten',
      'Kraxental',
      'Lahrndorf',
      'Mühlbach',
      'Mühlbachgraben',
      'Oberdambach',
      'Pesendorf',
      'Saaß',
      'Sand',
      'Sarning',
      'Sonnberg',
      'Ternberg',
      'Unterdambach',
      'Unterwald',
    ],
  },
  {
    postleitzahl: 4452,
    orte: ['Ternberg'],
  },
  {
    postleitzahl: 4453,
    orte: ['Ternberg'],
  },
  {
    postleitzahl: 4460,
    orte: ['Laussa', 'Losenstein'],
  },
  {
    postleitzahl: 4461,
    orte: ['Laussa', 'Oberdambach', 'Unterlaussa'],
  },
  {
    postleitzahl: 4462,
    orte: ['Arzberg', 'Reichraming'],
  },
  {
    postleitzahl: 4463,
    orte: [
      'Brunnbach',
      'Großraming',
      'Hintstein',
      'Laussa',
      'Lumplgraben',
      'Maria Neustift',
      'Neustiftgraben',
      'Oberplaißa',
      'Pechgraben',
      'Rodelsbach',
    ],
  },
  {
    postleitzahl: 4464,
    orte: ['Kleinreifling'],
  },
  {
    postleitzahl: 4470,
    orte: [
      'Einsiedl',
      'Enghagen am Tabor',
      'Enghagen',
      'Enns',
      'Ental',
      'Erlengraben',
      'Hiesendorf',
      'Kottingrat',
      'Kristein',
      'Kronau',
      'Lorch',
      'Moos',
      'Rabenberg',
      'Schieferegg',
      'Thaling',
      'Volkersdorf',
    ],
  },
  {
    postleitzahl: 4481,
    orte: [
      'Abwinden',
      'Asten',
      'Fisching',
      'Ipfdorf',
      'Luftenberg',
      'Raffelstetten',
    ],
  },
  {
    postleitzahl: 4482,
    orte: ['Ennsdorf', 'St. Valentin'],
  },
  {
    postleitzahl: 4483,
    orte: [
      'Angersberg',
      'Firsching',
      'Franzberg',
      'Hargelsberg',
      'Hart',
      'Hausmanning',
      'Penking',
      'Pirchhorn',
      'Schieferegg',
      'Sieding',
      'Thann',
    ],
  },
  {
    postleitzahl: 4484,
    orte: [
      'Dörfling',
      'Kronstorf',
      'Kronstorfberg',
      'Plaik',
      'Pühring',
      'Schieferegg',
      'Schmieding',
      'Stallbach',
      'Teufelsgraben',
      'Thaling',
      'Thann',
      'Unterhaus',
      'Winkling',
    ],
  },
  {
    postleitzahl: 4490,
    orte: [
      'Bruck bei Hausleiten',
      'Bruck bei Tödling',
      'Enzing',
      'Fernbach',
      'Gemering',
      'Hausleiten',
      'Hohenbrunn',
      'Mickstetten',
      'Niederfraunleiten',
      'Oberfraunleiten',
      'Oberndorf',
      'Oberweidlham',
      'Ölkam',
      'Rohrbach',
      'Samesleiten',
      'Sankt Florian',
      'Taunleiten',
      'Tillysburg',
      'Tödling',
      'Unterweidlham',
      'Weilling',
    ],
  },
  {
    postleitzahl: 4491,
    orte: [
      'Dörfl',
      'Grünbrunn',
      'Kiebach',
      'Niederneukirchen',
      'Obereglsee',
      'Ruprechtshofen',
      'Steggraben',
      'Untereglsee',
      'Weichstetten',
    ],
  },
  {
    postleitzahl: 4492,
    orte: [
      'Harmannsdorf',
      'Hofkirchen im Traunkreis',
      'Kiebach',
      'Lanzenberg',
      'Rappersdorf',
    ],
  },
  {
    postleitzahl: 4493,
    orte: ['Goldberg', 'Losensteinleiten', 'Maria Laah', 'Wolfern'],
  },
  {
    postleitzahl: 4501,
    orte: ['Lindach', 'Neuhofen an der Krems'],
  },
  {
    postleitzahl: 4502,
    orte: [
      'Grub',
      'Kimmersdorf',
      'Kurzenkirchen',
      'Niederschöfring',
      'Nöstlbach',
      'Oberndorf',
      'Oberschöfring',
      'Pachersdorf',
      'Pichlwang',
      'Sankt Marien',
      'Stein',
      'Thal',
      'Tiestling',
      'Weichstetten',
    ],
  },
  {
    postleitzahl: 4511,
    orte: [
      'Allhaming',
      'Laimgräben',
      'Lindach',
      'Neuhofen an der Krems',
      'Sipbach',
    ],
  },
  {
    postleitzahl: 4521,
    orte: [
      'Droißendorf',
      'Goldberg',
      'Hilbern',
      'Matzelsdorf',
      'Oberndorf',
      'Pichlwang',
      'Schiedlberg',
      'Thanstetten',
      'Weichstetten',
    ],
  },
  {
    postleitzahl: 4522,
    orte: ['Droißendorf', 'Matzelsdorf', 'Sierning', 'Thanstetten'],
  },
  {
    postleitzahl: 4523,
    orte: [
      'Aschach an der Steyr',
      'Neuzeug',
      'Schwaming',
      'Sierning',
      'Tinsting',
    ],
  },
  {
    postleitzahl: 4531,
    orte: [
      'Burg',
      'Gerersdorf',
      'Halbarting',
      'Kematen an der Krems',
      'Kiesenberg',
      'Neuhofen an der Krems',
      'Rath',
      'Schachen',
      'Sierning',
    ],
  },
  {
    postleitzahl: 4532,
    orte: [
      'Achleiten',
      'Brandstatt',
      'Fierling',
      'Furtberg',
      'Halbarting',
      'Haselberg',
      'Kremsmünster',
      'Krottendorf',
      'Oberrohr',
      'Rohr im Kremstal',
    ],
  },
  {
    postleitzahl: 4533,
    orte: [
      'Brandstatt',
      'Pellndorf',
      'Piberbach',
      'Siedlung',
      'Weifersdorf',
      'Winden',
    ],
  },
  {
    postleitzahl: 4540,
    orte: [
      'Bad Hall',
      'Feyregg',
      'Kremsmünster',
      'Möderndorf',
      'Mühlgrub',
      'Pfarrkirchen bei Bad Hall',
    ],
  },
  {
    postleitzahl: 4541,
    orte: ['Adlwang'],
  },
  {
    postleitzahl: 4542,
    orte: ['Nußbach'],
  },
  {
    postleitzahl: 4550,
    orte: ['Achleiten', 'Kremsmünster', 'Rohr im Kremstal'],
  },
  {
    postleitzahl: 4551,
    orte: [
      'Großendorf',
      'Hammersdorf',
      'Maidorf',
      'Penzendorf',
      'Pesendorf',
      'Ried im Traunkreis',
      'Rührndorf',
      'Schachadorf',
      'Voitsdorf',
      'Weigersdorf',
      'Zenndorf',
    ],
  },
  {
    postleitzahl: 4552,
    orte: [
      'Diepersdorf',
      'Feyregg',
      'Hiersdorf',
      'Penzendorf',
      'Schachadorf',
      'Strienzing',
      'Wartberg an der Krems',
    ],
  },
  {
    postleitzahl: 4553,
    orte: ['Haselböckau', 'Hausmanning', 'Maisdorf', 'Schlierbach'],
  },
  {
    postleitzahl: 4554,
    orte: ['Hausmanning', 'Oberschlierbach'],
  },
  {
    postleitzahl: 4560,
    orte: ['Kirchdorf an der Krems'],
  },
  {
    postleitzahl: 4562,
    orte: ['Steinbach am Ziehberg'],
  },
  {
    postleitzahl: 4563,
    orte: ['Micheldorf'],
  },
  {
    postleitzahl: 4564,
    orte: ['Klaus an der Pyhrnbahn'],
  },
  {
    postleitzahl: 4565,
    orte: [
      'Haselbäckau',
      'Inzersdorf im Kremstal',
      'Lauterbach',
      'Magdalenaberg',
    ],
  },
  {
    postleitzahl: 4571,
    orte: ['Klaus an der Pyhrnbahn', 'Kniewas', 'Steyrling'],
  },
  {
    postleitzahl: 4572,
    orte: ['Kniewas', 'Sankt Pankraz', 'Schalchgraben', 'Tambergau'],
  },
  {
    postleitzahl: 4573,
    orte: [
      'Hinterberg',
      'Hinterstoder',
      'Hutterer Böden',
      'Mitterstoder',
      'Tambergau',
      'Vorderstoder',
      'Vordertambergau',
    ],
  },
  {
    postleitzahl: 4574,
    orte: [
      'Gaisriegl',
      'Tambergau',
      'Vorderstoder',
      'Vordertambergau',
      'Walchegg',
    ],
  },
  {
    postleitzahl: 4575,
    orte: [
      'Mayrwinkl',
      'Pichl',
      'Pießling',
      'Rading',
      'Roßleithen',
      'Schweizersberg',
      'Vordertambergau',
      'Walchegg',
    ],
  },
  {
    postleitzahl: 4580,
    orte: ['Edlbach', 'Windischgarsten'],
  },
  {
    postleitzahl: 4581,
    orte: ['Edlbach', 'Rosenau am Hengstpaß'],
  },
  {
    postleitzahl: 4582,
    orte: [
      'Edlbach',
      'Fahrenberg',
      'Gleinkerau',
      'Mitterweng',
      'Oberweng',
      'Seebach',
      'Spital am Pyhrn',
    ],
  },
  {
    postleitzahl: 4591,
    orte: ['Breitenau', 'Molln', 'Ramsau', 'Rosenau am Hengstpaß'],
  },
  {
    postleitzahl: 4592,
    orte: ['Leonstein', 'Pernzell'],
  },
  {
    postleitzahl: 4593,
    orte: ['Obergrünburg', 'Pernzell', 'Untergrünburg'],
  },
  {
    postleitzahl: 4594,
    orte: ['Haagen', 'Mitteregg', 'Untergrünburg', 'Wagenhub'],
  },
  {
    postleitzahl: 4595,
    orte: [
      'Eggmair',
      'Furtberg',
      'Großmengersdorf',
      'Pesendorf',
      'Sankt Nikola',
      'Steinersdorf',
      'Waldneukirchen',
    ],
  },
  {
    postleitzahl: 4596,
    orte: [
      'Forstau',
      'Pieslwang',
      'Steinbach an der Steyr',
      'Ternberg',
      'Zehetner',
    ],
  },
  {
    postleitzahl: 4600,
    orte: [
      'Aichberg',
      'Au',
      'Berg',
      'Bergerndorf',
      'Bernardin',
      'Blindenmarkt',
      'Brandln',
      'Dickerldorf',
      'Dietach',
      'Doppelgraben',
      'Eben',
      'Edtholz',
      'Gaßl',
      'Grabenhof',
      'Gunskirchen',
      'Haidl',
      'Hochpoint',
      'Höllwiesen',
      'Hölzl',
      'Kirchham',
      'Laahen',
      'Lichtenegg',
      'Mitterlaab',
      'Niederthan',
      'Nöham',
      'Oberhaid',
      'Oberhart',
      'Oberlaab',
      'Oberthan',
      'Ottstorf',
      'Pernau',
      'Puchberg',
      'Roithen',
      'Rosenau',
      'Schafwiesen',
      'Schauersberg',
      'Schleißheim',
      'Stadlhof',
      'Thalheim bei Wels',
      'Trausenegg',
      'Untereisenfeld',
      'Unterleithen',
      'Unterschauersberg',
      'Waidhausen',
      'Wels',
      'Wimpassing',
      'Wispl',
    ],
  },
  {
    postleitzahl: 4611,
    orte: [
      'Buchkirchen',
      'Ennsberg',
      'Epping',
      'Hartberg',
      'Holzwiesen',
      'Hörling',
      'Hundsham',
      'Kandlberg',
      'Lachgraben',
      'Luckermair',
      'Niedergrafing',
      'Niederhocherenz',
      'Niederlaab',
      'Obergrafing',
      'Oberhocherenz',
      'Oberperwend',
      'Oberprisching',
      'Ötzing',
      'Radlach',
      'Schickenhäuser',
      'Schnadt',
      'Sommerfeld',
      'Spengenedt',
      'Uttenthal',
      'Wörist',
    ],
  },
  {
    postleitzahl: 4612,
    orte: [
      'Aigen',
      'Breitenaich',
      'Finklham',
      'Herrnholz',
      'Hochscharten',
      'Kronberg',
      'Leppersdorf',
      'Oberndorf',
      'Rexham',
      'Roitham',
      'Roithen',
      'Scharten',
      'Sommerfeld',
      'Steinberg',
      'Vitta',
    ],
  },
  {
    postleitzahl: 4613,
    orte: [
      'Elend',
      'Haberfelden',
      'Hupfau',
      'Mistelbach bei Wels',
      'Öhnerhäuser',
      'Ottenham',
      'Unterholz',
      'Wolfsgrub',
    ],
  },
  {
    postleitzahl: 4614,
    orte: [
      'Au an der Traun',
      'Kappern',
      'Leithen',
      'Marchtrenk',
      'Mitterperwend',
      'Niederperwend',
      'Niederprisching',
      'Oberneufahrn',
      'Schafwiesen',
      'Unterhaid',
      'Unterhart',
      'Unterneufahrn',
    ],
  },
  {
    postleitzahl: 4615,
    orte: [
      'Grillparz',
      'Holzhausen',
      'Jebenstein',
      'Kranzing',
      'Lehen',
      'Niederprisching',
    ],
  },
  {
    postleitzahl: 4616,
    orte: [
      'Bergern',
      'Graßing',
      'Hetzendorf',
      'Schimpelsberg',
      'Sinnersdorf',
      'Weißkirchen',
      'Weyerbach',
    ],
  },
  {
    postleitzahl: 4621,
    orte: [
      'Giering',
      'Kremsmünster',
      'Leombach',
      'Loibingdorf',
      'Permannsberg',
      'Rappersdorf',
      'Schachermairdorf',
      'Schnarrndorf',
      'Sipbachzell',
    ],
  },
  {
    postleitzahl: 4622,
    orte: ['Brunnern', 'Eggendorf im Traunkreis', 'Hueb', 'Kroisbach'],
  },
  {
    postleitzahl: 4623,
    orte: [
      'Aichberg',
      'Aigen',
      'Au bei der Traun',
      'Au bei Hischmannsberg',
      'Au bei Sirfling',
      'Auholz',
      'Baumgarting',
      'Bichlwimm',
      'Buchleiten',
      'Dorf',
      'Fallsbach',
      'Fernreith',
      'Gänsanger',
      'Grünbach',
      'Gunskirchen',
      'Hof',
      'Holzgassen',
      'Holzing',
      'Irnharting',
      'Kalchau',
      'Kappling',
      'Kottingreith',
      'Kranzl am Eck',
      'Lehen',
      'Liedering',
      'Lucken',
      'Luckenberg',
      'Moostal',
      'Niederschacher',
      'Oberndorf',
      'Oberriethal',
      'Oberschacher',
      'Pfarrhofwies',
      'Pöschlberg',
      'Pötzlberg',
      'Riethal',
      'Roith',
      'Salling',
      'Schlambart',
      'Sirfling',
      'Spraid',
      'Straßern',
      'Ströblberg',
      'Thal',
      'Vitzing',
      'Vornholz',
      'Waldenberg',
      'Waldling',
      'Wallnstorf',
      'Wilhaming',
      'Wimberg',
    ],
  },
  {
    postleitzahl: 4624,
    orte: [
      'Arbing',
      'Balding',
      'Breitenau',
      'Dirnberg',
      'Felling',
      'Graben',
      'Hölking',
      'Horning',
      'Krexham',
      'Mitterfils',
      'Nölling',
      'Oberfils',
      'Parzham',
      'Pennewang',
      'Pimming',
      'Rosenberg',
      'Schmitzberg',
      'Schneiting',
      'Staffel',
      'Stürzling',
      'Unterfils',
      'Unterwald',
      'Weinzierl',
      'Weißbach',
      'Wiesham',
    ],
  },
  {
    postleitzahl: 4625,
    orte: [
      'Aigen',
      'Amesberg',
      'Bachstätten',
      'Braunberg',
      'Eglsee',
      'Großkrottendorf',
      'Grub',
      'Haindorf',
      'Holzhäuseln bei Wilhelmsberg',
      'Humplberg',
      'Kapsam',
      'Kleinkrottendorf',
      'Kohlböckhof',
      'Kronberg',
      'Kurzenkirchen',
      'Maierhof',
      'Moos',
      'Obereggen',
      'Offenhausen',
      'Osterberg',
      'Paschlberg',
      'Pfaffendorf',
      'Sittenthal',
      'Stockerberg',
      'Stritzing',
      'Untereggen',
      'Voglsang',
      'Vornholz',
      'Weinberg',
      'Wies',
      'Wieshäusl',
      'Würting',
    ],
  },
  {
    postleitzahl: 4631,
    orte: [
      'Achleiten',
      'Alkrucken',
      'Au',
      'Elmischhub',
      'Forst',
      'Geigen',
      'Geisensheim',
      'Gfereth',
      'Gölding',
      'Haag',
      'Haiding',
      'Holzhäuser',
      'Kalteneck',
      'Katzbach',
      'Krenglbach',
      'Nadernberg',
      'Oberham',
      'Öhlgraben',
      'Radgattern',
      'Schmiding',
      'Unrading',
      'Wieshof',
      'Winkeln',
      'Wörist',
      'Wundersberg',
    ],
  },
  {
    postleitzahl: 4632,
    orte: [
      'Ach',
      'Aichet',
      'Aichmühl',
      'Am Irrach',
      'Angsterlehen',
      'Auhub',
      'Brandstatt',
      'Breitwies',
      'Buchet',
      'Dingberg',
      'Etzelsdorf',
      'Fadleiten',
      'Falzberg',
      'Franzing',
      'Freiung',
      'Geisensheim',
      'Haag',
      'Hochwimm',
      'Holzhäuser',
      'Inn',
      'Jägersberg',
      'Kaiserleiten',
      'Kerschberg',
      'Krottendorf',
      'Lechlödt',
      'Malling',
      'Mitterleiten',
      'Mitterndorf',
      'Moosleiten',
      'Nisting',
      'Oberirrach',
      'Oberndorf',
      'Oberthambach',
      'Ödt',
      'Pfaffendorf',
      'Pichl bei Wels',
      'Pröstlsberg',
      'Puchet',
      'Pühret',
      'Schalbach',
      'Schmiedsberg',
      'Schnappling',
      'Schnittering',
      'Schustersberg',
      'Silbersberg',
      'Stadl',
      'Steinpichl',
      'Sulzbach',
      'Trappelsberg',
      'Unterirrach',
      'Unterthambach',
      'Uttendorf',
      'Waldgattern',
      'Weilbach',
      'Weinberg',
      'Winkelfeld',
    ],
  },
  {
    postleitzahl: 4633,
    orte: [
      'Breitwies',
      'Bubendorf',
      'Burghartsberg',
      'Burgstall',
      'Gaubing',
      'Grübl',
      'Kematen am Innbach',
      'Moos',
      'Oberdoppl',
      'Oberholzing',
      'See',
      'Steinerkirchen am Innbach',
      'Straß',
      'Unterdoppl',
      'Unterholzing',
      'Weilbach',
      'Wiesing',
    ],
  },
  {
    postleitzahl: 4641,
    orte: [
      'Forstberg',
      'Oberhart',
      'Oberschauersberg',
      'Steinhaus',
      'Taxlberg',
      'Traunleiten',
      'Unterhart',
    ],
  },
  {
    postleitzahl: 4642,
    orte: [
      'Dirnberg',
      'Giering',
      'Heiligenkreuz',
      'Maidorf',
      'Oberautal',
      'Oberhart',
      'Pochendorf',
      'Rappersdorf',
      'Sattledt',
      'Unterhart',
    ],
  },
  {
    postleitzahl: 4643,
    orte: [
      'Dürndorf',
      'Etzelsdorf',
      'Gundendorf',
      'Hammersdorf',
      'Lungendorf',
      'Magdalenaberg',
      'Mitterndorf',
      'Pettenbach',
      'Pratsdorf',
      'Steinbach am Ziehberg',
      'Steinfelden',
    ],
  },
  {
    postleitzahl: 4644,
    orte: [
      'Dorf',
      'Grünau im Almtal',
      'Mühldorf',
      'Sankt Konrad',
      'Scharnstein',
      'Viechtwang',
    ],
  },
  {
    postleitzahl: 4645,
    orte: ['Grünau im Almtal', 'Mühldorf'],
  },
  {
    postleitzahl: 4650,
    orte: [
      'Aichham',
      'Aigen',
      'Bergern',
      'Brandstatt',
      'Breitenberg',
      'Edt',
      'Fischerau',
      'Fluchtwang',
      'Graben',
      'Hagenberg',
      'Hölzlberg',
      'Holzmanning',
      'Klaus',
      'Kreisbichl',
      'Kropfing',
      'Laimberg',
      'Lambach',
      'Lehen',
      'Mairlambach',
      'Mernbach',
      'Mitterberg',
      'Niederschwaig',
      'Niederzeiling',
      'Oberroithen',
      'Oberzeiling',
      'Roith',
      'Saag',
      'Schlatt',
      'Schmidhub',
      'Schußstatt',
      'Sperr',
      'Unterroithen',
      'Winkling',
      'Ziegelstadl',
    ],
  },
  {
    postleitzahl: 4651,
    orte: ['Stadl-Hausruck', 'Stadl-Traun', 'Stadl-Ufer'],
  },
  {
    postleitzahl: 4652,
    orte: [
      'Almegg',
      'Atzing',
      'Atzmannsdorf',
      'Eden',
      'Eggenberg',
      'Fischlham',
      'Forstberg',
      'Frohnhofen',
      'Gundersdorf',
      'Hafeld',
      'Hammersedt',
      'Heitzing',
      'Hummelberg',
      'Kriegsham',
      'Laherberg',
      'Linden',
      'Niederheischbach',
      'Oberaustall',
      'Oberheischbach',
      'Ornharting',
      'Pesenlittring',
      'Reuharting',
      'Ritzendorf',
      'Schnelling',
      'Seebach',
      'Sölling',
      'Steinerkirchen an der Traun',
      'Stockham',
      'Taxlberg',
      'Wollsberg',
      'Zauset',
    ],
  },
  {
    postleitzahl: 4653,
    orte: [
      'Eberstalzell',
      'Hallwang',
      'Ittensam',
      'Littring',
      'Mayersdorf',
      'Spieldorf',
      'Wipfing',
    ],
  },
  {
    postleitzahl: 4654,
    orte: [
      'Aigen',
      'Au',
      'Bachloh',
      'Bergham',
      'Dorfham',
      'Ellnkam',
      'Giering',
      'Haag',
      'Haidermoos',
      'Kößlwang',
      'Neydharting',
      'Traun',
      'Wimsbach',
    ],
  },
  {
    postleitzahl: 4655,
    orte: ['Hötzelsdorf', 'Reuharting', 'Vorchdorf'],
  },
  {
    postleitzahl: 4656,
    orte: [
      'Bergham',
      'Danzlau',
      'Edtholz',
      'Eisengattern',
      'Feichtenberg',
      'Guggenberg',
      'Hagenmühle',
      'Hilzing',
      'Hüttenboden',
      'Im Tal',
      'In der Au',
      'Kaltenmarkt',
      'Kampesberg',
      'Kirchham',
      'Kogl',
      'Kohlwiese',
      'Krottendorf',
      'Laakirchen',
      'Laizing',
      'Laudachtal',
      'Steg',
      'Wahl',
      'Windberg',
    ],
  },
  {
    postleitzahl: 4661,
    orte: [
      'Altmanning',
      'Au',
      'Auholz',
      'Außerpühret',
      'Außerroh',
      'Bichlbauer',
      'Bühl',
      'Deising',
      'Edt',
      'Edtmayer',
      'Innerroh',
      'Kemating',
      'Kirnbach',
      'Lebl-Roith',
      'Magling',
      'Mitterbuch',
      'Nöstling',
      'Oberbuch',
      'Palmsdorf',
      'Roitham',
      'Sandgasse',
      'Stötten',
      'Unterpühret',
      'Vornbuch',
      'Wangham',
      'Watzing',
    ],
  },
  {
    postleitzahl: 4662,
    orte: ['Laakirchen'],
  },
  {
    postleitzahl: 4663,
    orte: ['Laakirchen'],
  },
  {
    postleitzahl: 4664,
    orte: ['Kranabeth', 'Laakirchen', 'Moosham', 'Oberweis'],
  },
  {
    postleitzahl: 4671,
    orte: [
      'Aichkirchen',
      'Aming',
      'Brunngasse',
      'Dorf',
      'Eisgering',
      'Getzing',
      'Gewerbepark Neukirchen bei Lambach',
      'Hof',
      'Hofern',
      'Iming',
      'Ingerendt',
      'Löpperding',
      'Neukirchen bei Lambach',
      'Niederharrern',
      'Nopping',
      'Oberschwaig',
      'Pisdorf',
      'Pitting',
      'Puch',
      'Rabenberg',
      'Roitfeld',
      'Schörgendorf',
      'Spöck',
      'Stötten',
      'Stroham',
      'Voglhub',
      'Weinberg',
      'Willing',
    ],
  },
  {
    postleitzahl: 4672,
    orte: [
      'Bachmanning',
      'Bachmannsberg',
      'Hundhagen',
      'Klind',
      'Kohlgrub',
      'Krottendorf',
      'Oberndorf',
      'Oberseling',
      'Pühret',
      'Unterseling',
      'Weingarten',
    ],
  },
  {
    postleitzahl: 4673,
    orte: [
      'Aspoltsberg',
      'Bachhäuseln',
      'Baumgarting',
      'Bernhartsdorf',
      'Bugram',
      'Edt am Stömerberg',
      'Eggerding',
      'Fading',
      'Felling',
      'Föching',
      'Gaspoltshofen',
      'Gramberg',
      'Grub',
      'Hairedt',
      'Hinterleiten',
      'Hofing',
      'Höft',
      'Hörbach',
      'Hörmeting',
      'Hub',
      'Kronleiten',
      'Leithen',
      'Mairhof',
      'Moos',
      'Niederbauern',
      'Obeltsham',
      'Oberbergham',
      'Obergrünbach',
      'Oberhöftberg',
      'Ohrenschall',
      'Seiring',
      'Sölliberg',
      'Unteraffnang',
      'Unterbergham',
      'Untergrünbach',
      'Unterhöftberg',
      'Watzing',
    ],
  },
  {
    postleitzahl: 4674,
    orte: [
      'Altenhof am Hausruck',
      'Buchleiten',
      'Gröming',
      'Holzing',
      'Lenglach',
      'Mösenedt',
      'Mühlbach',
      'Oberaffnang',
      'Oberepfenhofen',
      'Obergmain',
      'Unterepfenhofen',
      'Untergmain',
      'Weinberg',
    ],
  },
  {
    postleitzahl: 4675,
    orte: [
      'Auhäuseln',
      'Buch',
      'Dirisam',
      'Einberg',
      'Eitzenberg',
      'Fuchshub',
      'Grub',
      'Gründling',
      'Hofreith',
      'Niederndorf',
      'Ortmanau',
      'Pesendorf',
      'Schachenreith',
      'Schwarzgrub',
      'Schwarzschachen',
      'Seewiesen',
      'Stüblreith',
      'Trattnach',
      'Unterlehen',
      'Untermeggenbach',
      'Weibern',
    ],
  },
  {
    postleitzahl: 4676,
    orte: [
      'Aistersheim',
      'Augassen',
      'Auwiesen',
      'Edt',
      'Grub',
      'Haid',
      'Haidenheim',
      'Himmelreich',
      'Kottingaistersheim',
      'Mühlberg',
      'Pöttenheim',
      'Rakesing',
      'Thalheim',
      'Viertlbach',
    ],
  },
  {
    postleitzahl: 4680,
    orte: [
      'Aubach',
      'Bachleiten',
      'Brunnberg',
      'Buchegg',
      'Ditting',
      'Dorf',
      'Eidenedt',
      'Geierau',
      'Gotthaming',
      'Grolzham',
      'Haag am Hausruck',
      'Hatscheksiedlung',
      'Hinteregg',
      'Hochfeld',
      'Hundassing',
      'Kreuzerfeld',
      'Kruglug',
      'Leiten',
      'Letten',
      'Lugendorf',
      'Luisenhöhe',
      'Manichgattern',
      'Niedernhaag',
      'Obermeggenbach',
      'Oberntor',
      'Pramwald',
      'Rampersdorf',
      'Reischau',
      'Starhemberg',
      'Steinpoint',
    ],
  },
  {
    postleitzahl: 4681,
    orte: [
      'Frei',
      'Großwaldenberg',
      'Höbeting',
      'Holzhäuseln',
      'Innernsee',
      'Kleinwaldenberg',
      'Lamperstorf',
      'Mösenpoint',
      'Mühllehen',
      'Parz',
      'Pommersberg',
      'Poppenreith',
      'Rottenbach',
      'Schachet',
      'Stötten',
      'Watzing',
      'Weeg',
      'Winkling',
    ],
  },
  {
    postleitzahl: 4682,
    orte: [
      'Aigen',
      'Arming',
      'Aspet',
      'Bergham',
      'Brunau',
      'Buchet',
      'Buchleiten',
      'Erlet',
      'Geboltskirchen',
      'Gschwendt',
      'Holzhäuseln',
      'Langau',
      'Leithen',
      'Lucka',
      'Marschalling',
      'Niederentern',
      'Oberentern',
      'Odelboding',
      'Piesing',
      'Polzing',
      'Reitting',
      'Roßwald',
      'Scheiben',
      'Stein',
      'Thalham',
      'Trattnach',
      'Traunhof',
      'Wiesing',
      'Wilding',
      'Zeißerding',
    ],
  },
  {
    postleitzahl: 4690,
    orte: [
      'Aich',
      'Anzental',
      'Bach',
      'Bergern',
      'Ebersäuln',
      'Edt',
      'Eglau',
      'Ennsberg',
      'Glatzing',
      'Hart',
      'Höck',
      'Hof',
      'Johannisthal',
      'Kaiseredt',
      'Kaufing',
      'Kirchdorf',
      'Kochlöffling',
      'Kreut',
      'Lebertsham',
      'Litzing',
      'Mitterberg',
      'Mitterbergholz',
      'Mühlparz',
      'Mühlwang',
      'Neudorf',
      'Niederholzham',
      'Oberndorf',
      'Pfaffenberg',
      'Philippsberg',
      'Pichl',
      'Pitzenberg',
      'Pitzenbergholz',
      'Römerberg',
      'Rüstorf',
      'Rutzenham',
      'Schwanenstadt',
      'Staig',
      'Windham',
      'Winkl',
    ],
  },
  {
    postleitzahl: 4691,
    orte: [
      'Apeding',
      'Asperding',
      'Breitenschützing',
      'Herrenschützing',
      'Hinterschützing',
      'Hörweg',
      'Oberharrern',
      'Römerberg',
      'Schlatt',
      'Staig',
      'Weikharting',
    ],
  },
  {
    postleitzahl: 4692,
    orte: [
      'Bergham',
      'Hainbach',
      'Hehenberg',
      'Iming',
      'Kaiting',
      'Koppl',
      'Kroißbach',
      'Laah',
      'Moos',
      'Niederau',
      'Niederthalheim',
      'Oberau',
      'Obersteindlberg',
      'Penetzdorf',
      'Pengering',
      'Rankar',
      'Salfing',
      'Untersteindlberg',
      'Viert',
      'Windham',
      'Wufing',
    ],
  },
  {
    postleitzahl: 4693,
    orte: [
      'Berg',
      'Brauching',
      'Bubenland',
      'Buchleiten',
      'Desselbrunn',
      'Deutenham',
      'Edt',
      'Fallholz',
      'Feldham',
      'Haus',
      'Hofstätten',
      'Hub',
      'Johannisthal',
      'Kreut',
      'Oberhaidach',
      'Roith',
      'Sicking',
      'Traunwang',
      'Unterhaidach',
      'Viecht',
      'Windern',
    ],
  },
  {
    postleitzahl: 4694,
    orte: [
      'Aichlham',
      'Aupointen',
      'Aurachkirchen',
      'Edlach',
      'Edt',
      'Ehrendorf',
      'Ehrenfeld',
      'Föding',
      'Fraunsdorf',
      'Großreith',
      'Hafendorf',
      'Hildprechting',
      'Hochbau',
      'Hochleithen',
      'Holzhäuseln',
      'Irresberg',
      'Kleinreith',
      'Kohlwehr',
      'Obernathal',
      'Oberthalham',
      'Ohlsdorf',
      'Parz',
      'Peiskam',
      'Penesdorf',
      'Preinsdorf',
      'Purndorf',
      'Rittham',
      'Ruhsam',
      'Sandhäuslberg',
      'Traich',
      'Unternathal',
      'Unterthalham',
      'Weinberg',
    ],
  },
  {
    postleitzahl: 4701,
    orte: [
      'Bad Schallerbach',
      'Bergern',
      'Gebersdorf',
      'Müllerberg',
      'Schönau',
    ],
  },
  {
    postleitzahl: 4702,
    orte: [
      'Bergern',
      'Breitwiesen',
      'Edlgassen',
      'Furth',
      'Grub',
      'Hilling',
      'Holz',
      'Holzhäuser',
      'Hungerberg',
      'Kitzing',
      'Malling',
      'Mauer',
      'Parzham',
      'Uttenthal',
      'Wallern an der Trattnach',
      'Weghof',
      'Winkeln',
    ],
  },
  {
    postleitzahl: 4707,
    orte: [
      'Aigendorf',
      'Alte Rosenau',
      'Am Kröpflmühlerberg',
      'Anzenberg',
      'Atschenbach',
      'Au',
      'Brandhof',
      'Buchet',
      'Dingbach',
      'Fischleithen',
      'Fürth',
      'Gewerbepark',
      'Haid',
      'Handelspark',
      'Hiererberg',
      'Hiering',
      'Hornesberg',
      'Kehrbach',
      'Kochlöffleck',
      'Kröpflmühle',
      'Kumpfhub',
      'Margarethen',
      'Mitterndorf',
      'Niederndorf',
      'Oberschaffenberg',
      'Parz',
      'Pühret',
      'Rosenau',
      'Rosengarten',
      'Schaffenberg',
      'Schlüßlberg',
      'Schnölzenberg',
      'Sonnwies',
      'Straßfeld',
      'Tegernbach',
      'Thal',
      'Trattenegg',
      'Unternberg',
      'Weinberg',
      'Wintersberg',
    ],
  },
  {
    postleitzahl: 4710,
    orte: [
      'Aigen',
      'Edt',
      'Egg',
      'Ferdinand-Huber-Siedlung',
      'Forsthof',
      'Grieskirchen',
      'Grub',
      'Hainbuch',
      'Hiering',
      'Hornesberg',
      'Jörgerberg',
      'Kaltenbach',
      'Kickendorf',
      'Kolbing',
      'Kroisbach',
      'Lahof',
      'Maximilian',
      'Moosham',
      'Neuwies',
      'Niederweng',
      'Obersteinbach',
      'Oberwödling',
      'Parz',
      'Paschallern',
      'Pollham',
      'Pollhamerwald',
      'Sankt Georgen bei Grieskirchen',
      'Schickberg',
      'Schmidgraben',
      'Schönau',
      'Schwabegg',
      'Stein',
      'Steindlberg',
      'Stritzing',
      'Tollet',
      'Tolleterau',
      'Unternberg',
      'Untersteinbach',
      'Vierhausen',
      'Wackersbuch',
      'Wimm',
      'Winkeln',
    ],
  },
  {
    postleitzahl: 4712,
    orte: [
      'Aichet bei Grub',
      'Aichet bei Kiesenberg',
      'Armau',
      'Gaisedt',
      'Grub',
      'Haid',
      'Haus',
      'Hilpetsberg',
      'Holzing',
      'Kiesenberg',
      'Krumbach',
      'Mairdoppl',
      'Michaelnbach',
      'Minithal',
      'Niederndorf',
      'Niederwödling',
      'Oberfurth',
      'Oberreitbach',
      'Oberspaching',
      'Pollesbach',
      'Reichenau',
      'Schappenedt',
      'Schickenedt',
      'Schmidgraben',
      'Schölmlahn',
      'Seiblberg',
      'Spöck',
      'Stefansdorf',
      'Stockedt',
      'Unterfurth',
      'Unterreitbach',
      'Weiking',
      'Zelli',
    ],
  },
  {
    postleitzahl: 4713,
    orte: [
      'Diesting',
      'Enzendorf',
      'Gallspach',
      'Gferedt',
      'Niederndorf',
      'Schützendorf',
      'Thall',
      'Thongraben',
      'Vierhausen',
      'Vornwald',
      'Wies',
    ],
  },
  {
    postleitzahl: 4714,
    orte: [
      'Breinroith',
      'Breitwies',
      'Bruckhof',
      'Egg',
      'Erlet',
      'Etnischberg',
      'Felling',
      'Freinberg',
      'Gferet',
      'Hart',
      'Hirm',
      'Holzackern',
      'Holzhäuseln bei Hart',
      'Holzhäuseln bei Wilhelmsberg',
      'Inn',
      'Kirchberg',
      'Kröstlinghof',
      'Langdorf',
      'Linet',
      'Meggenhofen',
      'Moos',
      'Niederbuch',
      'Niederetnisch',
      'Oberetnisch',
      'Obergallspach',
      'Oberndorf',
      'Pfarrhofsberg',
      'Radhof',
      'Rahof',
      'Roitham',
      'Schlatt',
      'Straß',
      'Trappenhof',
      'Vornbuch',
      'Wald',
      'Wilhelmsberg',
      'Wimm',
      'Zwisl',
    ],
  },
  {
    postleitzahl: 4715,
    orte: [
      'Adrischendorf',
      'Aich',
      'Aichet',
      'Altenhof',
      'Brandstetten',
      'Damberg',
      'Dietensam',
      'Eiblhub',
      'Erb',
      'Fellhof',
      'Fürstling',
      'Gries',
      'Grubhof',
      'Gstötten',
      'Haslau',
      'Hehenberg',
      'Helmling',
      'Hofmaning',
      'Holz',
      'Keneding',
      'Korntnerberg',
      'Mödlbach',
      'Niedertrattnach',
      'Oberolzing',
      'Obertrattbach',
      'Obertrattnach',
      'Odlboding',
      'Ragering',
      'Reischau',
      'Roith',
      'Schröttenham',
      'Stadlberg',
      'Stockwies',
      'Taufkirchen an der Trattnach',
      'Unterolzing',
      'Unterstetten',
      'Untertrattbach',
      'Vatersam',
      'Weidenau',
      'Widldorf',
      'Winkl',
    ],
  },
  {
    postleitzahl: 4716,
    orte: [
      'Aigen',
      'Brunham',
      'Gassen',
      'Hof',
      'Hofkirchen an der Trattnach',
      'Jungroith',
      'Panbruck',
      'Pichl',
      'Regnersdorf',
      'Ruhringsdorf',
      'Schallbach',
      'Sinzing',
      'Sommerfeld',
      'Strötting',
      'Weng',
    ],
  },
  {
    postleitzahl: 4720,
    orte: [
      'Aigen',
      'Albrechtsberg',
      'Aschau',
      'Aspeth',
      'Au',
      'Auing',
      'Baumgarten',
      'Birnsteig',
      'Dürrnaschach',
      'Ebergassen',
      'Endt',
      'Erlach',
      'Flenkengrub',
      'Frauenhub',
      'Geßwagen',
      'Güttling',
      'Hading',
      'Häuseln am Holz',
      'Henning',
      'Hof',
      'Holzhäuseln',
      'Holzleithen',
      'Itzling',
      'Kainzing',
      'Kallham',
      'Kallhamerdorf',
      'Kimpling',
      'Kirchbach',
      'Kledt',
      'Kronlach',
      'Lehen',
      'Mairdoppl',
      'Mairhof',
      'Moos',
      'Neumarkt im Hausruckkreis',
      'Niederleithen',
      'Oberaschach',
      'Obereibach',
      'Oberhof',
      'Obernfurth',
      'Oberrühringsdorf',
      'Obersameting',
      'Parzleithen',
      'Pauzenberg',
      'Pehring',
      'Penzing',
      'Poing',
      'Pötting',
      'Puchet',
      'Putzenbach',
      'Rumpfendopl',
      'Schildorf',
      'Sixberg',
      'Spielmannsberg',
      'Stockham',
      'Straßhof',
      'Sumeding',
      'Unternfurth',
      'Unterrühringsdorf',
      'Untersameting',
      'Wachling',
      'Weireth',
      'Wies',
      'Wiesing',
      'Würzberg',
    ],
  },
  {
    postleitzahl: 4721,
    orte: [
      'Altenseng',
      'Altschwendt',
      'Danrath',
      'Fasthub',
      'Hausmanning',
      'Putzenbach',
      'Rien',
      'Rödham',
      'Urleinsberg',
      'Wohlmarch',
    ],
  },
  {
    postleitzahl: 4722,
    orte: [
      'Achleiten',
      'Adenbruck',
      'Aichet',
      'Asing',
      'Besenberg',
      'Blindenau',
      'Brandstätten',
      'Breitau',
      'Bruck an der Aschach',
      'Buch',
      'Dunkenedt',
      'Eckartsroith',
      'Enzing',
      'Erleinsdorf',
      'Feichten',
      'Freiling',
      'Fuchshub',
      'Greinsfurth',
      'Griesbach',
      'Gschwendthäuser',
      'Haargassen',
      'Höhenstein',
      'Holzleithen',
      'Hötzmannsberg',
      'Hub',
      'Itzling',
      'Kastlingeredt',
      'Kirchenfeld',
      'Knotzberg',
      'Köppensteegen',
      'Krottenthal',
      'Langenpeuerbach',
      'Leithen',
      'Mittereibach',
      'Mühlbrenning',
      'Niederaching',
      'Niederensfelden',
      'Niederweiding',
      'Nußbaum',
      'Oberaching',
      'Oberbubenberg',
      'Obererleinsbach',
      'Oberndorf',
      'Oberngrub',
      'Oberweiding',
      'Ort an der Straß',
      'Parz am Öhlstampf',
      'Parz bei Gattern',
      'Peuerbach',
      'Pfarrhofheuberg',
      'Prambeckenhof',
      'Pühret',
      'Ranna',
      'Ratzling',
      'Rittberg',
      'Sallet',
      'Schieferhub',
      'Sölden an der Straß',
      'Spielmannsberg',
      'St. Pius',
      'Staureth',
      'Steegen',
      'Stefansdorf',
      'Steinbruck',
      'Steingrüneredt',
      'Stieglhof',
      'Teucht',
      'Thomasberg',
      'Unterbubenberg',
      'Untereibach',
      'Untererleinsbach',
      'Unterheuberg',
      'Unterndobl',
      'Untertreßleinsbach',
      'Untwüsten',
      'Urleinsberg',
      'Usting',
      'Vest',
      'Waasen',
      'Waasnerau',
      'Weireth',
      'Windprechting',
      'Winkl',
    ],
  },
  {
    postleitzahl: 4723,
    orte: [
      'Au bei Ed',
      'Au bei Natternbach',
      'Baumühl',
      'Berndorf',
      'Bernrad',
      'Dopl',
      'Eck',
      'Ed',
      'Entholz',
      'Fronberg',
      'Gaisbuchen',
      'Gschaid',
      'Haibach',
      'Hairet',
      'Hochstraß',
      'Hörmating',
      'Hörzingerwald',
      'Hungberg',
      'Kapping',
      'Kirchberg',
      'Knotzberg',
      'Kreuz',
      'Lichtberg',
      'Moos',
      'Natternbach',
      'Oberhörzing',
      'Obermaggau',
      'Obertresleinsbach',
      'Pfeneberg',
      'Pötzenau',
      'Pötzling',
      'Püret',
      'Reiting',
      'Rittberg',
      'Schmiedparz',
      'Tal',
      'Traunolding',
      'Untereck',
      'Unterhörzing',
      'Untermaggau',
      'Wolfgrub',
    ],
  },
  {
    postleitzahl: 4724,
    orte: [
      'Aigen',
      'Altenberg',
      'Baumgarten',
      'Eben bei Sankt Sixt',
      'Erledt',
      'Eschenau im Hausruckkreis',
      'Feuermühl',
      'Frankengrub',
      'Gferedt',
      'Graspoint',
      'Hagenberg',
      'Hasledt',
      'Hausleithen',
      'Hech',
      'Hengstberg',
      'Hofing',
      'Hofingerleithen',
      'Hofstetten',
      'Höllberg',
      'Hungberg',
      'Inzing',
      'Jebing',
      'Kirchberg',
      'Knotzberg',
      'Königshub',
      'Mäusburg',
      'Mehring',
      'Mehringerau',
      'Mitteraubach',
      'Moosau',
      'Neubach',
      'Neukirchen am Walde',
      'Oberaubach',
      'Oberbuchberg',
      'Obergermating',
      'Polstergrub',
      'Pühret',
      'Rath',
      'Reith',
      'Salling',
      'Schachen',
      'Spattenbrunn',
      'Stilzing',
      'Stocket',
      'Straß bei Sankt Sixt',
      'Unteraubach',
      'Unterbuchberg',
      'Untergermating',
      'Untergrub',
      'Veitsberg',
      'Vilzbach',
      'Vorau',
      'Waldbach',
      'Weibing',
      'Willing',
      'Winklpoint',
      'Zierreit',
    ],
  },
  {
    postleitzahl: 4725,
    orte: [
      'Adelsgrub',
      'Au',
      'Breitenau',
      'Dorf',
      'Dornedt',
      'Eben',
      'Edern',
      'Flenkental',
      'Fraunhof',
      'Grübl',
      'Gschwendt',
      'Hackendorf',
      'Henndorf',
      'Höllau',
      'Innerleiten',
      'Kahlberg',
      'Kößlau',
      'Lehen',
      'Maierhof',
      'Mittelbach',
      'Mühlbach',
      'Oberleiten',
      'Panholz',
      'Prünst',
      'Reisedt',
      'Reiting',
      'Sagedt',
      'Schauern',
      'Simling',
      'St. Aegidi',
      'Stadl',
      'Steinedt',
      'Tullern',
      'Voglgrub',
      'Walleiten',
      'Wallern',
      'Witzenedt',
      'Zimmerleiten',
    ],
  },
  {
    postleitzahl: 4730,
    orte: [
      'Anrath',
      'Aschach',
      'Auweidenholz',
      'Auwies',
      'Bäckenhof',
      'Bergern',
      'Breitwies',
      'Brunnwald',
      'Dittenbach',
      'Eitzenberg',
      'Esthofen',
      'Gewerbepark Süd',
      'Grillparz',
      'Gugerling',
      'Hausleiten',
      'Holzing',
      'Hueb bei Lindbruck',
      'Hueb bei Manzing',
      'Imperndorf',
      'Inzing',
      'Keppling',
      'Kollerbichl',
      'Kranabithen',
      'Kropfleiten',
      'Lindbruck',
      'Löwengrub',
      'Moospolling',
      'Niederndorf',
      'Niederspaching',
      'Obergschwendt',
      'Oberviehbach',
      'Oberwegbach',
      'Parzham',
      'Prambacherholz',
      'Punzing',
      'Purgstall',
      'Röckendorferholz',
      'Schöffling',
      'Schurrerprambach',
      'Sittling',
      'Steinparz',
      'Stillfüssing',
      'Stroiß',
      'Thall',
      'Thallham',
      'Untergschwendt',
      'Unterheuberg',
      'Unterviehbach',
      'Unterwegbach',
      'Waikhartsberg',
      'Waizenkirchen',
      'Waldweidenholz',
      'Weg',
      'Weidenholz',
      'Willersdorf',
      'Wölflhof',
    ],
  },
  {
    postleitzahl: 4731,
    orte: [
      'Andrichsberg',
      'Baumgarten',
      'Birihub',
      'Dachsberg',
      'Gallham',
      'Gföll',
      'Gföllnerwald',
      'Großsteingrub',
      'Grüben',
      'Gschnarret',
      'Hundswies',
      'Kleinsteingrub',
      'Kleinstroheim',
      'Langstögen',
      'Mairing',
      'Manzing',
      'Mittergallsbach',
      'Oberdoppl',
      'Obereschlbach',
      'Oberfreundorf',
      'Obergallsbach',
      'Pertmannshub',
      'Prambachkirchen',
      'Prattsdorf',
      'Ritzing',
      'Sallmannsberg',
      'Stallberg',
      'Steinbruch',
      'Taubing',
      'Unterbruck',
      'Unterdoppl',
      'Untereschlbach',
      'Untergallsbach',
      'Unterprambach',
      'Uttenthal',
      'Waizenkirchen',
      'Watzenbach',
      'Weinberg',
      'Weinzierlbruck',
    ],
  },
  {
    postleitzahl: 4732,
    orte: [
      'Aigelsberg',
      'Am Bäckerberg',
      'Ebenstraß',
      'Eppenedt',
      'Großgerstdopl',
      'Kirnwies',
      'Kleingerstdoppl',
      'Lameth',
      'Mitterwinkl',
      'Naichet',
      'Niederwinkl',
      'Oberprambach',
      'Ramesedt',
      'Reith',
      'Sankt Thomas',
      'Schmidgraben',
      'Straß',
      'Wimm',
    ],
  },
  {
    postleitzahl: 4733,
    orte: [
      'Andling',
      'Au',
      'Bach',
      'Bruck',
      'Eitzenberg',
      'Freindorf',
      'Grub',
      'Haid',
      'Heiligenberg',
      'Irrenedt',
      'Laab',
      'Maiden',
      'Moos',
      'Oberleiten',
      'Schörgendorf',
      'Süssenbach',
      'Wassergraben',
    ],
  },
  {
    postleitzahl: 4741,
    orte: [
      'Dötzledt',
      'Eck',
      'Fellhof',
      'Gassen',
      'Gugenedt',
      'Hareding',
      'Hub',
      'Kubing',
      'Lehen',
      'Märzendorf',
      'Oberhof',
      'Oberhöglham',
      'Pauredt',
      'Penesedt',
      'Perndorf',
      'Rappoltsberg',
      'Still',
      'Unterhöglham',
      'Weberndorf',
      'Weeg',
      'Wendling',
      'Zupfing',
    ],
  },
  {
    postleitzahl: 4742,
    orte: [
      'Asbach',
      'Bernhartsleiten',
      'Bruck',
      'Doppl',
      'Durrach',
      'Echtsberg',
      'Edt',
      'Feldegg',
      'Forsthub',
      'Gattring',
      'Gerhartsbrunn',
      'Gewerbepark',
      'Gries',
      'Großpoxruck',
      'Grübl',
      'Gstöcket',
      'Hebetsberg',
      'Hochhub',
      'Irringsdorf',
      'Kleinpoxruck',
      'Klinget',
      'Kornrödt',
      'Lucka',
      'Lughof',
      'Oberprenning',
      'Pram',
      'Pramberg',
      'Rabenberg',
      'Rabenthal',
      'Renhartsberg',
      'Rotten',
      'Rühring',
      'Schulterzucker',
      'Standharting',
      'Steinbruck',
      'Straß',
      'Unterleiten',
      'Unterprenning',
      'Viertlbach',
      'Wallner',
      'Wimm',
    ],
  },
  {
    postleitzahl: 4743,
    orte: [
      'Aggstein',
      'Böcklarn',
      'Brenning',
      'Dorf',
      'Eschlried',
      'Hilligan',
      'Maierhof',
      'Manhartsberg',
      'Manhartsgrub',
      'Mari',
      'Maribach',
      'Osternach',
      'Peterskirchen',
      'Untermauer',
      'Wolketsedt',
    ],
  },
  {
    postleitzahl: 4751,
    orte: [
      'Altmannsdorf',
      'Augendobl',
      'Außerjebing',
      'Dorf',
      'Großreiting',
      'Habetswohl',
      'Hinterndobl',
      'Kleinreiting',
      'Kumpfmühl',
      'Lohndorf',
      'Mitterjebing',
      'Mundorfing',
      'Natzing',
      'Obernparz',
      'Parting',
      'Pimingsdorf',
      'Roiding',
      'Schacha',
      'Schatzdorf',
      'Stögen',
      'Thalling',
      'Vorderndobl',
      'Weigljebing',
    ],
  },
  {
    postleitzahl: 4752,
    orte: [
      'Achleiten',
      'Baumgarten',
      'Bayrisch-Habach',
      'Berg',
      'Birkenallee',
      'Habach',
      'Ottenedt',
      'Pomedt',
      'Riedau',
      'Schwaben',
      'Schwabenbach',
      'Stieredt',
      'Vormarkt',
      'Wildhag',
    ],
  },
  {
    postleitzahl: 4753,
    orte: [
      'Aichet',
      'Altmannsdorf',
      'Arling',
      'Baumgarten',
      'Brandstätten',
      'Breitenried',
      'Bruckleiten',
      'Edtleiten',
      'Ellerbach bei Taiskirchen im Innkreis',
      'Ellerbach',
      'Flohleiten',
      'Gansing',
      'Gotthalmsedt',
      'Günzing',
      'Helfingsdorf',
      'Hohenerlach',
      'Jebing',
      'Jedretsberg',
      'Kainzing',
      'Kleingaisbach',
      'Kühdobl',
      'Lacken',
      'Lindet',
      'Petersham',
      'Sittling',
      'Taiskirchen im Innkreis',
      'Tiefenbach',
      'Unterbreitenried',
      'Wiesenberg',
      'Wietraun',
      'Wohleiten',
      'Wolfsedt',
      'Zahra',
    ],
  },
  {
    postleitzahl: 4754,
    orte: [
      'Albertsedt',
      'Andrichsfurt',
      'Furt',
      'Gehnbach',
      'Irger',
      'Krammern',
      'Moosedt',
      'Pötting',
      'Raschhof',
      'Steingreß',
      'Straß',
      'Walchshausen',
      'Weilhart',
    ],
  },
  {
    postleitzahl: 4755,
    orte: [
      'Aiglbrechting',
      'Bernetsedt',
      'Blümling',
      'Brandesleiten',
      'Dobl',
      'Dorf',
      'Eichberg',
      'Fuckersberg',
      'Gmeinedt',
      'Habekendobl',
      'Hausmanning',
      'Hellwagen',
      'Holzedt',
      'Hub',
      'Jebling',
      'Krena',
      'Obergriesbach',
      'Ornetsedt',
      'Point',
      'Reischenbach',
      'Schwarzgrub',
      'Sienleiten',
      'Stögen',
      'Tischling',
      'Weireth',
      'Wiesing',
      'Wildhag',
      'Willing',
      'Würting',
      'Zell an der Pram',
    ],
  },
  {
    postleitzahl: 4760,
    orte: [
      'Bründl',
      'Brünning',
      'Einburg',
      'Gautzham',
      'Großprambach',
      'Kleinpireth',
      'Krennhof',
      'Niederham',
      'Oberspitzling',
      'Pausing',
      'Raab',
      'Rackersedt',
      'Riedlhof',
      'Thal',
      'Ungering',
      'Weeg',
    ],
  },
  {
    postleitzahl: 4761,
    orte: [
      'Bimmersdorf',
      'Enzenkirchen',
      'Goldberg',
      'Hacking',
      'Heitzing',
      'Hintersberg',
      'Jagern',
      'Kenading',
      'Kriegen',
      'Matzing',
      'Mühlwitraun',
      'Oberau',
      'Oberleiten',
      'Ratzenbach',
      'Ruprechtsberg',
      'Schwarzenberg',
      'Straßwitraun',
      'Ungernberg',
    ],
  },
  {
    postleitzahl: 4762,
    orte: [
      'Aichet',
      'Antlangkirchen',
      'Dick',
      'Geiselham',
      'Geizedt',
      'Gschaid',
      'Landersberg',
      'Oberantlang',
      'Oberleiten',
      'Patrichsham',
      'Reiting',
      'St. Willibald',
      'Wamprechtsham',
    ],
  },
  {
    postleitzahl: 4770,
    orte: [
      'An der Fernstraße',
      'Andorf',
      'Autzing',
      'Bach',
      'Basling',
      'Bruck',
      'Burgerding',
      'Eberleinsedt',
      'Edt bei Heitzing',
      'Edt beim Pfarrhof',
      'Erlau',
      'Gerolding',
      'Getzing',
      'Großpichl',
      'Großschörgern',
      'Haula',
      'Hebertspram',
      'Heitzing',
      'Heitzingerau',
      'Hier',
      'Hof',
      'Hörzberg',
      'Hötzenedt',
      'Hötzlarn',
      'Humerleiten',
      'Hutstock',
      'Kleinpichl',
      'Kleinschörgern',
      'Kreilern',
      'Kurzenkirchen',
      'Laab',
      'Lauterbrunn',
      'Lichtegg',
      'Linden',
      'Lohstampf',
      'Matzing',
      'Mayrhof',
      'Niederhartwagen',
      'Niederleiten',
      'Oberndorf',
      'Pimpfing',
      'Pram',
      'Pranzen',
      'Rablern',
      'Radlern',
      'Schärdingerau',
      'Schießedt',
      'Schulleredt',
      'Seifriedsedt',
      'Teuflau',
      'Untergriesbach',
      'Winertsham',
      'Winertshamerau',
      'Winteraigen',
    ],
  },
  {
    postleitzahl: 4771,
    orte: [
      'Doblern',
      'Grub',
      'Hacking',
      'Oberhaigen',
      'Sigharting',
      'Thal',
      'Thalmannsbach',
      'Unterhaigen',
      'Unterholzen',
      'Wurmsdobl',
    ],
  },
  {
    postleitzahl: 4772,
    orte: [
      'Augental',
      'Blindendorf',
      'Breiningsdorf',
      'Breitenberg',
      'Bruck',
      'Ellerbach',
      'Gerhagen',
      'Gupfing',
      'Hutstock',
      'Kromberg',
      'Lambrechten',
      'Messenbach',
      'Neundling',
      'Rabenstreit',
      'Reichergerhagen',
      'Reschenedt',
      'Sonnleiten',
      'Winkl',
      'Wohlmuthen',
    ],
  },
  {
    postleitzahl: 4773,
    orte: [
      'Bernedt',
      'Edenaichet',
      'Edenrad',
      'Eggerding',
      'Hackledt',
      'Hof',
      'Höribach',
      'Hundshagen',
      'Maasbach',
      'Maihof',
      'Ranseredt',
      'Wernhartsgrub',
    ],
  },
  {
    postleitzahl: 4774,
    orte: [
      'Andiesen',
      'Bach',
      'Bernedt',
      'Bodenhofen',
      'Dietraching',
      'Dietrichshofen',
      'Edenrad',
      'Großwiesenhart',
      'Grub',
      'Hackenbuch',
      'Holzleithen',
      'Hub',
      'Kleinwiesenhart',
      'Lindenedt',
      'Niederham',
      'Oberfucking',
      'Schratzberg',
      'Singern',
      'St. Marienkirchen bei Schärding',
      'Stocket',
      'Unterfucking',
      'Wernhartsgrub',
    ],
  },
  {
    postleitzahl: 4775,
    orte: [
      'Aichberg',
      'Aichedt',
      'Bachschwölln',
      'Baumgarten',
      'Berg',
      'Berndobl',
      'Brauchsdorf',
      'Brunedt',
      'Feicht',
      'Furth-Pfaffing',
      'Furth',
      'Gadern',
      'Gmeinau',
      'Haberedt',
      'Höbmannsbach',
      'Höbmannsdorf',
      'Holzing',
      'Hundshagen',
      'Igling',
      'Jechtenham',
      'Kalchgrub',
      'Kapelln',
      'Kleinwaging',
      'Laufenbach',
      'Leoprechting',
      'Maad',
      'Oberpramau',
      'Pfaffingdorf',
      'Pram',
      'Schwendt',
      'Sinzing',
      'Sonndorf',
      'Taufkirchen an der Pram',
      'Unterpramau',
      'Wagholming',
      'Wimm',
      'Windten',
      'Wolfsedt',
    ],
  },
  {
    postleitzahl: 4776,
    orte: [
      'Alfersham',
      'Angsüß',
      'Antersham',
      'Bartenberg',
      'Bernolden',
      'Brunnern',
      'Buchet',
      'Diersbach',
      'Dobl',
      'Eden',
      'Edenwiesen',
      'Erledt',
      'Etzelbach',
      'Froschau',
      'Großwaging',
      'Gumping',
      'Hartwagen',
      'Herrnberg',
      'Hochegg',
      'Igling',
      'Inding',
      'Kalling',
      'Kindling',
      'Kobledt',
      'Mayberg',
      'Mitterndorf',
      'Mörstalling',
      'Oberedt',
      'Raad',
      'Schmidsedt',
      'Schwabenhub',
      'Sonndorf',
      'Unterholzen',
    ],
  },
  {
    postleitzahl: 4777,
    orte: ['Heiligenbaum', 'Mayrhof', 'Oberndorf'],
  },
  {
    postleitzahl: 4780,
    orte: [
      'Allerheiligen',
      'Brunnwies',
      'Kreuzberg',
      'Schärding Innere Stadt',
      'Schärding Vorstadt',
    ],
  },
  {
    postleitzahl: 4782,
    orte: [
      'Aigerding',
      'Allerding',
      'Badhöring',
      'Bubing',
      'Buch',
      'Edt',
      'Etzelsdorf',
      'Gopperding',
      'Grub',
      'Haid',
      'Kalchgrub',
      'Oberhofen',
      'Oberteufenbach',
      'Otterbach',
      'Pramerdorf',
      'Pramhof',
      'Rahaberg',
      'Rainding',
      'Samberg',
      'St. Florian am Inn',
      'Steinbach',
      'Stocket',
      'Unterteufenbach',
      'Vielsassing',
    ],
  },
  {
    postleitzahl: 4783,
    orte: [
      'Fraunhof',
      'Göpping',
      'Hofötz',
      'Linden',
      'Öhret',
      'Rutzenberg',
      'Sachsenberg',
      'Schafberg',
      'Stöbichen',
      'Wernstein am Inn',
      'Wimberg',
      'Zwickledt',
    ],
  },
  {
    postleitzahl: 4784,
    orte: [
      'Achleiten',
      'Amelreiching',
      'Asing',
      'Bach',
      'Dierthalling',
      'Edt',
      'Entholz',
      'Fraunhof',
      'Gattern',
      'Grub',
      'Ingling',
      'Kinham',
      'Lehen',
      'Lindenberg',
      'Luck',
      'Schardenberg',
      'Schönbach',
      'Wibling',
      'Winkl',
    ],
  },
  {
    postleitzahl: 4785,
    orte: [
      'Anzberg',
      'Bach',
      'Freinberg',
      'Haibach',
      'Hanzing',
      'Hinding',
      'Kritzing',
      'Lehen',
      'Neudling',
      'Saming',
    ],
  },
  {
    postleitzahl: 4786,
    orte: [
      'Atzmanning',
      'Brunnenthal',
      'Brunnwies',
      'Dobl',
      'Eggersham',
      'Haraberg',
      'Hueb',
      'Kapfham',
      'Korneredt',
      'Kreuzberg',
      'Reikersberg',
      'Wallensham',
    ],
  },
  {
    postleitzahl: 4791,
    orte: [
      'Berndlsiedlung',
      'Eggenberg',
      'Haselbach',
      'Hauzing',
      'Hingsham',
      'Höbmannsbach',
      'Höcking',
      'Höretzberg',
      'Kapfham',
      'Korneredt',
      'Luck',
      'Ortenholz',
      'Pfaffing',
      'Rainbach im Innkreis',
      'Randolfing',
      'Salling',
      'Sinzing',
      'Steinberg',
      'Sumetsrad',
      'Weizenau',
      'Wienering',
    ],
  },
  {
    postleitzahl: 4792,
    orte: [
      'Eisenbirn',
      'Eitzenberg',
      'Englhaming',
      'Feicht',
      'Ficht',
      'Freundorf',
      'Füchsledt',
      'Geibing',
      'Ginzlberg',
      'Hötzenberg',
      'Landertsberg',
      'Langendorf',
      'Ludham',
      'Münzkirchen',
      'Prackenberg',
      'Raad',
      'Schießdorf',
      'Steinerzaun',
      'Wilhelming',
    ],
  },
  {
    postleitzahl: 4793,
    orte: [
      'Altendorf',
      'Aschenberg',
      'Au',
      'Danedt',
      'Ebertsberg',
      'Ginzldorf',
      'Höll',
      'Jetzingerdorf',
      'Kössldorf',
      'Oberndorf',
      'Penzingerdorf',
      'Razing',
      'Schnürberg',
      'Steinerzaun',
      'Watzing',
      'Wienetsdorf',
    ],
  },
  {
    postleitzahl: 4794,
    orte: [
      'Au',
      'Beharding',
      'Dürnberg',
      'Engertsberg',
      'Entholz',
      'Glatzing',
      'Grafendorf',
      'Hub',
      'Kahlberg',
      'Kenading',
      'Kimleinsdorf',
      'Knechtelsdorf',
      'Kopfing im Innkreis',
      'Kopfingerdorf',
      'Leithen',
      'Matzelsdorf',
      'Mitteredt',
      'Neukirchendorf',
      'Paulsdorf',
      'Pratztrum',
      'Raffelsdorf',
      'Rasdorf',
      'Ruholding',
      'Straß',
      'Wollmannsdorf',
    ],
  },
  {
    postleitzahl: 4800,
    orte: [
      'Aham',
      'Aichet',
      'Altensam',
      'Attnang',
      'Deutenham',
      'Hohenbaumgarten',
      'Landertsham',
      'Lehen',
      'Moosham',
      'Niederstraß',
      'Oberstraß',
      'Puchheim',
      'Pühret',
      'Schlierberg',
      'Sicking',
      'Sonnleithen',
      'Steinhübl',
      'Unterpilsbach',
      'Wankham',
    ],
  },
  {
    postleitzahl: 4801,
    orte: ['Eben', 'Mühlbach', 'Nachdemsee', 'Traunkirchen'],
  },
  {
    postleitzahl: 4802,
    orte: [
      'Ebensee',
      'Kohlstatt',
      'Lahnstein',
      'Langwies',
      'Oberlangbath',
      'Offensee',
      'Plankau',
      'Rindbach',
      'Roith',
      'Trauneck',
      'Unterlangbath',
    ],
  },
  {
    postleitzahl: 4810,
    orte: [
      'Altmünster',
      'Buchen',
      'Eck',
      'Gmunden',
      'Gschwandt',
      'Moosham',
      'Neuhofen',
      'Pinsdorf',
    ],
  },
  {
    postleitzahl: 4812,
    orte: [
      'Buchen',
      'Gmundnerberg',
      'Großkufhaus',
      'Innergrub',
      'Mairhof',
      'Moos',
      'Neuhofen',
      'Pinsdorf',
      'Pinsdorfberg',
      'Reindlmühl',
      'Steinbichl',
      'Wiesen',
      'Wolfsgrub',
    ],
  },
  {
    postleitzahl: 4813,
    orte: [
      'Altmünster',
      'Eben',
      'Ebenzweier',
      'Eck',
      'Gmundnerberg',
      'Grasberg',
      'Nachdemsee',
    ],
  },
  {
    postleitzahl: 4814,
    orte: [
      'Altmünster',
      'Eben',
      'Gmundnerberg',
      'Grasberg',
      'Kasten',
      'Mühlbach',
      'Neukirchen',
      'Reindlmühl',
    ],
  },
  {
    postleitzahl: 4816,
    orte: ['Gschwandt', 'Laakirchen', 'Moosham', 'Oberndorf'],
  },
  {
    postleitzahl: 4817,
    orte: ['Dorf', 'Edt', 'Gschwandt', 'Kohlwiese', 'Sankt Konrad', 'Steg'],
  },
  {
    postleitzahl: 4820,
    orte: [
      'Ahorn',
      'Bad Ischl',
      'Eck',
      'Haiden',
      'Hinterstein',
      'Jainzen',
      'Kaltenbach',
      'Kößlbach',
      'Kreutern',
      'Lauffen',
      'Lindau',
      'Mitterweißenbach',
      'Perneck',
      'Ramsau',
      'Reiterndorf',
      'Rettenbach',
      'Roith',
      'Steinbruch',
      'Steinfeld',
      'Sulzbach',
    ],
  },
  {
    postleitzahl: 4821,
    orte: ['Kaltenbach', 'Lauffen', 'Reiterndorf', 'Sulzbach'],
  },
  {
    postleitzahl: 4822,
    orte: [
      'Anzenau',
      'Au',
      'Bad Goisern',
      'Edt',
      'Görb',
      'Gschwandt',
      'Herndl',
      'Kogl',
      'Lasern',
      'Muth',
      'Obersee',
      'Pichlern',
      'Posern',
      'Pötschen',
      'Primesberg',
      'Ramsau',
      'Rehkogl',
      'Reitern',
      'Riedln',
      'Sankt Agatha',
      'Sarstein',
      'Solbach',
      'Stambach',
      'Steeg',
      'Steinach',
      'Unterjoch',
      'Untersee',
      'Weißenbach',
      'Wiesen',
      'Wildpfad',
      'Wurmstein',
    ],
  },
  {
    postleitzahl: 4823,
    orte: ['Gosauzwang'],
  },
  {
    postleitzahl: 4824,
    orte: ['Gosau'],
  },
  {
    postleitzahl: 4825,
    orte: ['Gosau'],
  },
  {
    postleitzahl: 4830,
    orte: ['Gosauzwang', 'Hallstatt', 'Lahn', 'Salzberg'],
  },
  {
    postleitzahl: 4831,
    orte: ['Obertraun', 'Winkl'],
  },
  {
    postleitzahl: 4840,
    orte: [
      'Am Landlberg',
      'Buchleiten',
      'Diesenbach',
      'Dörfl',
      'Dürnau',
      'Freileiten',
      'Kirchberg',
      'Kirchstetten',
      'Oberhaus',
      'Oberpilsbach',
      'Pfarrerfeld',
      'Schöndorf',
      'Untereinwald',
      'Unterpilsbach',
      'Vöcklabruck',
      'Vornbuch',
      'Wagrain',
      'Wegscheid',
      'Ziegelwies',
    ],
  },
  {
    postleitzahl: 4841,
    orte: [
      'Ainwalding',
      'Außerhafling',
      'Billichsedt',
      'Brunau',
      'Brunngstaudet',
      'Dornet',
      'Einwald',
      'Engelsheim',
      'Fuchsberg',
      'Grillmoos',
      'Haag',
      'Heitzing',
      'Heuweg',
      'Hocheck',
      'Hochmoos',
      'Innerhafling',
      'Jocheredt',
      'Kellner',
      'Kien',
      'Kirchholz',
      'Kochberg',
      'Kronberg',
      'Mittereinwald',
      'Mitterschlag',
      'Mösl',
      'Natternberg',
      'Obereinwald',
      'Oberleim',
      'Pohn',
      'Pohnedt',
      'Rametsberg',
      'Reichering',
      'Schmidham',
      'Ungenach',
      'Unterleim',
      'Vorderschlag',
      'Zahnhof',
      'Zehentpoint',
    ],
  },
  {
    postleitzahl: 4842,
    orte: [
      'Bruck',
      'Burgstall',
      'Ehwalchen',
      'Franzeneck',
      'Gerhardsberg',
      'Gewerbestraße',
      'Heinrichsberg',
      'Hinteredt',
      'Hinterschachen',
      'Hochrain',
      'Kalletsberg',
      'Ketzerhub',
      'Kopplbrenn',
      'Kreuth',
      'Pettenfirst',
      'Roith',
      'Schablberg',
      'Schierling',
      'Schwarzland',
      'Vornholz',
      'Wegleithen',
      'Wolfsdoppl',
      'Zell am Pettenfirst',
    ],
  },
  {
    postleitzahl: 4843,
    orte: [
      'Aigen',
      'Ampflwang',
      'Buchleiten',
      'Eitzing',
      'Hinterschlagen',
      'Innerleiten',
      'Lukasberg',
      'Ort',
      'Rabelsberg',
      'Rödleiten',
      'Schachen',
      'Scheiblwies',
      'Schmitzberg',
      'Siedlung',
      'Vorderschlagen',
      'Waldpoint',
      'Wassenbach',
      'Wörmansedt',
    ],
  },
  {
    postleitzahl: 4844,
    orte: [
      'Dornet',
      'Geidenberg',
      'Himmelreich',
      'Illingbuch',
      'Lahn',
      'Lixlau',
      'Oberregau',
      'Preising',
      'Pürstling',
      'Regau',
      'Riedl',
      'Roith',
      'Schacha',
      'Schalchham',
      'Schönberg',
      'Zaissing',
    ],
  },
  {
    postleitzahl: 4845,
    orte: [
      'Alm',
      'Dorf',
      'Eck',
      'Hattenberg',
      'Hinterbuch',
      'Hub',
      'Kirchberg',
      'Mairhof',
      'Neudorf',
      'Oberkriech',
      'Pilling',
      'Reith',
      'Ritzing',
      'Rutzenmoos',
      'Stölln',
      'Tiefenweg',
      'Unterkriech',
      'Weiding',
      'Wiesen',
    ],
  },
  {
    postleitzahl: 4846,
    orte: [
      'Au',
      'Einwarting',
      'Erlau',
      'Fisching',
      'Gewerbepark Mitte',
      'Gewerbepark Ost',
      'Gewerbepark West',
      'Hainprechting',
      'Jebing',
      'Landertsham',
      'Piesing',
      'Pühret',
      'Redlham',
      'Sonnfeld',
      'Tuffeltsham',
    ],
  },
  {
    postleitzahl: 4849,
    orte: ['Puchkirchen'],
  },
  {
    postleitzahl: 4850,
    orte: [
      'Ader',
      'Altwartenburg',
      'Außerungenach',
      'Eiding',
      'Grillmoos',
      'Gsteinedt',
      'Haag',
      'Jochling',
      'Kalchofen',
      'Leidern',
      'Maierhof',
      'Mühlfeld',
      'Neuwartenburg',
      'Oberau',
      'Obergallaberg',
      'Oberthalheim',
      'Pichlwang',
      'Stöfling',
      'Straß',
      'Timelkam',
      'Unterau',
      'Untergallaberg',
      'Wimberg',
    ],
  },
  {
    postleitzahl: 4851,
    orte: [
      'Baumgarting',
      'Bergham',
      'Bierbaum',
      'Egning',
      'Fischham',
      'Fischhamering',
      'Gallnbrunn',
      'Gampern',
      'Genstetten',
      'Haunolding',
      'Hehenberg',
      'Hörgattern',
      'Koberg',
      'Oberheikerding',
      'Piesdorf',
      'Pöring',
      'Schwarzmoos',
      'Siedling',
      'Stein',
      'Steindorf',
      'Stötten',
      'Unterheikerding',
      'Viehaus',
      'Weiterschwang',
      'Witzling',
    ],
  },
  {
    postleitzahl: 4852,
    orte: [
      'Alexenau',
      'Bach',
      'Gahberg',
      'Miglberg',
      'Reichholz',
      'Seeberg',
      'Steinwand',
      'Weyregg am Attersee',
    ],
  },
  {
    postleitzahl: 4853,
    orte: [
      'Berg',
      'Blümigen',
      'Dorf',
      'Feld',
      'Forstamt',
      'Gmauret',
      'Haslach',
      'Hochlecken',
      'Kaisigen',
      'Kienklause',
      'Kiental',
      'Oberfeichten',
      'Seefeld',
      'Steinbach am Attersee',
      'Unterfeichten',
      'Unterroith',
      'Weißenbach am Attersee',
    ],
  },
  {
    postleitzahl: 4854,
    orte: ['Unterburgau'],
  },
  {
    postleitzahl: 4860,
    orte: [
      'Alt Lenzing',
      'Burgstall',
      'Haid',
      'Kraims',
      'Lenzing',
      'Neuhausen',
      'Oberachmann',
      'Obereck',
      'Pichlwang',
      'Raudaschlmühle',
      'Reibersdorf',
      'Thal',
      'Ulrichsberg',
      'Unterachmann',
      'Untereck',
      'Untergallaberg',
    ],
  },
  {
    postleitzahl: 4861,
    orte: [
      'Aurach am Hongar',
      'Fantaberg',
      'Gahberg',
      'Grafenbuch',
      'Hainbach',
      'Halbmoos',
      'Illingbuch',
      'Jetzing',
      'Kammer',
      'Kasten',
      'Looh',
      'Marktwald',
      'Moos',
      'Niederham',
      'Oberhehenfeld',
      'Pranzing',
      'Raschbach',
      'Schörfling',
      'Steinbach',
      'Sulzberg',
      'Weichselbaum',
      'Wörzing',
    ],
  },
  {
    postleitzahl: 4863,
    orte: [
      'Ainwalchen',
      'Baum',
      'Buchberg',
      'Gerlham',
      'Haidach',
      'Haining',
      'Kemating',
      'Kraims',
      'Litzlberg',
      'Moos',
      'Neißing',
      'Neubrunn',
      'Pettighofen',
      'Reichersberg',
      'Roitham',
      'Seewalchen am Attersee',
      'Staudach',
      'Steindorf',
      'Unterbuchberg',
    ],
  },
  {
    postleitzahl: 4864,
    orte: [
      'Abtsdorf',
      'Altenberg',
      'Attersee',
      'Aufham',
      'Breitenröth',
      'Mühlbach',
      'Neuhofen',
      'Oberbach',
      'Palmsdorf',
    ],
  },
  {
    postleitzahl: 4865,
    orte: [
      'Aich',
      'Aichereben',
      'Dexelbach',
      'Lichtenbuch',
      'Limberg',
      'Nußdorf am Attersee',
      'Parschallen',
      'Reith',
      'Streit',
      'Zell',
    ],
  },
  {
    postleitzahl: 4866,
    orte: ['Au', 'Buchenort', 'Oberburgau', 'Unterach', 'Unterburgau'],
  },
  {
    postleitzahl: 4870,
    orte: [
      'Aierzelten',
      'Fischham',
      'Frieding',
      'Gopprechting',
      'Graben',
      'Gries',
      'Gründberg',
      'Haid',
      'Hainberg',
      'Hainleiten',
      'Hangstraße',
      'Hausham',
      'Holzpoint',
      'Hörading',
      'Hötzing',
      'Kalvarienberg',
      'Krichpoint',
      'Kropfling',
      'Landberg',
      'Maulham',
      'Maurachen',
      'Mauracherberg',
      'Mesnerleiten',
      'Mitterberg',
      'Moos',
      'Mörasing',
      'Mösendorf',
      'Mösenthal',
      'Mühlreith',
      'Nindorf',
      'Oberkogl',
      'Pfaffing',
      'Reichenthalheim',
      'Schmidham',
      'Schneiderweg',
      'Schweiber',
      'Sonnleiten',
      'Spielberg',
      'Steinberg',
      'Teicht',
      'Thal',
      'Unteralberting',
      'Unterholz',
      'Unterkogl',
      'Viecht',
      'Vöcklamarkt',
      'Walchen',
      'Walkering',
      'Waschprechting',
      'Waschprechtingerberg',
      'Weixlbaum',
      'Weixlbaumerberg',
      'Wies',
      'Wilding',
      'Ziegelhaid',
    ],
  },
  {
    postleitzahl: 4871,
    orte: [
      'Arnberg',
      'Außerhörgersteig',
      'Bachleiten',
      'Dorf',
      'Egg',
      'Exlwöhr',
      'Haslach',
      'Haslau',
      'Kappligen',
      'Kienleiten',
      'Langwies',
      'Mühlstaudet',
      'Neudorf',
      'Pfefferberg',
      'Pollhammeredt',
      'Ragereck',
      'Redl',
      'Rohrwies',
      'Satteltal',
      'Teichweg',
      'Tiefenbach',
      'Unterau',
      'Zeiling',
      'Zipf',
    ],
  },
  {
    postleitzahl: 4872,
    orte: [
      'Ackersberg',
      'Biber',
      'Dachschwendau',
      'Endriegl',
      'Froschern',
      'Haid',
      'Höllersberg',
      'Jagersberg',
      'Kogl',
      'Kolopfern',
      'Lichtenegg',
      'Meislgrub',
      'Mixental',
      'Mühlleiten',
      'Neukirchen an der Vöckla',
      'Oberthumberg',
      'Raschbach',
      'Redl',
      'Satteltal',
      'Seirigen',
      'Sonnleiten',
      'Spöck',
      'Stipplmühl',
      'Teufligen',
      'Unterthumberg',
      'Verwang',
      'Waltersdorf',
      'Wegleiten',
      'Welsern',
      'Weyr',
      'Wimm',
      'Windbichl',
      'Winteredt',
      'Wöhr',
      'Zuckau',
    ],
  },
  {
    postleitzahl: 4873,
    orte: [
      'Arbing',
      'Au',
      'Aubach',
      'Badstuben',
      'Brunnhölzl',
      'Diemröth',
      'Dorf',
      'Endriegl',
      'Engern',
      'Erdpries',
      'Erkaburgen',
      'Erlatwaid',
      'Finkenröth',
      'Fischeredt',
      'Fischigen',
      'Frankenburg am Hausruck',
      'Friedhalbing',
      'Geldigen',
      'Göblberg',
      'Grünbergsiedlung',
      'Halt',
      'Hilprigen',
      'Hintersteining',
      'Hoblschlag',
      'Hofberg',
      'Innerhörgersteig',
      'Innerleiten',
      'Kinast',
      'Klanigen',
      'Leitrachstätten',
      'Lessigen',
      'Loixigen',
      'Marigen',
      'Märzigen',
      'Mauern',
      'Mayrhof',
      'Mitterriegl',
      'Niederriegl',
      'Oberedt',
      'Oberegg',
      'Oberfeitzing',
      'Oberhaselbach',
      'Ottigen',
      'Ottokönigen',
      'Otzigen',
      'Pehigen',
      'Perschling',
      'Point',
      'Pramegg',
      'Raitenberg',
      'Redleiten',
      'Redltal',
      'Renigen',
      'Rothauptberg',
      'Schnöllhof',
      'Schweinegg',
      'Seibrigen',
      'Stöckert',
      'Unteredt',
      'Unterfeitzing',
      'Unterhaselbach',
      'Vordersteining',
      'Wiederhals',
      'Winkl',
      'Zachleiten',
    ],
  },
  {
    postleitzahl: 4880,
    orte: [
      'Aich',
      'Alkersdorf',
      'Baum',
      'Berg im Attergau',
      'Bergham',
      'Brandham',
      'Buch',
      'Eggenberg',
      'Eisenpalmsdorf',
      'Engljähring',
      'Hipping',
      'Jedlham',
      'Katterlohen',
      'Kogl',
      'Königswiesen',
      'Lohen',
      'Lohened',
      'Pössing',
      'Raith',
      'Rixing',
      'Rubensdorf',
      'St. Georgen im Attergau',
      'Staudach',
      'Thalham',
      'Thanham',
      'Thern',
      'Walsberg',
      'Wötzing',
    ],
  },
  {
    postleitzahl: 4881,
    orte: [
      'Dachsenberg',
      'Erlat',
      'Fronbühel',
      'Halt',
      'Innerlohen',
      'Kronberg',
      'Leming',
      'Lichtenberg',
      'Mitterleiten',
      'Oberleiten',
      'Pabing',
      'Powang',
      'Sagerer',
      'Seeblick',
      'Stöttham',
      'Straß im Attergau',
      'Wald',
      'Wildenhag',
    ],
  },
  {
    postleitzahl: 4882,
    orte: [
      'Gessenschwandt',
      'Grossenschwandt',
      'Oberaschau',
      'Oberwang',
      'Radau',
      'Traschwandt',
    ],
  },
  {
    postleitzahl: 4890,
    orte: [
      'Asten',
      'Auleiten',
      'Brandstatt',
      'Buchscharten',
      'Danzenreith',
      'Egg',
      'Frankenmarkt',
      'Freudenthal',
      'Geßlingen',
      'Giga',
      'Gries',
      'Gstocket',
      'Haitigen',
      'Haitzenthal',
      'Hauchhorn',
      'Höhenwarth',
      'Hölleiten',
      'Hussenreith',
      'Kritzing',
      'Kühschinken',
      'Moos',
      'Mösendorf',
      'Mühlberg',
      'Pabigen',
      'Piereth',
      'Pointen',
      'Raspoldsedt',
      'Reittern',
      'Röth',
      'Rudlberg',
      'Schwertfern',
      'Stadln',
      'Stauf',
      'Steinwand',
      'Truchtlingen',
      'Tuttingen',
      'Unterrain',
      'Vöcklatal',
      'Weißenkirchen im Attergau',
      'Wieneröth',
      'Wimm',
      'Ziegelstadl',
    ],
  },
  {
    postleitzahl: 4891,
    orte: [
      'Bergham',
      'Brunnwies',
      'Fellern',
      'Forstern',
      'Gaisteig',
      'Geretseck',
      'Haberpoint',
      'Haidach',
      'Hechfeld',
      'Hocheck',
      'Höhenwarth',
      'Kirchham',
      'Landgraben',
      'Lascostraße',
      'Matzlröth',
      'Nößlthal',
      'Obermühlham',
      'Oberschwand',
      'Pading',
      'Plain',
      'Pöndorf',
      'Preinröth',
      'Schachen',
      'Schrofnerstraße',
      'Schwaigern',
      'Untermühlham',
      'Unterreith',
      'Unterschwand',
      'Vöcklatal',
      'Volkerding',
    ],
  },
  {
    postleitzahl: 4892,
    orte: [
      'Adligen',
      'Außerreith',
      'Doppelmühle',
      'Emming',
      'Fachberg',
      'Feichtenberg',
      'Fornach',
      'Forsterreith',
      'Gferreth',
      'Gmeineck',
      'Grilln',
      'Grillnpoint',
      'Grubleiten',
      'Grubleitenpoint',
      'Oberalberting',
      'Obermoos',
      'Pichl',
      'Ramsau',
      'Röth',
      'Sallach',
      'Saxigen',
      'Schnöllerberg',
      'Schwandeck',
      'Seppenröth',
      'Sieberer',
      'Unterholzing',
      'Unterkogl',
      'Walligen',
      'Zaißen',
    ],
  },
  {
    postleitzahl: 4893,
    orte: [
      'Brandstatt',
      'Breitenau',
      'Entersgraben',
      'Gassen',
      'Gollau',
      'Greith',
      'Guggenberg',
      'Harpoint',
      'Haslau-Berg',
      'Haslau',
      'Häusern',
      'Heissing',
      'Hof',
      'Kohlstatt',
      'Lindau',
      'Oberschwand',
      'Schweibern',
      'Steinbach',
      'Tiefgraben',
      'Unterschwand',
      'Vormoos',
      'Zell am Moos',
    ],
  },
  {
    postleitzahl: 4894,
    orte: [
      'Berg',
      'Brunnberg',
      'Eichenweg',
      'Fischhof',
      'Gegend',
      'Gewerbegebiet-Salzweg',
      'Haslach',
      'Höhenroith',
      'Laiter',
      'Oberhofen am Irrsee',
      'Obernberg',
      'Rabenschwand',
      'Römerhof',
      'Salzweg',
      'Schoibern',
      'Stock',
      'Wegdorf',
    ],
  },
  {
    postleitzahl: 4901,
    orte: [
      'Achleithen',
      'Bärnthal',
      'Bergern',
      'Bruckmühl',
      'Deisenham',
      'Englfing',
      'Gatterlacken',
      'Grub',
      'Grünbach',
      'Hagleithen',
      'Hausruckedt',
      'Holzham',
      'Holzleithen',
      'Hub',
      'Kronabitten',
      'Kropfling',
      'Laah',
      'Manning',
      'Mansing',
      'Mitterarming',
      'Niederpuchheim',
      'Oberkienberg',
      'Obermühlau',
      'Ottnang',
      'Plötzenedt',
      'Rackering',
      'Redl',
      'Roithing',
      'Schachen bei Furtpoint',
      'Schlag',
      'Simmering',
      'Stockedt',
      'Thomasroith',
      'Untermühlau',
      'Vorderarming',
      'Vornwald',
      'Walding',
      'Wassenbrunn',
      'Wiesing',
    ],
  },
  {
    postleitzahl: 4902,
    orte: [
      'Aferhagen',
      'Albertsham',
      'Deisenham',
      'Friesam',
      'Gstaudet',
      'Hauxmoos',
      'Hueb',
      'Imling',
      'Kohlgrube',
      'Kühnberg',
      'Litzlfeld',
      'Öldenberg',
      'Schlaugenham',
      'Schlaugenholz',
      'Steinpoint',
      'Unterkienberg',
      'Waid',
      'Waidring',
      'Watzing',
      'Wilding',
      'Wolfsegg am Hausruck',
    ],
  },
  {
    postleitzahl: 4903,
    orte: [
      'Au',
      'Furtpoint',
      'Gasteig',
      'Hofmanning',
      'Kreuth',
      'Lehen',
      'Manning',
      'Moos',
      'Schachen bei Furtpoint',
      'Schachen bei Wolfshütte',
      'Scharedt',
      'Starling',
      'Stocket',
      'Vornbuch',
      'Wolfshütte',
      'Zaun',
    ],
  },
  {
    postleitzahl: 4904,
    orte: [
      'Aigen',
      'Atzbach',
      'Baumgarting',
      'Breitwiesen',
      'Enzelsberg',
      'Freundling',
      'Gneisting',
      'Hippelsberg',
      'Katzenberg',
      'Köppach',
      'Lameckberg',
      'Oberapping',
      'Oberholzham',
      'Point',
      'Reichering',
      'Ritzling',
      'Schnötzing',
      'Seiring',
      'Staudach',
      'Unterapping',
      'Weigensam',
    ],
  },
  {
    postleitzahl: 4906,
    orte: [
      'Albertsham',
      'Anetsham',
      'Anhang',
      'Antiesen',
      'Aspach',
      'Eberschwang',
      'Edt',
      'Eichetsham',
      'Feichtet',
      'Felling',
      'Fleischhacken',
      'Greifenedt',
      'Hausruck',
      'Hof',
      'Hötzing',
      'Illing',
      'Königsberg',
      'Leopoldshofstatt',
      'Mitterbreitsach',
      'Moos',
      'Mühring',
      'Oberbreitsach',
      'Ötzling',
      'Prinsach',
      'Pumberg',
      'Putting',
      'Reinthal',
      'Straß',
      'Vocking',
      'Walling',
      'Wappeltsham',
      'Wolfharting',
      'Wörling',
    ],
  },
  {
    postleitzahl: 4910,
    orte: [
      'Altenried',
      'Asenham',
      'Atzing',
      'Aubach',
      'Daring',
      'Dunzing',
      'Haging',
      'Hochkuchl',
      'Hof',
      'Oberbrunn',
      'Pattigham',
      'Pattighamried',
      'Renetsham',
      'Ried im Innkreis',
      'Sankt Thomas',
      'Schachen',
      'Schwarzenbach',
      'Zeilach',
    ],
  },
  {
    postleitzahl: 4911,
    orte: [
      'Aigen',
      'Am Stadion',
      'Eschlried',
      'Fuchsleiten',
      'Hannesgrub Nord',
      'Hannesgrub Süd',
      'Holnberg',
      'Holzhäuseln',
      'Lehen',
      'Moosedt',
      'Ottenbach',
      'Pesenreith',
      'Rabenberg',
      'Schnalla',
      'Schönfeld',
      'Stöcklgras',
      'Tumeltsham',
      'Walchshausen',
    ],
  },
  {
    postleitzahl: 4912,
    orte: [
      'Auleiten',
      'Baumbach',
      'Baumgarten',
      'Bergetsedt',
      'Gobrechtsham',
      'Grillnau',
      'Hauping',
      'Holzleiten',
      'Hörzing',
      'Kohlhof',
      'Langstraß',
      'Leinberg',
      'Neuhofen im Innkreis',
      'Niederbrunn',
      'Oberleinberg',
      'Ponneredt',
      'Rettenbrunn',
      'Spießberg',
      'Wiesen',
    ],
  },
  {
    postleitzahl: 4920,
    orte: [
      'Aigen',
      'Au',
      'Auerding',
      'Ebersau',
      'Freidling',
      'Kronawitten',
      'Lehen',
      'Litzlham',
      'Marö',
      'Ottenberg',
      'Otzling',
      'Parz',
      'Piereth',
      'Rampfen',
      'Rendlberg',
      'Sankt Kollmann',
      'Schildorn',
      'Schmidsberg',
      'Streit',
      'Weiketsedt',
      'Weissenbrunn',
      'Winkl',
      'Wolfersberg',
    ],
  },
  {
    postleitzahl: 4921,
    orte: [
      'Aching',
      'Aschbrechting',
      'Breiningsham',
      'Breitsach',
      'Dürnberg',
      'Emprechting',
      'Engersdorf',
      'Ficht',
      'Gadering',
      'Gonetsreith',
      'Hilprechting',
      'Hohenzell',
      'Kager',
      'Langstadl',
      'Leisen',
      'Mauler',
      'Oberham',
      'Oberlemberg',
      'Obermauer',
      'Plöck',
      'Ponner',
      'Roith',
      'Wanger',
      'Willmerting',
      'Wöging',
      'Wötzling',
    ],
  },
  {
    postleitzahl: 4922,
    orte: [
      'Geiersberg',
      'Gstöcket',
      'Oberleiten',
      'Oberrühring',
      'Pramerdorf',
      'Rödham',
      'Rödt',
      'Schernham',
    ],
  },
  {
    postleitzahl: 4923,
    orte: [
      'Bergham',
      'Felling',
      'Fossing',
      'Gunzing',
      'Helmerding',
      'Hochkuchl',
      'Kemating',
      'Kobernaußen',
      'Kramling',
      'Lauterbach',
      'Lohnsburg',
      'Magetsham',
      'Mitterberg',
      'Neulendt',
      'Reintal',
      'Schauberg',
      'Schlag',
      'Schmidham',
      'Schönberg',
      'Stelzen',
    ],
  },
  {
    postleitzahl: 4924,
    orte: [
      'Bach',
      'Baumgarten',
      'Besendorf',
      'Bleckenwegen',
      'Brackenberg',
      'Brandstatt',
      'Brast',
      'Breitwies',
      'Dundeck',
      'Edthelm',
      'Födering',
      'Gitthof',
      'Hacksperr',
      'Hartlberg',
      'Höschmühl',
      'Knechtsgern',
      'Kohleck',
      'Lerz',
      'Maireck',
      'Neffenedt',
      'Nußbaum am Kobernaußer Walde',
      'Reith',
      'Roderer',
      'Schratteneck',
      'Schwendt',
      'Straß',
      'Waldzell',
      'Weißenbrunn',
      'Wirglau',
      'Wirmling',
    ],
  },
  {
    postleitzahl: 4925,
    orte: [
      'Altsommerau',
      'Ecklham',
      'Feitzing',
      'Großpiesenham',
      'Guggenberg',
      'Gumpling',
      'Gutensham',
      'Hartlhof',
      'Kleinpiesenham',
      'Knirzing',
      'Kronawitten',
      'Lungdorf',
      'Noxberg',
      'Pramet',
      'Rödt',
      'Schmieding',
      'Senzenberg',
      'Windischhub',
    ],
  },
  {
    postleitzahl: 4926,
    orte: [
      'Baching',
      'Grausgrub',
      'Hatting',
      'Hof',
      'Jetzing',
      'Kern',
      'Kleinbach',
      'Lehen',
      'Manaberg',
      'Obereselbach',
      'Pilgersham',
      'Sankt Marienkirchen am Hausruck',
      'Stocket',
      'Unering',
      'Untereselbach',
    ],
  },
  {
    postleitzahl: 4931,
    orte: [
      'Aichet',
      'Aigen',
      'Arnberg am Kobernaußer Walde',
      'Atzing',
      'Berstenham',
      'Bockenbach',
      'Duttenberg',
      'Gledt',
      'Grading',
      'Großenreith',
      'Großweiffendorf',
      'Gügling',
      'Hub',
      'Jagleck',
      'Karlberg',
      'Katzenberg',
      'Kleinreith',
      'Kleinschneidt',
      'Kleinweiffendorf',
      'Kriegledt',
      'Lehen',
      'Mairing',
      'Mettmach',
      'Mitterdorf',
      'Nagsdorf',
      'Neulendt',
      'Neundling',
      'Nösting',
      'Oberdorf',
      'Scherwolling',
      'Staxroith',
      'Warmanstadl',
    ],
  },
  {
    postleitzahl: 4932,
    orte: [
      'Ampfenham',
      'Au',
      'Buch',
      'Edt',
      'Federnberg',
      'Grub',
      'Kasing',
      'Kirchheim im Innkreis',
      'Kraxenberg',
      'Ramerding',
      'Ried',
      'Rödham',
      'Schacher',
    ],
  },
  {
    postleitzahl: 4933,
    orte: [
      'Aichet',
      'Buchleiting',
      'Döging',
      'Eisecking',
      'Hinterholz',
      'Hobling',
      'Leithen',
      'Maierhof',
      'Naderling',
      'Roith',
      'Steinberg',
      'Teinsberg',
      'Weißau',
      'Wieselberg',
      'Wildenau',
    ],
  },
  {
    postleitzahl: 4941,
    orte: [
      'Abstätten',
      'Aich',
      'Asenham',
      'Atzing',
      'Aubach',
      'Aubachberg',
      'Baching',
      'Bubesting',
      'Dopplhub',
      'Fritzging',
      'Gigling',
      'Käfermühl',
      'Langdorf',
      'Mehrnbach',
      'Probenzing',
      'Renetsham',
      'Ried im Innkreis',
      'Riegerting',
      'Sieber',
      'Steinbach',
      'Stötten',
      'Thaling',
      'Zimetsberg',
    ],
  },
  {
    postleitzahl: 4942,
    orte: [
      'Außerguggenberg',
      'Baumgarten',
      'Bruck',
      'Dorf',
      'Edt',
      'Freiling',
      'Geretsdorf',
      'Gundersberg',
      'Gurten',
      'Itzenthal',
      'Mairing',
      'Mittermoos',
      'Neuratting',
      'Oberndorf',
      'Ranzing',
      'Reiset',
      'Schmalzberg',
      'Schmiedhof',
      'Sieberting',
      'Wagnerberg',
      'Weinberg',
      'Wippenham',
    ],
  },
  {
    postleitzahl: 4943,
    orte: [
      'Durchham',
      'Ellreching',
      'Geinberg',
      'Hart',
      'Haudering',
      'Imolkam',
      'Kager',
      'Moosham',
      'Neuhaus',
      'Nonsbach',
      'Oberaichet',
      'Pirath',
      'Schmalzberg',
      'Simetsham',
      'Winten',
    ],
  },
  {
    postleitzahl: 4950,
    orte: [
      'Altheim',
      'Burgstall',
      'Diepolding',
      'Englwertsham',
      'Gallenberg',
      'Gaugsham',
      'Kling',
      'Lehen',
      'Lüfteneck',
      'Mauernberg',
      'Schwaig',
      'Stern',
      'Wagham',
      'Weidenthal',
      'Weirading',
      'Wolfegg',
    ],
  },
  {
    postleitzahl: 4951,
    orte: [
      'Aigelsberg',
      'Altenaichet',
      'Graham',
      'Holzerding',
      'Imolkam',
      'Nonsbach',
      'Ornading',
      'Polling im Innkreis',
      'Remoneuberg',
    ],
  },
  {
    postleitzahl: 4952,
    orte: [
      'Appersting',
      'Bauerding',
      'Bergham',
      'Buch',
      'Burgstall',
      'Elling',
      'Gunderding',
      'Hainschwang',
      'Harterding',
      'Hauserding',
      'Hunding',
      'Leithen',
      'Mankham',
      'Matzelsberg',
      'Pirath',
      'Riedlham',
      'Steingassen',
      'Weng im Innkreis',
      'Wernthal',
    ],
  },
  {
    postleitzahl: 4961,
    orte: ['Burgstall', 'Gimpling', 'Mühlheim am Inn', 'Niederach', 'Stötting'],
  },
  {
    postleitzahl: 4962,
    orte: [
      'Aham',
      'Alberting',
      'Amberg',
      'Frauenstein',
      'Gundholling',
      'Holl',
      'Kaltenau',
      'Mamling',
      'Mining',
      'Obersunzing',
      'Öppling',
      'Schickenedt',
      'Unterbergham',
      'Untersunzing',
    ],
  },
  {
    postleitzahl: 4963,
    orte: [
      'Aham',
      'Aselkam',
      'Bergham',
      'Bogenhofen',
      'Dietfurt',
      'Guggenberg',
      'Hagenau',
      'Hart',
      'Heitzenberg',
      'Hundslau',
      'Jahrsdorf',
      'Moos',
      'Nöfing',
      'Ofen',
      'Reikersdorf',
      'Sankt Peter am Hart',
      'Spraid',
      'Wimm',
    ],
  },
  {
    postleitzahl: 4970,
    orte: [
      'Bankham',
      'Ertlberg',
      'Hofing',
      'Kirchberg',
      'Obereitzing',
      'Probenzing',
      'Sausack',
      'Untereitzing',
      'Ursprung',
      'Wöppelhub',
    ],
  },
  {
    postleitzahl: 4971,
    orte: [
      'Altenried',
      'Antiesen',
      'Asenham',
      'Aurolzmünster',
      'Baumgartling',
      'Danner',
      'Edenbach',
      'Forchtenau',
      'Kochreith',
      'Lauterbrunn',
      'Maierhof',
      'Maria Aich',
      'Pesenreit',
      'Schöndorf',
      'Seyring',
      'Weierfing',
    ],
  },
  {
    postleitzahl: 4972,
    orte: [
      'Aigen',
      'Antiesen',
      'Dann',
      'Dietarding',
      'Dobl',
      'Dulmading',
      'Etting',
      'Flöcklern',
      'Gaisbach',
      'Gunderpolling',
      'Haging',
      'Himmelreich',
      'Murau',
      'Rabenfurt',
      'Stelzham',
      'Unterhaselberg',
      'Utzenaich',
      'Weilbolden',
      'Wilhelming',
      'Wimm',
      'Windhag',
      'Wohlmuthen',
      'Wolfstraß',
    ],
  },
  {
    postleitzahl: 4973,
    orte: [
      'Berg',
      'Breitenaich',
      'Bruck',
      'Diesseits',
      'Dobl',
      'Forsthub',
      'Furth',
      'Haging',
      'Hofing',
      'Hötzlarn',
      'Jenseits',
      'Karchham',
      'Koblstadt',
      'Langzaun',
      'Ort',
      'Rabenfurt',
      'Reisedt',
      'Sankt Ulrich',
      'Sindhöring',
      'Stockham',
      'Traxlham',
      'Weindorf',
      'Wolfau',
    ],
  },
  {
    postleitzahl: 4974,
    orte: [
      'Aichberg',
      'Aigen',
      'Bischelsdorf',
      'Hart',
      'Hübing',
      'Kammer',
      'Kellern',
      'Ort im Innkreis',
      'Osternach',
      'Reichersberg',
      'Reintal',
      'Stött',
      'Traxlham',
    ],
  },
  {
    postleitzahl: 4975,
    orte: ['Dorf', 'Etzelshofen', 'Roßbach', 'Schnelldorf', 'Suben'],
  },
  {
    postleitzahl: 4980,
    orte: [
      'Antiesenhofen',
      'Hübing',
      'Maasbach',
      'Mitterding',
      'Münsteuer',
      'Ungerding',
      'Viehausen',
      'Würm',
    ],
  },
  {
    postleitzahl: 4981,
    orte: [
      'Fraham',
      'Linn',
      'Minaberg',
      'Münsteuer',
      'Pfaffing',
      'Reichersberg',
    ],
  },
  {
    postleitzahl: 4982,
    orte: [
      'Graben',
      'Greifing',
      'Großmurham',
      'Katzenberg',
      'Katzenbergleithen',
      'Kirchdorf am Inn',
      'Moosböck',
      'Mörschwang',
      'Möslwimm',
      'Mühlberg',
      'Obernberg am Inn',
      'Rottenberg',
      'Schalchham',
      'Simetsham',
      'Ufer',
    ],
  },
  {
    postleitzahl: 4983,
    orte: [
      'Dietraching',
      'Grub',
      'Hofing',
      'Hub',
      'Krautsdorf',
      'Niederweilbach',
      'Nonsbach',
      'Pischelsdorf',
      'Röfl',
      'Sankt Georgen bei Obernberg am Inn',
      'Ulrichstal',
      'Wimm',
    ],
  },
  {
    postleitzahl: 4984,
    orte: [
      'Detzlhof',
      'Ellreching',
      'Hinterweintal',
      'Kirchberg',
      'Kleinmurham',
      'Klingersberg',
      'Kölbl',
      'Lindl',
      'Moosböck',
      'Neudorf',
      'Oberweintal',
      'Tal',
      'Voitshofen',
      'Weilbach',
    ],
  },
  {
    postleitzahl: 5020,
    orte: ['Salzburg'],
  },
  {
    postleitzahl: 5023,
    orte: ['Guggenthal', 'Heuberg', 'Salzburg'],
  },
  {
    postleitzahl: 5026,
    orte: ['Salzburg'],
  },
  {
    postleitzahl: 5061,
    orte: [
      'Elsbethen',
      'Gfalls',
      'Glasenbach',
      'Haslach',
      'Hinterwinkl',
      'Höhenwald',
      'Oberwinkl',
      'Salzburg',
      'Vorderfager',
      'Zieglau',
    ],
  },
  {
    postleitzahl: 5071,
    orte: [
      'Gois',
      'Himmelreich',
      'Käferheim',
      'Kleßheim',
      'Salzburg',
      'Schwarzenbergkaserne',
      'Siezenheim',
      'Viehhausen',
      'Wals',
      'Walserberg',
      'Walserfeld',
    ],
  },
  {
    postleitzahl: 5081,
    orte: ['Anif', 'Neu-Anif', 'Niederalm', 'Salzburg'],
  },
  {
    postleitzahl: 5082,
    orte: ['Eichet', 'Glanegg', 'Grödig', 'Salzburg', 'Sankt Leonhard'],
  },
  {
    postleitzahl: 5083,
    orte: ['Eichet', 'Sankt Leonhard', 'Taxach'],
  },
  {
    postleitzahl: 5084,
    orte: ['Großgmain'],
  },
  {
    postleitzahl: 5090,
    orte: ['Au', 'Faistau', 'Hallenstein', 'Lofer', 'Mayrberg', 'Scheffsnoth'],
  },
  {
    postleitzahl: 5091,
    orte: ['Gföll', 'Niederland', 'Reit', 'Unken', 'Unkenberg'],
  },
  {
    postleitzahl: 5092,
    orte: [
      'Gumping',
      'Kirchental',
      'Obsthurn',
      'Sankt Martin bei Lofer',
      'Wildental',
    ],
  },
  {
    postleitzahl: 5093,
    orte: [
      'Frohnwies',
      'Hintertal',
      'Oberweißbach',
      'Pürzlbach',
      'Unterweißbach',
    ],
  },
  {
    postleitzahl: 5101,
    orte: ['Bergheim', 'Lengfelden', 'Muntigl', 'Plain', 'Voggenberg'],
  },
  {
    postleitzahl: 5102,
    orte: [
      'Acharting',
      'Anthering',
      'Anzfelden',
      'Berg',
      'Gollacken',
      'Kobl',
      'Lehen',
      'Ried',
      'Schönberg',
      'Trainting',
      'Wald',
      'Wurmassing',
      'Würzenberg',
    ],
  },
  {
    postleitzahl: 5110,
    orte: ['Haidenöster', 'Loipferding', 'Oberndorf bei Salzburg'],
  },
  {
    postleitzahl: 5111,
    orte: ['Bürmoos'],
  },
  {
    postleitzahl: 5112,
    orte: [
      'Asten',
      'Ausserfürt',
      'Bruck',
      'Gresenberg',
      'Hausmoning',
      'Innerfürt',
      'Knotzing',
      'Lamprechtshausen',
      'Maxdorf',
      'Niederarnsdorf',
      'Nopping',
      'Oberarnsdorf',
      'Reicherting',
      'Riedlkam',
      'Sankt Alban',
      'Schmieden',
      'Schwerting',
      'Stockham',
      'Weidental',
      'Wildmann',
      'Willenberg',
    ],
  },
  {
    postleitzahl: 5113,
    orte: [
      'Aglassing',
      'Au',
      'Bruckenholz',
      'Eching',
      'Helmberg',
      'Holzhausen',
      'Irlach',
      'Jauchsdorf',
      'Königsberg',
      'Krögn',
      'Moospirach',
      'Ölling',
      'Roding',
      'Sankt Georgen bei Salzburg',
      'Seetal',
      'Vollern',
    ],
  },
  {
    postleitzahl: 5114,
    orte: [
      'Bulharting',
      'Dreimühlen',
      'Göming',
      'Gunsering',
      'Kemating',
      'Mittergöming',
      'Reinberg',
    ],
  },
  {
    postleitzahl: 5120,
    orte: [
      'Edt',
      'Haigermoos',
      'Hollersbach',
      'Kirchberg',
      'Laubenbach',
      'Loidersdorf',
      'Mühlach',
      'Ortholling',
      'Pfaffing',
      'Pirach',
      'Reith',
      'Riedersbach',
      'Sankt Pantaleon',
      'Seeleiten',
      'Steinwag',
      'Stockham',
      'Trimmelkam',
      'Weyer',
      'Wildshut',
    ],
  },
  {
    postleitzahl: 5121,
    orte: [
      'Am Anger',
      'Biri',
      'Diepoltsdorf',
      'Döstling',
      'Eckldorf',
      'Ehersdorf',
      'Eichbichl',
      'Ernsting',
      'Ettenau',
      'Felm',
      'Fucking',
      'Gumpling',
      'Hadermarkt',
      'Haid',
      'Hofstadt',
      'Hofweiden',
      'Hollersbach',
      'Hörndl',
      'Hucking',
      'Leithen',
      'Marktl',
      'Neues Dorf',
      'Ölling',
      'Ostermiething',
      'Roidham',
      'Schmidham',
      'Schwabenlandl',
      'Sensberg',
      'Simling',
      'Sinzing',
      'St. Radegund',
      'Staig',
      'Steinbach',
      'Tarsdorf',
      'Weißplatz',
      'Werfenau',
      'Wimm',
      'Winham',
      'Wolfing',
      'Wupping',
    ],
  },
  {
    postleitzahl: 5122,
    orte: [
      'Ach',
      'Barsdorf',
      'Dorfen',
      'Duttendorf',
      'Endt',
      'Geretsdorf',
      'Grund',
      'Grünhilling',
      'Hochburg',
      'Holzgassen',
      'Kälbermoos',
      'Kreil',
      'Lindach',
      'Mitterndorf',
      'Oberkriebach',
      'Reisach',
      'Reith',
      'Sengstatt',
      'Staudach',
      'Thann',
      'Unterkriebach',
      'Unterweitzberg',
      'Wanghausen',
      'Weng',
      'Werfenau',
    ],
  },
  {
    postleitzahl: 5123,
    orte: ['Aufhausen', 'Berg', 'Kreuzlinden', 'Mühltal', 'Überackern', 'Weng'],
  },
  {
    postleitzahl: 5131,
    orte: [
      'Aich',
      'Buch',
      'Dorfibm',
      'Eggenham',
      'Eisengöring',
      'Franking',
      'Hehermoos',
      'Holzleithen',
      'Holzöster',
      'Neuhausen',
      'Oberfranking',
      'Pimbach',
      'Witzling',
    ],
  },
  {
    postleitzahl: 5132,
    orte: [
      'Brunn',
      'Ehrschwendt',
      'Emmersberg',
      'Gasteig',
      'Geretsberg',
      'Goldbrunn',
      'Henkham',
      'Hinterhof',
      'Kobl',
      'Lehrsberg',
      'Maxlmoos',
      'Mühlberg',
      'Pimbach',
      'Preisenberg',
      'Reith',
      'Straß',
      'Webersdorf',
      'Weißplatz',
      'Werberg',
    ],
  },
  {
    postleitzahl: 5133,
    orte: [
      'Baumgarten',
      'Bierberg',
      'Bitzlthal',
      'Dick',
      'Gilgenberg am Weilhart',
      'Gilgenberg Revier',
      'Hinterklam',
      'Hof',
      'Hoißgassen',
      'Hopfersbach',
      'Hub',
      'Lohnsberg',
      'Mairhof',
      'Reith',
      'Röhrn',
      'Ruderstallgassen',
      'Schnellberg',
      'Sterz',
      'Webersdorf',
      'Weidenthal',
      'Zeisberg',
    ],
  },
  {
    postleitzahl: 5134,
    orte: [
      'Adenbrunn',
      'Berg',
      'Berndorf',
      'Bernhof',
      'Bruck im Holz',
      'Bruck',
      'Brunn im Gries',
      'Brunnthal',
      'Ebenthal',
      'Ginshöring',
      'Gries',
      'Haus',
      'Holz',
      'Kammern',
      'Kronleiten',
      'Ottenschwand',
      'Paischen',
      'Paschen',
      'Polzwies',
      'Prielhof',
      'Reith',
      'Reuhub',
      'Schmieding',
      'Schwand im Innkreis',
      'Semmelhof',
      'Sengthal',
      'Siebenmaiern',
      'Spieglern',
      'Viermaiern',
      'Weilhart',
    ],
  },
  {
    postleitzahl: 5141,
    orte: [
      'Einsperg',
      'Elling',
      'Furkern',
      'Habersdorf',
      'Hackenbuch',
      'Haslach',
      'Jedendorf',
      'Kimmelsdorf',
      'Moosdorf',
      'Moosmühl',
      'Mühlbach',
      'Puttenhausen',
      'Seeleiten',
      'Stadl',
      'Weichsee',
    ],
  },
  {
    postleitzahl: 5142,
    orte: [
      'Arnstetten',
      'Autmannsdorf',
      'Beckenberg',
      'Bergstetten',
      'Eggelsberg',
      'Gerberling',
      'Großschäding',
      'Gundertshausen',
      'Haselreith',
      'Hehenberg',
      'Heimhausen',
      'Hitzging',
      'Hötzenau',
      'Ibm',
      'Kleinschäding',
      'Meindlsberg',
      'Miesling',
      'Oberhaslach',
      'Oberhaunsberg',
      'Pippmannsberg',
      'Revier Eggelsberg',
      'Revier Gundertshausen',
      'Revier Heimhausen',
      'Trametshausen',
      'Untergrub',
      'Unterhaunsberg',
      'Wannersdorf',
      'Weilbuch',
      'Weinberg',
    ],
  },
  {
    postleitzahl: 5143,
    orte: [
      'Aich',
      'Altheim',
      'Aschau',
      'Außerpirach',
      'Bamberg',
      'Burgkirchen',
      'Edt',
      'Emerding',
      'Feldkirchen bei Mattighofen',
      'Gietzing',
      'Gstaig',
      'Hafenberg',
      'Haiderthal',
      'Hansried',
      'Haselpfaffing',
      'Hennergraben',
      'Holz',
      'Höslrein',
      'Innerpirach',
      'Jetzing',
      'Kampern',
      'Kendling',
      'Klöpfing',
      'Oichten',
      'Öppelhausen',
      'Ottenhausen',
      'Otterfing',
      'Primsing',
      'Quick',
      'Renzlhausen',
      'Revier Renzlhausen',
      'Sattlern',
      'Sperledt',
      'Vormoos',
      'Wenigaschau',
      'Wexling',
      'Wiesing',
      'Willersdorf',
    ],
  },
  {
    postleitzahl: 5144,
    orte: [
      'Adenberg',
      'Aigen',
      'Anferding',
      'Angern',
      'Apfental',
      'Brandstatt',
      'Buchsberg',
      'Eckbach',
      'Edthof',
      'Feichten',
      'Fillmannsbach',
      'Großschieder',
      'Handenberg',
      'Hangöbl',
      'Hinterberg',
      'Kastenberg',
      'Kleinschieder',
      'Kohlbach',
      'Kölln',
      'Leimhof',
      'Moos',
      'Pöllersberg',
      'Polzwies',
      'Reichsberg',
      'Sandtal',
      'Sankt Georgen am Fillmannsbach',
      'Scheuern',
      'Steckenbach',
      'Straß',
      'Utting',
      'Weg',
      'Wies',
      'Wurmshub',
      'Zaun',
    ],
  },
  {
    postleitzahl: 5145,
    orte: [
      'Apfenthal',
      'Bachleiten',
      'Badhub',
      'Bogendorf',
      'Brand',
      'Bründl',
      'Dietzing',
      'Dorf',
      'Eisenhub',
      'Engelberg',
      'Enknach',
      'Eschberg',
      'Friedrichsdorf',
      'Frieseneck',
      'Grillham',
      'Gsotthub',
      'Händschuh',
      'Häusl',
      'Hinterberg',
      'Hof',
      'Hollstraß',
      'Kammerleiten',
      'Kirchweg',
      'Königsaich',
      'Kottingauerbach',
      'Maierhof',
      'Neukirchen an der Enknach',
      'Oberguggen',
      'Oberthal',
      'Österlehen',
      'Paßberg',
      'Rittersberg',
      'Scheuhub',
      'Schmalzhofen',
      'Schützing',
      'Solling',
      'Spritzendorf',
      'Stadlern',
      'Stockhofen',
      'Stoibergassen',
      'Straß',
      'Tausendengel',
      'Unterguggen',
      'Unterholz',
      'Walzing',
      'Wiesmaiern',
    ],
  },
  {
    postleitzahl: 5151,
    orte: [
      'Altsberg',
      'Durchham',
      'Eisping',
      'Gastein',
      'Hainbach',
      'Hochberg',
      'Irlach',
      'Kleinberg',
      'Kroisbach',
      'Lauterbach',
      'Liersching',
      'Lukasedt',
      'Nußdorf am Haunsberg',
      'Olching',
      'Pabing',
      'Pinswag',
      'Reinharting',
      'Rottstätt',
      'Schlößl',
      'Schröck',
      'Steinbach',
      'Waidach',
      'Weitwörth',
    ],
  },
  {
    postleitzahl: 5152,
    orte: [
      'Au',
      'Breitenlohe',
      'Buchach',
      'Dorfbeuern',
      'Michaelbeuern',
      'Reitsberg',
      'Scherhaslach',
      'Schönberg',
      'Thalhausen',
      'Vorau',
      'Wagnerfeld',
      'Wagnergraben',
    ],
  },
  {
    postleitzahl: 5161,
    orte: ['Elixhausen'],
  },
  {
    postleitzahl: 5162,
    orte: [
      'Au',
      'Kleinberg',
      'Mühlbach',
      'Obertrum am See',
      'Schmieding',
      'Schmiedkeller',
      'Schöngumprechting',
    ],
  },
  {
    postleitzahl: 5163,
    orte: [
      'Bergham',
      'Brandstätt',
      'Bruck',
      'Dietersham',
      'Eidenham',
      'Fischerjuden',
      'Guggenberg',
      'Heming',
      'Hiltenwiesen',
      'Imsee',
      'Macking',
      'Mattsee',
      'Mödenham',
      'Mundenham',
      'Neckreith',
      'Palting',
      'Rutzing',
      'Singham',
      'Stockham',
      'Unteröd',
      'Weikertsham',
    ],
  },
  {
    postleitzahl: 5164,
    orte: ['Seeham'],
  },
  {
    postleitzahl: 5165,
    orte: ['Berndorf bei Salzburg', 'Großenegg', 'Reinharting'],
  },
  {
    postleitzahl: 5166,
    orte: [
      'Baumgarten',
      'Edt',
      'Elexlochen',
      'Endfelden',
      'Grub',
      'Gumperding',
      'Hinterbuch',
      'Kirchsteig',
      'Oberröd',
      'Perwang am Grabensee',
      'Reith',
      'Rödhausen',
      'Rudersberg',
      'Stockach',
      'Unterröd',
    ],
  },
  {
    postleitzahl: 5201,
    orte: [
      'Bayerham',
      'Brunn',
      'Fischtaging',
      'Halberstätten',
      'Huttich',
      'Kothgumprechting',
      'Kraiham',
      'Mayerlehen',
      'Mödlham',
      'Ried',
      'Schmieding',
      'Schöngumprechting',
      'Seekirchen am Wallersee',
      'Seewalchen',
      'Waldprechting',
      'Wies',
      'Wimm',
      'Wimmsiedlung',
      'Zaisberg',
    ],
  },
  {
    postleitzahl: 5202,
    orte: [
      'Höhenroith',
      'Lengroid',
      'Maierhof',
      'Matzing',
      'Neufahrn',
      'Neumarkt am Wallersee',
      'Pfongau',
      'Schalkham',
      'Sighartstein',
      'Sommerholz',
      'Thalham',
      'Wallersee-Ostbucht',
      'Wertheim',
    ],
  },
  {
    postleitzahl: 5203,
    orte: [
      'Enharting',
      'Gramling',
      'Helming',
      'Hilgertsheim',
      'Kleinköstendorf',
      'Köstendorf',
      'Spanswag',
      'Tannham',
      'Tödtleinsdorf',
      'Weng',
    ],
  },
  {
    postleitzahl: 5204,
    orte: [
      'Aigelsbrunn',
      'Angern',
      'Außerroid',
      'Baierham',
      'Baumbach',
      'Bodenberg',
      'Bruckmoos',
      'Brunn',
      'Eck',
      'Eingarten',
      'Fißlthal',
      'Haarlacken',
      'Haidach',
      'Haselreith',
      'Haslach',
      'Hochfeld',
      'Holzfeld',
      'Hüttenedt',
      'Innerroid',
      'Irrsdorf',
      'Jagdenroid',
      'Jagdhub',
      'Latein',
      'Neuhofen',
      'Oberholz',
      'Pfenninglanden',
      'Pölzleiten',
      'Rattensam',
      'Reitzing',
      'Rilling',
      'Roidwalchen',
      'Ruckling',
      'Schwandt',
      'Stadlberg',
      'Steindorf',
      'Stockham',
      'Straßwalchen',
      'Taigen',
      'Vöcklatal',
      'Voglhub',
      'Watzlberg',
      'Winkl',
      'Winzerroid',
      'Zagling',
    ],
  },
  {
    postleitzahl: 5205,
    orte: ['Schleedorf'],
  },
  {
    postleitzahl: 5211,
    orte: [
      'Ameisberg',
      'Aug',
      'Bach',
      'Baierberg',
      'Flörlplain',
      'Frauscherberg',
      'Friedburg',
      'Gassl',
      'Gollmannseck',
      'Gstöckat',
      'Heiligenstatt',
      'Holz',
      'Igelsberg',
      'Kühbichl',
      'Lengau',
      'Mittererb',
      'Oberehrneck',
      'Pfannenstiel',
      'Sankt Ulrich',
      'Schwöll',
      'Teichstätt',
      'Unterehrneck',
      'Untererb',
      'Utzweih',
      'Wimpassing',
    ],
  },
  {
    postleitzahl: 5212,
    orte: [
      'Edt',
      'Hocheck',
      'Höcken',
      'Krenwald',
      'Kühbichl',
      'Obererb',
      'Schneegattern',
    ],
  },
  {
    postleitzahl: 5221,
    orte: [
      'Ainhausen',
      'Astätt',
      'Babenham',
      'Bergham',
      'Daxjuden',
      'Dirnham',
      'Edenplain',
      'Feldbach',
      'Gebertsham',
      'Gunzing',
      'Gutferding',
      'Hofstätt',
      'Intenham',
      'Kerschham',
      'Koppelstätt',
      'Kranzing',
      'Lasberg',
      'Lochen am See',
      'Niedertrum',
      'Oberhaft',
      'Oberweißau',
      'Petersham',
      'Rackersing',
      'Reitsham',
      'Scherschham',
      'Schimmerljuden',
      'Sprinzenberg',
      'Stein',
      'Stullerding',
      'Tannberg',
      'Unterlochen',
      'Wichenham',
      'Zeisental',
    ],
  },
  {
    postleitzahl: 5222,
    orte: [
      'Ach',
      'Achenlohe',
      'Achtal',
      'Althöllersberg',
      'Baumgarten',
      'Bradirn',
      'Buch',
      'Haidberg',
      'Hirschlag',
      'Höllersberg',
      'Katztal',
      'Kolming',
      'Lichteneck',
      'Munderfing',
      'Oberweißau',
      'Parz',
      'Pfaffing',
      'Rödt',
      'Spreitzenberg',
      'Stocker',
      'Unterweißau',
      'Valentinhaft',
      'Wiesenham',
    ],
  },
  {
    postleitzahl: 5223,
    orte: ['Erlach', 'Fludau', 'Kitzing', 'Kuglberg', 'Pfaffstätt', 'Sollern'],
  },
  {
    postleitzahl: 5224,
    orte: [
      'Au',
      'Auerbach',
      'Holz',
      'Höring',
      'Oberirnprechting',
      'Oberkling',
      'Riensberg',
      'Rietzing',
      'Unterirnprechting',
      'Unterkling',
      'Wimpassing',
    ],
  },
  {
    postleitzahl: 5225,
    orte: [
      'Abern',
      'Bernroid',
      'Gewerbegebiet',
      'Hochhalting',
      'Jeging',
      'Oberedt',
      'Pfaffing',
      'Schweiber',
      'Unteredt',
    ],
  },
  {
    postleitzahl: 5230,
    orte: ['Mattighofen'],
  },
  {
    postleitzahl: 5231,
    orte: [
      'Äpfelberg',
      'Au',
      'Auffang',
      'Baumgarten',
      'Erb',
      'Furth',
      'Häuslberg',
      'Hitzleiten',
      'Langwiedmoos',
      'Mitterholzleiten',
      'Neudorf',
      'Oberharlochen',
      'Oberholzleiten',
      'Oberlindach',
      'Oberweinberg',
      'Schalchen',
      'Stallhofen',
      'Unterharlochen',
      'Unterholzleiten',
      'Unterlindach',
      'Unterlochen',
      'Unterweinberg',
      'Weinberg',
      'Wiesing',
    ],
  },
  {
    postleitzahl: 5232,
    orte: [
      'Aigen',
      'Alterding',
      'Angelberg',
      'Bermading',
      'Buch',
      'Eglsee',
      'Entham',
      'Ersperding',
      'Gopperding',
      'Gumping',
      'Hilprechtsham',
      'Iming',
      'Kirchberg bei Mattighofen',
      'Kobl',
      'Lamperding',
      'Moosdorf',
      'Oberkreit',
      'Obermaisling',
      'Sauldorf',
      'Setzka',
      'Siegertshaft',
      'Thal',
      'Unterkreit',
      'Untermaisling',
      'Walterding',
      'Wendling',
    ],
  },
  {
    postleitzahl: 5233,
    orte: [
      'Aich',
      'Berg',
      'Buch',
      'Deimledt',
      'Dessenhausen',
      'Edt',
      'Engelschärding',
      'Erlach',
      'Feldmühl',
      'Glatzberg',
      'Großgollern',
      'Gschwendt',
      'Hart',
      'Humertsham',
      'Irnstötten',
      'Kager',
      'Kaltenhausen',
      'Kleingollern',
      'Landerting',
      'Moos',
      'Ottendorf',
      'Perleiten',
      'Pfaffing',
      'Pischelsdorf am Engelbach',
      'Posching',
      'Schmidham',
      'Schwarzgröben',
      'Siegerting',
      'Stapfing',
      'Stempfen',
      'Unterhart',
      'Wagenham',
      'Wehrsdorf',
    ],
  },
  {
    postleitzahl: 5241,
    orte: [
      'Aicheck',
      'Breitenberg',
      'Bucheck',
      'Großenaich',
      'Gstocket',
      'Haslau',
      'Leitnerseck',
      'Maria Schmolln',
      'Michlbach',
      'Oberfeld',
      'Oberminathal',
      'Perneck',
      'Schnellberg',
      'Schweigertsreith',
      'Sollach',
      'Sonnleiten',
      'Thannstraß',
      'Unterfeld',
      'Unterminathal',
      'Utzeneck',
      'Warleiten',
      'Winkelpoint',
    ],
  },
  {
    postleitzahl: 5242,
    orte: [
      'Bachleiten',
      'Dobl',
      'Frauschereck',
      'Geierseck',
      'Grubmühl',
      'Höh',
      'Klafterreith',
      'Obereck',
      'Peretseck',
      'Perneck',
      'Raucheneck',
      'Sankt Johann am Walde',
      'Schauberg',
      'Scherfeck',
      'Schlagereck',
      'Schnaidt',
      'Schneibenschlag',
      'Schöfeck',
      'Stixeck',
      'Straß',
    ],
  },
  {
    postleitzahl: 5251,
    orte: [
      'Aichbichl',
      'Aigertsham',
      'Ainetsreit',
      'Außerleiten',
      'Buchberg',
      'Diepoltsham',
      'Dobl',
      'Eden',
      'Eigelsberg',
      'Eitzing',
      'Feichta',
      'Haging',
      'Herbstheim',
      'Höhnhart',
      'Hub',
      'Leithen am Walde',
      'Leitrachstetten',
      'Liedlschwandt',
      'Miesenberg',
      'Oberaichberg',
      'Offenschwandt',
      'Peretsdobl',
      'Perwart',
      'Roith',
      'Schwandt',
      'Stegmühl',
      'Straß',
      'Thalheim',
      'Thannstraß',
      'Unteraichberg',
      'Warleiten',
      'Wasserdobl',
      'Windschnur',
      'Winkl',
    ],
  },
  {
    postleitzahl: 5252,
    orte: [
      'Aspach',
      'Baumgarten',
      'Döging',
      'Dötting',
      'Ecking',
      'Englham',
      'Haging',
      'Kappeln',
      'Kasting',
      'Katzlberg',
      'Kleinschneidt',
      'Migelsbach',
      'Mitterberg',
      'Niederham',
      'Parz',
      'Pimberg',
      'Rottersham',
      'Thal',
      'Wasserdobl',
    ],
  },
  {
    postleitzahl: 5261,
    orte: [
      'Albrechtsberg',
      'Anzenberg',
      'Freihub',
      'Gaismannslohen',
      'Grillham',
      'Haslau',
      'Heitzing',
      'Helpfau',
      'Höfen',
      'Kager',
      'Lohnau',
      'Ort',
      'Reichsdorf',
      'Reith',
      'Sankt Florian',
      'Scheiblberg',
      'Sonnleiten',
      'Steinbruch',
      'Steinrödt',
      'Straß',
      'Uttendorf',
      'Wienern',
      'Zeiledt',
    ],
  },
  {
    postleitzahl: 5270,
    orte: [
      'Albrechtsberg',
      'Alm',
      'Biburg',
      'Brand',
      'Brunning',
      'Eglsee',
      'Fartham',
      'Harham',
      'Kobledt',
      'Mauerkirchen',
      'Penning',
      'Reichsdorf',
      'Spitzenberg',
      'Spraidt',
      'Stockleiten',
      'Tal',
      'Unterbrunning',
      'Vorbuch',
      'Wollöster',
    ],
  },
  {
    postleitzahl: 5271,
    orte: [
      'Bäckenberg',
      'Dietraching',
      'Grubedt',
      'Hufnagl',
      'Moosbach',
      'Reisach',
      'Reisedt',
      'Schacha',
      'Sonnleiten',
      'Spraidt',
      'Waasen',
      'Wimholz',
      'Winden',
    ],
  },
  {
    postleitzahl: 5272,
    orte: [
      'Ascherdorf',
      'Himmelschlag',
      'Hub',
      'Leitrachstetten',
      'Lindlau',
      'Matt',
      'Mitterdorf',
      'Obertreubach',
      'Pfendhub',
      'Radlham',
      'Schacha',
      'Schalchen',
      'Schiefeck',
      'Teiseneck',
      'Untertreubach',
      'Ursprung',
      'Weidenpoint',
      'Wimholz',
      'Wittigau',
    ],
  },
  {
    postleitzahl: 5273,
    orte: [
      'Bruckwies',
      'Buch',
      'Edt',
      'Fraham',
      'Frieseneck',
      'Grünau',
      'Gschaidt',
      'Hinteredt',
      'Hofing',
      'Hub',
      'Jaiding',
      'Krottenthal',
      'Marlupp',
      'Parschalling',
      'Pirat',
      'Pudexing',
      'Rödham',
      'Roßbach',
      'Sankt Veit im Innkreis',
      'Schacher',
      'Schwathof',
      'Thal',
      'Ursprung',
      'Wesen',
      'Wimhub',
      'Wolfeck',
      'Zechleiten',
    ],
  },
  {
    postleitzahl: 5274,
    orte: [
      'Alharting',
      'Atzing',
      'Au',
      'Brunning',
      'Burgkirchen',
      'Edthof',
      'Fartham',
      'Forstern',
      'Fuchshofen',
      'Fürch',
      'Geretsdorf',
      'Hermading',
      'Herrngassen',
      'Holzgassen',
      'Kaltenhausen',
      'Kühberg',
      'Lindhof',
      'Maxedt',
      'Meinharting',
      'Mitterlach',
      'Oberhartberg',
      'Oberseibersdorf',
      'Passberg',
      'Sankt Georgen an der Mattig',
      'Unterhartberg',
      'Unterseibersdorf',
      'Vorbuch',
      'Weikerding',
    ],
  },
  {
    postleitzahl: 5280,
    orte: [
      'Aching',
      'Braunau am Inn',
      'Braunau Neustadt',
      'Dietfurt',
      'Gasteig',
      'Haiden',
      'Haselbach',
      'Himmellindach',
      'Höft',
      'Laab',
      'Lach',
      'Lindach',
      'Maierhof',
      'Neue Heimat',
      'Oberaching',
      'Osternberg',
      'Ranshofen',
      'Tal',
    ],
  },
  {
    postleitzahl: 5282,
    orte: [
      'Au',
      'Blankenbach',
      'Brunn im Gries',
      'Kühberg',
      'Lach',
      'Oberrothenbuch',
      'Osternberg',
      'Ranshofen',
      'Roith',
      'Scheuhub',
      'Unterrothenbuch',
    ],
  },
  {
    postleitzahl: 5300,
    orte: ['Berg', 'Esch', 'Hallwang', 'Zilling'],
  },
  {
    postleitzahl: 5301,
    orte: ['Eugendorf', 'Kalham', 'Schwaighofen'],
  },
  {
    postleitzahl: 5302,
    orte: ['Eugendorf', 'Henndorf am Wallersee'],
  },
  {
    postleitzahl: 5303,
    orte: [
      'Egg',
      'Enzersberg',
      'Leithen',
      'Oberdorf',
      'Thalgau',
      'Thalgauberg',
      'Unterdorf',
      'Vetterbach',
    ],
  },
  {
    postleitzahl: 5310,
    orte: [
      'Gaisberg',
      'Guggenberg',
      'Hof',
      'Innerschwand',
      'Keuschen',
      'Mondsee',
      'Oberburgau',
      'Scharfling',
      'St. Lorenz',
      'Tiefgraben',
    ],
  },
  {
    postleitzahl: 5311,
    orte: ['Au', 'Innerschwand'],
  },
  {
    postleitzahl: 5321,
    orte: ['Habach', 'Koppl', 'Ladau', 'Winkl'],
  },
  {
    postleitzahl: 5322,
    orte: ['Hof bei Salzburg'],
  },
  {
    postleitzahl: 5323,
    orte: [
      'Ebenau',
      'Hinterebenau',
      'Hinterwinkl',
      'Unterberg',
      'Vorderschroffenau',
      'Wimberg',
    ],
  },
  {
    postleitzahl: 5324,
    orte: [
      'Alm',
      'Anger',
      'Faistenau',
      'Hintersee',
      'Lämmerbach',
      'Lidaun',
      'Ramsau',
      'Tiefbrunnau',
      'Vordersee',
      'Wald',
    ],
  },
  {
    postleitzahl: 5325,
    orte: ['Plainfeld'],
  },
  {
    postleitzahl: 5330,
    orte: ['Fuschl am See'],
  },
  {
    postleitzahl: 5340,
    orte: ['Laim', 'Pöllach', 'Sankt Gilgen', 'Winkl'],
  },
  {
    postleitzahl: 5342,
    orte: ['Gschwand', 'Gschwendt', 'Ried'],
  },
  {
    postleitzahl: 5350,
    orte: ['Aigen', 'Gschwendt', 'Strobl', 'Weißenbach'],
  },
  {
    postleitzahl: 5360,
    orte: [
      'Aschau',
      'Au',
      'Bürglstein',
      'Graben',
      'Markt',
      'Mönichsreith',
      'Radau',
      'Ried',
      'Rußbach',
      'Schwarzenbach',
      'Weinbach',
      'Windhag',
      'Wirling',
    ],
  },
  {
    postleitzahl: 5400,
    orte: [
      'Adneter Riedl',
      'Au',
      'Bad Dürrnberg',
      'Burgfried',
      'Gamp',
      'Gries',
      'Hallein',
      'Neualm',
      'Oberalm',
      'Taxach',
    ],
  },
  {
    postleitzahl: 5411,
    orte: ['Oberalm', 'Vorderwiestal'],
  },
  {
    postleitzahl: 5412,
    orte: ['Hinterwiestal', 'Puch bei Hallein', 'Sankt Jakob am Thurn'],
  },
  {
    postleitzahl: 5421,
    orte: ['Adnet', 'Riedl', 'Spumberg', 'Waidach', 'Wimberg'],
  },
  {
    postleitzahl: 5422,
    orte: ['Bad Dürrnberg', 'Hallein'],
  },
  {
    postleitzahl: 5423,
    orte: ['Oberlangenberg', 'Taugl', 'Tauglboden'],
  },
  {
    postleitzahl: 5424,
    orte: [
      'Rengerberg',
      'Riedl',
      'Sankt Margarethen',
      'Unterlangenberg',
      'Vigaun',
    ],
  },
  {
    postleitzahl: 5425,
    orte: ['Gaißau', 'Krispl'],
  },
  {
    postleitzahl: 5431,
    orte: [
      'Garnei',
      'Gasteig',
      'Georgenberg',
      'Jadorf',
      'Kellau',
      'Kuchl',
      'Moos',
      'Unterlangenberg',
      'Weißenbach',
    ],
  },
  {
    postleitzahl: 5440,
    orte: [
      'Golling an der Salzach',
      'Obergäu',
      'Scheffau am Tennengebirge',
      'Torren',
      'Voregg',
    ],
  },
  {
    postleitzahl: 5441,
    orte: [
      'Abtenau',
      'Au',
      'Döllerhof',
      'Erlfeld',
      'Fischbach',
      'Gseng',
      'Hallseiten',
      'Kehlhof',
      'Leitenhaus',
      'Lindenthal',
      'Möselberg',
      'Pichl',
      'Rigaus',
      'Schorn',
      'Schratten',
      'Seetratten',
      'Seydegg',
      'Stocker',
      'Unterberg',
      'Wagner',
      'Waldhof',
      'Wallingwinkl',
      'Wegscheid',
      'Weitenau',
    ],
  },
  {
    postleitzahl: 5442,
    orte: ['Gseng', 'Hallseiten', 'Rußbachsaag', 'Schattau', 'Seetratten'],
  },
  {
    postleitzahl: 5450,
    orte: ['Imlau', 'Reitsam', 'Scharten', 'Schlaming', 'Werfen'],
  },
  {
    postleitzahl: 5451,
    orte: ['Reitsam', 'Scharten', 'Sulzau', 'Wimm'],
  },
  {
    postleitzahl: 5452,
    orte: [
      'Dorf',
      'Dorfwerfen',
      'Ellmauthal',
      'Grub',
      'Imlau',
      'Laubichl',
      'Lehen',
      'Maier',
      'Pöham',
      'Reitsam',
      'Scharten',
      'Schlaming',
    ],
  },
  {
    postleitzahl: 5453,
    orte: ['Eulersberg', 'Lampersbach', 'Weng'],
  },
  {
    postleitzahl: 5500,
    orte: [
      'Alpfahrt',
      'Bischofshofen',
      'Buchberg',
      'Gainfeld',
      'Haidberg',
      'Kreuzberg',
      'Laideregg',
      'Mitterberghütten',
      'Pöham',
      'Winkl',
    ],
  },
  {
    postleitzahl: 5505,
    orte: ['Mühlbach am Hochkönig', 'Reitsam', 'Schlöglberg'],
  },
  {
    postleitzahl: 5511,
    orte: ['Bairau', 'Hüttau', 'Iglsbach', 'Sonnberg', 'Sonnhalb'],
  },
  {
    postleitzahl: 5521,
    orte: ['Bairau', 'Hüttau', 'Sonnberg'],
  },
  {
    postleitzahl: 5522,
    orte: ['Lammertal', 'Sankt Martin am Tennengebirge'],
  },
  {
    postleitzahl: 5523,
    orte: ['Gappen', 'Neubach', 'Promberg'],
  },
  {
    postleitzahl: 5524,
    orte: [
      'Annaberg im Lammertal',
      'Braunötzhof',
      'Fischbach',
      'Gappen',
      'Hefenscher',
      'Klockau',
      'Leitenhaus',
      'Neubach',
      'Promberg',
      'Salfelden',
      'Steuer',
    ],
  },
  {
    postleitzahl: 5531,
    orte: ['Eben im Pongau', 'Gasthofberg', 'Schattbach'],
  },
  {
    postleitzahl: 5532,
    orte: ['Filzmoos', 'Neuberg'],
  },
  {
    postleitzahl: 5541,
    orte: ['Altenmarkt im Pongau'],
  },
  {
    postleitzahl: 5542,
    orte: ['Feuersang', 'Flachau', 'Höch', 'Reitdorf'],
  },
  {
    postleitzahl: 5550,
    orte: ['Höggen', 'Löbenau', 'Mandling', 'Radstadt', 'Schwemmberg'],
  },
  {
    postleitzahl: 5552,
    orte: ['Forstau'],
  },
  {
    postleitzahl: 5561,
    orte: ['Untertauern'],
  },
  {
    postleitzahl: 5562,
    orte: ['Obertauern', 'Tweng', 'Untertauern'],
  },
  {
    postleitzahl: 5563,
    orte: ['Tweng'],
  },
  {
    postleitzahl: 5570,
    orte: ['Faningberg', 'Mauterndorf', 'Neuseß', 'Steindorf'],
  },
  {
    postleitzahl: 5571,
    orte: ['Mariapfarr', 'Pichl', 'Zankwarn'],
  },
  {
    postleitzahl: 5572,
    orte: ['Sankt Andrä im Lungau'],
  },
  {
    postleitzahl: 5573,
    orte: ['Weißpriach'],
  },
  {
    postleitzahl: 5574,
    orte: ['Göriach'],
  },
  {
    postleitzahl: 5575,
    orte: ['Lessach', 'Zoitzach'],
  },
  {
    postleitzahl: 5580,
    orte: [
      'Haiden',
      'Keusching',
      'Lasaberg',
      'Mörtelsdorf',
      'Sauerfeld',
      'Seetal',
      'Tamsweg',
      'Wölting',
    ],
  },
  {
    postleitzahl: 5581,
    orte: ['Sankt Margarethen im Lungau'],
  },
  {
    postleitzahl: 5582,
    orte: [
      'Höf',
      'Oberweißburg',
      'Sankt Martin',
      'Sankt Michael im Lungau',
      'Unterweißburg',
    ],
  },
  {
    postleitzahl: 5583,
    orte: ['Hintermuhr', 'Schellgaden', 'Vordermuhr'],
  },
  {
    postleitzahl: 5584,
    orte: ['Lamm', 'Rothenwand', 'Wald', 'Zederhaus'],
  },
  {
    postleitzahl: 5585,
    orte: ['Unternberg'],
  },
  {
    postleitzahl: 5591,
    orte: ['Mignitz', 'Mitterberg', 'Ramingstein'],
  },
  {
    postleitzahl: 5592,
    orte: ['Bundschuh', 'Thomatal'],
  },
  {
    postleitzahl: 5600,
    orte: [
      'Einöden',
      'Floitensberg',
      'Ginau',
      'Hallmoos',
      'Maschl',
      'Plankenau',
      'Reinbach',
      'Rettenstein',
      'Sankt Johann im Pongau',
      'Urreiting',
    ],
  },
  {
    postleitzahl: 5602,
    orte: [
      'Floitensberg',
      'Ginau',
      'Hof',
      'Hofmarkt',
      'Schwaighof',
      'Vorderkleinarl',
      'Wagrain Markt',
    ],
  },
  {
    postleitzahl: 5603,
    orte: ['Kleinarl'],
  },
  {
    postleitzahl: 5611,
    orte: ['Großarl'],
  },
  {
    postleitzahl: 5612,
    orte: ['Hüttschlag', 'Karteis', 'See'],
  },
  {
    postleitzahl: 5620,
    orte: ['Oberhof', 'Schwarzach im Pongau'],
  },
  {
    postleitzahl: 5621,
    orte: ['Enkerbichl', 'Sankt Veit im Pongau', 'Schattau', 'Weng'],
  },
  {
    postleitzahl: 5622,
    orte: [
      'Altenhof',
      'Boden',
      'Buchberg',
      'Enkerbichl',
      'Hasling',
      'Hofmark',
      'Maierhof',
      'March',
      'Mitterstein',
      'Oberhof',
      'Schattau',
      'Schwarzach im Pongau',
      'Weng',
    ],
  },
  {
    postleitzahl: 5630,
    orte: [
      'Anger',
      'Bad Hofgastein',
      'Breitenberg',
      'Gadaunern',
      'Harbach',
      'Heißingfelding',
      'Laderding',
      'Vorderschneeberg',
      'Weinetsberg',
      'Wieden',
    ],
  },
  {
    postleitzahl: 5632,
    orte: [
      'Bergl',
      'Dorfgastein',
      'Klammstein',
      'Luggau',
      'Maierhofen',
      'Unterberg',
    ],
  },
  {
    postleitzahl: 5640,
    orte: ['Bad Gastein'],
  },
  {
    postleitzahl: 5645,
    orte: ['Bad Gastein'],
  },
  {
    postleitzahl: 5651,
    orte: [
      'Berg',
      'Boden',
      'Embach',
      'Eschenau',
      'Heuberg',
      'Lend',
      'Maierhof',
      'Teufenbach',
      'Urbar',
      'Winkl',
    ],
  },
  {
    postleitzahl: 5652,
    orte: ['Dienten am Hochkönig'],
  },
  {
    postleitzahl: 5660,
    orte: [
      'Eschenau',
      'Großsonnberg',
      'Gschwandtnerberg',
      'Hasenbach',
      'Höf',
      'Högmoos',
      'Hopfberg',
      'Kleinsonnberg',
      'March',
      'Taxberg',
      'Taxenbach',
      'Thannberg',
      'Winkl',
    ],
  },
  {
    postleitzahl: 5661,
    orte: [
      'Bucheben',
      'Rauris',
      'Seidlwinkl',
      'Unterland',
      'Vorstandrevier',
      'Wörtherberg',
    ],
  },
  {
    postleitzahl: 5662,
    orte: [
      'Brandenau',
      'Bruck an der Großglocknerstraße',
      'Gries',
      'Großsonnberg',
      'Hauserdorf',
      'Högmoos',
      'Kleinsonnberg',
      'Lacken',
      'Niederhof',
      'Reit',
      'Sankt Georgen',
      'Steinbach',
      'Thannberg',
      'Winkl',
    ],
  },
  {
    postleitzahl: 5671,
    orte: [
      'Bruck an der Großglocknerstraße',
      'Fischhorn',
      'Hundsdorf',
      'Krössenbach',
      'Pichl',
      'Vorfusch',
    ],
  },
  {
    postleitzahl: 5672,
    orte: ['Taxenbacher-Fusch', 'Zeller-Fusch'],
  },
  {
    postleitzahl: 5700,
    orte: ['Bruckberg', 'Erlberg', 'Schmitten', 'Thumersbach', 'Zell am See'],
  },
  {
    postleitzahl: 5710,
    orte: ['Kaprun'],
  },
  {
    postleitzahl: 5721,
    orte: ['Aufhausen', 'Hummersdorf', 'Piesendorf', 'Walchen'],
  },
  {
    postleitzahl: 5722,
    orte: [
      'Aisdorf',
      'Ematen',
      'Gaisbichl',
      'Jesdorf',
      'Lengdorf',
      'Niedernsill',
      'Steindorf',
    ],
  },
  {
    postleitzahl: 5723,
    orte: [
      'Hofham',
      'Köhlbichl',
      'Litzldorf',
      'Pölsen',
      'Quettensberg',
      'Schwarzenbach',
      'Stubach',
      'Tobersbach',
      'Uggl',
      'Uttendorf',
    ],
  },
  {
    postleitzahl: 5724,
    orte: ['Bam', 'Dürnberg', 'Pirtendorf', 'Stuhlfelden', 'Wilhelmsdorf'],
  },
  {
    postleitzahl: 5730,
    orte: [
      'Arndorf',
      'Burk',
      'Felben',
      'Feldstein',
      'Jochberg',
      'Jochbergthurn',
      'Klausen',
      'Lämmerbichl',
      'Loferstein',
      'Mayrhofen',
      'Mittersill',
      'Oberfelben',
      'Paßthurn',
      'Rettenbach',
      'Schattberg',
      'Spielbichl',
      'Thalbach',
      'Unterfelben',
      'Weißenstein',
    ],
  },
  {
    postleitzahl: 5731,
    orte: [
      'Arndorf',
      'Grubing',
      'Hollersbach im Pinzgau',
      'Jochberg',
      'Jochbergthurn',
      'Lämmerbichl',
      'Reitlehen',
      'Rettenbach',
      'Schattberg',
    ],
  },
  {
    postleitzahl: 5733,
    orte: ['Bramberg am Wildkogel'],
  },
  {
    postleitzahl: 5741,
    orte: [
      'Bramberg am Wildkogel',
      'Mitterhohenbramberg',
      'Neukirchen am Großvenediger',
      'Rosental',
      'Sulzau',
    ],
  },
  {
    postleitzahl: 5742,
    orte: [
      'Hinterwaldberg',
      'Königsleiten',
      'Lahn',
      'Vorderkrimml',
      'Vorderwaldberg',
      'Wald',
    ],
  },
  {
    postleitzahl: 5743,
    orte: ['Hochkrimml', 'Oberkrimml', 'Unterkrimml'],
  },
  {
    postleitzahl: 5751,
    orte: ['Atzing', 'Maishofen', 'Mitterhofen'],
  },
  {
    postleitzahl: 5752,
    orte: ['Viehhofen'],
  },
  {
    postleitzahl: 5753,
    orte: ['Hinterglemm', 'Saalbach'],
  },
  {
    postleitzahl: 5754,
    orte: ['Hinterglemm'],
  },
  {
    postleitzahl: 5760,
    orte: [
      'Almdorf',
      'Bachwinkl',
      'Breitenbergham',
      'Bsuch',
      'Deuting',
      'Dorfheim',
      'Euring',
      'Gerling',
      'Haid',
      'Harham',
      'Hof',
      'Hohlwegen',
      'Kehlbach',
      'Lenzing',
      'Letting',
      'Marzon',
      'Mayrhofen',
      'Niederhaus',
      'Obsmarkt',
      'Pabing',
      'Pfaffenhofen',
      'Pfaffing',
      'Rain',
      'Ramseiden',
      'Ruhgassing',
      'Saalfelden am Steinernen Meer',
      'Schinking',
      'Schmalenbergham',
      'Schmieding',
      'Schützing',
      'Thor',
      'Uttenhofen',
      'Weikersbach',
      'Wiesersberg',
      'Wiesing',
    ],
  },
  {
    postleitzahl: 5761,
    orte: [
      'Aberg',
      'Alm',
      'Bachwinkl',
      'Enterwinkl',
      'Griesbachwinkl',
      'Hinterthal',
      'Krallerwinkl',
      'Schattberg',
      'Schloßberg',
      'Sonnberg',
    ],
  },
  {
    postleitzahl: 5771,
    orte: [
      'Berg',
      'Ecking',
      'Grießen',
      'Hirnreit',
      'Hütten',
      'Leogang',
      'Madreit',
      'Otting',
      'Pirzbichl',
      'Rain',
      'Rosental',
      'Schwarzleo',
      'Sinning',
      'Sonnberg',
      'Sonnrain',
      'Ullach',
    ],
  },
  {
    postleitzahl: 6020,
    orte: [
      'Amras',
      'Arzl',
      'Hötting',
      'Innsbruck',
      'Mühlau',
      'Mutters',
      'Natters',
      'Pradl',
      'Raitis',
      'Schönberg im Stubaital',
      'Vill',
      'Wilten',
    ],
  },
  {
    postleitzahl: 6060,
    orte: ['Hall in Tirol', 'Heiligkreuz'],
  },
  {
    postleitzahl: 6063,
    orte: ['Rum', 'Thaur'],
  },
  {
    postleitzahl: 6065,
    orte: ['Thaur'],
  },
  {
    postleitzahl: 6067,
    orte: ['Absam'],
  },
  {
    postleitzahl: 6068,
    orte: ['Mils'],
  },
  {
    postleitzahl: 6069,
    orte: ['Gnadenwald'],
  },
  {
    postleitzahl: 6070,
    orte: ['Ampass'],
  },
  {
    postleitzahl: 6071,
    orte: ['Aldrans'],
  },
  {
    postleitzahl: 6072,
    orte: ['Lans'],
  },
  {
    postleitzahl: 6073,
    orte: ['Aldrans', 'Sistrans'],
  },
  {
    postleitzahl: 6074,
    orte: ['Rinn'],
  },
  {
    postleitzahl: 6075,
    orte: ['Tulfes', 'Volderwald'],
  },
  {
    postleitzahl: 6080,
    orte: ['Igls', 'Vill'],
  },
  {
    postleitzahl: 6082,
    orte: ['Patsch'],
  },
  {
    postleitzahl: 6083,
    orte: ['Ellbögen'],
  },
  {
    postleitzahl: 6091,
    orte: ['Götzens', 'Natters'],
  },
  {
    postleitzahl: 6092,
    orte: ['Birgitz'],
  },
  {
    postleitzahl: 6094,
    orte: ['Axamer Lizum', 'Axams', 'Bachl', 'Kristen'],
  },
  {
    postleitzahl: 6095,
    orte: ['Grinzens'],
  },
  {
    postleitzahl: 6100,
    orte: [
      'Mösern',
      'Reith bei Seefeld',
      'Seefeld in Tirol',
      'Telfs',
      'Wildmoos',
    ],
  },
  {
    postleitzahl: 6103,
    orte: ['Reith bei Seefeld'],
  },
  {
    postleitzahl: 6105,
    orte: ['Leutasch'],
  },
  {
    postleitzahl: 6108,
    orte: ['Scharnitz'],
  },
  {
    postleitzahl: 6111,
    orte: ['Großvolderberg', 'Kleinvolderberg', 'Volders'],
  },
  {
    postleitzahl: 6112,
    orte: ['Wattens'],
  },
  {
    postleitzahl: 6113,
    orte: ['Wattenberg'],
  },
  {
    postleitzahl: 6114,
    orte: ['Kolsass'],
  },
  {
    postleitzahl: 6115,
    orte: ['Kolsassberg'],
  },
  {
    postleitzahl: 6116,
    orte: ['Weer'],
  },
  {
    postleitzahl: 6121,
    orte: ['Baumkirchen'],
  },
  {
    postleitzahl: 6122,
    orte: ['Fritzens'],
  },
  {
    postleitzahl: 6123,
    orte: [
      'Eggen',
      'Mairbach',
      'Neu-Terfens',
      'Schlögelsbach',
      'Terfens',
      'Umlberg',
      'Vomperbach',
    ],
  },
  {
    postleitzahl: 6130,
    orte: ['Schwaz'],
  },
  {
    postleitzahl: 6133,
    orte: ['Weerberg'],
  },
  {
    postleitzahl: 6134,
    orte: ['Fiecht', 'Vomp', 'Vomperbach', 'Vomperberg'],
  },
  {
    postleitzahl: 6135,
    orte: ['Schlagturn', 'Stans'],
  },
  {
    postleitzahl: 6136,
    orte: ['Pill'],
  },
  {
    postleitzahl: 6141,
    orte: ['Schönberg im Stubaital'],
  },
  {
    postleitzahl: 6142,
    orte: ['Mieders'],
  },
  {
    postleitzahl: 6143,
    orte: [
      'Altstadt',
      'Matrei am Brenner',
      'Matreiwald',
      'Mühlbachl',
      'Mützens',
      'Obfeldes',
      'Pfons',
      'Schöfens',
      'Statz',
      'Zieglstadl',
    ],
  },
  {
    postleitzahl: 6145,
    orte: ['Außerweg', 'Oberweg', 'Unterweg'],
  },
  {
    postleitzahl: 6150,
    orte: ['Gschnitz', 'Mauern', 'Stafflach', 'Statz', 'Steinach am Brenner'],
  },
  {
    postleitzahl: 6152,
    orte: ['Trins'],
  },
  {
    postleitzahl: 6154,
    orte: ['Außerschmirn', 'Innerschmirn', 'Vals'],
  },
  {
    postleitzahl: 6156,
    orte: ['Gries am Brenner'],
  },
  {
    postleitzahl: 6157,
    orte: ['Obernberg am Brenner'],
  },
  {
    postleitzahl: 6161,
    orte: ['Natters'],
  },
  {
    postleitzahl: 6162,
    orte: ['Kreith', 'Mutters', 'Raitis'],
  },
  {
    postleitzahl: 6165,
    orte: ['Telfes im Stubai'],
  },
  {
    postleitzahl: 6166,
    orte: ['Fulpmes', 'Medraz'],
  },
  {
    postleitzahl: 6167,
    orte: ['Medraz', 'Neustift im Stubaital'],
  },
  {
    postleitzahl: 6170,
    orte: ['Pettnau', 'Zirl'],
  },
  {
    postleitzahl: 6173,
    orte: ['Oberperfuss'],
  },
  {
    postleitzahl: 6175,
    orte: ['Afling', 'Kematen in Tirol'],
  },
  {
    postleitzahl: 6176,
    orte: ['Afling', 'Kematen in Tirol', 'Völs'],
  },
  {
    postleitzahl: 6178,
    orte: ['Unterperfuss'],
  },
  {
    postleitzahl: 6179,
    orte: ['Ranggen'],
  },
  {
    postleitzahl: 6181,
    orte: ['Sellrain'],
  },
  {
    postleitzahl: 6182,
    orte: ['Gries im Sellrain', 'Stams'],
  },
  {
    postleitzahl: 6183,
    orte: ['Kühtai'],
  },
  {
    postleitzahl: 6184,
    orte: ['St. Sigmund im Sellrain'],
  },
  {
    postleitzahl: 6200,
    orte: ['Jenbach', 'Strass im Zillertal', 'Tratzberg'],
  },
  {
    postleitzahl: 6210,
    orte: [
      'Astenberg',
      'Bradl',
      'Dikat',
      'Ehrenstall',
      'Erlach',
      'Rofansiedlung',
      'Tiergarten',
      'Wiesing',
    ],
  },
  {
    postleitzahl: 6212,
    orte: ['Maurach', 'Pertisau'],
  },
  {
    postleitzahl: 6213,
    orte: ['Pertisau'],
  },
  {
    postleitzahl: 6215,
    orte: ['Achenkirch', 'Bächental', 'Hinterriß', 'Steinberg am Rofan'],
  },
  {
    postleitzahl: 6220,
    orte: ['Buch'],
  },
  {
    postleitzahl: 6222,
    orte: ['Gallzein'],
  },
  {
    postleitzahl: 6230,
    orte: ['Brixlegg', 'Mehrn', 'Zimmermoos'],
  },
  {
    postleitzahl: 6232,
    orte: ['Münster'],
  },
  {
    postleitzahl: 6233,
    orte: ['Mariatal', 'Voldöpp'],
  },
  {
    postleitzahl: 6234,
    orte: ['Aschau', 'Brandenberg'],
  },
  {
    postleitzahl: 6235,
    orte: ['Hygna', 'Reith im Alpbachtal', 'Scheffach'],
  },
  {
    postleitzahl: 6236,
    orte: ['Alpbach'],
  },
  {
    postleitzahl: 6240,
    orte: ['Rattenberg'],
  },
  {
    postleitzahl: 6241,
    orte: ['Radfeld'],
  },
  {
    postleitzahl: 6250,
    orte: ['Kundl', 'Liesfeld', 'Saulueg'],
  },
  {
    postleitzahl: 6252,
    orte: ['Breitenbach am Inn', 'Haus', 'Kleinsöll', 'Schönau'],
  },
  {
    postleitzahl: 6260,
    orte: ['Bruck am Ziller', 'Bruckerberg', 'Imming', 'Reith im Alpbachtal'],
  },
  {
    postleitzahl: 6261,
    orte: ['Schlitters', 'Strass im Zillertal'],
  },
  {
    postleitzahl: 6262,
    orte: ['Schlitters'],
  },
  {
    postleitzahl: 6263,
    orte: ['Fügen', 'Gagering', 'Kapfing', 'Kleinboden', 'Schlitters'],
  },
  {
    postleitzahl: 6264,
    orte: ['Fügenberg', 'Pankrazberg', 'Schlitters'],
  },
  {
    postleitzahl: 6265,
    orte: ['Hart im Zillertal', 'Helfenstein', 'Holdernach'],
  },
  {
    postleitzahl: 6271,
    orte: ['Finsing', 'Kleinboden', 'Uderns'],
  },
  {
    postleitzahl: 6272,
    orte: ['Kaltenbach'],
  },
  {
    postleitzahl: 6273,
    orte: ['Ried im Zillertal'],
  },
  {
    postleitzahl: 6274,
    orte: ['Aschau', 'Distelberg'],
  },
  {
    postleitzahl: 6275,
    orte: ['Stumm'],
  },
  {
    postleitzahl: 6276,
    orte: ['Gattererberg', 'Stummerberg'],
  },
  {
    postleitzahl: 6277,
    orte: ['Zellberg', 'Zellbergeben'],
  },
  {
    postleitzahl: 6278,
    orte: ['Hainzenberg'],
  },
  {
    postleitzahl: 6280,
    orte: ['Gerlosberg', 'Rohrberg', 'Zell am Ziller'],
  },
  {
    postleitzahl: 6281,
    orte: ['Gerlos'],
  },
  {
    postleitzahl: 6283,
    orte: ['Hippach-Schwendberg', 'Laimach', 'Schwendau', 'Zell am Ziller'],
  },
  {
    postleitzahl: 6284,
    orte: ['Ramsau im Zillertal'],
  },
  {
    postleitzahl: 6290,
    orte: ['Brandberg', 'Mayrhofen', 'Schwendau'],
  },
  {
    postleitzahl: 6292,
    orte: ['Finkenberg', 'Schwendau'],
  },
  {
    postleitzahl: 6293,
    orte: ['Tux'],
  },
  {
    postleitzahl: 6294,
    orte: ['Tux'],
  },
  {
    postleitzahl: 6295,
    orte: ['Finkenberg', 'Ginzling'],
  },
  {
    postleitzahl: 6300,
    orte: ['Wörgl'],
  },
  {
    postleitzahl: 6305,
    orte: ['Itter'],
  },
  {
    postleitzahl: 6306,
    orte: ['Söll'],
  },
  {
    postleitzahl: 6311,
    orte: ['Auffach', 'Oberau', 'Thierbach'],
  },
  {
    postleitzahl: 6313,
    orte: ['Auffach'],
  },
  {
    postleitzahl: 6314,
    orte: ['Grafenweg', 'Niederau'],
  },
  {
    postleitzahl: 6320,
    orte: ['Achleit', 'Angerberg', 'Embach'],
  },
  {
    postleitzahl: 6321,
    orte: ['Angath'],
  },
  {
    postleitzahl: 6322,
    orte: ['Kirchbichl'],
  },
  {
    postleitzahl: 6323,
    orte: ['Bad Häring'],
  },
  {
    postleitzahl: 6324,
    orte: ['Mariastein'],
  },
  {
    postleitzahl: 6330,
    orte: [
      'Endach',
      'Kufstein-Kaisertal',
      'Kufstein-Stadtberg',
      'Kufstein',
      'Mitterndorf',
      'Morsbach',
      'Söll',
      'Thierberg',
      'Weissach',
      'Zell',
    ],
  },
  {
    postleitzahl: 6334,
    orte: ['Schwoich'],
  },
  {
    postleitzahl: 6335,
    orte: [
      'Almen',
      'Hinterthiersee',
      'Landl',
      'Mitterland',
      'Schmiedtal',
      'Vorderthiersee',
    ],
  },
  {
    postleitzahl: 6336,
    orte: [
      'Morsbach',
      'Niederbreitenbach',
      'Oberlangkampfen',
      'Unterlangkampfen',
    ],
  },
  {
    postleitzahl: 6341,
    orte: [
      'Asching',
      'Brand',
      'Ebbs',
      'Eichelwang',
      'Kaisertal',
      'Nußham',
      'Oberbuchberg',
      'Oberndorf',
      'Wagrain-Mühltal',
    ],
  },
  {
    postleitzahl: 6342,
    orte: ['Niederndorf'],
  },
  {
    postleitzahl: 6343,
    orte: ['Erl', 'Erlerberg', 'Mühlgraben'],
  },
  {
    postleitzahl: 6344,
    orte: ['Durchholzen', 'Oed', 'Schwaigs', 'Walchsee'],
  },
  {
    postleitzahl: 6345,
    orte: ['Kössen'],
  },
  {
    postleitzahl: 6346,
    orte: ['Eiberg', 'Gränzing', 'Hausern', 'Noppenberg', 'Praschberg'],
  },
  {
    postleitzahl: 6347,
    orte: ['Rettenschöss'],
  },
  {
    postleitzahl: 6351,
    orte: ['Scheffau am Wilden Kaiser', 'Söll'],
  },
  {
    postleitzahl: 6352,
    orte: ['Ellmau', 'Reith bei Kitzbühel'],
  },
  {
    postleitzahl: 6353,
    orte: [
      'Going am Wilden Kaiser',
      'Prama',
      'Reith bei Kitzbühel',
      'Schattseite',
      'Sonnseite',
    ],
  },
  {
    postleitzahl: 6361,
    orte: [
      'Glantersberg',
      'Grafenweg',
      'Gruberberg',
      'Hopfgarten-Markt',
      'Kelchsau',
      'Penningberg',
      'Salvenberg',
    ],
  },
  {
    postleitzahl: 6363,
    orte: ['Westendorf'],
  },
  {
    postleitzahl: 6364,
    orte: ['Brixen im Thale'],
  },
  {
    postleitzahl: 6365,
    orte: ['Kirchberg in Tirol', 'Reith bei Kitzbühel'],
  },
  {
    postleitzahl: 6370,
    orte: ['Kitzbühel', 'Reith bei Kitzbühel'],
  },
  {
    postleitzahl: 6371,
    orte: ['Aurach bei Kitzbühel'],
  },
  {
    postleitzahl: 6372,
    orte: ['Oberndorf in Tirol'],
  },
  {
    postleitzahl: 6373,
    orte: ['Jochberg'],
  },
  {
    postleitzahl: 6380,
    orte: ['St. Johann in Tirol'],
  },
  {
    postleitzahl: 6382,
    orte: ['Kirchdorf in Tirol'],
  },
  {
    postleitzahl: 6383,
    orte: ['Erpfendorf', 'Kirchdorf in Tirol'],
  },
  {
    postleitzahl: 6384,
    orte: ['Waidring'],
  },
  {
    postleitzahl: 6385,
    orte: ['Schwendt'],
  },
  {
    postleitzahl: 6391,
    orte: ['Fieberbrunn'],
  },
  {
    postleitzahl: 6392,
    orte: ['St. Jakob in Haus'],
  },
  {
    postleitzahl: 6393,
    orte: ['St. Ulrich am Pillersee'],
  },
  {
    postleitzahl: 6395,
    orte: ['Hochfilzen'],
  },
  {
    postleitzahl: 6401,
    orte: ['Eben', 'Hof', 'Inzing', 'Moos', 'Schindeltal', 'Toblaten'],
  },
  {
    postleitzahl: 6402,
    orte: ['Hatting', 'Hattingerberg'],
  },
  {
    postleitzahl: 6403,
    orte: ['Flaurling'],
  },
  {
    postleitzahl: 6404,
    orte: ['Polling in Tirol', 'Pollingberg'],
  },
  {
    postleitzahl: 6405,
    orte: ['Pfaffenhofen'],
  },
  {
    postleitzahl: 6406,
    orte: ['Oberhofen im Inntal'],
  },
  {
    postleitzahl: 6408,
    orte: ['Pettnau'],
  },
  {
    postleitzahl: 6410,
    orte: [
      'Bairbach',
      'Birkenberg',
      'Brand',
      'Buchen',
      'Hinterberg',
      'Lehen',
      'Platten',
      'St. Veit',
      'Telfs',
      'Wildmoos',
    ],
  },
  {
    postleitzahl: 6413,
    orte: ['Wildermieming'],
  },
  {
    postleitzahl: 6414,
    orte: ['Barwies', 'Obermieming', 'See', 'Untermieming'],
  },
  {
    postleitzahl: 6416,
    orte: ['Obsteig'],
  },
  {
    postleitzahl: 6421,
    orte: ['Rietz'],
  },
  {
    postleitzahl: 6422,
    orte: ['Stams'],
  },
  {
    postleitzahl: 6423,
    orte: ['Mötz'],
  },
  {
    postleitzahl: 6424,
    orte: ['Silz'],
  },
  {
    postleitzahl: 6425,
    orte: ['Haiming', 'Haimingerberg', 'Schlierenzau'],
  },
  {
    postleitzahl: 6426,
    orte: ['Roppen'],
  },
  {
    postleitzahl: 6430,
    orte: ['Haiming', 'Ötztal-Bahnhof'],
  },
  {
    postleitzahl: 6432,
    orte: ['Sautens'],
  },
  {
    postleitzahl: 6433,
    orte: ['Brunau', 'Haiming', 'Ochsengarten', 'Oetz'],
  },
  {
    postleitzahl: 6441,
    orte: ['Farst', 'Köfels', 'Niederthai', 'Östen', 'Tumpen', 'Umhausen'],
  },
  {
    postleitzahl: 6444,
    orte: ['Längenfeld'],
  },
  {
    postleitzahl: 6450,
    orte: ['Gurgl', 'Heiligkreuz', 'Sölden', 'Zwieselstein'],
  },
  {
    postleitzahl: 6456,
    orte: ['Gurgl', 'Sölden'],
  },
  {
    postleitzahl: 6458,
    orte: ['Sölden', 'Vent'],
  },
  {
    postleitzahl: 6460,
    orte: ['Arzl im Pitztal', 'Imst', 'Karrösten'],
  },
  {
    postleitzahl: 6462,
    orte: ['Karres'],
  },
  {
    postleitzahl: 6463,
    orte: ['Karrösten'],
  },
  {
    postleitzahl: 6464,
    orte: ['Tarrenz'],
  },
  {
    postleitzahl: 6465,
    orte: ['Nassereith'],
  },
  {
    postleitzahl: 6471,
    orte: [
      'Arzl im Pitztal',
      'Blons',
      'Hochasten',
      'Leins',
      'Ried',
      'Timls',
      'Wald',
    ],
  },
  {
    postleitzahl: 6473,
    orte: ['Fließ', 'Jerzens', 'Wenns'],
  },
  {
    postleitzahl: 6474,
    orte: ['Jerzens'],
  },
  {
    postleitzahl: 6481,
    orte: ['Plangeross', 'St. Leonhard im Pitztal', 'Zaunhof'],
  },
  {
    postleitzahl: 6491,
    orte: ['Schönwies'],
  },
  {
    postleitzahl: 6492,
    orte: ['Imsterberg'],
  },
  {
    postleitzahl: 6493,
    orte: ['Mils bei Imst'],
  },
  {
    postleitzahl: 6500,
    orte: ['Fließ', 'Grins', 'Landeck', 'Stanz bei Landeck'],
  },
  {
    postleitzahl: 6511,
    orte: ['Zammerberg', 'Zams'],
  },
  {
    postleitzahl: 6521,
    orte: ['Fließ'],
  },
  {
    postleitzahl: 6522,
    orte: ['Prutz'],
  },
  {
    postleitzahl: 6524,
    orte: ['Kaunertal'],
  },
  {
    postleitzahl: 6525,
    orte: ['Faggen'],
  },
  {
    postleitzahl: 6526,
    orte: ['Kauns'],
  },
  {
    postleitzahl: 6527,
    orte: ['Kaunerberg'],
  },
  {
    postleitzahl: 6528,
    orte: ['Fendels'],
  },
  {
    postleitzahl: 6531,
    orte: ['Ried im Oberinntal'],
  },
  {
    postleitzahl: 6532,
    orte: ['Ladis'],
  },
  {
    postleitzahl: 6533,
    orte: ['Fiss'],
  },
  {
    postleitzahl: 6534,
    orte: ['Serfaus'],
  },
  {
    postleitzahl: 6541,
    orte: ['Serfaus', 'Tösens'],
  },
  {
    postleitzahl: 6542,
    orte: ['Nauders', 'Pfunds', 'Serfaus'],
  },
  {
    postleitzahl: 6543,
    orte: ['Nauders'],
  },
  {
    postleitzahl: 6544,
    orte: ['Spiss'],
  },
  {
    postleitzahl: 6551,
    orte: ['Pians', 'Quadratsch'],
  },
  {
    postleitzahl: 6552,
    orte: ['Tobadill'],
  },
  {
    postleitzahl: 6553,
    orte: ['Kappl', 'Langesthei', 'See', 'Tobadill'],
  },
  {
    postleitzahl: 6555,
    orte: ['Kappl', 'See'],
  },
  {
    postleitzahl: 6561,
    orte: ['Ischgl', 'Mathon'],
  },
  {
    postleitzahl: 6562,
    orte: ['Ischgl', 'Mathon'],
  },
  {
    postleitzahl: 6563,
    orte: ['Galtür'],
  },
  {
    postleitzahl: 6571,
    orte: ['Strengen'],
  },
  {
    postleitzahl: 6572,
    orte: ['Flirsch'],
  },
  {
    postleitzahl: 6574,
    orte: ['Pettneu am Arlberg', 'Schnann'],
  },
  {
    postleitzahl: 6580,
    orte: ['St. Anton am Arlberg', 'St. Jakob am Arlberg'],
  },
  {
    postleitzahl: 6591,
    orte: ['Grins', 'Quadratsch'],
  },
  {
    postleitzahl: 6600,
    orte: [
      'Breitenwang',
      'Ehenbichl',
      'Lechaschau',
      'Musau',
      'Oberletzen',
      'Oberpinswang',
      'Pflach',
      'Reutte',
      'Unterletzen',
      'Unterpinswang',
    ],
  },
  {
    postleitzahl: 6604,
    orte: ['Höfen'],
  },
  {
    postleitzahl: 6610,
    orte: ['Hinterbichl', 'Holz', 'Wängle', 'Winkl'],
  },
  {
    postleitzahl: 6611,
    orte: ['Heiterwang'],
  },
  {
    postleitzahl: 6621,
    orte: [
      'Berwang',
      'Bichlbach',
      'Bichlbächle',
      'Kleinstockach',
      'Lähn',
      'Wengle',
    ],
  },
  {
    postleitzahl: 6622,
    orte: ['Berwang', 'Brand', 'Gröben', 'Mitteregg', 'Rinnen', 'Tal'],
  },
  {
    postleitzahl: 6623,
    orte: ['Kelmen', 'Namlos'],
  },
  {
    postleitzahl: 6631,
    orte: ['Lermoos', 'Obergarten', 'Untergarten'],
  },
  {
    postleitzahl: 6632,
    orte: ['Ehrwald'],
  },
  {
    postleitzahl: 6633,
    orte: ['Biberwier'],
  },
  {
    postleitzahl: 6642,
    orte: ['Stanzach'],
  },
  {
    postleitzahl: 6644,
    orte: ['Elmen', 'Klimm', 'Martinau'],
  },
  {
    postleitzahl: 6645,
    orte: ['Vorderhornbach'],
  },
  {
    postleitzahl: 6646,
    orte: ['Hinterhornbach'],
  },
  {
    postleitzahl: 6647,
    orte: ['Boden', 'Bschlabs'],
  },
  {
    postleitzahl: 6650,
    orte: ['Gramais'],
  },
  {
    postleitzahl: 6651,
    orte: ['Grießau', 'Häselgehr'],
  },
  {
    postleitzahl: 6652,
    orte: [
      'Elbigenalp',
      'Köglen',
      'Obergiblen',
      'Obergrünau',
      'Untergiblen',
      'Untergrünau',
    ],
  },
  {
    postleitzahl: 6653,
    orte: ['Bach', 'Elbigenalp', 'Obergiblen', 'Schönau', 'Stockach', 'Zams'],
  },
  {
    postleitzahl: 6654,
    orte: ['Holzgau', 'Schönau'],
  },
  {
    postleitzahl: 6655,
    orte: ['Dickenau', 'Hägerau', 'Hinterellenbogen', 'Kaisers', 'Steeg'],
  },
  {
    postleitzahl: 6670,
    orte: ['Forchach'],
  },
  {
    postleitzahl: 6671,
    orte: ['Gaicht', 'Rieden', 'Weißenbach am Lech'],
  },
  {
    postleitzahl: 6672,
    orte: ['Gaicht', 'Haller', 'Nesselwängle', 'Rauth'],
  },
  {
    postleitzahl: 6673,
    orte: ['Enge', 'Grän', 'Haldensee', 'Lumberg'],
  },
  {
    postleitzahl: 6675,
    orte: ['Tannheim'],
  },
  {
    postleitzahl: 6677,
    orte: [
      'Fricken',
      'Kappl',
      'Rehbach',
      'Schattwald',
      'Steig',
      'Wies',
      'Zöblen',
    ],
  },
  {
    postleitzahl: 6682,
    orte: ['Vils'],
  },
  {
    postleitzahl: 6691,
    orte: ['Jungholz'],
  },
  {
    postleitzahl: 6700,
    orte: ['Bludenz', 'Lorüns', 'Stallehr'],
  },
  {
    postleitzahl: 6706,
    orte: ['Bürs'],
  },
  {
    postleitzahl: 6707,
    orte: ['Bürserberg'],
  },
  {
    postleitzahl: 6708,
    orte: ['Brand'],
  },
  {
    postleitzahl: 6710,
    orte: ['Beschling', 'Latz', 'Nenzing', 'Nenzinger Himmel'],
  },
  {
    postleitzahl: 6712,
    orte: ['Thüringen'],
  },
  {
    postleitzahl: 6713,
    orte: ['Ludesch', 'Ludescherberg'],
  },
  {
    postleitzahl: 6714,
    orte: ['Nüziders'],
  },
  {
    postleitzahl: 6719,
    orte: ['Bludesch'],
  },
  {
    postleitzahl: 6721,
    orte: ['Thüringerberg'],
  },
  {
    postleitzahl: 6722,
    orte: ['St. Gerold'],
  },
  {
    postleitzahl: 6723,
    orte: ['Blons'],
  },
  {
    postleitzahl: 6731,
    orte: [
      'Bickelwald',
      'Boden',
      'Bregenzer',
      'Buchboden',
      'Buchholz',
      'Bühl',
      'Faschinastraße',
      'Flecken',
      'Garsella',
      'Halde',
      'Käscher',
      'Litze',
      'Mühle',
      'Nesler',
      'Reutele',
      'Risana',
      'Rothenbrunnen',
      'Rufana',
      'Sand',
      'Schmiede',
      'Seeberg',
      'Senzaboda',
      'Stein',
      'Steinbild',
      'Studa',
      'Türtsch',
    ],
  },
  {
    postleitzahl: 6733,
    orte: [
      'Faschina',
      'Fontanella',
      'Garlitt',
      'Mittelberg',
      'Säge',
      'Seewald',
      'Türtsch',
    ],
  },
  {
    postleitzahl: 6741,
    orte: ['Litze', 'Marul', 'Plazera', 'Raggal'],
  },
  {
    postleitzahl: 6751,
    orte: ['Ausserbraz', 'Innerbraz'],
  },
  {
    postleitzahl: 6752,
    orte: ['Dalaas', 'Wald am Arlberg'],
  },
  {
    postleitzahl: 6754,
    orte: ['Klösterle', 'Stuben'],
  },
  {
    postleitzahl: 6762,
    orte: ['Stuben'],
  },
  {
    postleitzahl: 6763,
    orte: ['Lech'],
  },
  {
    postleitzahl: 6764,
    orte: ['Dalaas', 'Lech', 'Wald am Arlberg'],
  },
  {
    postleitzahl: 6767,
    orte: ['Hochkrumbach', 'Lechleiten', 'Warth'],
  },
  {
    postleitzahl: 6771,
    orte: ['St. Anton im Montafon'],
  },
  {
    postleitzahl: 6773,
    orte: ['Vandans'],
  },
  {
    postleitzahl: 6774,
    orte: ['Tschagguns'],
  },
  {
    postleitzahl: 6780,
    orte: ['Schruns'],
  },
  {
    postleitzahl: 6781,
    orte: ['Bartholomäberg', 'Gantschier', 'Innerberg'],
  },
  {
    postleitzahl: 6782,
    orte: ['Silbertal'],
  },
  {
    postleitzahl: 6787,
    orte: ['Gargellen'],
  },
  {
    postleitzahl: 6791,
    orte: ['Gargellen', 'Gortipohl', 'St. Gallenkirch'],
  },
  {
    postleitzahl: 6793,
    orte: ['Gaschurn', 'Partenen'],
  },
  {
    postleitzahl: 6794,
    orte: ['Partenen'],
  },
  {
    postleitzahl: 6800,
    orte: ['Feldkirch'],
  },
  {
    postleitzahl: 6811,
    orte: ['Göfis'],
  },
  {
    postleitzahl: 6812,
    orte: ['Meiningen'],
  },
  {
    postleitzahl: 6820,
    orte: ['Beschling', 'Frastanz', 'Gurtis', 'Mittelberg'],
  },
  {
    postleitzahl: 6822,
    orte: [
      'Düns',
      'Dünserberg',
      'Röns',
      'Satteins',
      'Schnifis',
      'Schnifnerberg',
    ],
  },
  {
    postleitzahl: 6824,
    orte: ['Röns', 'Schlins'],
  },
  {
    postleitzahl: 6830,
    orte: ['Laterns', 'Rankweil'],
  },
  {
    postleitzahl: 6832,
    orte: ['Röthis', 'Sulz'],
  },
  {
    postleitzahl: 6833,
    orte: ['Fraxern', 'Klaus'],
  },
  {
    postleitzahl: 6834,
    orte: ['Übersaxen'],
  },
  {
    postleitzahl: 6835,
    orte: ['Batschuns', 'Dafins', 'Muntlix'],
  },
  {
    postleitzahl: 6836,
    orte: ['Viktorsberg'],
  },
  {
    postleitzahl: 6837,
    orte: ['Weiler'],
  },
  {
    postleitzahl: 6840,
    orte: ['Götzis'],
  },
  {
    postleitzahl: 6841,
    orte: ['Mäder'],
  },
  {
    postleitzahl: 6842,
    orte: ['Koblach'],
  },
  {
    postleitzahl: 6844,
    orte: ['Altach'],
  },
  {
    postleitzahl: 6845,
    orte: ['Hohenems'],
  },
  {
    postleitzahl: 6850,
    orte: ['Dornbirn', 'Schwarzenberg'],
  },
  {
    postleitzahl: 6858,
    orte: ['Bildstein', 'Schwarzach'],
  },
  {
    postleitzahl: 6861,
    orte: ['Alberschwende'],
  },
  {
    postleitzahl: 6863,
    orte: ['Egg', 'Großdorf'],
  },
  {
    postleitzahl: 6866,
    orte: ['Andelsbuch'],
  },
  {
    postleitzahl: 6867,
    orte: ['Schwarzenberg'],
  },
  {
    postleitzahl: 6870,
    orte: ['Bezau', 'Reuthe'],
  },
  {
    postleitzahl: 6874,
    orte: ['Bizau'],
  },
  {
    postleitzahl: 6881,
    orte: ['Mellau'],
  },
  {
    postleitzahl: 6882,
    orte: ['Hirschau', 'Schnepfau'],
  },
  {
    postleitzahl: 6883,
    orte: ['Au', 'Rehmen'],
  },
  {
    postleitzahl: 6884,
    orte: ['Damüls', 'Türtsch'],
  },
  {
    postleitzahl: 6886,
    orte: ['Schoppernau'],
  },
  {
    postleitzahl: 6888,
    orte: ['Schröcken'],
  },
  {
    postleitzahl: 6890,
    orte: ['Fußach', 'Lustenau'],
  },
  {
    postleitzahl: 6900,
    orte: ['Bregenz', 'Fluh', 'Lochau', 'Möggers'],
  },
  {
    postleitzahl: 6911,
    orte: ['Eichenberg', 'Lochau'],
  },
  {
    postleitzahl: 6912,
    orte: ['Hörbranz'],
  },
  {
    postleitzahl: 6914,
    orte: ['Hohenweiler'],
  },
  {
    postleitzahl: 6921,
    orte: ['Kennelbach'],
  },
  {
    postleitzahl: 6922,
    orte: ['Wolfurt'],
  },
  {
    postleitzahl: 6923,
    orte: ['Lauterach'],
  },
  {
    postleitzahl: 6932,
    orte: ['Langen bei Bregenz'],
  },
  {
    postleitzahl: 6933,
    orte: ['Doren'],
  },
  {
    postleitzahl: 6934,
    orte: ['Sulzberg', 'Thal'],
  },
  {
    postleitzahl: 6941,
    orte: ['Langenegg'],
  },
  {
    postleitzahl: 6942,
    orte: ['Krumbach'],
  },
  {
    postleitzahl: 6943,
    orte: ['Riefensberg'],
  },
  {
    postleitzahl: 6951,
    orte: ['Lingenau'],
  },
  {
    postleitzahl: 6952,
    orte: ['Bolgenach', 'Hittisau', 'Sibratsgfäll'],
  },
  {
    postleitzahl: 6960,
    orte: ['Buch'],
  },
  {
    postleitzahl: 6971,
    orte: ['Fußach', 'Hard'],
  },
  {
    postleitzahl: 6972,
    orte: ['Fußach'],
  },
  {
    postleitzahl: 6973,
    orte: ['Fußach', 'Höchst'],
  },
  {
    postleitzahl: 6974,
    orte: ['Gaißau'],
  },
  {
    postleitzahl: 6991,
    orte: ['Riezlern'],
  },
  {
    postleitzahl: 6992,
    orte: ['Hirschegg', 'Riezlern'],
  },
  {
    postleitzahl: 6993,
    orte: ['Hirschegg', 'Mittelberg'],
  },
  {
    postleitzahl: 7000,
    orte: [
      'Eisenstadt',
      'Kleinhöflein im Burgenland',
      'Sankt Georgen am Leithagebirge',
    ],
  },
  {
    postleitzahl: 7011,
    orte: ['Siegendorf / Cindrof'],
  },
  {
    postleitzahl: 7012,
    orte: ['Zagersdorf / Cogrštof'],
  },
  {
    postleitzahl: 7013,
    orte: ['Klingenbach / Klimpuh'],
  },
  {
    postleitzahl: 7020,
    orte: ['Loipersbach im Burgenland'],
  },
  {
    postleitzahl: 7021,
    orte: ['Baumgarten / Pajngrt', 'Draßburg / Rasporak'],
  },
  {
    postleitzahl: 7022,
    orte: ['Schattendorf'],
  },
  {
    postleitzahl: 7023,
    orte: ['Pöttelsdorf', 'Stöttera', 'Zemendorf'],
  },
  {
    postleitzahl: 7024,
    orte: ['Hirm'],
  },
  {
    postleitzahl: 7031,
    orte: ['Krensdorf'],
  },
  {
    postleitzahl: 7032,
    orte: ['Sigleß'],
  },
  {
    postleitzahl: 7033,
    orte: ['Pöttsching', 'Zillingtal / Celindof'],
  },
  {
    postleitzahl: 7034,
    orte: ['Zillingtal / Celindof'],
  },
  {
    postleitzahl: 7035,
    orte: ['Steinbrunn / Štikapron', 'Zillingtal / Celindof'],
  },
  {
    postleitzahl: 7041,
    orte: ['Wulkaprodersdorf / Vulkaprodrštof'],
  },
  {
    postleitzahl: 7042,
    orte: ['Antau / Otava'],
  },
  {
    postleitzahl: 7051,
    orte: ['Großhöflein'],
  },
  {
    postleitzahl: 7052,
    orte: ['Müllendorf'],
  },
  {
    postleitzahl: 7053,
    orte: ['Hornstein / Vorištan'],
  },
  {
    postleitzahl: 7061,
    orte: ['Trausdorf an der Wulka / Trajštof'],
  },
  {
    postleitzahl: 7062,
    orte: ['Sankt Margarethen im Burgenland'],
  },
  {
    postleitzahl: 7063,
    orte: ['Oggau am Neusiedler See'],
  },
  {
    postleitzahl: 7064,
    orte: ['Oslip / Uzlop'],
  },
  {
    postleitzahl: 7071,
    orte: ['Rust'],
  },
  {
    postleitzahl: 7072,
    orte: ['Mörbisch am See'],
  },
  {
    postleitzahl: 7081,
    orte: ['Schützen am Gebirge'],
  },
  {
    postleitzahl: 7082,
    orte: ['Donnerskirchen'],
  },
  {
    postleitzahl: 7083,
    orte: ['Purbach am Neusiedler See'],
  },
  {
    postleitzahl: 7091,
    orte: ['Breitenbrunn am Neusiedler See'],
  },
  {
    postleitzahl: 7092,
    orte: ['Winden am See'],
  },
  {
    postleitzahl: 7093,
    orte: ['Jois'],
  },
  {
    postleitzahl: 7100,
    orte: ['Neusiedl am See', 'Weiden am See'],
  },
  {
    postleitzahl: 7111,
    orte: ['Parndorf / Pandrof'],
  },
  {
    postleitzahl: 7121,
    orte: ['Weiden am See'],
  },
  {
    postleitzahl: 7122,
    orte: ['Gols'],
  },
  {
    postleitzahl: 7123,
    orte: ['Halbturn', 'Mönchhof'],
  },
  {
    postleitzahl: 7131,
    orte: ['Halbturn'],
  },
  {
    postleitzahl: 7132,
    orte: ['Apetlon', 'Frauenkirchen'],
  },
  {
    postleitzahl: 7141,
    orte: ['Podersdorf am See'],
  },
  {
    postleitzahl: 7142,
    orte: ['Illmitz'],
  },
  {
    postleitzahl: 7143,
    orte: ['Apetlon'],
  },
  {
    postleitzahl: 7151,
    orte: ['Wallern im Burgenland'],
  },
  {
    postleitzahl: 7152,
    orte: ['Pamhagen'],
  },
  {
    postleitzahl: 7161,
    orte: ['Apetlon', 'Sankt Andrä am Zicksee'],
  },
  {
    postleitzahl: 7162,
    orte: ['Tadten'],
  },
  {
    postleitzahl: 7163,
    orte: ['Andau'],
  },
  {
    postleitzahl: 7201,
    orte: ['Neudörfl'],
  },
  {
    postleitzahl: 7202,
    orte: ['Bad Sauerbrunn', 'Lichtenwörth', 'Pöttsching', 'Wiesen'],
  },
  {
    postleitzahl: 7203,
    orte: ['Wiesen'],
  },
  {
    postleitzahl: 7210,
    orte: ['Mattersburg', 'Walbersdorf'],
  },
  {
    postleitzahl: 7212,
    orte: ['Forchtenstein', 'Ofenbach'],
  },
  {
    postleitzahl: 7221,
    orte: ['Marz'],
  },
  {
    postleitzahl: 7222,
    orte: ['Rohrbach bei Mattersburg'],
  },
  {
    postleitzahl: 7223,
    orte: ['Sieggraben'],
  },
  {
    postleitzahl: 7301,
    orte: ['Deutschkreutz', 'Girm'],
  },
  {
    postleitzahl: 7302,
    orte: ['Kroatisch Minihof / Mjenovo', 'Nikitsch / Filež'],
  },
  {
    postleitzahl: 7304,
    orte: [
      'Großwarasdorf / Veliki Borištof',
      'Kleinwarasdorf / Mali Borištof',
      'Langental / Longitolj',
      'Mitterpullendorf',
      'Nebersdorf / Šuševo',
    ],
  },
  {
    postleitzahl: 7311,
    orte: ['Haschendorf', 'Neckenmarkt'],
  },
  {
    postleitzahl: 7312,
    orte: ['Horitschon', 'Unterpetersdorf'],
  },
  {
    postleitzahl: 7321,
    orte: ['Lackendorf', 'Raiding', 'Unterfrauenhaid'],
  },
  {
    postleitzahl: 7322,
    orte: ['Lackenbach'],
  },
  {
    postleitzahl: 7323,
    orte: ['Ritzing'],
  },
  {
    postleitzahl: 7331,
    orte: ['Kalkgruben', 'Tschurndorf', 'Weppersdorf'],
  },
  {
    postleitzahl: 7332,
    orte: ['Kobersdorf', 'Oberpetersdorf'],
  },
  {
    postleitzahl: 7341,
    orte: [
      'Landsee',
      'Lindgraben',
      'Markt Sankt Martin',
      'Neudorf bei Landsee',
    ],
  },
  {
    postleitzahl: 7342,
    orte: ['Kaisersdorf / Kalištrof'],
  },
  {
    postleitzahl: 7343,
    orte: ['Neutal'],
  },
  {
    postleitzahl: 7344,
    orte: ['Stoob'],
  },
  {
    postleitzahl: 7350,
    orte: ['Mitterpullendorf', 'Oberpullendorf / Felsőpulya'],
  },
  {
    postleitzahl: 7361,
    orte: [
      'Frankenau / Frakanava',
      'Kroatisch Geresdorf / Gerištof',
      'Lutzmannsburg',
      'Strebersdorf',
    ],
  },
  {
    postleitzahl: 7371,
    orte: ['Oberrabnitz', 'Schwendgraben', 'Unterrabnitz'],
  },
  {
    postleitzahl: 7372,
    orte: ['Draßmarkt', 'Karl'],
  },
  {
    postleitzahl: 7373,
    orte: ['Piringsdorf'],
  },
  {
    postleitzahl: 7374,
    orte: ['Weingraben / Bajngrob'],
  },
  {
    postleitzahl: 7400,
    orte: [
      'Drumling',
      'Oberschützen',
      'Oberwart / Felsőőr',
      'Sankt Martin in der Wart',
      'Unterschützen',
    ],
  },
  {
    postleitzahl: 7410,
    orte: ['Kitzladen', 'Loipersdorf im Burgenland'],
  },
  {
    postleitzahl: 7411,
    orte: ['Buchschachen', 'Markt Allhau'],
  },
  {
    postleitzahl: 7412,
    orte: ['Wolfau'],
  },
  {
    postleitzahl: 7421,
    orte: ['Mönichkirchen'],
  },
  {
    postleitzahl: 7422,
    orte: ['Riedlingsdorf'],
  },
  {
    postleitzahl: 7423,
    orte: [
      'Grafenschachen',
      'Hochart',
      'Kroisegg',
      'Neustift an der Lafnitz',
      'Pinkafeld',
      'Sinnersdorf',
    ],
  },
  {
    postleitzahl: 7425,
    orte: [
      'Schönherrn',
      'Schreibersdorf',
      'Weinberg im Burgenland',
      'Wiesfleck',
    ],
  },
  {
    postleitzahl: 7431,
    orte: ['Bad Tatzmannsdorf', 'Jormannsdorf', 'Oberschützen', 'Sulzriegel'],
  },
  {
    postleitzahl: 7432,
    orte: [
      'Aschau im Burgenland',
      'Oberschützen',
      'Schmiedrait',
      'Willersdorf',
    ],
  },
  {
    postleitzahl: 7433,
    orte: [
      'Bergwerk',
      'Grodnau',
      'Mariasdorf',
      'Neustift bei Schlaining',
      'Tauchen',
    ],
  },
  {
    postleitzahl: 7434,
    orte: [
      'Bernstein',
      'Dreihütten',
      'Holzschlag',
      'Redlschlag',
      'Rettenbach',
      'Stuben',
    ],
  },
  {
    postleitzahl: 7435,
    orte: [
      'Glashütten bei Schlaining',
      'Günseck',
      'Holzschlag',
      'Oberkohlstätten',
      'Unterkohlstätten',
    ],
  },
  {
    postleitzahl: 7441,
    orte: [
      'Bubendorf im Burgenland',
      'Deutsch Gerisdorf',
      'Kogl im Burgenland',
      'Lebenbrunn',
      'Pilgersdorf',
      'Salmannsdorf',
      'Steinbach im Burgenland',
    ],
  },
  {
    postleitzahl: 7442,
    orte: [
      'Glashütten bei Langeck im Burgenland',
      'Hammerteich',
      'Hochstraß',
      'Langeck im Burgenland',
      'Lockenhaus',
    ],
  },
  {
    postleitzahl: 7443,
    orte: ['Liebing', 'Rattersdorf'],
  },
  {
    postleitzahl: 7444,
    orte: ['Klostermarienberg', 'Mannersdorf an der Rabnitz', 'Unterloisdorf'],
  },
  {
    postleitzahl: 7451,
    orte: ['Oberloisdorf'],
  },
  {
    postleitzahl: 7452,
    orte: [
      'Großmutschen / Mučindrof',
      'Kleinmutschen / Pervane',
      'Unterpullendorf / Dolnja Pulja',
    ],
  },
  {
    postleitzahl: 7453,
    orte: ['Dörfl', 'Steinberg'],
  },
  {
    postleitzahl: 7461,
    orte: [
      'Allersdorf im Burgenland / Ključarevci',
      'Allersgraben / Širokani',
      'Altschlaining',
      'Goberling',
      'Mönchmeierhof / Marof',
      'Neumarkt im Tauchental',
      'Podler / Poljanci',
      'Rauhriegel / Rorigljin',
      'Stadtschlaining',
    ],
  },
  {
    postleitzahl: 7463,
    orte: [
      'Oberpodgoria / Podgorje',
      'Rumpersdorf / Rupišće',
      'Unterpodgoria / Bošnjakov Brig',
      'Weiden bei Rechnitz / Bandol',
      'Zuberbach / Sabara',
    ],
  },
  {
    postleitzahl: 7464,
    orte: ['Althodis / Stari Hodas', 'Markt Neuhodis'],
  },
  {
    postleitzahl: 7471,
    orte: ['Rechnitz'],
  },
  {
    postleitzahl: 7472,
    orte: [
      'Dürnbach im Burgenland / Vincjet',
      'Schachendorf / Čajta',
      'Schandorf / Čemba',
    ],
  },
  {
    postleitzahl: 7473,
    orte: ['Burg', 'Hannersdorf', 'Woppendorf'],
  },
  {
    postleitzahl: 7474,
    orte: [
      'Burg',
      'Deutsch-Schützen',
      'Edlitz im Burgenland',
      'Eisenberg an der Pinka',
      'Höll',
      'Sankt Kathrein im Burgenland',
    ],
  },
  {
    postleitzahl: 7501,
    orte: [
      'Oberdorf im Burgenland',
      'Rotenturm an der Pinka',
      'Siget in der Wart / Őrisziget',
      'Spitzzicken / Hrvatski Cikljin',
    ],
  },
  {
    postleitzahl: 7502,
    orte: ['Eisenzicken', 'Unterwart / Alsóőr'],
  },
  {
    postleitzahl: 7503,
    orte: [
      'Dürnbach im Burgenland / Vincjet',
      'Großpetersdorf',
      'Jabing',
      'Kleinpetersdorf',
      'Kleinzicken',
      'Miedlingsdorf',
      'Welgersdorf',
      'Zuberbach / Sabara',
    ],
  },
  {
    postleitzahl: 7511,
    orte: [
      'Großbachselten',
      'Kleinbachselten',
      'Kotezicken',
      'Mischendorf',
      'Neuhaus in der Wart',
      'Rohrbach an der Teich',
    ],
  },
  {
    postleitzahl: 7512,
    orte: ['Badersdorf', 'Harmisch', 'Kirchfidisch', 'Kohfidisch'],
  },
  {
    postleitzahl: 7521,
    orte: [
      'Eberau',
      'Gaas',
      'Kulm im Burgenland',
      'Oberbildein',
      'Unterbildein',
      'Winten',
    ],
  },
  {
    postleitzahl: 7522,
    orte: [
      'Deutsch Bieling',
      'Deutsch Ehrensdorf',
      'Hagensdorf im Burgenland',
      'Heiligenbrunn',
      'Kroatisch Ehrensdorf',
      'Luising',
      'Reinersdorf',
      'Steinfurt',
      'Strem',
      'Sumetendorf',
    ],
  },
  {
    postleitzahl: 7531,
    orte: ['Kemeten'],
  },
  {
    postleitzahl: 7532,
    orte: ['Litzelsdorf'],
  },
  {
    postleitzahl: 7533,
    orte: ['Ollersdorf im Burgenland'],
  },
  {
    postleitzahl: 7534,
    orte: ['Olbendorf'],
  },
  {
    postleitzahl: 7535,
    orte: [
      'Gamischdorf',
      'Rauchwart',
      'Sankt Michael im Burgenland',
      'Schallendorf im Burgenland',
    ],
  },
  {
    postleitzahl: 7536,
    orte: ['Güttenbach / Pinkovac'],
  },
  {
    postleitzahl: 7537,
    orte: ['Neuberg im Burgenland / Nova Gora'],
  },
  {
    postleitzahl: 7540,
    orte: [
      'Glasing',
      'Großmürbisch',
      'Güssing',
      'Inzenhof',
      'Kleinmürbisch',
      'Krottendorf',
      'Moschendorf',
      'Neustift bei Güssing',
      'Sankt Nikolaus',
      'Steingraben',
      'Tschanigraben',
      'Urbersdorf',
    ],
  },
  {
    postleitzahl: 7542,
    orte: ['Gerersdorf bei Güssing', 'Rehgraben', 'Sulz im Burgenland'],
  },
  {
    postleitzahl: 7543,
    orte: ['Eisenhüttl', 'Kukmirn', 'Limbach', 'Neusiedl'],
  },
  {
    postleitzahl: 7544,
    orte: [
      'Deutsch Tschantschendorf',
      'Hasendorf im Burgenland',
      'Kroatisch Tschantschendorf',
      'Punitz',
      'Tobaj',
      'Tudersdorf',
    ],
  },
  {
    postleitzahl: 7551,
    orte: ['Bocksdorf', 'Heugraben', 'Rohr im Burgenland', 'Stegersbach'],
  },
  {
    postleitzahl: 7552,
    orte: ['Stinatz / Stinjaki'],
  },
  {
    postleitzahl: 7561,
    orte: ['Heiligenkreuz im Lafnitztal', 'Poppendorf im Burgenland'],
  },
  {
    postleitzahl: 7562,
    orte: ['Eltendorf', 'Zahling'],
  },
  {
    postleitzahl: 7563,
    orte: ['Königsdorf'],
  },
  {
    postleitzahl: 7564,
    orte: ['Dobersdorf'],
  },
  {
    postleitzahl: 7571,
    orte: ['Rudersdorf'],
  },
  {
    postleitzahl: 7572,
    orte: ['Deutsch Kaltenbrunn', 'Rohrbrunn'],
  },
  {
    postleitzahl: 7574,
    orte: ['Burgauberg', 'Neudauberg'],
  },
  {
    postleitzahl: 8010,
    orte: [
      'Edelsbach bei Graz',
      'Graz,01.Bez.:Innere Stadt',
      'Graz,02.Bez.:Sankt Leonhard',
      'Graz,03.Bez.:Geidorf',
      'Graz,06.Bez.:Jakomini',
      'Graz,07.Bez.:Liebenau',
      'Graz,08.Bez.:Sankt Peter',
      'Graz,09.Bez.:Waltendorf',
      'Graz,10.Bez.:Ries',
      'Graz,11.Bez.:Mariatrost',
      'Graz,12.Bez.:Andritz',
      'Hönigtal',
      'Kainbach',
      'Schaftal',
    ],
  },
  {
    postleitzahl: 8020,
    orte: [
      'Graz,04.Bez.:Lend',
      'Graz,05.Bez.:Gries',
      'Graz,13.Bez.:Gösting',
      'Graz,14.Bez.:Eggenberg',
      'Graz,15.Bez.:Wetzelsdorf',
      'Graz,16.Bez.:Straßgang',
      'Graz,17.Bez.:Puntigam',
    ],
  },
  {
    postleitzahl: 8036,
    orte: [
      'Graz,03.Bez.:Geidorf',
      'Graz,10.Bez.:Ries',
      'Graz,11.Bez.:Mariatrost',
    ],
  },
  {
    postleitzahl: 8041,
    orte: [
      'Graz,06.Bez.:Jakomini',
      'Graz,07.Bez.:Liebenau',
      'Graz,08.Bez.:Sankt Peter',
    ],
  },
  {
    postleitzahl: 8042,
    orte: [
      'Graz,06.Bez.:Jakomini',
      'Graz,07.Bez.:Liebenau',
      'Graz,08.Bez.:Sankt Peter',
      'Graz,09.Bez.:Waltendorf',
      'Graz,13.Bez.:Gösting',
    ],
  },
  {
    postleitzahl: 8043,
    orte: [
      'Graz,03.Bez.:Geidorf',
      'Graz,11.Bez.:Mariatrost',
      'Graz,12.Bez.:Andritz',
    ],
  },
  {
    postleitzahl: 8044,
    orte: [
      'Fölling',
      'Graz,10.Bez.:Ries',
      'Graz,11.Bez.:Mariatrost',
      'Graz,12.Bez.:Andritz',
      'Niederschöckl',
      'Oberschöckl',
      'Purgstall bei Eggersdorf',
      'Rabnitz',
      'Schaftal',
      'Weinitzen',
    ],
  },
  {
    postleitzahl: 8045,
    orte: [
      'Buch',
      'Graz,12.Bez.:Andritz',
      'Hochgreit',
      'Hohenberg',
      'Kalkleiten',
      'Oberschöckl',
      'Weinitzen',
    ],
  },
  {
    postleitzahl: 8046,
    orte: [
      'Eichberg',
      'Graz,12.Bez.:Andritz',
      'Graz,13.Bez.:Gösting',
      'Hochgreit',
      'Hub',
      'Krail',
      'Leber',
      'Mühl',
      'Neudorf',
      'Rannach',
      'Sankt Veit',
      'Steingraben',
      'Ursprung',
    ],
  },
  {
    postleitzahl: 8047,
    orte: [
      'Graz,02.Bez.:Sankt Leonhard',
      'Graz,09.Bez.:Waltendorf',
      'Graz,10.Bez.:Ries',
      'Hart bei Graz',
      'Hönigtal',
      'Kainbach',
    ],
  },
  {
    postleitzahl: 8051,
    orte: [
      'Graz,04.Bez.:Lend',
      'Graz,13.Bez.:Gösting',
      'Graz,14.Bez.:Eggenberg',
      'Thal',
    ],
  },
  {
    postleitzahl: 8052,
    orte: [
      'Graz,13.Bez.:Gösting',
      'Graz,14.Bez.:Eggenberg',
      'Graz,15.Bez.:Wetzelsdorf',
      'Mantscha',
      'Oberberg',
      'Steinberg',
      'Thal',
    ],
  },
  {
    postleitzahl: 8053,
    orte: [
      'Graz,05.Bez.:Gries',
      'Graz,15.Bez.:Wetzelsdorf',
      'Graz,16.Bez.:Straßgang',
    ],
  },
  {
    postleitzahl: 8054,
    orte: [
      'Attendorf',
      'Graz,16.Bez.:Straßgang',
      'Graz,17.Bez.:Puntigam',
      'Hautzendorf',
      'Mantscha',
      'Mühlriegl',
      'Neupirka',
      'Neuwindorf',
      'Pirka',
      'Riederhof',
      'Seiersberg',
      'Windorf',
    ],
  },
  {
    postleitzahl: 8055,
    orte: [
      'Graz,05.Bez.:Gries',
      'Graz,16.Bez.:Straßgang',
      'Graz,17.Bez.:Puntigam',
      'Neuwindorf',
      'Seiersberg',
      'Windorf',
    ],
  },
  {
    postleitzahl: 8061,
    orte: [
      'Diepoltsberg',
      'Ebersdorf',
      'Kickenheim',
      'Oberschöckl',
      'Plenzengreith',
      'Rabnitz',
      'Rinnegg',
      'Sankt Radegund bei Graz',
      'Schöckl',
      'Stenzengreith',
      'Stockheim',
      'Willersdorf',
    ],
  },
  {
    postleitzahl: 8062,
    orte: [
      'Gschwendt',
      'Hart bei Eggersdorf',
      'Hofstätten',
      'Kumberg',
      'Niederschöckl',
      'Rabnitz',
    ],
  },
  {
    postleitzahl: 8063,
    orte: [
      'Brodersdorf',
      'Brodingberg',
      'Edelsbach bei Graz',
      'Eggersdorf bei Graz',
      'Hart bei Eggersdorf',
      'Haselbach',
      'Höf',
      'Hönigtal',
      'Mitterlaßnitz',
      'Nestelbach bei Graz',
      'Pircha',
      'Präbach',
      'Purgstall bei Eggersdorf',
      'Rabnitz',
    ],
  },
  {
    postleitzahl: 8071,
    orte: ['Berndorf', 'Hausmannstätten'],
  },
  {
    postleitzahl: 8072,
    orte: [
      'Dillach',
      'Enzelsdorf',
      'Fernitz',
      'Gnaning',
      'Mellach',
      'Sankt Ulrich am Waasen',
      'Wutschdorf',
    ],
  },
  {
    postleitzahl: 8073,
    orte: [
      'Abtissendorf',
      'Feldkirchen bei Graz',
      'Graz,17.Bez.:Puntigam',
      'Lebern',
      'Neupirka',
      'Neuwindorf',
      'Pirka',
      'Seiersberg',
      'Wagnitz',
    ],
  },
  {
    postleitzahl: 8074,
    orte: [
      'Dürwagersbach',
      'Grambach',
      'Graz,07.Bez.:Liebenau',
      'Graz,08.Bez.:Sankt Peter',
      'Lamberg',
      'Raaba',
    ],
  },
  {
    postleitzahl: 8075,
    orte: ['Hart bei Graz', 'Laßnitzhöhe'],
  },
  {
    postleitzahl: 8076,
    orte: ['Vasoldsberg'],
  },
  {
    postleitzahl: 8077,
    orte: ['Dörfla', 'Gössendorf', 'Thondorf'],
  },
  {
    postleitzahl: 8081,
    orte: [
      'Allerheiligen bei Wildon',
      'Edelstauden',
      'Empersdorf',
      'Felgitsch',
      'Frannach',
      'Guggitzgraben',
      'Heiligenkreuz am Waasen',
      'Kittenbach',
      'Kleinfeiting',
      'Kohldorf',
      'Liebensdorf',
      'Manning',
      'Oberdorf',
      'Oberlabill',
      'Pirching am Traubenberg',
      'Rettenbach in Oststeiermark',
      'Sankt Ulrich am Waasen',
      'Vasoldsberg',
      'Weißenbach',
    ],
  },
  {
    postleitzahl: 8082,
    orte: [
      'Breitenbuch',
      'Dörfla',
      'Glatzau',
      'Kirchbach in Steiermark',
      'Kittenbach',
      'Kleinfrannach',
      'Maierhofen',
      'Maxendorf',
      'Oberdorf am Hochegg',
      'Petersdorf II',
      'Sankt Stefan im Rosental',
      'Tagensdorf',
      'Tiefernitz',
      'Weißenbach',
      'Zerlach',
      'Ziprein',
    ],
  },
  {
    postleitzahl: 8083,
    orte: [
      'Hamet',
      'Jahrbach',
      'Maierhofen',
      'Sankt Stefan im Rosental',
      'Tagensdorf',
      'Wetzelsdorf bei Jagerberg',
      'Wörth',
    ],
  },
  {
    postleitzahl: 8091,
    orte: [
      'Grasdorf',
      'Jagerberg',
      'Jahrbach',
      'Lugitsch',
      'Oberzirknitz',
      'Pöllau',
      'Radisch',
      'Sankt Stefan im Rosental',
      'Ungerdorf',
      'Unterzirknitz',
    ],
  },
  {
    postleitzahl: 8092,
    orte: [
      'Landorf',
      'Mettersdorf am Saßbach',
      'Rannersdorf am Saßbach',
      'Rohrbach am Rosenberg',
      'Zehensdorf',
    ],
  },
  {
    postleitzahl: 8093,
    orte: [
      'Bierbaum am Auersbach',
      'Dietersdorf am Gnasbach',
      'Edla',
      'Entschendorf am Ottersbach',
      'Mettersdorf am Saßbach',
      'Oberrosenberg',
      'Perbersdorf bei Sankt Peter',
      'Rohrbach am Rosenberg',
      'Sankt Peter am Ottersbach',
      'Wiersdorf',
      'Wittmannsdorf',
      'Zehensdorf',
    ],
  },
  {
    postleitzahl: 8101,
    orte: [
      'Forstviertel',
      'Freßnitzviertel',
      'Kirchenviertel',
      'Sankt Veit',
      'Unterfriesach',
    ],
  },
  {
    postleitzahl: 8102,
    orte: [
      'Amstein',
      'Freßnitzviertel',
      'Markterviertl',
      'Präbichl',
      'Rechberg',
      'Schönegg',
      'Semriach',
      'Thoneben',
      'Unterneudorf',
      'Windhof',
    ],
  },
  {
    postleitzahl: 8103,
    orte: [
      'Eisbach',
      'Gschnaidt',
      'Hörgas',
      'Kehr und Plesch',
      'Rein',
      'Stübinggraben',
    ],
  },
  {
    postleitzahl: 8111,
    orte: [
      'Eisbach',
      'Hundsdorf',
      'Judendorf',
      'Kugelberg',
      'Plankenwarth',
      'Rötz',
      'Straßengel',
    ],
  },
  {
    postleitzahl: 8112,
    orte: [
      'Eisbach',
      'Gratwein',
      'Hörgas',
      'Kugelberg',
      'Rein',
      'Sankt Oswald bei Plankenwarth',
    ],
  },
  {
    postleitzahl: 8113,
    orte: [
      'Eisbach',
      'Gschnaidt',
      'Jaritzberg',
      'Kalchberg',
      'Lichtenegg',
      'Michlbach',
      'Plankenwarth',
      'Reiteregg',
      'Rohrbach',
      'Sankt Bartholomä',
      'Sankt Oswald bei Plankenwarth',
      'Södingberg',
      'Stiwoll',
      'Thal',
    ],
  },
  {
    postleitzahl: 8114,
    orte: [
      'Deutschfeistritz',
      'Forstviertel',
      'Friesach',
      'Großstübing',
      'Gschnaidt',
      'Himberg',
      'Hörgas',
      'Kleinstübing',
      'Königgraben',
      'Stübinggraben',
      'Unterfriesach',
    ],
  },
  {
    postleitzahl: 8120,
    orte: ['Peggau'],
  },
  {
    postleitzahl: 8121,
    orte: ['Adriach', 'Deutschfeistritz', 'Himberg', 'Königgraben', 'Prenning'],
  },
  {
    postleitzahl: 8122,
    orte: ['Arzwaldgraben', 'Hofamt', 'Land-Übelbach', 'Prenning', 'Waldstein'],
  },
  {
    postleitzahl: 8124,
    orte: [
      'Großstübing',
      'Kleintal',
      'Land-Übelbach',
      'Markt-Übelbach',
      'Neuhof',
    ],
  },
  {
    postleitzahl: 8130,
    orte: [
      'Adriach',
      'Badl',
      'Brunnhof',
      'Frohnleiten',
      'Gams',
      'Gamsgraben',
      'Gschwendt',
      'Hofamt',
      'Kühau',
      'Laas',
      'Laufnitzdorf',
      'Laufnitzgraben',
      'Leutnant Günther-Siedlung',
      'Maria Ebenort',
      'Peggau',
      'Peugen',
      'Pfannberg',
      'Rothleiten',
      'Schönau',
      'Schrauding',
      'Schrems',
      'Tyrnau',
      'Ungersdorf',
      'Vordere Gams',
      'Wannersdorf',
    ],
  },
  {
    postleitzahl: 8131,
    orte: [
      'Mautstatt',
      'Mixnitz',
      'Pernegg',
      'Roßgraben',
      'Röthelstein',
      'Traföß',
    ],
  },
  {
    postleitzahl: 8132,
    orte: ['Gabraun', 'Kirchdorf', 'Pernegg', 'Traföß', 'Zlatten'],
  },
  {
    postleitzahl: 8141,
    orte: [
      'Bierbaum',
      'Dietersdorf',
      'Hautzendorf',
      'Laa',
      'Oberpremstätten',
      'Unterpremstätten',
      'Zettling',
    ],
  },
  {
    postleitzahl: 8142,
    orte: [
      'Dietersdorf',
      'Forst',
      'Gradenfeld',
      'Kasten',
      'Ponigl',
      'Steindorf',
      'Wundschuh',
      'Zwaring',
    ],
  },
  {
    postleitzahl: 8143,
    orte: [
      'Dobl',
      'Fading',
      'Muttendorf',
      'Petzendorf',
      'Tobisegg',
      'Unterpremstätten',
      'Weinzettl',
      'Wuschan',
    ],
  },
  {
    postleitzahl: 8144,
    orte: [
      'Attendorf',
      'Attendorfberg',
      'Badegg',
      'Bischofegg',
      'Haselsdorf',
      'Haselsdorfberg',
      'Hautzendorf',
      'Lieboch',
      'Oberpremstätten',
      'Riederhof',
      'Seiersberg',
      'Tobelbad',
      'Unterpremstätten',
    ],
  },
  {
    postleitzahl: 8151,
    orte: [
      'Altenberg',
      'Altreiteregg',
      'Attendorf',
      'Attendorfberg',
      'Berndorf',
      'Doblegg',
      'Haselsdorfberg',
      'Hausdorf',
      'Hitzendorf',
      'Höllberg',
      'Holzberg',
      'Mayersdorf',
      'Neureiteregg',
      'Niederberg',
      'Oberberg',
      'Pirka',
      'Reiteregg',
      'Rohrbach',
      'Sankt Bartholomä',
      'Södingberg',
      'Steinberg',
      'Thal',
    ],
  },
  {
    postleitzahl: 8152,
    orte: [
      'Aichegg',
      'Bernau',
      'Berndorf',
      'Gasselberg',
      'Hausdorf',
      'Kalchberg',
      'Michlbach',
      'Muggauberg',
      'Neudorf bei Sankt Johann ob Hohenburg',
      'Raßberg',
      'Södingberg',
      'Stallhofen',
      'Voitsberg',
    ],
  },
  {
    postleitzahl: 8153,
    orte: [
      'Eggartsberg',
      'Geistthal',
      'Gschnaidt',
      'Kleinalpe',
      'Neuhof',
      'Södingberg',
      'Sonnleiten',
    ],
  },
  {
    postleitzahl: 8160,
    orte: [
      'Affental',
      'Alterilz',
      'Birchbaum',
      'Büchl',
      'Dürntal',
      'Etzersdorf',
      'Farcha',
      'Garrach',
      'Göttelsberg',
      'Grub',
      'Gschaid bei Weiz',
      'Hafning',
      'Haselbach bei Weiz',
      'Haufenreith',
      'Hofstätten',
      'Kleinsemmering',
      'Krammersdorf',
      'Krottendorf',
      'Landscha bei Weiz',
      'Leska',
      'Mortantsch',
      'Naas',
      'Nöstl',
      'Oberdorf bei Thannhausen',
      'Oberdorf',
      'Oberfladnitz',
      'Obergreith',
      'Peesen',
      'Pichl an der Raab',
      'Ponigl',
      'Preding',
      'Raas',
      'Regerstätten',
      'Steinberg bei Weiz',
      'Stenzengreith',
      'Trennstein',
      'Untergreith',
      'Weiz',
    ],
  },
  {
    postleitzahl: 8162,
    orte: [
      'Amstein',
      'Arzberg',
      'Auen',
      'Hart',
      'Haufenreith',
      'Hintertober',
      'Hohenau an der Raab',
      'Krammersdorf',
      'Oberneudorf',
      'Passail',
      'Plenzengreith',
      'Tober',
      'Tulwitzdorf',
      'Unterneudorf',
    ],
  },
  {
    postleitzahl: 8163,
    orte: [
      'Fladnitz an der Teichalm',
      'Fladnitz-Tober',
      'Fladnitzberg',
      'Nechnitz',
      'Rechberg',
      'Schrems',
      'Semriach',
      'Teichalm',
      'Tulwitzdorf',
      'Tulwitzviertl',
      'Tyrnau',
    ],
  },
  {
    postleitzahl: 8171,
    orte: ['Sankt Kathrein am Offenegg'],
  },
  {
    postleitzahl: 8172,
    orte: [
      'Haslau bei Birkfeld',
      'Hohenau an der Raab',
      'Naintsch',
      'Offenegg',
      'Rossegg',
      'Sallegg',
    ],
  },
  {
    postleitzahl: 8181,
    orte: [
      'Arndorf bei Sankt Ruprecht an der Raab',
      'Dietmannsdorf',
      'Dörfl an der Raab',
      'Farcha',
      'Fünfing bei Sankt Ruprecht an der Raab',
      'Grub bei Sankt Ruprecht an der Raab',
      'Gschwendt',
      'Hohenkogl',
      'Kühwiesen',
      'Lohngraben',
      'Mitterdorf an der Raab',
      'Neudorf bei Sankt Ruprecht an der Raab',
      'Oberdorf',
      'Pichl an der Raab',
      'Preding',
      'Rollsdorf',
      'Sankt Ruprecht an der Raab',
      'Schirnitz',
      'Unterfladnitz',
      'Untergreith',
      'Wolfgruben b.Sankt Ruprecht a.d.Raab',
      'Wollsdorf',
      'Wollsdorferegg',
    ],
  },
  {
    postleitzahl: 8182,
    orte: [
      'Elz',
      'Harl',
      'Höfling',
      'Klettendorf',
      'Kulming',
      'Oberfeistritz',
      'Perndorf',
      'Puch bei Weiz',
    ],
  },
  {
    postleitzahl: 8183,
    orte: ['Floing', 'Höfling', 'Lebing', 'Oberfeistritz', 'Unterfeistritz'],
  },
  {
    postleitzahl: 8184,
    orte: [
      'Anger',
      'Baierdorf-Dorf',
      'Baierdorf-Umgebung',
      'Floing',
      'Fresen',
      'Naintsch',
      'Oberfeistritz',
      'Rossegg',
      'Viertelfeistritz',
    ],
  },
  {
    postleitzahl: 8190,
    orte: [
      'Aschau',
      'Außeregg',
      'Berg-und Hinterleitenviertel',
      'Birkfeld',
      'Dorfviertel',
      'Feistritz',
      'Gschaid bei Birkfeld',
      'Haslau bei Birkfeld',
      'Piregg',
      'Rabendorf',
      'Sallegg',
      'Waisenegg',
    ],
  },
  {
    postleitzahl: 8191,
    orte: ['Aschau', 'Birkfeld', 'Rabendorf', 'Rossegg', 'Sallegg'],
  },
  {
    postleitzahl: 8192,
    orte: ['Außeregg', 'Feistritz', 'Pacher', 'Strallegg'],
  },
  {
    postleitzahl: 8200,
    orte: [
      'Albersdorf',
      'Arnwiesen',
      'Brodersdorf',
      'Brodingberg',
      'Flöcking',
      'Fünfing bei Gleisdorf',
      'Gamling',
      'Gleisdorf',
      'Hart',
      'Hofstätten an der Raab',
      'Kalch',
      'Kaltenbrunn',
      'Labuch',
      'Laßnitzthal',
      'Ludersdorf',
      'Mitterlaßnitz',
      'Nitscha',
      'Obergroßau',
      'Pircha',
      'Pirching an der Raab',
      'Postelgraben',
      'Präbach',
      'Sinabelkirchen',
      'Ungerdorf',
      'Urscha',
      'Wetzawinkel',
      'Wilfersdorf',
      'Wolfgruben bei Gleisdorf',
      'Wünschendorf',
    ],
  },
  {
    postleitzahl: 8211,
    orte: [
      'Egelsdorf',
      'Fünfing bei Gleisdorf',
      'Großpesendorf',
      'Kalch',
      'Neudorf',
      'Nitschaberg',
      'Oberrettenbach',
      'Postelgraben',
      'Prebensdorf',
      'Prebuch',
      'Preßguts',
      'Schirnitz',
      'Wolfgruben bei Gleisdorf',
    ],
  },
  {
    postleitzahl: 8212,
    orte: [
      'Elz',
      'Gersdorf an der Feistritz',
      'Hart',
      'Hartensdorf',
      'Höfling',
      'Kleinpesendorf',
      'Kulming',
      'Oberrettenbach',
      'Pischelsdorf in der Steiermark',
      'Reichendorf',
      'Rohrbach am Kulm',
      'Romatschachen',
      'Rothgmos',
      'Schachen am Römerbach',
      'Siegersdorf bei Herberstein',
    ],
  },
  {
    postleitzahl: 8221,
    orte: ['Hirnsdorf', 'Hofing', 'Illensdorf', 'Kaibing'],
  },
  {
    postleitzahl: 8222,
    orte: [
      'Buchberg bei Herberstein',
      'Hofing',
      'Kaibing',
      'Kulming',
      'Sankt Johann bei Herberstein',
      'Siegersdorf bei Herberstein',
      'Untertiefenbach',
    ],
  },
  {
    postleitzahl: 8223,
    orte: [
      'Buchberg bei Herberstein',
      'Floing',
      'Freienberg',
      'Siegersdorf bei Herberstein',
      'Stubenberg am See',
      'Vockenberg',
      'Zeil bei Stubenberg',
    ],
  },
  {
    postleitzahl: 8224,
    orte: [
      'Blaindorf',
      'Dienersdorf',
      'Hartl',
      'Hinteregg',
      'Hofing',
      'Hofkirchen',
      'Kaindorf',
      'Kopfing',
      'Obertiefenbach',
      'Untertiefenbach',
      'Vockenberg',
      'Winzendorf',
    ],
  },
  {
    postleitzahl: 8225,
    orte: [
      'Flattendorf',
      'Hinteregg',
      'Hofkirchen',
      'Köppelreith',
      'Oberneuberg',
      'Obersaifen',
      'Pöllau',
      'Pongratzen',
      'Prätis',
      'Rabenwald',
      'Schönau',
      'Staudach',
      'Unterneuberg',
      'Winkl-Boden',
      'Winzendorf',
      'Zeil-Pöllau',
    ],
  },
  {
    postleitzahl: 8230,
    orte: [
      'Altenberg',
      'Eggendorf',
      'Flattendorf',
      'Habersdorf',
      'Hartberg',
      'Klaffenau',
      'Lafnitz',
      'Löffelbach',
      'Mitterdombach',
      'Oberlungitz',
      'Penzendorf',
      'Ring',
      'Safenau',
      'Sankt Johann in der Haide',
      'Schildbach',
      'Schölbing',
      'Siebenbrunn',
      'Staudach',
      'Unterlungitz',
      'Untersafen',
      'Wagendorf',
      'Winzendorf',
      'Wolfgrub',
    ],
  },
  {
    postleitzahl: 8232,
    orte: [
      'Erdwegen',
      'Grafendorf bei Hartberg',
      'Kleinlungitz',
      'Lechen',
      'Obersafen',
      'Pongratzen',
      'Reibersdorf',
      'Seibersdorf am Hammerwald',
      'Stambach',
      'Untersafen',
      'Zeilerviertel',
    ],
  },
  {
    postleitzahl: 8233,
    orte: ['Kleinlungitz', 'Lafnitz', 'Rohrbachschlag'],
  },
  {
    postleitzahl: 8234,
    orte: [
      'Eichberg',
      'Kleinlungitz',
      'Lebing',
      'Limbach',
      'Reinberg',
      'Riegl',
      'Rohrbach an der Lafnitz',
      'Rohrbachschlag',
    ],
  },
  {
    postleitzahl: 8240,
    orte: [
      'Ehrenschachen',
      'Friedberg',
      'Oberwaldbauern',
      'Ortgraben',
      'Schwaighof',
      'Stögersbach',
    ],
  },
  {
    postleitzahl: 8241,
    orte: [
      'Bergen',
      'Burgfeld',
      'Dechantskirchen',
      'Hohenau am Wechsel',
      'Kroisbach',
      'Limbach',
      'Rohrbachschlag',
      'Schlag bei Thalberg',
      'Stögersbach',
    ],
  },
  {
    postleitzahl: 8242,
    orte: [
      'Auerbach',
      'Festenburg',
      'Köppel',
      'Kronegg',
      'Riegl',
      'Sankt Lorenzen am Wechsel',
    ],
  },
  {
    postleitzahl: 8243,
    orte: [
      'Baumgarten',
      'Dirnegg',
      'Haideggendorf',
      'Koglreith',
      'Ortgraben',
      'Pinggau',
      'Schaueregg',
      'Sparberegg',
      'Steirisch-Tauchen',
      'Tanzegg',
      'Wiesenhöf',
    ],
  },
  {
    postleitzahl: 8244,
    orte: [
      'Anger',
      'Elsenau',
      'Götzendorf',
      'Haberl',
      'Karnegg',
      'Knolln',
      'Neussing',
      'Schäffern',
      'Spital',
      'Stübegg',
    ],
  },
  {
    postleitzahl: 8250,
    orte: [
      'Kleinschlag',
      'Lebing',
      'Puchegg',
      'Reinberg',
      'Riegersbach',
      'Schachen bei Vorau',
      'Schnellerviertel',
      'Vorau',
      'Vornholz',
      'Zeil-Pöllau',
      'Zeilerviertel',
    ],
  },
  {
    postleitzahl: 8251,
    orte: ['Festenburg', 'Karnerviertel', 'Köppel', 'Riegersbach'],
  },
  {
    postleitzahl: 8252,
    orte: ['Karnerviertel', 'Riegersbach', 'Schmiedviertel'],
  },
  {
    postleitzahl: 8253,
    orte: [
      'Arzberg',
      'Breitenbrunn',
      'Riegersbach',
      'Rieglerviertel',
      'Schmiedviertel',
      'Schrimpf',
      'Sommersgut',
      'Vornholz',
    ],
  },
  {
    postleitzahl: 8254,
    orte: ['Kandlbauer', 'Pittermann', 'Sichart', 'Sommersgut', 'Vornholz'],
  },
  {
    postleitzahl: 8255,
    orte: ['Filzmoos', 'Kaltenegg', 'Kirchenviertel', 'Steinhöf'],
  },
  {
    postleitzahl: 8261,
    orte: [
      'Arnwiesen',
      'Egelsdorf',
      'Frösau',
      'Fünfing bei Gleisdorf',
      'Gnies',
      'Gschmaier',
      'Nagl',
      'Nestelbach im Ilztal',
      'Obergroßau',
      'Oberrettenbach',
      'Sinabelkirchen',
      'Untergroßau',
      'Unterrettenbach',
      'Wetzawinkel',
      'Wolfgruben bei Gleisdorf',
    ],
  },
  {
    postleitzahl: 8262,
    orte: [
      'Buchberg bei Ilz',
      'Dambach',
      'Dörfl',
      'Eichberg bei Hartmannsdorf',
      'Gnies',
      'Gschmaier',
      'Hainfeld bei Fürstenfeld',
      'Hochenegg',
      'Ilz',
      'Kalsdorf bei Ilz',
      'Kleegraben',
      'Leithen',
      'Mutzenfeld',
      'Nestelbach im Ilztal',
      'Nestelberg',
      'Neudorf bei Ilz',
      'Reigersberg',
      'Walkersdorf',
      'Ziegenberg',
    ],
  },
  {
    postleitzahl: 8263,
    orte: [
      'Großwilfersdorf',
      'Herrnberg',
      'Maierhofbergen',
      'Maierhofen',
      'Radersdorf',
    ],
  },
  {
    postleitzahl: 8264,
    orte: [
      'Großhartmannsdorf',
      'Hainersdorf',
      'Lichtenwald',
      'Obgrün',
      'Riegersdorf',
    ],
  },
  {
    postleitzahl: 8265,
    orte: [
      'Blaindorf',
      'Gersdorf an der Feistritz',
      'Großhartmannsdorf',
      'Großsteinbach',
      'Gschmaier',
      'Hartl',
      'Kroisbach an der Feistritz',
      'Leithen',
      'Neusiedl',
    ],
  },
  {
    postleitzahl: 8271,
    orte: [
      'Bad Waltersdorf',
      'Geier',
      'Großhart',
      'Hohenbrugg',
      'Leitersdorf bei Hartberg',
      'Oberlimbach',
      'Rohrbach bei Waltersdorf',
      'Sebersdorf',
      'Wagerberg',
    ],
  },
  {
    postleitzahl: 8272,
    orte: [
      'Ebersdorf',
      'Geier',
      'Geiseldorf',
      'Großhart',
      'Hartl',
      'Neusiedl',
      'Neustift bei Sebersdorf',
      'Nörning',
      'Rohrbach bei Waltersdorf',
      'Sebersdorf',
      'Unterbuch',
    ],
  },
  {
    postleitzahl: 8273,
    orte: ['Ebersdorf', 'Großhart', 'Nörning', 'Wagenbach'],
  },
  {
    postleitzahl: 8274,
    orte: [
      'Geiseldorf',
      'Hopfau',
      'Längenbach',
      'Lemberg',
      'Mitterndorf',
      'Oberbuch',
      'Unterbuch',
      'Unterdombach',
      'Unterrohr',
      'Weinberg',
      'Wenireith',
    ],
  },
  {
    postleitzahl: 8280,
    orte: [
      'Altenmarkt bei Fürstenfeld',
      'Dietersdorf bei Fürstenfeld',
      'Fürstenfeld',
      'Hartl bei Fürstenfeld',
      'Kohlgraben',
      'Speltenbach',
      'Stadtbergen',
      'Übersbach',
    ],
  },
  {
    postleitzahl: 8282,
    orte: [
      'Dietersdorf bei Fürstenfeld',
      'Gillersdorf',
      'Henndorf im Burgenland',
      'Loipersdorf bei Fürstenfeld',
      'Rittschein',
      'Stein',
    ],
  },
  {
    postleitzahl: 8283,
    orte: [
      'Bad Blumau',
      'Bierbaum an der Safen',
      'Jobst',
      'Kleinsteinbach',
      'Leitersdorf bei Hartberg',
      'Lindegg',
      'Loimeth',
      'Schwarzmannshofen',
      'Speilbrunn',
    ],
  },
  {
    postleitzahl: 8291,
    orte: ['Burgau'],
  },
  {
    postleitzahl: 8292,
    orte: ['Hackerberg', 'Neudau', 'Unterlimbach'],
  },
  {
    postleitzahl: 8293,
    orte: ['Wörterberg', 'Wörth an der Lafnitz'],
  },
  {
    postleitzahl: 8294,
    orte: [
      'Hopfau',
      'Mitterberg',
      'Oberrohr',
      'Schölbing',
      'Steinbüchl',
      'Unterrohr',
    ],
  },
  {
    postleitzahl: 8295,
    orte: ['Altenberg', 'Sankt Johann in der Haide', 'Unterlungitz'],
  },
  {
    postleitzahl: 8301,
    orte: [
      'Hart bei Graz',
      'Höf',
      'Hönigtal',
      'Kainbach',
      'Laßnitzhöhe',
      'Mitterlaßnitz',
      'Nestelbach bei Graz',
      'Präbach',
    ],
  },
  {
    postleitzahl: 8302,
    orte: [
      'Edelsgrub',
      'Empersdorf',
      'Hirtenfeld',
      'Kogelbuch',
      'Krumegg',
      'Langegg-Ort',
      'Laßnitzhöhe',
      'Laßnitzthal',
      'Mitterlaßnitz',
      'Nestelbach bei Graz',
      'Präbach',
    ],
  },
  {
    postleitzahl: 8311,
    orte: [
      'Bärnbach',
      'Eichberg bei Hartmannsdorf',
      'Frösau',
      'Kaag',
      'Markt Hartmannsdorf',
      'Mitterfladnitz',
      'Oed',
      'Pöllau bei Gleisdorf',
      'Reith bei Hartmannsdorf',
      'Wetzawinkel',
    ],
  },
  {
    postleitzahl: 8312,
    orte: [
      'Bärnbach',
      'Breitenbach',
      'Krennach',
      'Neustift',
      'Oed',
      'Ottendorf an der Rittschein',
      'Schweinz',
      'Ziegenberg',
    ],
  },
  {
    postleitzahl: 8313,
    orte: [
      'Breitenfeld an der Rittschein',
      'Lembach bei Riegersburg',
      'Neustift',
      'Sankt Kind',
      'Schweinz',
      'Tiefenbach',
    ],
  },
  {
    postleitzahl: 8321,
    orte: [
      'Entschendorf',
      'Goggitsch',
      'Hofstätten an der Raab',
      'Kroisbach',
      'St. Margarethen an der Raab',
      'Sulz',
      'Takern I',
      'Takern II',
      'Urscha',
      'Wetzawinkel',
      'Zöbing',
    ],
  },
  {
    postleitzahl: 8322,
    orte: [
      'Eichkögl',
      'Erbersdorf',
      'Fladnitz im Raabtal',
      'Mitterfladnitz',
      'Sankt Marein bei Graz-Umgebung',
      'Siegersdorf',
      'Studenzen',
    ],
  },
  {
    postleitzahl: 8323,
    orte: [
      'Goggitsch',
      'Hirtenfeld',
      'Kohldorf',
      'Krumegg',
      'Lambach',
      'Mittergoggitsch',
      'Nestelbach bei Graz',
      'Obergoggitsch',
      'Petersdorf II',
      'Sankt Marein bei Graz-Markt',
      'Sankt Marein bei Graz-Umgebung',
      'Tiefernitz',
      'Unterbuch',
      'Zaunstein',
    ],
  },
  {
    postleitzahl: 8324,
    orte: [
      'Axbach',
      'Berndorf',
      'Hof',
      'Kirchberg an der Raab',
      'Oberdorf am Hochegg',
      'Oberstorcha',
      'Petersdorf II',
      'Radersdorf',
      'Sankt Stefan im Rosental',
      'Tiefernitz',
      'Wörth bei Kirchberg an der Raab',
    ],
  },
  {
    postleitzahl: 8330,
    orte: [
      'Auersbach',
      'Bergl',
      'Dörfl',
      'Edelsbach bei Feldbach',
      'Edersgraben',
      'Feldbach',
      'Gniebing',
      'Gossendorf',
      'Höflach',
      'Krennach',
      'Leitersdorf im Raabtal',
      'Mühldorf bei Feldbach',
      'Obergiem',
      'Oberkornbach',
      'Oberweißenbach',
      'Oedt bei Feldbach',
      'Paurach',
      'Pernreith',
      'Pertlstein',
      'Petersdorf',
      'Raabau',
      'Reiting',
      'Rohr an der Raab',
      'Schützing',
      'Untergiem',
      'Unterweißenbach',
      'Wetzelsdorf',
    ],
  },
  {
    postleitzahl: 8332,
    orte: [
      'Auersbach',
      'Edelsbach bei Feldbach',
      'Fladnitz im Raabtal',
      'Gniebing',
      'Kaag',
      'Mitterfladnitz',
      'Paurach',
      'Rohr an der Raab',
      'Wetzelsdorf',
    ],
  },
  {
    postleitzahl: 8333,
    orte: [
      'Altenmarkt bei Riegersburg',
      'Auersbach',
      'Bergl',
      'Breitenfeld an der Rittschein',
      'Dörfl',
      'Edelsgraben',
      'Grub I',
      'Krennach',
      'Lembach bei Riegersburg',
      'Lödersdorf II',
      'Oberkornbach',
      'Riegersburg',
      'Schützing',
      'Schweinz',
      'Stang bei Hatzendorf',
      'Wetzelsdorf',
    ],
  },
  {
    postleitzahl: 8334,
    orte: [
      'Bergl',
      'Edelsgraben',
      'Leitersdorf im Raabtal',
      'Lödersdorf I',
      'Lödersdorf II',
      'Oberkornbach',
    ],
  },
  {
    postleitzahl: 8341,
    orte: [
      'Axbach',
      'Baumgarten',
      'Häusla',
      'Kohlberg',
      'Oberstorcha',
      'Paldau',
      'Perlsdorf',
      'Pöllau',
      'Puch',
      'Reith',
      'Saaz',
      'Sankt Stefan im Rosental',
      'Unterstorcha',
      'Wörth',
    ],
  },
  {
    postleitzahl: 8342,
    orte: [
      'Aug',
      'Badenbrunn',
      'Baumgarten',
      'Burgfried',
      'Dietersdorf am Gnasbach',
      'Ebersdorf',
      'Fischa',
      'Glatzental',
      'Gnas',
      'Grabersdorf',
      'Hirsdorf',
      'Höf',
      'Katzelsdorf',
      'Katzendorf',
      'Kinsdorf',
      'Kohlberg',
      'Ludersdorf',
      'Maierdorf',
      'Oberauersbach',
      'Obergnas',
      'Perlsdorf',
      'Pernreith',
      'Poppendorf',
      'Radisch',
      'Raning',
      'Thien',
      'Trössing',
      'Unterauersbach',
      'Wörth',
    ],
  },
  {
    postleitzahl: 8343,
    orte: [
      'Hofstätten',
      'Katzendorf',
      'Poppendorf',
      'Trautmannsdorf',
      'Waldsberg',
    ],
  },
  {
    postleitzahl: 8344,
    orte: [
      'Bad Gleichenberg',
      'Bairisch Kölldorf',
      'Gleichenberg Dorf',
      'Gossendorf',
      'Haag',
      'Klausen',
      'Mahrensdorf',
      'Merkendorf',
      'Obergiem',
      'Petersdorf',
      'Pichla',
      'Steinbach',
      'Trautmannsdorf',
      'Waldsberg',
      'Wilhelmsdorf',
    ],
  },
  {
    postleitzahl: 8345,
    orte: [
      'Dirnbach',
      'Ebersdorf',
      'Grub II',
      'Hart bei Straden',
      'Hof bei Straden',
      'Karbach',
      'Karla',
      'Kronnersdorf',
      'Krusdorf',
      'Marktl',
      'Muggendorf',
      'Nägelsdorf',
      'Neusetz',
      'Radochen',
      'Schwabau',
      'Stainz bei Straden',
      'Straden',
      'Sulzbach',
      'Trössing',
      'Waasen am Berg',
      'Waldprecht',
      'Wieden-Klausen',
    ],
  },
  {
    postleitzahl: 8350,
    orte: [
      'Brunn',
      'Burgfeld',
      'Fehring',
      'Gutendorf',
      'Haselbach',
      'Hatzendorf',
      'Höflach',
      'Hohenbrugg an der Raab',
      'Johnsdorf',
      'Magland',
      'Mahrensdorf',
      'Pertlstein',
      'Petersdorf I',
      'Petzelsdorf bei Fehring',
      'Schiefer',
      'Weinberg an der Raab',
      'Welten',
    ],
  },
  {
    postleitzahl: 8352,
    orte: [
      'Hohenbrugg an der Raab',
      'Magland',
      'Oberlamm',
      'Unterlamm',
      'Weinberg an der Raab',
    ],
  },
  {
    postleitzahl: 8353,
    orte: [
      'Burgfeld',
      'Gutendorf',
      'Kapfenstein',
      'Kölldorf',
      'Neustift',
      'Pichla',
    ],
  },
  {
    postleitzahl: 8354,
    orte: [
      'Aigen',
      'Frutten',
      'Gießelsdorf',
      'Hochstraden',
      'Jamm',
      'Klapping',
      'Plesch',
      'Risola',
      'Sichauf',
      'Waltra',
    ],
  },
  {
    postleitzahl: 8355,
    orte: [
      'Frutten',
      'Größing',
      'Hürth',
      'Jörgen',
      'Klöchberg',
      'Laasen',
      'Patzen',
      'Pichla bei Radkersburg',
      'Tieschen',
    ],
  },
  {
    postleitzahl: 8361,
    orte: [
      'Habegg',
      'Hatzendorf',
      'Lödersdorf II',
      'Oberlamm',
      'Oedgraben',
      'Stang bei Hatzendorf',
      'Tiefenbach',
      'Unterhatzendorf',
    ],
  },
  {
    postleitzahl: 8362,
    orte: [
      'Aschbach bei Fürstenfeld',
      'Ebersdorf',
      'Hartl bei Fürstenfeld',
      'Kohlgraben',
      'Maierhofbergen',
      'Oberlamm',
      'Rittschein',
      'Ruppersdorf',
      'Söchau',
      'Stadtbergen',
      'Tautendorf bei Fürstenfeld',
      'Tiefenbach',
      'Übersbach',
    ],
  },
  {
    postleitzahl: 8380,
    orte: [
      'Grieselstein',
      'Henndorf im Burgenland',
      'Jennersdorf',
      'Neumarkt an der Raab',
      'Rax',
    ],
  },
  {
    postleitzahl: 8382,
    orte: [
      'Deutsch Minihof',
      'Krobotek',
      'Maria Bild',
      'Mogersdorf',
      'Rosendorf',
      'Wallendorf',
      'Weichselbaum',
    ],
  },
  {
    postleitzahl: 8383,
    orte: [
      'Doiber',
      'Eisenberg an der Raab',
      'Gritsch',
      'Oberdrosen',
      'Sankt Martin an der Raab',
      'Welten',
    ],
  },
  {
    postleitzahl: 8384,
    orte: [
      'Bonisdorf',
      'Minihof-Liebau',
      'Oberdrosen',
      'Tauka',
      'Windisch-Minihof',
    ],
  },
  {
    postleitzahl: 8385,
    orte: [
      'Bonisdorf',
      'Kalch',
      'Krottendorf bei Neuhaus am Klausenbach',
      'Mühlgraben',
      'Neuhaus am Klausenbach',
      'Welten',
    ],
  },
  {
    postleitzahl: 8401,
    orte: [
      'Abtissendorf',
      'Bierbaum',
      'Forst',
      'Großsulz',
      'Kalsdorf bei Graz',
      'Kleinsulz',
      'Laa',
      'Lebern',
      'Thalerhof',
      'Unterpremstätten',
      'Wagnitz',
      'Zettling',
    ],
  },
  {
    postleitzahl: 8402,
    orte: ['Werndorf'],
  },
  {
    postleitzahl: 8403,
    orte: [
      'Bachsdorf',
      'Dexenberg',
      'Göttling',
      'Jöß-Gewerbegebiet',
      'Jöß',
      'Kehlsdorf',
      'Lang',
      'Langaberg',
      'Lebring',
      'Oedt',
      'Ragnitz',
      'Sankt Margarethen bei Lebring',
      'Schirka',
      'Stangersdorf-Gewerbegebiet',
      'Stangersdorf',
    ],
  },
  {
    postleitzahl: 8410,
    orte: [
      'Afram',
      'Allerheiligen bei Wildon',
      'Aug',
      'Dillach',
      'Hart bei Wildon',
      'Kainach bei Wildon',
      'Lichendorf',
      'Mellach',
      'Neudorf ob Wildon',
      'Neudorf',
      'Stocking',
      'Sukdull',
      'Weitendorf',
      'Wildon',
    ],
  },
  {
    postleitzahl: 8411,
    orte: [
      'Flüssing',
      'Grötsch',
      'Hengsberg',
      'Kehlsdorf',
      'Komberg',
      'Kühberg',
      'Lamberg',
      'Matzelsdorf',
      'Schönberg an der Laßnitz',
      'Schrötten an der Laßnitz',
    ],
  },
  {
    postleitzahl: 8412,
    orte: [
      'Allerheiligen bei Wildon',
      'Großfeiting',
      'Sankt Ulrich am Waasen',
      'Schwasdorf',
      'Siebing',
      'Sukdull',
    ],
  },
  {
    postleitzahl: 8413,
    orte: [
      'Alla',
      'Badendorf',
      'Baldau',
      'Edelsee',
      'Gerbersdorf',
      'Gundersdorf',
      'Haslach an der Stiefing',
      'Kleinfeiting',
      'Kurzragnitz',
      'Lappach',
      'Laubegg',
      'Mitterlabill',
      'Oberragnitz',
      'Oedt',
      'Pesendorf',
      'Pichla',
      'Prentern',
      'Ragnitz',
      'Rohr',
      'Sankt Georgen an der Stiefing',
      'Stiefing',
      'Stiefingberg',
    ],
  },
  {
    postleitzahl: 8421,
    orte: [
      'Breitenfeld am Tannenriegel',
      'Glojach',
      'Hainsdorf im Schwarzautal',
      'Hamet',
      'Maggau',
      'Marchtring',
      'Matzelsdorf',
      'Sankt Nikolai ob Draßling',
      'Sankt Stefan im Rosental',
      'Schwarzau im Schwarzautal',
      'Seibuttendorf',
      'Techensdorf',
      'Unterlabill',
      'Wölferberg',
      'Wolfsberg im Schwarzautal',
      'Zehensdorf',
    ],
  },
  {
    postleitzahl: 8422,
    orte: ['Hütt', 'Leitersdorf', 'Matzelsdorf', 'Sankt Nikolai ob Draßling'],
  },
  {
    postleitzahl: 8423,
    orte: [
      'Labuttendorf',
      'Lind bei Sankt Veit am Vogau',
      'Lipsch',
      'Neutersdorf',
      'Perbersdorf bei Sankt Veit',
      'Pichla bei Mureck',
      'Rabenhof',
      'Sankt Veit am Vogau',
      'Seibersdorf bei Sankt Veit',
      'Wagendorf',
    ],
  },
  {
    postleitzahl: 8424,
    orte: ['Gabersdorf', 'Landscha an der Mur', 'Neudorf an der Mur', 'Sajach'],
  },
  {
    postleitzahl: 8430,
    orte: [
      'Bachsdorf',
      'Grottenhof',
      'Kaindorf',
      'Kogelberg',
      'Leibnitz',
      'Rettenbach',
      'Seggauberg',
    ],
  },
  {
    postleitzahl: 8431,
    orte: ['Gralla'],
  },
  {
    postleitzahl: 8434,
    orte: [
      'Altenberg',
      'Grössing',
      'Maxlon',
      'Neutillmitsch',
      'Steingrub',
      'Tillmitsch',
    ],
  },
  {
    postleitzahl: 8435,
    orte: [
      'Aflenz an der Sulm',
      'Hasendorf an der Mur',
      'Leitring',
      'Wagendorf',
      'Wagna',
    ],
  },
  {
    postleitzahl: 8441,
    orte: [
      'Brudersegg',
      'Fresing',
      'Höch',
      'Mantrach',
      'Nestelbach',
      'Rettenberg',
      'Sankt Andrä im Sausal',
      'Steinriegel',
    ],
  },
  {
    postleitzahl: 8442,
    orte: [
      'Einöd',
      'Fresing',
      'Gauitsch',
      'Greith',
      'Höch',
      'Neurath',
      'Sankt Andrä im Sausal',
      'Sausal',
      'Steinriegel',
    ],
  },
  {
    postleitzahl: 8443,
    orte: [
      'Dornach',
      'Fantsch',
      'Gasselsdorf',
      'Gleinstätten',
      'Goldes',
      'Graschach',
      'Haslach',
      'Maierhof',
      'Obergreith',
      'Pistorf',
      'Prarath',
      'Praratheregg',
      'Sausal',
      'Untergreith',
    ],
  },
  {
    postleitzahl: 8444,
    orte: [
      'Brünngraben',
      'Fantsch',
      'Höch',
      'Michlgleinz',
      'Neudorf im Sausal',
      'Reith',
      'Rettenberg',
      'Sankt Andrä im Sausal',
      'Sausal',
      'Weniggleinz',
    ],
  },
  {
    postleitzahl: 8451,
    orte: [
      'Gauitsch',
      'Heimschuh',
      'Kittenberg',
      'Kranach',
      'Muggenau',
      'Nestelberg',
      'Neurath',
      'Oberfahrenbach',
      'Oberlupitscheni',
      'Pernitsch',
      'Schönegg',
      'Seggauberg',
      'Unterfahrenbach',
    ],
  },
  {
    postleitzahl: 8452,
    orte: [
      'Burgstall',
      'Eichberg-Trautenburg',
      'Eichberg',
      'Goldes',
      'Großklein',
      'Maierhof',
      'Mantrach',
      'Mattelsberg',
      'Narrath',
      'Nestelbach',
      'Nestelberg',
      'Oberfahrenbach',
      'Pistorf',
    ],
  },
  {
    postleitzahl: 8453,
    orte: [
      'Eichberg-Trautenburg',
      'Eichberg',
      'Goldes',
      'Gündorf',
      'Kitzelsdorf',
      'Obergreith',
      'Radiga',
      'Saggau',
      'Sankt Johann im Saggautal',
      'Untergreith',
    ],
  },
  {
    postleitzahl: 8454,
    orte: [
      'Altenbach',
      'Arnfels',
      'Eichberg-Trautenburg',
      'Eichberg',
      'Hardegg',
      'Kitzelsdorf',
      'Krast',
      'Maltschach',
      'Oberhaag',
      'Remschnigg',
      'Saggau',
    ],
  },
  {
    postleitzahl: 8455,
    orte: [
      'Altenbach',
      'Bischofegg',
      'Lieschen',
      'Obergreith',
      'Oberhaag',
      'Pongratzen',
      'Wuggitz',
    ],
  },
  {
    postleitzahl: 8461,
    orte: [
      'Eckberg',
      'Ehrenhausen',
      'Ewitsch',
      'Gamlitz',
      'Ottenberg',
      'Ratsch an der Weinstraße',
      'Retznei',
      'Sulztal',
      'Unterlupitscheni',
      'Wielitsch',
      'Zieregg',
    ],
  },
  {
    postleitzahl: 8462,
    orte: [
      'Eckberg',
      'Fötschach',
      'Gamlitz',
      'Grubtal',
      'Kranach',
      'Labitschberg',
      'Oberfahrenbach',
      'Oberlupitscheni',
      'Sernau',
      'Steinbach',
    ],
  },
  {
    postleitzahl: 8463,
    orte: [
      'Eichberg-Trautenburg',
      'Fötschach',
      'Glanz',
      'Großwalz',
      'Kranach',
      'Langegg',
      'Leutschach',
      'Oberfahrenbach',
      'Pößnitz',
      'Remschnigg',
      'Schloßberg',
      'Steinbach',
    ],
  },
  {
    postleitzahl: 8471,
    orte: ['Oberschwarza', 'Seibersdorf bei Sankt Veit', 'Unterschwarza'],
  },
  {
    postleitzahl: 8472,
    orte: [
      'Gersdorf an der Mur',
      'Graßnitzberg',
      'Obegg',
      'Obervogau',
      'Spielfeld',
      'Straß in Steiermark',
      'Vogau',
    ],
  },
  {
    postleitzahl: 8473,
    orte: ['Lichendorf', 'Weitersfeld an der Mur'],
  },
  {
    postleitzahl: 8480,
    orte: [
      'Diepersdorf',
      'Eichfeld',
      'Fluttendorf',
      'Gosdorf',
      'Hainsdorf-Brunnsee',
      'Misselsdorf',
      'Mureck',
      'Oberrakitsch',
    ],
  },
  {
    postleitzahl: 8481,
    orte: ['Pichla bei Mureck', 'Priebing', 'Siebing', 'Weinburg am Saßbach'],
  },
  {
    postleitzahl: 8483,
    orte: [
      'Deutsch Goritz',
      'Hart bei Straden',
      'Haselbach',
      'Hofstätten bei Deutsch Goritz',
      'Krobathen',
      'Oberspitz',
      'Ratschendorf',
      'Salsach',
      'Schrötten bei Deutsch Goritz',
      'Unterspitz',
      'Weixelbaum',
    ],
  },
  {
    postleitzahl: 8484,
    orte: [
      'Dietzen',
      'Donnersdorf',
      'Hürth',
      'Oberpurkla',
      'Radochen',
      'Unterpurkla',
    ],
  },
  {
    postleitzahl: 8490,
    orte: [
      'Altneudörfl',
      'Bad Radkersburg',
      'Dedenitz',
      'Goritz bei Radkersburg',
      'Hummersdorf',
      'Laafeld',
      'Pfarrsdorf',
      'Pridahof',
      'Sicheldorf',
      'Zelting',
    ],
  },
  {
    postleitzahl: 8492,
    orte: [
      'Altneudörfl',
      'Dietzen',
      'Dornau',
      'Drauchen',
      'Halbenrain',
      'Hürth',
      'Klöchberg',
    ],
  },
  {
    postleitzahl: 8493,
    orte: [
      'Deutsch Haseldorf',
      'Gruisla',
      'Hürth',
      'Klöch',
      'Klöchberg',
      'Pichla bei Radkersburg',
      'Pölten',
    ],
  },
  {
    postleitzahl: 8501,
    orte: ['Lieboch', 'Schadendorf', 'Spatenhof'],
  },
  {
    postleitzahl: 8502,
    orte: [
      'Blumegg',
      'Breitenbach in der Weststeiermark',
      'Heuholz',
      'Hötschdorf',
      'Lannach',
      'Sajach',
      'Teipl',
    ],
  },
  {
    postleitzahl: 8503,
    orte: [
      'Blumegg',
      'Grafendorf bei Stainz',
      'Graggerer',
      'Heuholz',
      'Oisnitz',
      'Sankt Josef (Weststeiermark)',
      'Teipl',
      'Tobisegg',
      'Wetzelsdorf in der Weststeiermark',
      'Wetzelsdorfberg',
      'Wuschan',
    ],
  },
  {
    postleitzahl: 8504,
    orte: [
      'Grafendorf bei Stainz',
      'Grötsch',
      'Klein-Preding',
      'Leitersdorf',
      'Mettersdorf',
      'Pöls an der Wieserbahn',
      'Preding',
      'Tobis',
      'Tobisberg',
      'Wetzelsdorf in der Weststeiermark',
      'Wieselsdorf',
      'Wuschan',
      'Zehndorf',
      'Zwaring',
    ],
  },
  {
    postleitzahl: 8505,
    orte: [
      'Flamberg',
      'Greith',
      'Grötsch',
      'Lamperstätten',
      'Mitteregg',
      'Mollitsch',
      'Oberjahring',
      'Petzles',
      'Sankt Nikolai im Sausal',
      'Sausal',
      'Unterjahring',
      'Waldschach',
    ],
  },
  {
    postleitzahl: 8510,
    orte: [
      'Angenofen',
      'Ettendorf bei Stainz',
      'Gamsgebirg',
      'Grafendorf bei Stainz',
      'Graschuh',
      'Greim',
      'Greisdorf',
      'Herbersdorf',
      'Kothvogel',
      'Neudorf bei Stainz',
      'Neurath',
      'Pichling bei Stainz',
      'Rainbach',
      'Rassach',
      'Sallegg',
      'Sierling',
      'Sommereben',
      'Stainz',
      'Stallhof',
      'Teufenbach',
      'Trog',
      'Vochera am Weinberg',
      'Wald in der Weststeiermark',
    ],
  },
  {
    postleitzahl: 8511,
    orte: [
      'Greisdorf',
      'Grubberg',
      'Gundersdorf',
      'Lemsitz',
      'Lichtenhof',
      'Pichling bei Stainz',
      'Pirkhof',
      'Rossegg',
      'Sankt Stefan ob Stainz',
      'Sommereben',
      'Steinreib',
      'Teipl',
      'Teufenbach',
      'Zirknitz',
    ],
  },
  {
    postleitzahl: 8521,
    orte: [
      'Gussendorf',
      'Lassenberg',
      'Neudorf im Sausal',
      'Sankt Nikolai im Sausal',
      'Schönaich',
      'Waldschach',
      'Weniggleinz',
      'Wettmannstätten',
      'Wohlsdorf',
      'Zehndorf',
    ],
  },
  {
    postleitzahl: 8522,
    orte: [
      'Fantsch',
      'Groß Sankt Florian',
      'Grub bei Groß Sankt Florian',
      'Grünau an der Laßnitz',
      'Gussendorf',
      'Hasreith',
      'Kraubath in der Weststeiermark',
      'Krottendorf an der Laßnitz',
      'Lasselsdorf',
      'Lebing',
      'Michlgleinz',
      'Mönichgleinz',
      'Nassau',
      'Neudorf bei Stainz',
      'Otternitz',
      'Petzelsdorf in der Weststeiermark',
      'Rassach',
      'Sulzhof',
      'Tanzelsdorf',
      'Unterbergla',
      'Vochera an der Laßnitz',
    ],
  },
  {
    postleitzahl: 8523,
    orte: [
      'Deutschlandsberg',
      'Freidorf an der Laßnitz',
      'Freidorfer Gleinz',
      'Gersdorf',
      'Laßnitz',
      'Schamberg',
      'Zeierling',
    ],
  },
  {
    postleitzahl: 8524,
    orte: [
      'Bad Gams',
      'Bergegg',
      'Deutschlandsberg',
      'Feldbaum',
      'Freiland bei Deutschlandsberg',
      'Furth',
      'Gamsgebirg',
      'Gersdorf',
      'Greim',
      'Hohenfeld',
      'Kothvogel',
      'Mitteregg',
      'Müllegg',
      'Niedergams',
      'Rassach',
      'Sallegg',
      'Vochera am Weinberg',
    ],
  },
  {
    postleitzahl: 8530,
    orte: [
      'Deutschlandsberg',
      'Freidorfer Gleinz',
      'Freiland bei Deutschlandsberg',
      'Garanas',
      'Gressenberg',
      'Hohlbach',
      'Hollenegg',
      'Kloster',
      'Kresbach',
      'Kruckenberg',
      'Laßnitz',
      'Neuberg',
      'Niedergams',
      'Osterwitz',
      'Rettenbach',
      'Rostock',
      'Sallegg',
      'Trahütten',
    ],
  },
  {
    postleitzahl: 8541,
    orte: [
      'Aichegg',
      'Garanas',
      'Gressenberg',
      'Hollenegg',
      'Kerschbaum',
      'Kruckenberg',
      'Limberg',
      'Mainsdorf',
      'Mitterlimberg',
      'Neuberg',
      'Oberfresen',
      'Rettenbach',
      'Schwanberg',
      'Trag',
      'Unterfresen',
    ],
  },
  {
    postleitzahl: 8542,
    orte: [
      'Bergla',
      'Freidorf',
      'Greith',
      'Hohlbach',
      'Kerschbaum',
      'Korbin',
      'Mitterlimberg',
      'Moos',
      'Poppenforst',
      'Sankt Peter im Sulmtal',
      'Wieden',
    ],
  },
  {
    postleitzahl: 8543,
    orte: [
      'Aigen',
      'Bergla',
      'Dietmannsdorf im Sulmtal',
      'Dörfla',
      'Gasselsdorf',
      'Graschach',
      'Greith',
      'Gutenacker',
      'Oberhart',
      'Otternitz',
      'Reitererberg',
      'Sulb',
    ],
  },
  {
    postleitzahl: 8544,
    orte: [
      'Brunn',
      'Gasselsdorf',
      'Jagernigg',
      'Kopreinigg',
      'Obergreith',
      'Oberhart',
      'Pitschgauegg',
      'Pölfing',
      'Tombach',
      'Untergreith',
    ],
  },
  {
    postleitzahl: 8551,
    orte: [
      'Aichberg',
      'Altenmarkt',
      'Aug',
      'Buchegg',
      'Buchenberg',
      'Etzendorf',
      'Gaißeregg',
      'Gieselegg',
      'Hörmsdorf',
      'Jagernigg',
      'Kogl',
      'Lamberg',
      'Mitterlimberg',
      'Oberhart',
      'Pitschgau',
      'Pitschgauegg',
      'Pörbach',
      'Unterfresen',
      'Vordersdorf',
      'Wernersdorf',
      'Wiel',
      'Wies',
    ],
  },
  {
    postleitzahl: 8552,
    orte: [
      'Aibl',
      'Aichberg',
      'Altenmarkt',
      'Bachholz',
      'Eibiswald',
      'Feisternitz',
      'Hadernigg',
      'Haselbach',
      'Hörmsdorf',
      'Kleinradl',
      'Kornriegl',
      'Oberlatein',
      'Pitschgau',
      'Pörbach',
      'Sankt Bartlmä',
      'Sankt Lorenzen',
      'Stammeregg',
      'Staritsch',
      'Sterglegg',
      'Vordersdorf',
    ],
  },
  {
    postleitzahl: 8553,
    orte: [
      'Buchenberg',
      'Hadernigg',
      'Krumbach',
      'Mitterstraßen',
      'Rothwein',
      'Sankt Bartlmä',
      'Sankt Oswald ob Eibiswald',
      'Soboth',
      'Staritsch',
    ],
  },
  {
    postleitzahl: 8554,
    orte: ['Laaken', 'Soboth'],
  },
  {
    postleitzahl: 8561,
    orte: [
      'Berndorf',
      'Großsöding',
      'Höllberg',
      'Kleinsöding',
      'Moosing',
      'Pichling bei Mooskirchen',
      'Schadendorfberg',
      'Södingberg',
      'Stein',
    ],
  },
  {
    postleitzahl: 8562,
    orte: [
      'Bubendorf',
      'Fluttendorf',
      'Gießenberg',
      'Kniezenberg',
      'Mooskirchen',
      'Neudorf bei Mooskirchen',
      'Pirkhof',
      'Rauchegg',
      'Rubmannsberg',
      'Stögersdorf',
      'Zirknitz',
    ],
  },
  {
    postleitzahl: 8563,
    orte: [
      'Dietenberg',
      'Grabenwarth',
      'Greisdorf',
      'Krottendorf bei Ligist',
      'Ligist Markt',
      'Ligistberg',
      'Oberwald',
      'Sankt Martin am Wöllmißberg',
      'Sommereben',
      'Steinberg',
      'Unterwald',
    ],
  },
  {
    postleitzahl: 8564,
    orte: [
      'Dietenberg',
      'Gaisfeld',
      'Gasselberg',
      'Hallersdorf',
      'Kleingaisfeld',
      'Krottendorf bei Ligist',
      'Ligistberg',
      'Muggauberg',
      'Sankt Johann ob Hohenburg',
      'Unterwald',
      'Voitsberg',
    ],
  },
  {
    postleitzahl: 8565,
    orte: [
      'Hallersdorf',
      'Hausdorf',
      'Köppling',
      'Moosing',
      'Muggauberg',
      'Neudorf bei Sankt Johann ob Hohenburg',
      'Sankt Johann ob Hohenburg',
    ],
  },
  {
    postleitzahl: 8570,
    orte: [
      'Aichegg',
      'Bärnbach',
      'Großwöllmiß',
      'Hochtregist',
      'Kleinwöllmiß',
      'Krottendorf bei Ligist',
      'Rosental an der Kainach',
      'Voitsberg',
    ],
  },
  {
    postleitzahl: 8572,
    orte: [
      'Bärnbach',
      'Hemmerberg',
      'Hochtregist',
      'Piber',
      'Piberegg Rollsiedlung',
      'Piberegg',
      'Voitsberg',
    ],
  },
  {
    postleitzahl: 8573,
    orte: [
      'Breitenbach',
      'Gallmannsegg',
      'Hadergasse',
      'Hemmerberg',
      'Kainach bei Voitsberg',
      'Kohlschwarz',
      'Oswaldgraben',
    ],
  },
  {
    postleitzahl: 8580,
    orte: [
      'Edelschrott',
      'Graden',
      'Gradenberg',
      'Großwöllmiß',
      'Kirchberg',
      'Kleinwöllmiß',
      'Köflach',
      'Kreuzberg',
      'Maria Lankowitz',
      'Niedergößnitz',
      'Piber',
      'Piberegg',
      'Pichling bei Köflach',
      'Puchbach',
      'Rosental an der Kainach',
      'Sankt Martin am Wöllmißberg',
    ],
  },
  {
    postleitzahl: 8582,
    orte: ['Bärnbach', 'Piber', 'Rosental an der Kainach', 'Voitsberg'],
  },
  {
    postleitzahl: 8583,
    orte: [
      'Edelschrott',
      'Hochgößnitz',
      'Kreuzberg',
      'Modriach',
      'Pack',
      'Sankt Martin am Wöllmißberg',
    ],
  },
  {
    postleitzahl: 8584,
    orte: ['Hirschegg'],
  },
  {
    postleitzahl: 8591,
    orte: [
      'Hochgößnitz',
      'Kemetberg',
      'Kirchberg',
      'Köflach',
      'Maria Lankowitz',
      'Niedergößnitz',
      'Pichling bei Köflach',
      'Puchbach',
    ],
  },
  {
    postleitzahl: 8592,
    orte: ['Graden', 'Kirchberg', 'Kleinlobming', 'Salla'],
  },
  {
    postleitzahl: 8593,
    orte: ['Bärnbach', 'Breitenbach', 'Graden', 'Piberegg', 'Salla'],
  },
  {
    postleitzahl: 8600,
    orte: [
      'Arndorf',
      'Berndorf',
      'Bruck an der Mur',
      'Diemlach',
      'Frauenberg',
      'Heuberg',
      'Kaltbach',
      'Kotzgraben',
      'Mötschlach',
      'Oberaich',
      'Oberdorf',
      'Picheldorf',
      'Pischk',
      'Pischkberg',
      'Sankt Dionysen',
      'Schörgendorf',
      'Stegg',
      'Übelstein',
      'Urgental',
      'Utschtal',
      'Wiener Vorstadt',
    ],
  },
  {
    postleitzahl: 8605,
    orte: [
      'Arndorf',
      'Deuchendorf',
      'Diemlach',
      'Einöd',
      'Gassing',
      'Göritz',
      'Hafendorf',
      'Kapfenberg',
      'Krottendorf',
      'Parschlug',
      'Pönegg',
      'Pötschach',
      'Pötschen',
      'Sankt Lorenzen im Mürztal',
      'Sankt Martin',
      'Schörgendorf',
      'Stegg',
      'Winkl',
    ],
  },
  {
    postleitzahl: 8611,
    orte: [
      'Hüttengraben',
      'Oberdorf',
      'Obertal',
      'Rastal',
      'Sankt Katharein an der Laming',
      'Untertal',
    ],
  },
  {
    postleitzahl: 8612,
    orte: ['Oberort', 'Pichl-Großdorf', 'Tal', 'Unterort'],
  },
  {
    postleitzahl: 8614,
    orte: ['Gabraun', 'Roßgraben', 'Sankt Erhard', 'Sankt Jakob-Breitenau'],
  },
  {
    postleitzahl: 8616,
    orte: ['Amassegg', 'Gasen', 'Mitterbach', 'Sonnleitberg'],
  },
  {
    postleitzahl: 8621,
    orte: [
      'Aflenz Kurort',
      'Fölz',
      'Hinterberg',
      'Palbersdorf',
      'Sankt Ilgen',
      'Thörl',
    ],
  },
  {
    postleitzahl: 8622,
    orte: ['Etmißl', 'Lonschitz', 'Oisching'],
  },
  {
    postleitzahl: 8623,
    orte: ['Aflenz Kurort', 'Dörflach', 'Fölz', 'Jauring', 'Tutschach'],
  },
  {
    postleitzahl: 8624,
    orte: ['Au bei Turnau', 'Döllach', 'Göriach', 'Graßnitz', 'Hinterberg'],
  },
  {
    postleitzahl: 8625,
    orte: ['Göriach', 'Pogusch', 'Stübming', 'Thal', 'Turnau'],
  },
  {
    postleitzahl: 8630,
    orte: [
      'Freingraben',
      'Grünau',
      'Gußwerk',
      'Halltal',
      'Mariazell',
      'Mooshuben',
      'Rasing',
      'Rechengraben',
      'Sankt Sebastian',
      'Ulreichsberg',
      'Walstern',
    ],
  },
  {
    postleitzahl: 8632,
    orte: [
      'Freingraben',
      'Greith',
      'Gußwerk',
      'Schöneben',
      'Wegscheid',
      'Weichselboden',
    ],
  },
  {
    postleitzahl: 8634,
    orte: ['Aschbach', 'Gußwerk', 'Wegscheid'],
  },
  {
    postleitzahl: 8635,
    orte: ['Gollrad'],
  },
  {
    postleitzahl: 8636,
    orte: ['Göriach', 'Seewiesen'],
  },
  {
    postleitzahl: 8641,
    orte: [
      'Frauenberg',
      'Graschnitz',
      'Graschnitzgraben',
      'Pötschach',
      'Sankt Marein im Mürztal',
      'Schaldorf',
      'Sonnleiten-Wieden',
    ],
  },
  {
    postleitzahl: 8642,
    orte: [
      'Fuscht',
      'Gassing',
      'Göritz',
      'Lesing',
      'Mödersdorf',
      'Mürzgraben',
      'Nechelheim',
      'Pogusch',
      'Sankt Lorenzen im Mürztal',
      'Scheuchenegg',
    ],
  },
  {
    postleitzahl: 8643,
    orte: [
      'Allerheiligen im Mürztal',
      'Edelsdorf',
      'Jasnitz',
      'Kindberg',
      'Leopersdorf',
      'Sölsnitz',
      'Wieden',
    ],
  },
  {
    postleitzahl: 8644,
    orte: ['Alt-Hadersdorf', 'Kindberg', 'Mürzgraben', 'Mürzhofen'],
  },
  {
    postleitzahl: 8650,
    orte: ['Kindberg', 'Leopersdorf'],
  },
  {
    postleitzahl: 8652,
    orte: ['Alt-Hadersdorf', 'Kindberg', 'Leopersdorf'],
  },
  {
    postleitzahl: 8653,
    orte: [
      'Brandstatt',
      'Dickenbach',
      'Edelsdorf',
      'Fladenbach',
      'Fochnitz',
      'Hollersbach',
      'Possegg',
      'Retsch',
      'Sonnberg',
      'Stanz im Mürztal',
      'Traßnitz',
      'Unteralm',
    ],
  },
  {
    postleitzahl: 8654,
    orte: ['Falkenstein', 'Fischbach', 'Völlegg'],
  },
  {
    postleitzahl: 8661,
    orte: ['Mitterdorf im Mürztal', 'Wartberg im Mürztal'],
  },
  {
    postleitzahl: 8662,
    orte: [
      'Freßnitz',
      'Lutschaun',
      'Mitterdorf im Mürztal',
      'Sommer',
      'Wartberg im Mürztal',
    ],
  },
  {
    postleitzahl: 8663,
    orte: ['Großveitsch', 'Kleinveitsch', 'Niederaigen', 'Sommer', 'Veitsch'],
  },
  {
    postleitzahl: 8664,
    orte: ['Großveitsch', 'Kleinveitsch', 'Veitsch'],
  },
  {
    postleitzahl: 8665,
    orte: [
      'Feistritzberg',
      'Hönigsberg',
      'Langenwang-Schwöbing',
      'Langenwang',
      'Lechen',
      'Mitterberg',
      'Pretul',
      'Traibach',
    ],
  },
  {
    postleitzahl: 8670,
    orte: [
      'Alpl',
      'Feistritzberg',
      'Freßnitz',
      'Freßnitzgraben',
      'Krieglach-Schwöbing',
      'Krieglach',
      'Langenwang-Schwöbing',
      'Malleisten',
      'Massing',
      'Sommer',
    ],
  },
  {
    postleitzahl: 8671,
    orte: ['Alpl', 'Freßnitzgraben', 'St. Kathrein am Hauenstein'],
  },
  {
    postleitzahl: 8672,
    orte: ['Kirchenviertel', 'Landau', 'St. Kathrein am Hauenstein'],
  },
  {
    postleitzahl: 8673,
    orte: [
      'Falkenstein',
      'Feistritz',
      'Filzmoos',
      'Fischbach',
      'Grubbauer',
      'Kirchenviertel',
      'Landau',
      'Pacher',
      'Steinhöf',
      'Völlegg',
    ],
  },
  {
    postleitzahl: 8674,
    orte: [
      'Feistritzwald',
      'Filzmoos',
      'Grubbauer',
      'Inneres Kaltenegg',
      'Rettenegg',
    ],
  },
  {
    postleitzahl: 8680,
    orte: [
      'Auersbach',
      'Edlach',
      'Eichhorntal',
      'Ganz',
      'Hönigsberg',
      'Kohleben',
      'Lambach',
      'Lechen',
      'Mürzzuschlag',
      'Pernreit',
      'Schöneben',
      'Spital am Semmering',
    ],
  },
  {
    postleitzahl: 8682,
    orte: ['Hönigsberg', 'Langenwang', 'Lechen', 'Mürzzuschlag', 'Pretul'],
  },
  {
    postleitzahl: 8684,
    orte: ['Spital am Semmering'],
  },
  {
    postleitzahl: 8685,
    orte: ['Spital am Semmering', 'Steinhaus am Semmering'],
  },
  {
    postleitzahl: 8691,
    orte: ['Altenberg', 'Greith', 'Kapellen', 'Raxen', 'Stojen'],
  },
  {
    postleitzahl: 8692,
    orte: [
      'Alpl',
      'Altenberg',
      'Arzbach',
      'Dorf',
      'Greith',
      'Krampen',
      'Lechen',
      'Neudörfl',
      'Veitschbach',
    ],
  },
  {
    postleitzahl: 8693,
    orte: [
      'Dobrein',
      'Dürrenthal',
      'Lanau',
      'Mürzsteg',
      'Niederalpl',
      'Scheiterboden',
      'Tebrin',
    ],
  },
  {
    postleitzahl: 8694,
    orte: [
      'Altenberg',
      'Frein an der Mürz',
      'Kaltenbach',
      'Lahnsattel',
      'Scheiterboden',
      'Steinalpl',
    ],
  },
  {
    postleitzahl: 8700,
    orte: [
      'Donawitz',
      'Göß',
      'Hinterberg',
      'Judendorf',
      'Leitendorf',
      'Leoben',
    ],
  },
  {
    postleitzahl: 8712,
    orte: ['Kletschach', 'Köllach', 'Niklasdorf', 'Prentgraben', 'Proleb'],
  },
  {
    postleitzahl: 8713,
    orte: [
      'Greith',
      'Kaisersberg',
      'Lichtensteinerberg',
      'Lobming',
      'Niederdorf',
      'Sankt Stefan ob Leoben',
      'Zmöllach',
    ],
  },
  {
    postleitzahl: 8714,
    orte: [
      'Kraubath an der Mur',
      'Kraubathgraben',
      'Leising',
      'Niederdorf',
      'Preg',
    ],
  },
  {
    postleitzahl: 8715,
    orte: [
      'Fötschach',
      'Gottsbach',
      'Leistach',
      'Pichl',
      'Preg',
      'Preggraben',
      'Ritzendorf',
      'Sankt Benedikten',
      'Sankt Lorenzen bei Knittelfeld',
      'Sankt Margarethen bei Knittelfeld',
      'Schütt',
      'Ugendorf',
      'Untermur',
    ],
  },
  {
    postleitzahl: 8720,
    orte: [
      'Apfelberg',
      'Dürnberg',
      'Fötschach',
      'Glein',
      'Gobernitz',
      'Knittelfeld',
      'Kroisbach',
      'Landschach',
      'Mitterbach',
      'Neuhofen',
      'Obermur',
      'Rachau',
      'Rattenberg',
      'Sankt Margarethen bei Knittelfeld Sdlg',
      'Sankt Margarethen bei Knittelfeld',
      'Ugendorf',
    ],
  },
  {
    postleitzahl: 8723,
    orte: [
      'Hautzenbichl',
      'Kobenz',
      'Neuhautzenbichl',
      'Oberfarrach',
      'Raßnitz',
      'Reifersdorf',
      'Unterfarrach',
    ],
  },
  {
    postleitzahl: 8724,
    orte: [
      'Einhörn',
      'Flatschach',
      'Ingering I',
      'Lind',
      'Maßweg',
      'Neuhofen',
      'Pausendorf',
      'Sachendorf',
      'Schönberg',
      'Spielberg',
      'Weyern',
    ],
  },
  {
    postleitzahl: 8731,
    orte: [
      'Bischoffeld',
      'Gaal',
      'Gaalgraben',
      'Graden',
      'Ingering II',
      'Puchschachen',
      'Schattenberg',
    ],
  },
  {
    postleitzahl: 8732,
    orte: ['Dürnberg', 'Hart', 'Neuhofen', 'Seckau', 'Sonnwenddorf'],
  },
  {
    postleitzahl: 8733,
    orte: [
      'Altendorf',
      'Feistritz bei Knittelfeld',
      'Feistritzgraben',
      'Fentsch',
      'Fressenberg',
      'Greith',
      'Hof',
      'Kniepaß',
      'Laas',
      'Mitterfeld',
      'Moos',
      'Prankh',
      'Sankt Marein bei Knittelfeld',
      'Sankt Martha',
      'Wasserleith',
    ],
  },
  {
    postleitzahl: 8734,
    orte: [
      'Apfelberg',
      'Großlobming',
      'Kleinlobming',
      'Mitterlobming',
      'Thann',
    ],
  },
  {
    postleitzahl: 8740,
    orte: [
      'Allersdorf',
      'Farrach',
      'Laing',
      'Lind',
      'Möbersdorf',
      'Möbersdorfsiedlung',
      'Neufisching',
      'Neuzeltweg',
      'Pfaffendorf',
      'Spielberg',
      'Zeltweg',
    ],
  },
  {
    postleitzahl: 8741,
    orte: [
      'Allersdorf',
      'Baierdorf',
      'Baumkirchen',
      'Eppenstein',
      'Fisching',
      'Größenberg',
      'Großfeistritz',
      'Kathal',
      'Kleinlobming',
      'Kothgraben',
      'Maria Buch',
      'Mitterlobming',
      'Mühldorf',
      'Murdorf',
      'Pichling',
      'Reisstraße',
      'Schoberegg',
      'Schwarzenbach am Größing',
      'Weißkirchen in Steiermark',
    ],
  },
  {
    postleitzahl: 8742,
    orte: [
      'Amering',
      'Bärnthal',
      'Granitzen',
      'Größenberg',
      'Großprethal',
      'Kathal in Obdachegg',
      'Kathal',
      'Katschwald',
      'Kienberg',
      'Kleinprethal',
      'Lavantegg',
      'Mönchegg',
      'Obdach',
      'Obdachegg',
      'Ossach',
      'Rötsch',
      'Sankt Anna-Feriensiedlung',
      'Sankt Georgen in Obdachegg',
      'Schwarzenbach am Größing',
      'Warbach',
      'Winterleiten',
      'Zanitzen',
    ],
  },
  {
    postleitzahl: 8750,
    orte: [
      'Auerling',
      'Feeberg',
      'Gasselsdorf',
      'Judenburg',
      'Maria Buch',
      'Murdorf',
      'Oberweg',
      'Ossach',
      'Reifling',
      'Ritzersdorf',
      'Strettweg',
      'Waltersdorf',
      'Wöllmerdorf',
    ],
  },
  {
    postleitzahl: 8753,
    orte: [
      'Aichdorf',
      'Allerheiligen',
      'Allerheiligengraben',
      'Dietersdorf',
      'Fohnsdorf',
      'Hetzendorf',
      'Kumpitz',
      'Paßhammer',
      'Rattenberg',
      'Sillweg',
      'Wasendorf',
    ],
  },
  {
    postleitzahl: 8754,
    orte: ['Enzersdorf', 'Paig', 'Sauerbrunn', 'Thalheim'],
  },
  {
    postleitzahl: 8755,
    orte: [
      'Feistritzgraben',
      'Furth',
      'Mitterdorf',
      'Möschitzgraben',
      'Pichl',
      'Rach',
      'Rothenthurm',
      'Sankt Peter ob Judenburg',
    ],
  },
  {
    postleitzahl: 8756,
    orte: ['Pichlhofen', 'Sankt Georgen ob Judenburg', 'Scheiben', 'Wöll'],
  },
  {
    postleitzahl: 8761,
    orte: [
      'Allerheiligen',
      'Enzersdorf',
      'Götzendorf',
      'Greith',
      'Gusterheim',
      'Katzling',
      'Mauterndorf',
      'Mosing',
      'Mühltal',
      'Oberkurzheim',
      'Offenburg',
      'Pöls',
      'Pölshof',
      'Thalheim',
      'Thaling',
    ],
  },
  {
    postleitzahl: 8762,
    orte: [
      'Gföllgraben',
      'Katzling',
      'Möderbrugg',
      'Oberzeiring',
      'Sankt Oswald',
      'Unterzeiring',
      'Winden',
      'Zeiringgraben',
      'Zugtal',
    ],
  },
  {
    postleitzahl: 8763,
    orte: ['Bretstein', 'Möderbrugg', 'Pusterwald', 'Sankt Oswald'],
  },
  {
    postleitzahl: 8764,
    orte: ['Pusterwald'],
  },
  {
    postleitzahl: 8765,
    orte: [
      'Sankt Johann am Tauern Schattseite',
      'Sankt Johann am Tauern Sonnseite',
    ],
  },
  {
    postleitzahl: 8770,
    orte: [
      'Brunn',
      'Greith',
      'Hinterlainsach',
      'Jassing',
      'Liesingtal',
      'Madstein',
      'Sankt Michael in Obersteiermark',
      'Stadlhof',
      'Traboch',
      'Vorderlainsach',
    ],
  },
  {
    postleitzahl: 8772,
    orte: ['Mötschendorf', 'Stadlhof', 'Timmersdorf', 'Traboch'],
  },
  {
    postleitzahl: 8773,
    orte: [
      'Dirnsdorf',
      'Glarsdorf',
      'Kammern im Liesingtal',
      'Leims',
      'Liesing',
      'Mochl',
      'Mötschendorf',
      'Pfaffendorf',
      'Seiz',
      'Sparsbach',
      'Wolfgruben',
    ],
  },
  {
    postleitzahl: 8774,
    orte: [
      'Eselberg',
      'Liesingau',
      'Magdwiesen',
      'Mautern in Steiermark',
      'Rannach',
      'Reitingau',
    ],
  },
  {
    postleitzahl: 8775,
    orte: ['Kalwang', 'Pisching', 'Schattenberg', 'Sonnberg'],
  },
  {
    postleitzahl: 8781,
    orte: ['Furth', 'Liesing', 'Melling', 'Wald am Schoberpaß'],
  },
  {
    postleitzahl: 8782,
    orte: ['Furth', 'Treglwang'],
  },
  {
    postleitzahl: 8783,
    orte: ['Au bei Gaishorn am See', 'Gaishorn am See'],
  },
  {
    postleitzahl: 8784,
    orte: [
      'Bärndorf',
      'Dietmannsdorf bei Trieben',
      'Sankt Lorenzen im Paltental',
      'Schwarzenbach',
      'Trieben',
    ],
  },
  {
    postleitzahl: 8785,
    orte: ['Hohentauern', 'Triebental'],
  },
  {
    postleitzahl: 8786,
    orte: [
      'Bärndorf',
      'Boder',
      'Bruckmühl',
      'Büschendorf',
      'Edlach',
      'Klamm',
      'Oppenberg',
      'Rottenmann',
      'Sankt Georgen',
      'Singsdorf',
      'Strechau',
      'Strechen',
      'Villmannsdorf',
    ],
  },
  {
    postleitzahl: 8790,
    orte: ['Eisenerz'],
  },
  {
    postleitzahl: 8792,
    orte: [
      'Donawitz',
      'Glarsdorf',
      'Hessenberg',
      'Sankt Peter-Freienstein',
      'Tollinggraben',
      'Traboch',
      'Traidersberg',
    ],
  },
  {
    postleitzahl: 8793,
    orte: [
      'Edling',
      'Gai',
      'Gausendorf',
      'Gimplach',
      'Glarsdorf',
      'Gößgraben',
      'Hafning',
      'Krumpen',
      'Kurzheim',
      'Laintal',
      'Mochl',
      'Oberdorf',
      'Putzenberg',
      'Rötz',
      'Schardorf',
      'Töllach',
      'Treffning',
      'Trofaiach',
      'Untergimplach',
      'Unterkurzheim',
      'Windischbühel',
    ],
  },
  {
    postleitzahl: 8794,
    orte: ['Hafning', 'Krumpen', 'Rötz', 'Vordernberg'],
  },
  {
    postleitzahl: 8795,
    orte: ['Radmer an der Hasel', 'Radmer an der Stube'],
  },
  {
    postleitzahl: 8800,
    orte: ['Frauenburg', 'Scheiben', 'Unzmarkt'],
  },
  {
    postleitzahl: 8811,
    orte: [
      'Feßnach',
      'Lind bei Scheifling',
      'Niederwölz',
      'Puchfeld',
      'Sankt Lorenzen bei Scheifling',
      'Scheifling',
    ],
  },
  {
    postleitzahl: 8812,
    orte: ['Baierdorf', 'Frojach', 'Mariahof', 'Sankt Blasen'],
  },
  {
    postleitzahl: 8813,
    orte: ['Murau', 'Sankt Blasen', 'Sankt Lambrecht'],
  },
  {
    postleitzahl: 8820,
    orte: [
      'Baierdorf',
      'Kulm am Zirbitz',
      'Mariahof',
      'Neumarkt in Steiermark',
      'Perchau am Sattel',
      'Sankt Georgen bei Neumarkt',
      'Sankt Marein bei Neumarkt',
      'Sankt Veit in der Gegend',
      'Unterwald',
      'Zeutschach',
    ],
  },
  {
    postleitzahl: 8822,
    orte: [
      'Jakobsberg',
      'Kulm am Zirbitz',
      'Mühlen',
      'Noreia',
      'Sankt Veit in der Gegend',
      'St. Martin am Silberberg',
      'Unterwald',
    ],
  },
  {
    postleitzahl: 8831,
    orte: ['Niederwölz', 'Raiming', 'Schönberg-Lachtal'],
  },
  {
    postleitzahl: 8832,
    orte: [
      'Eselsberg',
      'Hinterburg',
      'Kammersberg',
      'Krumegg',
      'Mainhartsdorf',
      'Oberwölz (Stadt)',
      'Raiming',
      'Salchau',
      'Schöttl',
      'Vorstadt',
      'Winklern bei Oberwölz',
    ],
  },
  {
    postleitzahl: 8833,
    orte: ['Frojach', 'Teufenbach'],
  },
  {
    postleitzahl: 8841,
    orte: ['Frojach'],
  },
  {
    postleitzahl: 8842,
    orte: [
      'Althofen',
      'Frojach',
      'Kammersberg',
      'Katsch an der Mur',
      'Murau',
      'Peterdorf',
    ],
  },
  {
    postleitzahl: 8843,
    orte: [
      'Althofen',
      'Feistritz am Kammersberg',
      'Kammersberg',
      'Mitterdorf',
      'Peterdorf',
      'Pöllau am Greim',
      'St. Peter am Kammersberg',
    ],
  },
  {
    postleitzahl: 8844,
    orte: ['Baierdorf', 'Ranten', 'Rinegg', 'Schöder', 'Schöderberg'],
  },
  {
    postleitzahl: 8850,
    orte: [
      'Auen',
      'Frojach',
      'Laßnitz-Lambrecht',
      'Laßnitz-Murau',
      'Laßnitz',
      'Murau',
      'Sankt Egidi',
      'Sankt Lorenzen ob Murau',
      'Stolzalpe',
      'Triebendorf',
      'Zanitzberg',
    ],
  },
  {
    postleitzahl: 8852,
    orte: ['Murau', 'Stolzalpe'],
  },
  {
    postleitzahl: 8853,
    orte: ['Freiberg', 'Ranten', 'Rinegg', 'Seebach'],
  },
  {
    postleitzahl: 8854,
    orte: ['Krakaudorf', 'Krakauhintermühlen', 'Krakauschatten'],
  },
  {
    postleitzahl: 8861,
    orte: [
      'Bodendorf',
      'Lutzmannsdorf',
      'Sankt Georgen ob Murau',
      'Sankt Lorenzen ob Murau',
    ],
  },
  {
    postleitzahl: 8862,
    orte: [
      'Bodendorf',
      'Einach',
      'Falkendorf',
      'Paal',
      'Sonnberg',
      'St. Ruprecht ob Murau',
      'Stadl an der Mur',
      'Steindorf',
    ],
  },
  {
    postleitzahl: 8863,
    orte: ['Einach', 'Mitterberg', 'Predlitz'],
  },
  {
    postleitzahl: 8864,
    orte: ['Predlitz', 'Turrach'],
  },
  {
    postleitzahl: 8900,
    orte: ['Burgfried', 'Liezen', 'Selzthal'],
  },
  {
    postleitzahl: 8903,
    orte: [
      'Altlassing',
      'Burgfried',
      'Fuchslucken',
      'Gatschling',
      'Heuberg',
      'Lassing-Kirchdorf',
      'Moos',
      'Neusiedl',
      'Niedermoos',
      'Schattenberg',
      'Sonnberg',
      'Spiegelsberg',
      'Treschmitz',
      'Trojach',
      'Unterberg',
      'Wieden',
    ],
  },
  {
    postleitzahl: 8904,
    orte: ['Ardning', 'Frauenberg', 'Pürgschachen'],
  },
  {
    postleitzahl: 8911,
    orte: ['Admont', 'Aigen', 'Hall', 'Krumau'],
  },
  {
    postleitzahl: 8912,
    orte: ['Admont', 'Johnsbach', 'Krumau'],
  },
  {
    postleitzahl: 8913,
    orte: ['Admont', 'Gstatterboden', 'Weng im Gesäuse'],
  },
  {
    postleitzahl: 8920,
    orte: ['Hieflau', 'Jassingau', 'Radmer an der Stube'],
  },
  {
    postleitzahl: 8921,
    orte: ['Kirchenlandl', 'Lainbach', 'Mooslandl'],
  },
  {
    postleitzahl: 8922,
    orte: ['Gams bei Hieflau'],
  },
  {
    postleitzahl: 8923,
    orte: ['Palfau'],
  },
  {
    postleitzahl: 8924,
    orte: ['Rothwald-Langau', 'Wildalpen'],
  },
  {
    postleitzahl: 8931,
    orte: ['Großreifling', 'Kirchenlandl', 'Krippau', 'Mooslandl'],
  },
  {
    postleitzahl: 8932,
    orte: ['Bichl', 'Sankt Gallen', 'Weißenbach an der Enns', 'Wolfsbachau'],
  },
  {
    postleitzahl: 8933,
    orte: [
      'Bergerviertel',
      'Breitau',
      'Oberlaussa',
      'Oberreith',
      'Reiflingviertel',
      'Sankt Gallen',
      'Wolfsbachau',
    ],
  },
  {
    postleitzahl: 8934,
    orte: [
      'Altenmarkt bei Sankt Gallen',
      'Eßling',
      'Kleinreifling',
      'Oberlaussa',
      'Sankt Gallen',
      'Unterlaussa',
      'Wolfsbachau',
    ],
  },
  {
    postleitzahl: 8940,
    orte: [
      'Döllach',
      'Liezen',
      'Pyhrn',
      'Reithtal',
      'Schattenberg',
      'Stein',
      'Weißenbach bei Liezen',
    ],
  },
  {
    postleitzahl: 8942,
    orte: ['Maitschern', 'Wörschach'],
  },
  {
    postleitzahl: 8943,
    orte: [
      'Aich',
      'Aigen im Ennstal',
      'Aiglern',
      'Fischern',
      'Gatschen',
      'Hohenberg',
      'Ketten',
      'Lantschern',
      'Mitteregg',
      'Quilk',
      'Ritzmannsdorf',
      'Sallaberg',
      'Schlattham',
      'Tachenberg',
      'Vorberg',
    ],
  },
  {
    postleitzahl: 8950,
    orte: ['Niederhofen', 'Stainach'],
  },
  {
    postleitzahl: 8951,
    orte: ['Pürgg', 'Trautenfels', 'Unterburg', 'Untergrimming'],
  },
  {
    postleitzahl: 8952,
    orte: [
      'Altirdning',
      'Bleiberg',
      'Erlsberg',
      'Falkenburg',
      'Irdning',
      'Kienach',
      'Raumberg',
      'Winklern',
    ],
  },
  {
    postleitzahl: 8953,
    orte: [
      'Donnersbach',
      'Donnersbachwald',
      'Erlsberg',
      'Fuchsberg',
      'Furrach',
      'Ilgenberg',
      'Planneralm',
      'Ritzenberg',
      'Winklern',
    ],
  },
  {
    postleitzahl: 8954,
    orte: [
      'Diemlern',
      'Mitterberg',
      'Salza',
      'Sankt Martin am Grimming',
      'Tipschern',
    ],
  },
  {
    postleitzahl: 8960,
    orte: [
      'Gritschenberg',
      'Mitterberg',
      'Moosberg auch Sonnberg',
      'Niederöblarn',
      'Öblarn',
      'Sonnberg',
      'Straßerberg',
      'Strimitzen',
    ],
  },
  {
    postleitzahl: 8961,
    orte: ['Großsölk', 'Kleinsölk', 'Mitterberg', 'Sankt Nikolai im Sölktal'],
  },
  {
    postleitzahl: 8962,
    orte: [
      'Gersdorf',
      'Gröbming',
      'Michaelerberg',
      'Mitterberg',
      'Oberlengdorf',
      'Pruggern',
      'Unterlengdorf',
    ],
  },
  {
    postleitzahl: 8965,
    orte: ['Assach', 'Auberg', 'Michaelerberg', 'Pruggern'],
  },
  {
    postleitzahl: 8966,
    orte: ['Aich', 'Assach', 'Auberg', 'Ennsling', 'Gössenberg', 'Petersberg'],
  },
  {
    postleitzahl: 8967,
    orte: [
      'Aich',
      'Birnberg',
      'Ennsling',
      'Gumpenberg',
      'Haus',
      'Lehen',
      'Oberhaus',
      'Oberhausberg',
      'Petersberg',
      'Weißenbach',
    ],
  },
  {
    postleitzahl: 8970,
    orte: [
      'Fastenberg',
      'Klaus',
      'Lehen',
      'Oberhaus',
      'Oberhausberg',
      'Pichl',
      'Preunegg',
      'Schladming',
    ],
  },
  {
    postleitzahl: 8971,
    orte: ['Fastenberg', 'Obertal', 'Rohrmoos', 'Untertal'],
  },
  {
    postleitzahl: 8972,
    orte: ['Ramsau am Dachstein', 'Weißenbach'],
  },
  {
    postleitzahl: 8973,
    orte: ['Gleiming', 'Pichl', 'Preunegg'],
  },
  {
    postleitzahl: 8974,
    orte: ['Mandling', 'Pichl', 'Schladming'],
  },
  {
    postleitzahl: 8982,
    orte: [
      'Furt',
      'Klachau',
      'Pürgg',
      'Sonnenalm',
      'Tauplitz',
      'Tauplitzalm',
      'Zlem',
    ],
  },
  {
    postleitzahl: 8983,
    orte: [
      'Bad Mitterndorf',
      'Knoppen',
      'Krungl',
      'Neuhofen',
      'Obersdorf',
      'Rödschitz',
      'Sonnenalm',
      'Tauplitzalm',
      'Thörl',
      'Zauchen',
    ],
  },
  {
    postleitzahl: 8984,
    orte: ['Äußere Kainisch', 'Knoppen', 'Mühlreith', 'Pichl'],
  },
  {
    postleitzahl: 8990,
    orte: [
      'Anger',
      'Bad Aussee',
      'Eselsbach',
      'Gallhof',
      'Gschlößl',
      'Lerchenreith',
      'Obertressen',
      'Reitern',
      'Reith',
      'Sarstein',
      'Unterkainisch',
    ],
  },
  {
    postleitzahl: 8992,
    orte: ['Altaussee', 'Fischerndorf', 'Lichtersberg', 'Lupitsch', 'Puchen'],
  },
  {
    postleitzahl: 8993,
    orte: ['Archkogl', 'Bräuhof', 'Gößl', 'Mosern', 'Untertressen'],
  },
  {
    postleitzahl: 9020,
    orte: [
      'Farchern',
      'Gottesbichl',
      'Gundersdorf',
      'Klagenfurt,01.Bez.:Innere Stadt',
      'Klagenfurt,02.Bez.:Innere Stadt',
      'Klagenfurt,03.Bez.:Innere Stadt',
      'Klagenfurt,04.Bez.:Innere Stadt',
      'Klagenfurt,05.Bez.:St.Veiter Vorstadt',
      'Klagenfurt,06.Bez.:Völkermarkt.Vorst.',
      'Klagenfurt,07.Bez.:Viktringer Vorstadt',
      'Klagenfurt,08.Bez.:Villacher Vorstadt',
      'Klagenfurt,09.Bez.:Annabichl',
      'Klagenfurt,10.Bez.:St. Peter',
      'Klagenfurt,11.Bez.:St. Ruprecht',
      'Klagenfurt,12.Bez.:St. Martin',
      'Klagenfurt,13.Bez.:Viktring',
      'Klagenfurt,14.Bez.:Wölfnitz',
      'Klagenfurt,15.Bez.:Hörtendorf',
      'Kreuzbichl',
      'Portendorf',
      'Walddorf',
    ],
  },
  {
    postleitzahl: 9061,
    orte: [
      'Gabriel',
      'Klagenfurt,09.Bez.:Annabichl',
      'Klagenfurt,14.Bez.:Wölfnitz',
      'Klagenfurt,15.Bez.:Hörtendorf',
      'Nußberg',
      'Poppichl',
      'Tultschnig',
      'Ziegelsdorf',
    ],
  },
  {
    postleitzahl: 9062,
    orte: [
      'Albern',
      'Ameisbichl',
      'Arlsdorf',
      'Bärndorf',
      'Dellach',
      'Faning',
      'Freudenberg',
      'Gabriel',
      'Goritschitzen',
      'Gradenegg',
      'Knasweg',
      'Krainig',
      'Kreggab',
      'Malleberg',
      'Moosburg',
      'Nußberg',
      'Obergöriach',
      'Pernach',
      'Polan',
      'Pörtschach am Wörther See',
      'Prosintschach',
      'Ratzenegg',
      'Rosenau',
      'Seigbichl',
      'Simislau',
      'St. Peter',
      'Stallhofen',
      'Strußnighof',
      'Tigring',
      'Tuderschitz',
      'Untergöriach',
      'Unterlinden',
      'Vögelitz',
      'Wielen',
      'Windischbach-Gegend',
      'Windischbach',
      'Witsch',
      'Ziegelsdorf',
    ],
  },
  {
    postleitzahl: 9063,
    orte: [
      'Affelsdorf',
      'Arndorf',
      'Beintratten',
      'Bergl',
      'Dellach',
      'Galling',
      'Gersdorf',
      'Gröblach',
      'Hart',
      'Höfern',
      'Judendorf',
      'Kading',
      'Karnburg',
      'Klagenfurt,09.Bez.:Annabichl',
      'Klagenfurt,14.Bez.:Wölfnitz',
      'Kuchling',
      'Laasdorf',
      'Lind',
      'Maria Saal',
      'Meilsberg',
      'Meiselberg',
      'Möderndorf',
      'Pörtschach am Berg',
      'Possau',
      'Preilitz',
      'Prikalitz',
      'Raggasaal',
      'Ratzendorf',
      'Rosendorf',
      'Rotheis',
      'Sagrad',
      'St. Michael am Zollfeld',
      'Stegendorf',
      'Stuttern',
      'Tanzenberg',
      'Techmannsdorf',
      'Thurn',
      'Töltschach',
      'Ulrichsberg',
      'Unterwuhr',
      'Wainz',
      'Willersdorf',
      'Winklern',
      'Wrießnitz',
      'Wutschein',
      'Zell',
      'Zollfeld',
    ],
  },
  {
    postleitzahl: 9064,
    orte: [
      'Christofberg',
      'Deinsdorf',
      'Dürnfeld',
      'Eibelhof',
      'Eixendorf',
      'Frankenberg',
      'Freudenberg',
      'Gammersdorf',
      'Geiersdorf',
      'Göriach',
      'Großgörtschach',
      'Haag',
      'Hollern',
      'Kleingörtschach',
      'Krobathen',
      'Kronabeth',
      'Lassendorf',
      'Latschach',
      'Leibnitz',
      'Magdalensberg',
      'Matzendorf',
      'Ochsendorf',
      'Ottmanach',
      'Pirk',
      'Pischeldorf',
      'Reigersdorf',
      'Salchendorf',
      'Schöpfendorf',
      'Sillebrücke',
      'St. Filippen',
      'St. Lorenzen',
      'St. Martin',
      'St. Michael ob der Gurk',
      'St. Thomas',
      'Timenitz',
      'Treffelsdorf',
      'Unterbergen',
      'Vellach',
      'Wutschein',
      'Zeiselberg',
      'Zinsdorf',
    ],
  },
  {
    postleitzahl: 9065,
    orte: [
      'Aich an der Straße',
      'Berg',
      'Ebenthal',
      'Goritschach',
      'Gradnitz',
      'Gurnitz',
      'Haber',
      'Hinterberg',
      'Kohldorf',
      'Kosasmojach',
      'Kossiach / Kozje',
      'Kreuth / Rute',
      'Lipizach / Lipica',
      'Mieger',
      'Moosberg',
      'Niederdorf',
      'Obermieger',
      'Obitschach',
      'Pfaffendorf',
      'Priedl',
      'Radsberg / Radiše',
      'Rain',
      'Reichersdorf',
      'Rosenegg',
      'Rottenstein',
      'Saager',
      'Sabuatach',
      'Schwarz / Dvorec',
      'Tutzach / Tuce',
      'Untermieger',
      'Werouzach / Verovce',
      'Zell',
      'Zetterei',
      'Zwanzgerberg',
    ],
  },
  {
    postleitzahl: 9071,
    orte: [
      'Am Teller',
      'Köttmannsdorf',
      'Mostitz',
      'Neusaß / Vesava',
      'Plöschenberg / Plešivec',
      'Preliebl',
      'St. Gandolf',
      'St. Margarethen',
      'Trabesing',
      'Tretram',
      'Tschachoritsch',
      'Tschrestal',
      'Wurdach',
    ],
  },
  {
    postleitzahl: 9072,
    orte: [
      'Bach / Potok',
      'Edling / Kajzaze',
      'Fellersdorf / Bilnjovs',
      'Franzendorf / Branča vas',
      'Großkleinberg / Mala Gora',
      'Ludmannsdorf / Bilčovs',
      'Lukowitz / Koviče',
      'Moschenitzen / Moščenica',
      'Muschkau / Muškava',
      'Niederdörfl / Spodnja vesca',
      'Oberdörfl / Zgornja vesca',
      'Pugrad / Podgrad',
      'Rupertiberg / Na Gori',
      'Selkach / Želuče',
      'Strein / Stranje',
      'Wellersdorf / Velinja vas',
      'Zedras / Sodraževa',
    ],
  },
  {
    postleitzahl: 9073,
    orte: [
      'Aich',
      'Klagenfurt,07.Bez.:Viktringer Vorstadt',
      'Klagenfurt,13.Bez.:Viktring',
      'Lambichl',
      'Maiernigg',
      'Rotschitzen',
      'Schwanein',
      'Sekirn',
      'Thal',
      'Tretram',
    ],
  },
  {
    postleitzahl: 9074,
    orte: [
      'Dobein',
      'Dobeinitz',
      'Höflein',
      'Höhe',
      'Keutschach',
      'Leisbach',
      'Linden',
      'Pertitschach',
      'Plaschischen',
      'Plescherken',
      'Rauth',
      'Reauz',
      'Schelesnitz',
      'St. Margarethen',
      'St. Nikolai',
    ],
  },
  {
    postleitzahl: 9081,
    orte: ['Maiernigg', 'Raunach', 'Reifnitz', 'Sekirn', 'St. Anna'],
  },
  {
    postleitzahl: 9082,
    orte: ['Maria Wörth', 'Oberdellach', 'Unterdellach'],
  },
  {
    postleitzahl: 9100,
    orte: [
      'Arlsdorf',
      'Bach',
      'Dullach I',
      'Frankenberg',
      'Gurtschitschach',
      'Hafendorf',
      'Kaltenbrunn',
      'Krenobitsch',
      'Lippendorf',
      'Neudenstein',
      'Niedertrixen',
      'Obersielach',
      'Oschenitzen',
      'Penk',
      'Pörtschach',
      'Ratschitschach',
      'Reifnitz',
      'Ruhstatt',
      'St. Agnes',
      'St. Lorenzen',
      'St. Margarethen ob Töllerberg',
      'St. Peter am Wallersberg',
      'Töllerberg',
      'Unarach',
      'Völkermarkt',
      'Watzelsdorf',
      'Weinberg',
      'Wernzach',
    ],
  },
  {
    postleitzahl: 9102,
    orte: [
      'Aich',
      'Bergstein',
      'Bischofberg',
      'Bösenort',
      'Führholz',
      'Gänsdorf',
      'Gattersdorf',
      'Korb',
      'Kremschitz',
      'Kulm',
      'Michaelerberg',
      'Mittertrixen',
      'Obertrixen',
      'Rammersdorf',
      'Skoflitzen',
      'St. Georgen am Weinberg',
      'Terpetzen',
      'Waisenberg',
      'Winklern',
    ],
  },
  {
    postleitzahl: 9103,
    orte: [
      'Bösenort',
      'Diex',
      'Grafenbach',
      'Großenegg',
      'Haimburgerberg',
      'Michaelerberg',
      'Rüggen',
      'St. Ulrich am Johannserberg',
      'Wandelitzen',
    ],
  },
  {
    postleitzahl: 9104,
    orte: ['Pustritz', 'Tschrietes'],
  },
  {
    postleitzahl: 9111,
    orte: [
      'Attendorf',
      'Berg ob Attendorf',
      'Berg ob St. Martin',
      'Dobrowa',
      'Dürrenmoos',
      'Gletschach',
      'Großenegg',
      'Haimburg',
      'Haimburgerberg',
      'Mittertrixen',
      'Niedertrixen',
      'St. Jakob',
      'St. Martin',
      'St. Stefan',
      'Steinkogel',
      'Unterlinden',
      'Völkermarkt',
    ],
  },
  {
    postleitzahl: 9112,
    orte: [
      'Altenmarkt',
      'Enzelsdorf',
      'Erlach',
      'Gariusch',
      'Gletschach',
      'Gönitz',
      'Griffen',
      'Griffnergemeinde',
      'Großenegg',
      'Grutschen',
      'Haberberg',
      'Kaunz',
      'Kleindörfl',
      'Klosterberg',
      'Langegg',
      'Lichtenwald',
      'Limberg',
      'Lind',
      'Obere Gemeinde',
      'Obergreutschach',
      'Poppendorf',
      'Pustritz',
      'Rakounig',
      'Rausch',
      'Salzenberg',
      'Schloßberg',
      'St. Jakob',
      'St. Kollmann',
      'St. Leonhard an der Saualpe',
      'Stift Griffen',
      'Tschrietes',
      'Untergrafenbach',
      'Untergreutschach',
      'Unterrain',
      'Wallersberg',
      'Wallersdorf',
      'Wölfnitz',
      'Wriesen',
    ],
  },
  {
    postleitzahl: 9113,
    orte: [
      'Bach',
      'Dobrowa',
      'Eis',
      'Grutschen',
      'Kanaren',
      'Kleindiex',
      'Kraßnitz',
      'Lippitzbach',
      'Obermitterdorf',
      'Ruden',
      'St. Jakob',
      'St. Lorenzen',
      'St. Martin',
      'St. Nikolai',
      'St. Radegund',
      'Untermitterdorf',
      'Unternberg',
      'Unterrain',
      'Weißeneggerberg',
      'Wunderstätten',
    ],
  },
  {
    postleitzahl: 9121,
    orte: [
      'Admont',
      'Drauhofen',
      'Dullach II',
      'Greuth',
      'Höhenbergen',
      'Hungerrain',
      'Ladratschen',
      'Lassein',
      'Lasseinerbucht',
      'Niederdorf',
      'Rakollach',
      'Ruppgegend',
      'Tainach',
      'Tainacherfeld',
      'Wurzen',
    ],
  },
  {
    postleitzahl: 9122,
    orte: [
      'Brenndorf',
      'Duell',
      'Grabelsdorf / Grabalja vas',
      'Hart',
      'Horzach I / Horce I',
      'Horzach II / Horce II',
      'Kleindorf I',
      'Kleindorf II',
      'Klopein',
      'Lanzendorf',
      'Lauchenholz / Gluhi Les',
      'Littermoos',
      'Mökriach / Mokrije',
      'Nageltschach / Nagelče',
      'Oberburg',
      'Obersammelsdorf / Žamanje',
      'Oberseidendorf',
      'Peratschitzen',
      'Piskertschach',
      'Saager',
      'Schreckendorf',
      'Seelach',
      'Seidendorf',
      'Sertschach',
      'Srejach',
      'St. Kanzian am Klopeiner See',
      'St. Lorenzen',
      'St. Marxen',
      'St. Primus / Šentprimož',
      'St. Veit im Jauntal / Šentvid v Podjuni',
      'Stein im Jauntal',
      'Steinerberg',
      'Unterburg',
      'Unternarrach / Spodnje Vinare',
      'Untersammelsdorf',
      'Vesielach / Vesele',
      'Wasserhofen',
      'Weitendorf',
    ],
  },
  {
    postleitzahl: 9123,
    orte: ['Unterkrain'],
  },
  {
    postleitzahl: 9125,
    orte: [
      'Edling / Kazaze',
      'Graben',
      'Humtschach',
      'Kohldorf',
      'Kühnsdorf',
      'Mittlern',
      'Pribelsdorf',
      'Seebach',
      'St. Marxen',
      'Wasserhofen',
    ],
  },
  {
    postleitzahl: 9130,
    orte: [
      'Ameisbichl',
      'Annamischl',
      'Eibelhof',
      'Eiersdorf',
      'Erlach',
      'Goritschach',
      'Haidach',
      'Kreuth',
      'Kreuzergegend-Ost',
      'Kreuzergegend-West',
      'Krobathen',
      'Lanzendorf',
      'Leibsdorf',
      'Linsenberg',
      'Pischeldorf',
      'Poggersdorf',
      'Pubersdorf',
      'Rain',
      'Raunachmoos',
      'St. Johann',
      'St. Michael ob der Gurk',
      'Ströglach',
      'Wabelsdorf',
      'Wirtschach',
    ],
  },
  {
    postleitzahl: 9131,
    orte: [
      'Aich',
      'Althofen',
      'Dolina',
      'Froschendorf',
      'Grafenstein',
      'Gumisch',
      'Haidach',
      'Hum',
      'Klein Venedig',
      'Lind',
      'Linsendorf',
      'Münzendorf',
      'Oberfischern',
      'Oberwuchel',
      'Pakein',
      'Pirk',
      'Replach',
      'Saager',
      'Sabuatach',
      'Sand',
      'Schloss Rain',
      'Schulterndorf',
      'Skarbin',
      'St. Peter',
      'Tainacherfeld',
      'Thon',
      'Truttendorf',
      'Unterfischern',
      'Unterwuchel',
      'Werda',
      'Wölfnitz',
      'Zapfendorf',
    ],
  },
  {
    postleitzahl: 9132,
    orte: [
      'Abriach',
      'Abtei',
      'Dolintschach',
      'Enzelsdorf / Encelna vas',
      'Feld',
      'Freibach / Borovnica',
      'Gallizien',
      'Glantschach',
      'Goritschach',
      'Krejanzach',
      'Möchling',
      'Moos',
      'Pirk',
      'Pölzling',
      'Robesch',
      'Unterkrain',
      'Vellach',
      'Wildenstein',
    ],
  },
  {
    postleitzahl: 9133,
    orte: [
      'Altendorf',
      'Blasnitzenberg',
      'Drabunaschach / Drabunaže',
      'Dullach',
      'Goritschach / Goriče',
      'Hart',
      'Homelitschach',
      'Jerischach',
      'Kleinzapfen / Malčape',
      'Kristendorf / Kršna vas',
      'Miklauzhof',
      'Müllnern / Mlinče',
      'Obernarrach / Zgornje Vinare',
      'Pfannsdorf',
      'Pogerschitzen / Pogrče',
      'Polena',
      'Proboj',
      'Rain',
      'Rückersdorf / Rikarja vas',
      'Sagerberg / Zagorje',
      'Sielach',
      'Sittersdorf / Žitara vas',
      'Sonnegg / Ženek',
      'Tichoja / Tihoja',
      'Weinberg',
      'Wigasnitz',
      'Winkel',
      'Wrießnitz',
    ],
  },
  {
    postleitzahl: 9135,
    orte: [
      'Bad Eisenkappel / Železna Kapla',
      'Blasnitzen / Plaznica',
      'Ebriach / Obirsko',
      'Koprein Petzen / Pod Peco',
      'Koprein Sonnseite / Koprivna',
      'Leppen / Lepena',
      'Lobnig / Lobnik',
      'Rechberg / Rebrca',
      'Remschenig / Remšenik',
      'Trögern / Korte',
      'Unterort / Podkraj',
      'Vellach / Bela',
      'Weißenbach / Bela',
      'Zauchen / Suha',
    ],
  },
  {
    postleitzahl: 9141,
    orte: [
      'Buchbrunn / Bukovje',
      'Buchhalm',
      'Eberndorf / Dobrla vas',
      'Gablern / Lovanke',
      'Gösselsdorf / Goselna vas',
      'Hart',
      'Hof / Dvor',
      'Homitzberg',
      'Köcking',
      'Loibegg',
      'Mökriach / Mokrije',
      'Oberburg',
      'Pudab',
      'Slovenjach / Slovenje',
      'Unterbergen',
    ],
  },
  {
    postleitzahl: 9142,
    orte: [
      'Globasnitz / Globasnica',
      'Jaunstein / Podjuna',
      'Kleindorf / Mala vas',
      'Podrain / Podroje',
      'Slovenjach / Slovenje',
      'St. Stefan / Šteben',
      'Tschepitschach / Čepiče',
      'Unterbergen / Podgora',
      'Wackendorf / Večna vas',
    ],
  },
  {
    postleitzahl: 9143,
    orte: [
      'Dolintschitschach / Dolinčiče',
      'Feistritz ob Bleiburg / Bistrica pri Pliberku',
      'Gonowetz / Konovece',
      'Hinterlibitsch / Suha',
      'Hof / Dvor',
      'Lettenstätten / Letina',
      'Pirkdorf / Breška vas',
      'Ruttach-Schmelz / Rute',
      'St. Michael ob Bleiburg / Šmihel pri Pliberku',
      'Traundorf / Strpna vas',
      'Tscherberg / Črgoviče',
      'Unterlibitsch / Podlibič',
      'Unterort / Podkraj',
      'Winkel / Kot',
    ],
  },
  {
    postleitzahl: 9150,
    orte: [
      'Aich / Dob',
      'Bleiburg / Pliberk',
      'Dobrowa / Dobrova',
      'Draurain / Brege',
      'Ebersdorf / Drveša vas',
      'Einersdorf / Nonča vas',
      'Gonowetz / Konovece',
      'Grablach',
      'Hinterlibitsch / Suha',
      'Kömmel / Komelj',
      'Kömmelgupf / Komeljski Vrh',
      'Loibach / Libuče',
      'Lokowitzen',
      'Moos / Blato',
      'Penk / Ponikva',
      'Replach / Replje',
      'Rinkenberg / Vogrče',
      'Rinkolach / Rinkole',
      'Rischberg / Rižberk',
      'Ruttach / Rute',
      'Schattenberg',
      'Schilterndorf / Čirkovče',
      'St. Georgen / Šentjur',
      'St. Margarethen / Šmarjeta',
      'Unterort / Podkraj',
      'Weißenstein',
      'Wiederndorf / Vidra vas',
      'Winkel / Kot',
      'Woroujach / Borovje',
    ],
  },
  {
    postleitzahl: 9155,
    orte: [
      'Bach',
      'Berg ob Leifling',
      'Draugegend / Pri Dravi',
      'Graditschach / Gradiče',
      'Hart / Breg',
      'Heiligenstadt / Sveto mesto',
      'Illmitzen',
      'Kogelnigberg / Kogelska Gora',
      'Leifling',
      'Motschula',
      'Neuhaus',
      'Oberdorf / Gornja vas',
      'Pudlach',
      'Schwabegg / Žvabek',
      'Unterdorf / Dolnja vas',
      'Wesnitzen',
    ],
  },
  {
    postleitzahl: 9161,
    orte: [
      'Angern',
      'Angersbichl',
      'Ehrensdorf',
      'Gaisach',
      'Göltschach',
      'Göriach',
      'Haimach',
      'Hollenburg',
      'Lambichl',
      'Maria Rain',
      'Nadram',
      'Oberguntschach',
      'Obertöllern',
      'Saberda',
      'St. Ulrich',
      'Stemeritsch',
      'Strantschitschach',
      'Toppelsdorf',
      'Tschedram',
      'Unterguntschach',
      'Unterschloßberg',
      'Untertöllern',
      'Wegscheide',
    ],
  },
  {
    postleitzahl: 9162,
    orte: [
      'Babniak',
      'Dornach',
      'Kappel an der Drau',
      'Kirschentheuer',
      'Laiplach',
      'Rabenberg',
      'Singerberg',
      'St. Johann im Rosental / Šentjanž v Rožu',
      'Strau',
      'Weizelsdorf',
    ],
  },
  {
    postleitzahl: 9163,
    orte: [
      'Bodental / Poden',
      'Loibltal / Brodi',
      'Strugarjach / Strugarje',
      'Unterbergen',
      'Unterloibl',
      'Windisch Bleiberg / Slovenji Plajberk',
    ],
  },
  {
    postleitzahl: 9170,
    orte: [
      'Dörfl',
      'Ferlach',
      'Glainach',
      'Görtschach',
      'Jaklin',
      'Laak',
      'Otrouza',
      'Rauth',
      'Reßnig',
      'Seidolach',
      'Tratten / Trata',
      'Unterferlach',
      'Unterglainach',
      'Waidisch / Bajdiše',
      'Zell-Freibach / Sele-Borovnica',
      'Zell-Koschuta / Sele-Košuta',
      'Zell-Mitterwinkel / Sele-Srednji Kot',
      'Zell-Oberwinkel / Sele-Zvrhnji Kot',
      'Zell-Pfarre / Sele-Cerkev',
      'Zell-Schaida / Sele-Šajda',
    ],
  },
  {
    postleitzahl: 9173,
    orte: [
      'Dobrowa',
      'Dullach',
      'Freibach / Borovnica',
      'Gotschuchen',
      'Gupf',
      'Hintergupf',
      'Homölisch',
      'Niederdörfl',
      'Oberdörfl',
      'Sabosach',
      'Seel',
      'St. Margareten im Rosental',
      'Trieblach / Treblje',
      'Zell-Homölisch / Sele-Homeliše',
    ],
  },
  {
    postleitzahl: 9181,
    orte: [
      'Bärental',
      'Feistritz im Rosental',
      'Hundsdorf / Podsinja vas',
      'Matschach',
      'Niederdörfl / Spodnja vesca',
      'Suetschach',
    ],
  },
  {
    postleitzahl: 9182,
    orte: [
      'Dragositschach',
      'Fresnach',
      'Greuth / Rute',
      'Maria Elend / Podgorje',
      'St. Oswald',
      'Tallach',
    ],
  },
  {
    postleitzahl: 9183,
    orte: [
      'Frießnitz / Breznica',
      'Kanin / Hodnina',
      'Lessach / Leše',
      'Rosenbach',
      'Schlatten',
      'Tschemernitzen / Čemernica',
    ],
  },
  {
    postleitzahl: 9184,
    orte: [
      'Dreilach',
      'Feistritz',
      'Gorintschach',
      'Längdorf',
      'Mühlbach / Reka',
      'Schlatten',
      'Srajach / Sreje',
      'St. Jakob im Rosental / Šentjakob v Rožu',
      'St. Johann',
      'St. Peter / Šentpeter',
      'Tösching / Tešinja',
      'Winkl',
    ],
  },
  {
    postleitzahl: 9201,
    orte: [
      'Görtschach',
      'Hohenfeld',
      'Klagenfurt,12.Bez.:St. Martin',
      'Klagenfurt,14.Bez.:Wölfnitz',
      'Krumpendorf',
      'Pörtschach am Wörther See',
      'Pritschitz',
    ],
  },
  {
    postleitzahl: 9210,
    orte: ['Kreggab', 'Pörtschach am Wörther See', 'Pritschitz'],
  },
  {
    postleitzahl: 9212,
    orte: [
      'Arndorf',
      'Ebenfeld',
      'Greilitz',
      'Hadanig',
      'Karl',
      'Pavor',
      'Pernach',
      'Saag',
      'Schwarzendorf',
      'Sekull',
      'St. Bartlmä',
      'St. Martin am Techelsberg',
      'Tibitsch',
      'Töpriach',
      'Töschling',
      'Trabenig',
      'Trieblach',
    ],
  },
  {
    postleitzahl: 9220,
    orte: [
      'Aich',
      'Auen',
      'Augsdorf',
      'Bach',
      'Dröschitz',
      'Duel',
      'Fahrendorf',
      'Göriach',
      'Kantnig',
      'Kerschdorf',
      'Kranzlhofen',
      'Latschach',
      'Lind ob Velden',
      'Neudorf',
      'Oberjeserz',
      'Oberwinklern',
      'Rajach',
      'Saag',
      'Saisserach',
      'Selpritsch',
      'Sonnental',
      'Sternberg',
      'Unterjeserz',
      'Unterwinklern',
      'Velden am Wörther See',
      'Weinzierl',
    ],
  },
  {
    postleitzahl: 9231,
    orte: [
      'Dröschitz',
      'Kerschdorf',
      'Köstenberg',
      'Oberdorf',
      'Oberwinklern',
      'Untertauern',
      'Wurzen',
    ],
  },
  {
    postleitzahl: 9232,
    orte: [
      'Berg',
      'Bergl',
      'Buchheim',
      'Dolintschach',
      'Drau',
      'Duel',
      'Emmersdorf',
      'Frög / Breg',
      'Frojach',
      'Kleinberg',
      'Obergoritschach',
      'Pirk',
      'Raun / Ravne',
      'Rosegg',
      'St. Lambrecht',
      'St. Martin',
      'Untergoritschach',
    ],
  },
  {
    postleitzahl: 9241,
    orte: [
      'Damtschach',
      'Dragnitz',
      'Drautschen',
      'Duel',
      'Föderlach I',
      'Föderlach II',
      'Goritschach',
      'Gottestal',
      'Kaltschach',
      'Kantnig',
      'Kletschach',
      'Krottendorf',
      'Lichtpold',
      'Neudorf',
      'Ragain',
      'Sand',
      'Schleben',
      'Stallhofen',
      'Sternberg',
      'Terlach',
      'Trabenig',
      'Umberg',
      'Wernberg',
      'Wudmath',
      'Zettin',
    ],
  },
  {
    postleitzahl: 9300,
    orte: [
      'Aich',
      'Altglandorf',
      'Arndorf',
      'Baardorf',
      'Baiersdorf',
      'Blintendorf',
      'Breitenstein',
      'Dellach',
      'Dörfl',
      'Dornhof',
      'Draschelbach',
      'Dreifaltigkeit',
      'Eggen',
      'Frauenstein',
      'Gassing',
      'Goggerwenig',
      'Graßdorf',
      'Grassen',
      'Gray',
      'Hammergraben',
      'Hintnausdorf',
      'Höffern',
      'Holz',
      'Hörzenbrunn',
      'Hörzendorf',
      'Hunnenbrunn',
      'Kraindorf',
      'Laggen',
      'Lorenziberg',
      'Mail-Süd',
      'Mail',
      'Mairist',
      'Milbersdorf',
      'Muraunberg',
      'Niederdorf',
      'Nußberg',
      'Obermühlbach',
      'Pflugern',
      'Pirkfeld',
      'Podeblach',
      'Predl',
      'Projern',
      'Puppitsch',
      'Radweg',
      'Ritzendorf',
      'Sand',
      'Schaumboden',
      'Scheifling',
      'Siebenaich',
      'St. Andrä',
      'St. Donat',
      'St. Veit an der Glan',
      'Stammerdorf',
      'Steinbichl',
      'Steinbrücken',
      'Straganz',
      'Streimberg',
      'Stromberg',
      'Taggenbrunn',
      'Tratschweg',
      'Treffelsdorf',
      'Tschirnig',
      'Unterbergen',
      'Untermühlbach',
      'Wimitzstein',
      'Zensweg',
      'Zwein',
      'Zwischenbergen',
    ],
  },
  {
    postleitzahl: 9311,
    orte: [
      'Äußere Wimitz',
      'Föbing',
      'Grassen',
      'Grua',
      'Innere Wimitz',
      'Kraig',
      'Leiten',
      'Mellach',
      'Pfannhof',
      'Pörlinghof',
      'Seebichl',
      'Steinbichl',
      'Tratschweg',
      'Überfeld',
      'Weidenau',
      'Wimitz',
      'Zedl bei Kraig',
      'Zwein',
    ],
  },
  {
    postleitzahl: 9312,
    orte: [
      'Bergwerksgraben',
      'Dielach',
      'Drasenberg',
      'Eixendorf',
      'Gaming',
      'Gunzenberg',
      'Kogl',
      'Leiten',
      'Meiselding',
      'Pfannhof',
      'Pirka',
      'Rastenfeld',
      'Ringberg',
      'Stein',
      'Straganz',
      'Treffling',
      'Tschatschg',
      'Unterdeka',
      'Welsbach',
    ],
  },
  {
    postleitzahl: 9313,
    orte: [
      'Bernaich',
      'Dellach',
      'Drasendorf',
      'Fiming',
      'Krottendorf',
      'Reipersdorf',
      'Rottenstein',
      'St. Georgen am Längsee',
      'St. Peter',
      'Thalsdorf',
      'Töplach',
      'Unterlatschach',
      'Wolschart',
      'Zensberg',
    ],
  },
  {
    postleitzahl: 9314,
    orte: [
      'Garzern',
      'Gasselhof',
      'Gösseling',
      'Hochosterwitz',
      'Kreutern',
      'Labon',
      'Launsdorf',
      'Maigern',
      'Mannsberg',
      'Mauer',
      'Niederosterwitz',
      'Pölling',
      'Rain',
      'St. Martin',
      'St. Sebastian',
      'Thalsdorf',
      'Unterbruckendorf',
      'Unterpassering',
      'Weindorf',
      'Wiendorf',
    ],
  },
  {
    postleitzahl: 9321,
    orte: [
      'Boden',
      'Dobranberg',
      'Dürnfeld',
      'Edling',
      'Freiendorf',
      'Garzern',
      'Geiselsdorf',
      'Gölsach',
      'Grillberg',
      'Haide',
      'Haidkirchen',
      'Kappel am Krappfeld',
      'Krasta',
      'Landbrücken',
      'Latschach',
      'Lind',
      'Mannsberg',
      'Möriach',
      'Muschk',
      'Oberbruckendorf',
      'Passering',
      'Poppenhof',
      'Schöttlhof',
      'Silberegg',
      'St. Klementen',
      'St. Martin am Krappfeld',
      'St. Willibald',
      'Stammersdorf',
      'Unterbergen',
      'Unterpassering',
      'Unterstein',
      'Windisch',
      'Zedl',
      'Zeindorf',
    ],
  },
  {
    postleitzahl: 9322,
    orte: [
      'Eberdorf',
      'Gasteige',
      'Hirt',
      'Lorenzenberg',
      'Micheldorf',
      'Ruhsdorf',
    ],
  },
  {
    postleitzahl: 9323,
    orte: [
      'Dürnstein in der Steiermark',
      'Sankt Marein bei Neumarkt',
      'Wildbad Einöd',
    ],
  },
  {
    postleitzahl: 9330,
    orte: [
      'Aich',
      'Althofen',
      'Brugga',
      'Dachberg',
      'Eberdorf',
      'Epritz',
      'Guttaringberg',
      'Krasta',
      'Krumfelden',
      'Mölbling',
      'Muraniberg',
      'Rabenstein',
      'Rabing',
      'Rain',
      'Silberegg',
      'St. Kosmas',
      'St. Stefan am Krappfeld',
      'Stoberdorf',
      'Töscheldorf',
      'Treibach',
      'Unterbergen',
      'Weindorf',
    ],
  },
  {
    postleitzahl: 9334,
    orte: [
      'Deinsberg',
      'Guttaring',
      'Guttaringberg',
      'Höffern',
      'Hollersberg',
      'Maria Hilf',
      'Oberstranach',
      'Rabachboden',
      'Ratteingraben',
      'Schelmberg',
      'Schrottenbach',
      'Silberegg',
      'Sonnberg',
      'St. Gertruden',
      'Übersberg',
      'Urtl',
      'Urtlgraben',
      'Verlosnitz',
      'Waitschach',
    ],
  },
  {
    postleitzahl: 9335,
    orte: [
      'Hinterberg',
      'Knappenberg',
      'Lölling Graben',
      'Lölling Schattseite',
      'Lölling Sonnseite',
      'Semlach',
      'St. Johann am Pressen',
      'Stranach',
    ],
  },
  {
    postleitzahl: 9341,
    orte: [
      'Bachl',
      'Buldorf',
      'Dielach',
      'Dobersberg',
      'Drahtzug',
      'Edling',
      'Gassarest',
      'Gerach',
      'Glabötsch',
      'Gratschitz',
      'Gruschitz',
      'Gundersdorf',
      'Gunzenberg',
      'Hackl',
      'Hausdorf',
      'Herd',
      'Hohenfeld',
      'Höllein',
      'Kraßnitz',
      'Kreuth',
      'Kreuzen',
      'Kulmitzen',
      'Langwiesen',
      'Lees',
      'Lieding',
      'Machuli',
      'Mannsdorf',
      'Mellach',
      'Mitterdorf',
      'Moschitz',
      'Olschnitz-Lind',
      'Olschnitz',
      'Olschnögg',
      'Pabenberg',
      'Pöckstein-Zwischenwässern',
      'Pölling',
      'Ratschach',
      'Schattseite',
      'Schmaritzen',
      'Schneßnitz',
      'St. Georgen',
      'St. Jakob',
      'St. Johann',
      'St. Magdalen',
      'St. Peter',
      'Stein',
      'Straßburg-Stadt',
      'Unteraich',
      'Unterfarcha',
      'Unterrain',
      'Wattein',
      'Wildbach',
      'Wilpling',
      'Winklern',
    ],
  },
  {
    postleitzahl: 9342,
    orte: [
      'Dörfl',
      'Finsterdorf',
      'Föbing',
      'Gassarest',
      'Glanz',
      'Gruska',
      'Gurk',
      'Gwadnitz',
      'Hundsdorf',
      'Kreuzberg',
      'Krön',
      'Masternitzen',
      'Niederdorf',
      'Pisweg',
      'Ranitz',
      'Reichenhaus',
      'Straßa',
      'Sutsch',
      'Zabersdorf',
      'Zedl',
      'Zedroß',
      'Zeltschach',
    ],
  },
  {
    postleitzahl: 9343,
    orte: [
      'Ading',
      'Aich',
      'Bach (Zweinitz)',
      'Brunn (Zweinitz)',
      'Dielach',
      'Engelsdorf',
      'Grabenig',
      'Hundsdorf',
      'Kraßnitz',
      'Mödring',
      'St. Andrä',
      'Traming',
      'Wurz',
      'Zweinitz',
    ],
  },
  {
    postleitzahl: 9344,
    orte: [
      'Dalling',
      'Dolz',
      'Edling',
      'Grua',
      'Hafendorf',
      'Hardernitzen',
      'Kaindorf',
      'Kötschendorf',
      'Lind',
      'Massanig',
      'Nassing',
      'Niederwurz',
      'Oberort',
      'Planitz',
      'Psein',
      'Reinsberg',
      'Sadin',
      'Weitensfeld',
      'Wullroß',
      'Zammelsberg',
    ],
  },
  {
    postleitzahl: 9345,
    orte: [
      'Altenmarkt',
      'Braunsberg',
      'Hohenwurz',
      'Kaindorf',
      'Kleinglödnitz',
      'Lassenberg',
      'Leßnitz',
      'Mödritsch',
      'Reinsberg',
      'Steindorf',
      'Tschriet',
      'Zauchwinkel',
    ],
  },
  {
    postleitzahl: 9346,
    orte: [
      'Bach',
      'Brenitz',
      'Eden',
      'Flattnitz',
      'Glödnitz',
      'Grai',
      'Hohenwurz',
      'Jauernig',
      'Laas',
      'Lassenberg',
      'Moos',
      'Rain',
      'Schattseite',
      'Torf',
      'Tschröschen',
      'Weißberg',
    ],
  },
  {
    postleitzahl: 9360,
    orte: [
      'Dobritsch',
      'Dörfl',
      'Dürnstein in der Steiermark',
      'Engelsdorf',
      'Friesach',
      'Gaisberg',
      'Gaudritz',
      'Grafendorf',
      'Guldendorf',
      'Gulitzen',
      'Gundersdorf',
      'Guttaringberg',
      'Harold',
      'Hartmannsdorf',
      'Judendorf',
      'Kräuping',
      'Lorenzenberg',
      'Micheldorf',
      'Oberdorf II',
      'Olsa',
      'Ostrog',
      'Pabenberg',
      'Reisenberg',
      'Sattelbogen',
      'Schödendorf',
      'Schwall',
      'Silbermann',
      'Wagendorf',
      'Wiegen',
      'Zeltschach',
      'Zeltschachberg',
    ],
  },
  {
    postleitzahl: 9361,
    orte: [
      'Gunzenberg',
      'Gwerz',
      'Hundsdorf',
      'Ingolsthal',
      'Judendorf',
      'Leimersberg',
      'Mayerhofen',
      'Moserwinkl',
      'Oberdorf I',
      'Reisenberg',
      'Roßbach',
      'Schratzbach',
      'St. Johann',
      'St. Salvator',
      'St. Stefan',
      'Staudachhof',
      'Stegsdorf',
      'Timrian',
      'Wels',
      'Wiesen',
      'Zienitzen',
      'Zmuck',
    ],
  },
  {
    postleitzahl: 9362,
    orte: [
      'Feistritz',
      'Grades',
      'Marienheim',
      'Metnitz',
      'Schnatten',
      'Zwatzhof',
    ],
  },
  {
    postleitzahl: 9363,
    orte: [
      'Auen',
      'Feistritz',
      'Felfernigthal',
      'Klachl',
      'Maria Höfl',
      'Metnitz',
      'Mödring',
      'Oberalpe',
      'Oberhof Schattseite',
      'Oberhof Sonnseite',
      'Preining',
      'Schwarzenbach',
      'Teichl',
      'Unteralpe',
      'Vellach',
      'Wöbring',
    ],
  },
  {
    postleitzahl: 9371,
    orte: [
      'Brückl',
      'Eppersdorf',
      'Gutschen',
      'Hart',
      'Hausdorf',
      'Johannserberg',
      'Kaltenberg',
      'Klein St. Veit',
      'Krainberg',
      'Labegg',
      'Michaelerberg',
      'Oberkrähwald',
      'Pirkach',
      'Reisdorf',
      'Salchendorf',
      'Schmieddorf',
      'Selesen',
      'St. Gregorn',
      'St. Ulrich am Johannserberg',
      'St. Walburgen',
      'Terpetzen',
      'Tschutta',
    ],
  },
  {
    postleitzahl: 9372,
    orte: [
      'Baumgarten',
      'Eberstein',
      'Gutschen',
      'Hochfeistritz',
      'Kaltenberg',
      'Klein St. Paul',
      'Kulm',
      'Mirnig',
      'Rüggen',
      'St. Oswald',
      'St. Walburgen',
    ],
  },
  {
    postleitzahl: 9373,
    orte: [
      'Dobranberg',
      'Filfing',
      'Klein St. Paul',
      'Prailing',
      'Rattenberg',
      'Sittenberg',
      'St. Florian',
      'Wietersdorf',
    ],
  },
  {
    postleitzahl: 9374,
    orte: [
      'Buch',
      'Drattrum',
      'Dullberg',
      'Grünburg',
      'Kirchberg',
      'Kitschdorf',
      'Maria Hilf',
      'Mösel',
      'Müllergraben',
      'Oberwietingberg',
      'Raffelsdorf',
      'Schelmberg',
      'Unterwietingberg',
      'Wieting',
    ],
  },
  {
    postleitzahl: 9375,
    orte: [
      'Baierberg',
      'Deinsberg',
      'Dobritsch',
      'Gobertal',
      'Heft',
      'Höffern',
      'Hüttenberg Land',
      'Hüttenberg',
      'Lölling Sonnseite',
      'Ratteingraben',
      'Schalkendorf',
      'St. Johann am Pressen',
      'St. Martin am Silberberg',
      'Unterwald',
      'Verlosnitz',
      'Waitschach',
      'Zosen',
    ],
  },
  {
    postleitzahl: 9376,
    orte: [
      'Andreaskreuz',
      'Gossen',
      'Jouschitzen',
      'Knappenberg',
      'Lichtegg',
      'Obersemlach',
      'St. Johann am Pressen',
    ],
  },
  {
    postleitzahl: 9400,
    orte: [
      'Auen',
      'Gräbern',
      'Gries',
      'Hattendorf',
      'Hintergumitsch',
      'Kleinedling',
      'Kleinwinklern',
      'Pfaffendorf',
      'Pollheim',
      'Prebl',
      'Priel',
      'Raggl',
      'Reding',
      'Ritzing',
      'Schleifen',
      'Schoßbach',
      'Schwemmtratten',
      'St. Jakob',
      'St. Johann',
      'St. Stefan',
      'St. Thomas',
      'Unterleidenberg',
      'Vordergumitsch',
      'Wolfsberg',
      'Wölling',
      'Zellach',
    ],
  },
  {
    postleitzahl: 9411,
    orte: [
      'Aichberg',
      'Altendorf',
      'Arling',
      'Eselsdorf',
      'Forst',
      'Hattendorf',
      'Kötsch',
      'Lading',
      'Lausing',
      'Pollheim',
      'Priel',
      'St. Margarethen im Lavanttal',
      'St. Michael',
      'Thürn',
      'Witra',
    ],
  },
  {
    postleitzahl: 9412,
    orte: [
      'Arling',
      'Forst',
      'Leiwald',
      'Oberleidenberg',
      'Pfaffendorf',
      'Preims',
      'Raggl',
      'St. Margarethen im Lavanttal',
      'Unterleidenberg',
      'Witra',
    ],
  },
  {
    postleitzahl: 9413,
    orte: [
      'Auen',
      'Frantschach',
      'Gräbern',
      'Hintergumitsch',
      'Hinterwölch',
      'Kaltstuben',
      'Kamp',
      'Kamperkogel',
      'Limberg',
      'Obergösel',
      'Praken',
      'St. Gertraud',
      'Trum-und Prössinggraben',
      'Untergösel',
      'Vorderlimberg',
      'Vordertheißenegg',
      'Vorderwölch',
      'Weinebene',
      'Zellach',
    ],
  },
  {
    postleitzahl: 9421,
    orte: [
      'Eitweg',
      'Gemmersdorf',
      'Goding',
      'Hainsdorf',
      'Hartelsberg',
      'Hartneidstein',
      'Mosern',
      'Obereberndorf',
      'Oberpichling',
      'St. Ulrich',
    ],
  },
  {
    postleitzahl: 9422,
    orte: [
      'Aich',
      'Dachberg',
      'Eisdorf',
      'Farrach',
      'Lindhof',
      'Maria Rojach',
      'Mitterpichling',
      'Mühldorf',
      'Oberpichling',
      'Paierdorf',
      'Ragglach',
      'Ragglbach',
      'Untereberndorf',
    ],
  },
  {
    postleitzahl: 9423,
    orte: [
      'Andersdorf',
      'Fransdorf',
      'Götzendorf',
      'Gundisch-Mitte',
      'Gundisch-Nord',
      'Gundisch-Süd',
      'Herzogberg',
      'Hofwiesen',
      'Krakaberg',
      'Matschenbloch',
      'Niederhof',
      'Oberrainz',
      'Pfaffendorf',
      'Pontnig',
      'St. Georgen im Lavanttal',
      'Steinberg-Hart',
      'Steinberg-Oberhaus',
      'Unterpichling',
      'Weißenberg',
    ],
  },
  {
    postleitzahl: 9431,
    orte: [
      'Aichberg',
      'Glein',
      'Goding',
      'Großedling',
      'Hartelsberg',
      'Kleinedling',
      'Kleinrojach',
      'Kleinwinklern',
      'Maildorf',
      'Michaelsdorf',
      'Oberaigen',
      'Paildorf',
      'Pichling',
      'Priel',
      'Reideben',
      'Reinfelsdorf',
      'Reisberg',
      'Rieding',
      'Riegelsdorf',
      'Schaßbach',
      'Schobersberg',
      'Siegelsdorf',
      'St. Johann',
      'St. Marein',
      'St. Stefan',
      'Thürn',
      'Unteraigen',
      'Völking',
      'Vordergumitsch',
      'Weißenbach Gumitsch',
      'Weißenbach Rieding',
      'Winkling-Nord',
      'Wolkersdorf',
    ],
  },
  {
    postleitzahl: 9433,
    orte: [
      'Blaiken',
      'Burgstall-Pölling',
      'Burgstall-St. Andrä',
      'Fischering',
      'Framrach',
      'Gönitz',
      'Höfern',
      'Jakling',
      'Kienberg',
      'Kleinrojach',
      'Kollegg',
      'Kragelsdorf',
      'Lamm',
      'Langegg',
      'Langgen',
      'Magersdorf',
      'Messensach',
      'Mettersdorf',
      'Mosern',
      'Oberagsdorf',
      'Oberaigen',
      'Pirk',
      'Pölling',
      'Pustritz',
      'Schilting',
      'Schönweg-Pustritz',
      'Schönweg-St. Andrä',
      'Siebending',
      'St. Andrä',
      'St. Jakob',
      'Streitberg',
      'Tschrietes',
      'Unteragsdorf',
      'Unterrain',
      'Wimpassing',
      'Winkling-Nord',
      'Winkling-Süd',
      'Winkling',
      'Wois',
      'Wölzing-Fischering',
      'Wölzing-St. Andrä',
      'Zellbach',
    ],
  },
  {
    postleitzahl: 9441,
    orte: [
      'Gräbern',
      'Hintertheißenegg',
      'Schönberg',
      'Twimberg',
      'Vordertheißenegg',
      'Waldenstein',
    ],
  },
  {
    postleitzahl: 9451,
    orte: [
      'Kleinpreitenegg',
      'Oberauerling',
      'Oberpreitenegg',
      'Pack',
      'Preitenegg',
      'Unterauerling',
      'Unterpreitenegg',
    ],
  },
  {
    postleitzahl: 9461,
    orte: ['Auen', 'Gräbern', 'Prebl', 'Wölling'],
  },
  {
    postleitzahl: 9462,
    orte: [
      'Bad St. Leonhard im Lavanttal',
      'Erzberg',
      'Görlitzen',
      'Kalchberg',
      'Kliening',
      'Klippitztörl',
      'Leiwald',
      'Lichtengraben',
      'Mauterndorf',
      'Prebl',
      'Raning',
      'Schiefling',
      'Schönberg',
      'St. Peter im Lavanttal',
      'Steinbruch',
      'Twimberg',
      'Wartkogel',
      'Weitenbach',
      'Wiesenau',
      'Wisperndorf',
    ],
  },
  {
    postleitzahl: 9463,
    orte: [
      'Großprethal',
      'Reichenfels',
      'Sommerau',
      'St. Peter im Lavanttal',
      'Wartkogel',
      'Weitenbach',
      'Winterleiten',
      'Zanitzen',
    ],
  },
  {
    postleitzahl: 9470,
    orte: [
      'Aich',
      'Allersdorf',
      'Deutsch-Grutschen',
      'Gönitz',
      'Granitztal-St. Paul',
      'Granitztal-Weißenegg',
      'Hundsdorf',
      'Johannesberg',
      'Kampach',
      'Kollnitzgreuth',
      'Legerbuch',
      'Loschental',
      'Raggane',
      'Schildberg',
      'St. Margarethen',
      'St. Martin',
      'St. Paul im Lavanttal',
      'Stadling',
      'Unterhaus',
      'Unterrainz',
      'Weinberg',
      'Windisch-Grutschen',
      'Winkling',
      'Zellbach',
    ],
  },
  {
    postleitzahl: 9472,
    orte: [
      'Achalm',
      'Ettendorf',
      'Krottendorf',
      'Lamprechtsberg',
      'Magdalensberg',
      'Schwarzenbach',
      'Unterholz',
      'Weißenberg',
    ],
  },
  {
    postleitzahl: 9473,
    orte: [
      'Achalm',
      'Hart',
      'Lamprechtsberg',
      'Lavamünd',
      'Legerbuch',
      'Lorenzenberg',
      'Magdalensberg',
      'Pfarrdorf',
      'Plestätten',
      'Rabenstein',
      'Rabensteingreuth',
      'St. Vinzenz',
      'Unterbergen',
      'Witternig',
      'Wunderstätten',
      'Zeil',
    ],
  },
  {
    postleitzahl: 9500,
    orte: [
      'Dobrova',
      'Drautschen',
      'Duel',
      'Goritschach',
      'Gritschach',
      'Großvassach',
      'Heiligengeist',
      'Kleinsattel',
      'Kleinvassach',
      'Kumitz',
      'Landskron',
      'Maria Gail',
      'Mittewald ob Villach',
      'Neufellach',
      'Neulandskron',
      'Obere Fellach',
      'Oberwollanig',
      'Pogöriach',
      'Prossowitsch',
      'Rennstein',
      'St. Andrä',
      'St. Georgen',
      'St. Leonhard',
      'St. Michael',
      'St. Ulrich',
      'Tschinowitsch',
      'Turdanitsch',
      'Untere Fellach',
      'Unterwollanig',
      'Villach-Auen',
      'Villach-Innere Stadt',
      'Villach-Lind',
      'Villach-Seebach-Wasenboden',
      'Villach-St. Agathen und Perau',
      'Villach-St. Martin',
      'Villach-Völkendorf',
      'Villach-Warmbad-Judendorf',
      'Weißenbach',
      'Zauchen',
    ],
  },
  {
    postleitzahl: 9504,
    orte: ['Villach-Auen', 'Villach-Warmbad-Judendorf'],
  },
  {
    postleitzahl: 9520,
    orte: [
      'Annenheim',
      'Ossiachberg',
      'Sattendorf',
      'Stöcklweingarten',
      'Treffen',
    ],
  },
  {
    postleitzahl: 9521,
    orte: [
      'Eichholz',
      'Görtschach',
      'Kanzelhöhe',
      'Köttwein',
      'Niederdorf',
      'Oberdorf',
      'Ossiachberg',
      'Pölling',
      'Retzen',
      'Schloss Treffen',
      'Seespitz',
      'Töbring',
      'Treffen',
      'Tschlein',
      'Winklern',
    ],
  },
  {
    postleitzahl: 9523,
    orte: [
      'Gratschach',
      'Heiligen Gestade',
      'Kumitz',
      'Landskron',
      'Neulandskron',
      'St. Andrä',
      'St. Michael',
      'St. Ruprecht',
      'Urlaken',
      'Zauchen',
    ],
  },
  {
    postleitzahl: 9524,
    orte: [
      'Landskron',
      'St. Magdalen',
      'St. Ulrich',
      'Villach-Seebach-Wasenboden',
    ],
  },
  {
    postleitzahl: 9530,
    orte: [
      'Bad Bleiberg',
      'Bleiberg-Kreuth',
      'Bleiberg-Nötsch',
      'Hüttendorf',
      'Kadutschen',
    ],
  },
  {
    postleitzahl: 9531,
    orte: ['Hermsberg', 'Labientschach'],
  },
  {
    postleitzahl: 9535,
    orte: [
      'Aich',
      'Albersdorf',
      'Auen',
      'Farrendorf',
      'Goritschach',
      'Ottosch',
      'Penken',
      'Raunach',
      'Roach',
      'Roda',
      'Schiefling',
      'St. Kathrein',
      'Techelweg / Holbiče',
      'Zauchen',
    ],
  },
  {
    postleitzahl: 9536,
    orte: [
      'Dieschitz',
      'Latschach',
      'Pulpitsch / Pulpače',
      'St. Egyden',
      'Treffen / Trebinja',
    ],
  },
  {
    postleitzahl: 9541,
    orte: [
      'Äußere Einöde',
      'Buchholz',
      'Innere Einöde',
      'Kras',
      'Lötschenberg',
      'Retzen',
      'Winklern',
    ],
  },
  {
    postleitzahl: 9542,
    orte: [
      'Afritz am See',
      'Afritz',
      'Berg ob Afritz',
      'Gassen',
      'Kraa',
      'Lierzberg',
      'Lötschenberg',
      'Möderboden',
      'Scherzboden',
      'Tassach',
      'Tauchenberg',
      'Tobitsch',
      'Verditz',
    ],
  },
  {
    postleitzahl: 9543,
    orte: [
      'Arriach',
      'Berg ob Arriach',
      'Dreihofen',
      'Hinterbuchholz',
      'Hinterwinkl',
      'Hundsdorf',
      'Innerteuchen',
      'Laastadt',
      'Oberwöllan',
      'Sauboden',
      'Sauerwald',
      'Stadt',
      'Unterwöllan',
      'Vorderwinkl',
    ],
  },
  {
    postleitzahl: 9544,
    orte: [
      'Erlach',
      'Feld am See',
      'Feldpannalpe',
      'Klamberg',
      'Rauth',
      'Schattseite',
      'Untersee',
      'Wiesen',
    ],
  },
  {
    postleitzahl: 9545,
    orte: [
      'Dabor',
      'Ebene',
      'Erdmannsiedlung',
      'Frischg',
      'Hohensaß',
      'Kaning',
      'Laufenberg',
      'Mitterberg',
      'Obertweng',
      'Radenthein',
      'Schattseite',
      'Schrott',
      'St. Peter',
      'Untertweng',
      'Zödl',
    ],
  },
  {
    postleitzahl: 9546,
    orte: [
      'Aigen',
      'Bach',
      'Hohensaß',
      'Kleinkirchheim',
      'Obertschern',
      'Rottenstein',
      'St. Oswald',
      'Staudach',
      'Untertschern',
      'Zirkitzen',
    ],
  },
  {
    postleitzahl: 9551,
    orte: [
      'Bodensdorf',
      'Burg',
      'Deutschberg',
      'Ossiachberg',
      'St. Urban',
      'Steindorf am Ossiacher See',
      'Stiegl',
      'Stöcklweingarten',
      'Tratten',
      'Tschöran',
      'Unterberg',
      'Winkl Ossiachberg',
    ],
  },
  {
    postleitzahl: 9552,
    orte: [
      'Fresen',
      'Golk',
      'Manessen',
      'Ossiachberg',
      'Sallach',
      'Sonnberg',
      'Steindorf am Ossiacher See',
      'Stiegl',
    ],
  },
  {
    postleitzahl: 9554,
    orte: [
      'Agsdorf-Gegend',
      'Agsdorf',
      'Bach-St. Urban',
      'Bach',
      'Buggl in Bach',
      'Eggen',
      'Gall',
      'Gasmai',
      'Göschl',
      'Gößeberg',
      'Grai',
      'Hafenberg',
      'Kleingradenegg',
      'Lawesen',
      'Oberdorf',
      'Reggen',
      'Retschitz-Simonhöhe',
      'Retschitz',
      'Rittolach',
      'Rogg',
      'Simonhöhe',
      'St. Urban',
      'Stattenberg',
      'Trenk',
      'Tumpf',
      'Zirkitz',
      'Zwattendorf',
    ],
  },
  {
    postleitzahl: 9555,
    orte: [
      'Bach',
      'Besendorf',
      'Deblach',
      'Flatschach',
      'Friedlach',
      'Glanegg',
      'Glantscha',
      'Gösselsberg',
      'Grintschach',
      'Kadöll',
      'Krobathen',
      'Maria Feicht-Gegend',
      'Maria Feicht',
      'Mautbrücken',
      'Metschach',
      'Paindorf',
      'Schwambach',
      'St. Gandolf',
      'Unterglanegg',
      'Zmuln',
    ],
  },
  {
    postleitzahl: 9556,
    orte: [
      'Bärndorf',
      'Beißendorf',
      'Besendorf',
      'Eberdorf',
      'Eggen I',
      'Eggen II',
      'Fachau',
      'Freundsam',
      'Gasmai',
      'Glantschach',
      'Gößeberg',
      'Graben',
      'Gradenegg',
      'Gramilach',
      'Grassendorf',
      'Grund',
      'Haidach',
      'Hardegg',
      'Hart',
      'Hoch-Liebenfels',
      'Hohenstein',
      'Karlsberg',
      'Karnberg',
      'Kreuth',
      'Kulm',
      'Ladein',
      'Lebmach',
      'Liebenfels',
      'Liemberg',
      'Lorberhof',
      'Mailsberg',
      'Mauer',
      'Meschkowitz',
      'Miedling',
      'Moos',
      'Pflausach',
      'Pflugern',
      'Pulst',
      'Puppitsch',
      'Radelsdorf',
      'Rasting',
      'Reidenau',
      'Rohnsdorf',
      'Rosenbichl',
      'Sörg',
      'Sörgerberg',
      'St. Leonhard',
      'St. Paul',
      'Tauchendorf',
      'Tschadam',
      'Waggendorf',
      'Wasai',
      'Weitensfeld',
      'Woitsch',
      'Zmuln',
      'Zojach',
      'Zweikirchen',
    ],
  },
  {
    postleitzahl: 9560,
    orte: [
      'Adriach',
      'Agsdorf-Gegend',
      'Aich',
      'Albern',
      'Alpen',
      'Apetig',
      'Bichl',
      'Bösenlacken',
      'Briefelsdorf',
      'Buchscheiden',
      'Burgrad',
      'Debar',
      'Dellach',
      'Dietrichstein',
      'Dobra',
      'Dolintschig',
      'Dölnitz',
      'Draschen',
      'Eberdorf',
      'Eden',
      'Edern',
      'Edling',
      'Egg',
      'Elbling',
      'Farcha',
      'Fasching',
      'Feistritz',
      'Feldkirchen in Kärnten',
      'Felfern',
      'Förolach',
      'Fuchsgruben',
      'Glabegg',
      'Glan',
      'Glanblick',
      'Glanhofen',
      'Goggau',
      'Graben',
      'Gradisch',
      'Guttaring',
      'Haiden',
      'Hart',
      'Hinterwachsenberg',
      'Höfling',
      'Ingelsdorf',
      'Jeinitz',
      'Kaidern',
      'Kallitsch',
      'Kerschdorf',
      'Klachl',
      'Klausen',
      'Klein St. Veit',
      'Knasweg',
      'Kofl',
      'Köttern',
      'Krahberg',
      'Kraß',
      'Kraßnitz',
      'Kreuth',
      'Laboisen',
      'Lang',
      'Langacker',
      'Leinig',
      'Leiten',
      'Lendorf',
      'Liebetig',
      'Lindl',
      'Maltschach',
      'Markstein',
      'Mattersdorf',
      'Metzing',
      'Micheldorf',
      'Nadling',
      'Naßweg',
      'Niederdorf',
      'Niederwinklern',
      'Oberglan',
      'Pernegg',
      'Persching',
      'Pfaffendorf',
      'Poitschach-Baracke',
      'Poitschach',
      'Poitschachgraben',
      'Pökelitz',
      'Pollenitz',
      'Pölling',
      'Powirtschach',
      'Prägrad',
      'Prapra',
      'Praschig',
      'Rabensdorf',
      'Radweg',
      'Raunach',
      'Regenfeld',
      'Regin',
      'Rennweg',
      'Rotapfel',
      'Rottendorf',
      'Sallas',
      'Sassl',
      'Seitenberg',
      'Severgraben',
      'Sittich',
      'Sonnrain',
      'St. Martin',
      'St. Nikolai',
      'St. Ruprecht',
      'St. Stefan',
      'St. Ulrich',
      'Steuerberg',
      'Stocklitz',
      'Tauern',
      'Thörl',
      'Tiffen',
      'Tramoitschig',
      'Tscherneitsch',
      'Tschwarzen',
      'Unterberg',
      'Untere Glan',
      'Unterhof',
      'Unterrain',
      'Wabl',
      'Wachsenberg',
      'Waiern',
      'Weit',
      'Wiggis',
      'Witsch',
      'Zingelsberg',
    ],
  },
  {
    postleitzahl: 9562,
    orte: [
      'Außerteuchen',
      'Dragelsberg',
      'Eden',
      'Flatschach',
      'Glanz',
      'Grilzgraben',
      'Grintschach',
      'Himmelberg',
      'Hochegg',
      'Klatzenberg',
      'Kösting',
      'Lassen',
      'Linz',
      'Oberboden',
      'Pichlern',
      'Pojedl',
      'Sallach',
      'Saurachberg',
      'Schleichenfeld',
      'Schwaig',
      'Sonnleiten',
      'Spitzenbichl',
      'Tiebel',
      'Tiffnerwinkl',
      'Tobitsch',
      'Tschriet',
      'Werschling',
      'Winklern',
      'Wöllach',
      'Zedlitzberg',
    ],
  },
  {
    postleitzahl: 9563,
    orte: [
      'Außerteuchen',
      'Bergl',
      'Eben',
      'Gnesau',
      'Görzberg',
      'Görzwinkl',
      'Gurk',
      'Haidenbach',
      'Maitratten',
      'Mitteregg',
      'Sonnleiten',
      'Tiebel',
      'Weißenbach',
      'Zedlitzdorf',
    ],
  },
  {
    postleitzahl: 9564,
    orte: [
      'Falkertsee',
      'Lassen',
      'Mitterdorf',
      'Patergassen',
      'Plaß',
      'Rottenstein',
      'St. Margarethen',
      'Vorderkoflach',
      'Vorwald',
      'Wiederschwing',
      'Wiedweg',
    ],
  },
  {
    postleitzahl: 9565,
    orte: [
      'Ebene Reichenau',
      'Hinterkoflach',
      'Lorenzenberg',
      'Saureggen',
      'Schuß',
      'Seebach',
      'St. Lorenzen',
      'Turracherhöhe',
      'Waidach',
      'Winkl',
    ],
  },
  {
    postleitzahl: 9570,
    orte: ['Alt-Ossiach', 'Ossiach', 'Ostriach', 'Rappitsch'],
  },
  {
    postleitzahl: 9571,
    orte: [
      'Albeck Obere Schattseite',
      'Albeck Untere Schattseite',
      'Benesirnitz',
      'Egarn',
      'Frankenberg',
      'Grillenberg',
      'Hochrindl-Alpl',
      'Hochrindl-Kegel',
      'Hochrindl-Tatermann',
      'Hochrindl',
      'Hofern',
      'Holzern',
      'Kalsberg',
      'Kogl',
      'Kruckenalm',
      'Lamm',
      'Neualbeck',
      'Oberdörfl',
      'Obereggen',
      'Seebachern',
      'Sirnitz-Schattseite',
      'Sirnitz-Sonnseite',
      'Sirnitz-Winkl',
      'Sirnitz',
      'Spitzwiesen',
      'St. Ruprecht',
      'Stron',
      'Unterdörfl',
      'Untereggen',
      'Weitental',
      'Wippa',
    ],
  },
  {
    postleitzahl: 9572,
    orte: [
      'Albern',
      'Arlsdorf',
      'Bach',
      'Bischofsberg',
      'Brunn',
      'Deutsch Griffen',
      'Faulwinkel',
      'Gantschach',
      'Göschelsberg',
      'Graben',
      'Gray',
      'Hintereggen',
      'Leßnitz',
      'Meisenberg',
      'Messaneggen',
      'Mitteregg',
      'Oberlamm',
      'Pesseneggen',
      'Ratzendorf',
      'Rauscheggen',
      'Sand',
      'Tanzenberg',
      'Unterlamm',
    ],
  },
  {
    postleitzahl: 9580,
    orte: [
      'Bogenfeld',
      'Drobollach am Faaker See',
      'Egg am Faaker See',
      'Faak am See',
      'Graschitz',
      'Greuth',
      'Großsattel',
      'Kratschach',
      'Mittewald',
      'Serai',
      'St. Niklas an der Drau',
    ],
  },
  {
    postleitzahl: 9581,
    orte: [
      'Kopein',
      'Ledenitzen',
      'Mallenitzen',
      'Oberferlach / Zgornje Borovlje',
      'Petschnitzen / Pečnica',
      'Pirk',
      'Unteraichwald',
      'Unterferlach / Spodnje Borovlje',
    ],
  },
  {
    postleitzahl: 9582,
    orte: [
      'Altfinkenstein',
      'Latschach',
      'Oberaichwald',
      'Outschena',
      'Pogöriach',
      'Ratnitz',
      'Unteraichwald',
      'Untergreuth / Spodnje Rute',
    ],
  },
  {
    postleitzahl: 9583,
    orte: ['Faak am See'],
  },
  {
    postleitzahl: 9584,
    orte: ['Finkenstein', 'Goritschach / Zagoriče', 'Höfling'],
  },
  {
    postleitzahl: 9585,
    orte: [
      'Gödersdorf',
      'Müllnern',
      'Neumüllnern',
      'Stobitzen',
      'Susalitsch / Žužalče',
      'Techanting',
      'Villach-Warmbad-Judendorf',
    ],
  },
  {
    postleitzahl: 9586,
    orte: [
      'Fürnitz',
      'Hart / Ločilo',
      'Korpitsch',
      'Oberfederaun',
      'Oberschütt',
      'Sigmontitsch / Zmotiče',
      'St. Job',
      'Stobitzen',
      'Unterfederaun',
      'Unterschütt',
    ],
  },
  {
    postleitzahl: 9587,
    orte: [
      'Erlendorf',
      'Hart / Ločilo',
      'Korpitsch',
      'Krainberg',
      'Krainegg',
      'Neuhaus an der Gail',
      'Oberschütt',
      'Radendorf',
      'Riegersdorf',
      'St. Leonhard bei Siebenbrünn',
      'Tschau',
    ],
  },
  {
    postleitzahl: 9601,
    orte: [
      'Agoritschach',
      'Arnoldstein',
      'Erlendorf',
      'Gailitz',
      'Greuth',
      'Lind',
      'Pöckau',
      'Seltschach',
      'Stossau',
    ],
  },
  {
    postleitzahl: 9602,
    orte: [
      'Draschitz',
      'Greuth',
      'Hohenthurn',
      'Maglern',
      'Oberthörl',
      'Pessendellach',
      'Thörl-Maglern-Greuth',
      'Unterthörl',
    ],
  },
  {
    postleitzahl: 9611,
    orte: ['Emmersdorf', 'Förk', 'Michelhofen', 'Nötsch', 'Saak'],
  },
  {
    postleitzahl: 9612,
    orte: [
      'Bach',
      'Dellach',
      'Glabatschach',
      'Kerschdorf',
      'Kreublach',
      'Kühweg',
      'Labientschach',
      'Poglantschach',
      'Semering',
      'St. Georgen im Gailtal',
      'Wertschach',
    ],
  },
  {
    postleitzahl: 9613,
    orte: [
      'Achomitz / Zahomec',
      'Draschitz',
      'Dreulach',
      'Feistritz an der Gail',
      'Göriach',
    ],
  },
  {
    postleitzahl: 9614,
    orte: ['Bodenhof', 'Vorderberg'],
  },
  {
    postleitzahl: 9615,
    orte: [
      'Förolach',
      'Görtschach',
      'Presseggen',
      'Schinzengraben',
      'Siebenbrünn',
      'Wittenig',
      'Zuchen',
    ],
  },
  {
    postleitzahl: 9620,
    orte: [
      'Aigen',
      'Bergl',
      'Braunitzen',
      'Brunn',
      'Burgstall',
      'Eggforst',
      'Grünburg',
      'Guggenberg',
      'Hermagor',
      'Jadersdorf',
      'Kameritsch',
      'Khünburg',
      'Kraschach',
      'Kraß',
      'Kreuth ob Möschach',
      'Kühweg',
      'Kühwegboden',
      'Lassendorf',
      'Liesch',
      'Mitschig',
      'Möderndorf',
      'Neudorf',
      'Neuprießenegg',
      'Obermöschach',
      'Obervellach',
      'Podlanig',
      'Postran',
      'Potschach / Potoče',
      'Presseggen',
      'Presseggersee',
      'Radnig',
      'Radnigforst',
      'Sonnenalpe Nassfeld',
      'Sonnleitn',
      'St. Lorenzen im Gitschtal',
      'Tröpolach',
      'Untermöschach',
      'Untervellach',
      'Watschig',
      'Wulzentratten',
    ],
  },
  {
    postleitzahl: 9622,
    orte: ['Golz', 'Langwiesen', 'Leditz', 'Regitt', 'Weißbriach'],
  },
  {
    postleitzahl: 9623,
    orte: [
      'Bach',
      'Bichlhof',
      'Dragantschach',
      'Edling',
      'Hadersdorf',
      'Karnitzen',
      'Kerschdorf',
      'Köstendorf',
      'Latschach',
      'Matschiedl',
      'Nieselach',
      'Pölland',
      'Pörtschach',
      'Schinzengraben',
      'Schmölzing',
      'St. Paul an der Gail',
      'St. Stefan an der Gail',
      'Sussawitsch',
      'Tratten',
    ],
  },
  {
    postleitzahl: 9624,
    orte: [
      'Brugg',
      'Dellach / Dole',
      'Egg',
      'Fritzendorf',
      'Götzing',
      'Grafenau',
      'Kreuth ob Mellweg',
      'Latschach',
      'Mellach',
      'Mellweg',
      'Micheldorf',
      'Nampolach',
      'Paßriach',
      'Potschach / Potoče',
      'Süßenberg',
      'Toschehof',
    ],
  },
  {
    postleitzahl: 9631,
    orte: [
      'Achleiten',
      'Anraun',
      'Danz',
      'Jenig',
      'Kleinbergl',
      'Kreuth ob Rattendorf',
      'Rattendorf',
      'Schimanberg',
      'Schlanitzen',
      'Schmidt',
      'Tramun',
      'Tröpolach',
      'Waidegg',
    ],
  },
  {
    postleitzahl: 9632,
    orte: [
      'Hochwart',
      'Kirchbach',
      'Krieben',
      'Oberdöbernitzen',
      'Schimanberg',
      'Staudachberg',
      'Stöfflerberg',
      'Treßdorf',
      'Unterdöbernitzen',
      'Wassertheurerberg',
    ],
  },
  {
    postleitzahl: 9633,
    orte: [
      'Forst',
      'Oberdöbernitzen',
      'Reisach',
      'Reißkofelbad',
      'Rinsenegg',
      'Schönboden',
      'Stranig',
      'Unterbuchach',
    ],
  },
  {
    postleitzahl: 9634,
    orte: [
      'Bodenmühl',
      'Goderschach',
      'Grafendorf',
      'Griminitzen',
      'Gundersheim',
      'Katlingberg',
      'Lenzhof',
      'Oberbuchach',
      'Rauth',
      'Schmalzgrube',
      'Welzberg',
    ],
  },
  {
    postleitzahl: 9635,
    orte: [
      'Dellach',
      'Goldberg',
      'Gratzhof',
      'Gurina',
      'Kronhof',
      'Leifling',
      'Monsell',
      'Nölbling',
      'Rüben',
      'Siegelberg',
      'St. Daniel',
      'Stollwitz',
      'Weidenburg',
      'Wieserberg',
    ],
  },
  {
    postleitzahl: 9640,
    orte: [
      'Buchach',
      'Dobra',
      'Dolling',
      'Gailberg',
      'Gentschach',
      'Höfling',
      'Kosta',
      'Kötschach',
      'Kreuth',
      'Kreuzberg',
      'Krieghof',
      'Laas',
      'Lanz',
      'Mahlbach',
      'Mandorf',
      'Mauthen',
      'Nischlwitz',
      'Passau',
      'Plöcken',
      'Plon',
      'Sittmoos',
      'Wetzmann',
      'Würmlach',
    ],
  },
  {
    postleitzahl: 9651,
    orte: ['Aigen', 'St. Jakob im Lesachtal', 'Strajach', 'Würda'],
  },
  {
    postleitzahl: 9652,
    orte: [
      'Birnbaum',
      'Egg',
      'Kornat',
      'Mattling',
      'Nostra',
      'Podlanig',
      'Wodmaier',
    ],
  },
  {
    postleitzahl: 9653,
    orte: [
      'Assing',
      'Durnthal',
      'Klebas',
      'Ladstatt',
      'Liesing',
      'Niedergail',
      'Obergail',
      'Oberring',
      'Pallas',
      'Rüben',
      'Stabenthein',
      'Tscheltsch',
    ],
  },
  {
    postleitzahl: 9654,
    orte: [
      'Frohn',
      'St. Lorenzen im Lesachtal',
      'Tuffbad',
      'Wiesen',
      'Xaveriberg',
    ],
  },
  {
    postleitzahl: 9655,
    orte: [
      'Guggenberg',
      'Maria Luggau',
      'Moos',
      'Promeggen',
      'Raut',
      'Salach',
      'Sterzen',
      'Tiefenbach',
    ],
  },
  {
    postleitzahl: 9701,
    orte: [
      'Aichforst',
      'Beinten',
      'Brodbrenten',
      'Burgbichl',
      'Großegg',
      'Kamering',
      'Kleinegg',
      'Mauthbrücken',
      'Molzbichl',
      'Neuolsach',
      'Nußdorf',
      'Oberzmöln',
      'Olsach',
      'Rothenthurn',
      'Schwarzenbach',
      'Unterzmöln',
      'Winkl',
    ],
  },
  {
    postleitzahl: 9702,
    orte: [
      'Beinten',
      'Ferndorf',
      'Glanz',
      'Gschriet',
      'Insberg',
      'Laas',
      'Lang',
      'Nußdorf',
      'Politzen',
      'Rudersdorf',
      'Sonnwiesen',
      'St. Jakob',
      'St. Paul',
    ],
  },
  {
    postleitzahl: 9710,
    orte: [
      'Duel',
      'Ebenwald',
      'Feffernitz',
      'Feistritz an der Drau-Neusiedlung',
      'Feistritz an der Drau',
      'Mühlboden',
      'Neu-Feffernitz',
      'Nikelsdorf',
      'Pobersach',
      'Pogöriach',
      'Pöllan',
      'Rubland',
      'Stuben',
    ],
  },
  {
    postleitzahl: 9711,
    orte: [
      'Aichach',
      'Aifersdorf',
      'Kamering',
      'Kreuzen',
      'Liesing',
      'Nikelsdorf',
      'Patendorf',
      'Paternion',
      'Pölland',
      'Rosental',
      'Scharnitzen',
      'Tragail',
      'Tragin',
    ],
  },
  {
    postleitzahl: 9712,
    orte: [
      'Amberg',
      'Fresach',
      'Laas',
      'Mitterberg',
      'Mooswald',
      'Tragenwinkel',
    ],
  },
  {
    postleitzahl: 9713,
    orte: [
      'Alberden',
      'Drußnitz',
      'Hammergraben',
      'Hochegg',
      'Hollernach',
      'Ried',
      'Tragail',
      'Wiederschwing',
      'Ziebl',
      'Zlan',
    ],
  },
  {
    postleitzahl: 9714,
    orte: [
      'Boden',
      'Gassen',
      'Hochegg',
      'Kreuzen',
      'Mösel',
      'Rosental',
      'Seetal am Goldeck',
      'Stockenboi',
      'Unteralm',
      'Weißenbach',
      'Wiederschwing',
    ],
  },
  {
    postleitzahl: 9721,
    orte: ['Kellerberg', 'Lansach', 'Tscheuritsch', 'Uggowitz', 'Weißenstein'],
  },
  {
    postleitzahl: 9722,
    orte: ['Gummern', 'Lauen', 'Puch', 'Stadelbach', 'Töplitsch', 'Weißenbach'],
  },
  {
    postleitzahl: 9751,
    orte: [
      'Feistritz',
      'Lanzewitzen',
      'Nigglai',
      'Obergottesfeld',
      'Sachsenburg',
    ],
  },
  {
    postleitzahl: 9753,
    orte: [
      'Althaus',
      'Bärnbad',
      'Blaßnig',
      'Fellbach',
      'Fellberg',
      'Kleblach',
      'Lengholz',
      'Leßnig',
      'Lind im Drautal',
      'Oberallach',
      'Pirkeben',
      'Radlberg',
      'Raggnitz',
      'Siflitz',
    ],
  },
  {
    postleitzahl: 9754,
    orte: [
      'Flattachberg',
      'Gajach',
      'Gerlamoos',
      'Mitterberg',
      'Radlach',
      'Rottenstein',
      'Steinfeld',
    ],
  },
  {
    postleitzahl: 9761,
    orte: [
      'Amberg',
      'Amlach',
      'Bruggen',
      'Eben',
      'Egg',
      'Emberg',
      'Emberger Alm',
      'Gnoppnitz',
      'Greifenburg',
      'Gries',
      'Hauzendorf',
      'Kalch',
      'Kerschbaum',
      'Kreuzberg',
      'Pobersach',
      'Rasdorf',
      'Tröbelsberg',
      'Waisach',
      'Wassertheuer',
      'Weneberg',
    ],
  },
  {
    postleitzahl: 9762,
    orte: [
      'Gatschach',
      'Kreuzberg',
      'Naggl',
      'Neusach',
      'Oberdorf',
      'Techendorf',
      'Tröbelsberg',
    ],
  },
  {
    postleitzahl: 9771,
    orte: [
      'Berg',
      'Ebenberg',
      'Emberg',
      'Emberger Alm',
      'Feistritz',
      'Frallach',
      'Goppelsberg',
      'Oberberg',
      'Schlußnig',
    ],
  },
  {
    postleitzahl: 9772,
    orte: [
      'Dellach',
      'Draßnitz',
      'Draßnitzdorf',
      'Glatschach',
      'Grientschnig',
      'Nörenach',
      'Raßnig',
      'Rietschach',
      'Schmelz',
      'Stein',
      'Suppersberg',
      'Weinberg',
    ],
  },
  {
    postleitzahl: 9773,
    orte: [
      'Glanz',
      'Griebitsch',
      'Gröfelhof',
      'Hintergassen',
      'Irschen',
      'Leppen',
      'Mötschlach',
      'Pflügen',
      'Pölland',
      'Potschling',
      'Rittersdorf',
      'Schörstadt',
      'Stresweg',
      'Weneberg',
    ],
  },
  {
    postleitzahl: 9781,
    orte: [
      'Flaschberg',
      'Gailberg',
      'Oberdrauburg',
      'Oberpirkach',
      'Ötting',
      'Rosenberg',
      'Schrottenberg',
      'Simmerlach',
      'Unterpirkach',
      'Waidach',
      'Zwickenberg',
    ],
  },
  {
    postleitzahl: 9782,
    orte: [
      'Damer',
      'Lengberg',
      'Lindsberg',
      'Michelsberg',
      'Nikolsdorf',
      'Nörsach',
      'Plone',
    ],
  },
  {
    postleitzahl: 9800,
    orte: [
      'Aich',
      'Baldersdorf',
      'Edling',
      'Gendorf',
      'Kleinsaß',
      'Krieselsdorf',
      'Lurnbichl',
      'Molzbichl',
      'Oberamlach',
      'Oberdorf',
      'Schüttbach',
      'Spittal an der Drau',
      'St. Peter',
      'St. Sigmund',
      'St. Wolfgang',
      'Tangern',
      'Unteramlach',
      'Windschnurn',
      'Zgurn',
    ],
  },
  {
    postleitzahl: 9805,
    orte: [
      'Baldramsdorf',
      'Faschendorf',
      'Gendorf',
      'Goldeck',
      'Lampersberg',
      'Oberaich',
      'Rosenheim',
      'Schwaig',
      'Unterhaus',
    ],
  },
  {
    postleitzahl: 9811,
    orte: [
      'Feicht',
      'Feichtendorf',
      'Freßnitz',
      'Hühnersberg',
      'Lendorf',
      'Litzlhof',
      'Rojach',
      'St. Peter in Holz',
      'Tröbach',
    ],
  },
  {
    postleitzahl: 9812,
    orte: [
      'Göriach',
      'Pusarnitz',
      'St. Gertraud',
      'Steindorf',
      'Stöcklern',
      'Tröbach',
    ],
  },
  {
    postleitzahl: 9813,
    orte: [
      'Altenmarkt',
      'Drauhofen',
      'Metnitz',
      'Möllbrücke',
      'Pattendorf',
      'Premersdorf',
      'Sachsenburg',
      'St. Gertraud',
      'St. Stefan',
    ],
  },
  {
    postleitzahl: 9814,
    orte: ['Mühldorf', 'Pattendorf', 'Rappersdorf', 'Sachsenweg'],
  },
  {
    postleitzahl: 9815,
    orte: [
      'Hattelberg',
      'Mitterberg',
      'Oberkolbnitz',
      'Penk',
      'Polan',
      'Preisdorf',
      'Rottau',
      'Sandbichl',
      'Tratten',
      'Unterkolbnitz',
      'Zandlach',
    ],
  },
  {
    postleitzahl: 9816,
    orte: [
      'Gappen',
      'Litzldorf',
      'Moos',
      'Napplach',
      'Oberkolbnitz',
      'Penk',
      'Teuchl',
      'Unterkolbnitz',
      'Zwenberg',
    ],
  },
  {
    postleitzahl: 9821,
    orte: [
      'Dürnvellach',
      'Kaponig',
      'Lassach Schattseite',
      'Lassach Sonnseite',
      'Leutschach',
      'Obergratschach',
      'Obervellach-West',
      'Obervellach',
      'Oberwolliggen',
      'Pfaffenberg',
      'Raufen',
      'Räuflach',
      'Semslach',
      'Söbriach',
      'Stallhofen',
      'Stampf',
      'Untergratschach',
      'Untervocken',
      'Unterwolliggen',
    ],
  },
  {
    postleitzahl: 9822,
    orte: ['Dösen', 'Mallnitz', 'Rabisch', 'Stappitz'],
  },
  {
    postleitzahl: 9831,
    orte: [
      'Außerfragant',
      'Flattach',
      'Flattachberg',
      'Grafenberg',
      'Innerfragant',
      'Kleindorf',
      'Laas',
      'Schmelzhütten',
      'Waben',
    ],
  },
  {
    postleitzahl: 9832,
    orte: [
      'Berg ob Stall',
      'Gößnitz',
      'Gußnigberg',
      'Latzendorf',
      'Obersteinwand',
      'Pußtratten',
      'Rakowitzen',
      'Sagas',
      'Schwersberg',
      'Sonnberg',
      'Stadlberg',
      'Stall',
      'Stieflberg',
      'Untersteinwand',
      'Wöllatratten',
    ],
  },
  {
    postleitzahl: 9833,
    orte: [
      'Lainach',
      'Lamnitz',
      'Lobersberg',
      'Plappergassen',
      'Rangersdorf',
      'Stein',
      'Tresdorf',
      'Wenneberg',
      'Witschdorf',
      'Zladisch',
    ],
  },
  {
    postleitzahl: 9841,
    orte: [
      'Auen',
      'Langang',
      'Lobersberg',
      'Namlach',
      'Penzelberg',
      'Reintal',
      'Winklern',
      'Zwischenbergen',
    ],
  },
  {
    postleitzahl: 9842,
    orte: [
      'Asten',
      'Auen',
      'Lassach',
      'Mörtschach',
      'Mörtschachberg',
      'Pirkachberg',
      'Rettenbach',
      'Stampfen',
      'Stranach',
    ],
  },
  {
    postleitzahl: 9843,
    orte: [
      'Allas',
      'Am Putzenhof',
      'Döllach',
      'Egg',
      'Göritz',
      'Kraß',
      'Mitteldorf',
      'Mitten',
      'Putschall',
      'Ranach',
      'Sagritz',
      'Untersagritz',
      'Winklsagritz',
      'Zirknitz',
    ],
  },
  {
    postleitzahl: 9844,
    orte: [
      'Aichhorn',
      'Apriach',
      'Fleiß',
      'Hadergasse',
      'Hof',
      'Pockhorn',
      'Rojach',
      'Schachnern',
      'Untertauern',
      'Winkl',
      'Wolkersdorf',
    ],
  },
  {
    postleitzahl: 9851,
    orte: [
      'Karlsdorf',
      'Kras',
      'Lieserbrücke',
      'Lieseregg',
      'Lieserhofen',
      'Litzldorf',
      'Lurnbichl',
      'Raufen',
      'Seebach',
    ],
  },
  {
    postleitzahl: 9852,
    orte: [
      'Aich',
      'Altersberg',
      'Hintereggen',
      'Neuschitz',
      'Oberallach',
      'Pirk',
      'Rachenbach',
      'Radl',
      'Trebesing-Bad',
      'Trebesing',
      'Zelsach',
      'Zlatting',
    ],
  },
  {
    postleitzahl: 9853,
    orte: [
      'Brochendorf',
      'Burgwiese',
      'Dornbach',
      'Fischertratten',
      'Gmünd',
      'Großhattenberg',
      'Grünleiten',
      'Karnerau',
      'Kleinhattenberg',
      'Landfraß',
      'Malta',
      'Moos',
      'Moostratte',
      'Oberbuch',
      'Oberkreuschlach',
      'Perau',
      'Platz',
      'Saps',
      'Stubeck Sonnalm',
      'Treffenboden',
      'Unterbuch',
      'Unterkreuschlach',
    ],
  },
  {
    postleitzahl: 9854,
    orte: [
      'Brandstatt',
      'Feistritz',
      'Göß',
      'Gries',
      'Hilpersdorf',
      'Koschach',
      'Krainberg',
      'Malta',
      'Maltaberg',
      'Schlatzing',
      'Schlatzingerau',
    ],
  },
  {
    postleitzahl: 9861,
    orte: [
      'Densdorf',
      'Eisentratten',
      'Gamschitz',
      'Hammerboden',
      'Heitzelsberg',
      'Innernöring',
      'Laggen',
      'Leoben',
      'Leobengraben',
      'Lientsch',
      'Pirkeggen',
      'Pressingberg',
      'Puchreit',
      'Sonnberg',
      'Vordernöring',
    ],
  },
  {
    postleitzahl: 9862,
    orte: [
      'Heitzelsberg',
      'Illwitzen',
      'Innerkrems',
      'Kremsbrücke',
      'Leobengraben',
      'Neuhammer',
      'Oberburgstallberg',
      'Oberkremsberg',
      'Pleschberg',
      'Pleßnitz',
      'Purbach',
      'Rauchenkatsch',
      'Reitern',
      'St. Nikolai',
      'Steinwand',
      'Unterburgstallberg',
      'Unterkremsberg',
      'Unterkremsbrücke',
      'Vorderkrems',
      'Wetschenbach',
      'Winkl',
    ],
  },
  {
    postleitzahl: 9863,
    orte: [
      'Abwerzg',
      'Adenberg',
      'Angern',
      'Aschbach',
      'Atzensberg',
      'Brugg',
      'Frankenberg',
      'Gries',
      'Katschberghöhe',
      'Krangl',
      'Laußnitz',
      'Mühlbach',
      'Oberdorf',
      'Pleschberg',
      'Pölla',
      'Pron',
      'Rennweg',
      'Ried',
      'Saraberg',
      'Schlaipf',
      'St. Georgen',
      'St. Peter',
      'Steinwand',
      'Wirnsberg',
      'Zanaischg',
    ],
  },
  {
    postleitzahl: 9871,
    orte: [
      'Am Tschiernock',
      'Kolm',
      'Kötzing',
      'Kras',
      'Liedweg',
      'Muskanitzen',
      'Pirk',
      'Schloßau',
      'Seebach',
      'Seeboden am Millstätter See',
      'Tangern',
      'Trasischk',
      'Treffling',
      'Unterhaus',
    ],
  },
  {
    postleitzahl: 9872,
    orte: [
      'Dellach am Millstätter See',
      'Görtschach',
      'Gössering',
      'Grantsch',
      'Großdombra',
      'Hohengaß',
      'Kleindombra',
      'Lammersdorf',
      'Laubendorf',
      'Lechnerschaft',
      'Matzelsdorf',
      'Millstatt am See',
      'Obermillstatt',
      'Öttern',
      'Pesenthein am Millstätter See',
      'Sappl',
      'Schwaigerschaft',
      'Starfach',
      'Tangern',
      'Tschierweg',
    ],
  },
  {
    postleitzahl: 9873,
    orte: ['Döbriach am Millstätter See', 'Döbriach', 'Starfach'],
  },
  {
    postleitzahl: 9900,
    orte: ['Lienz', 'Patriasdorf'],
  },
  {
    postleitzahl: 9903,
    orte: ['Glanz', 'Oberdrum', 'Oberlienz'],
  },
  {
    postleitzahl: 9904,
    orte: ['Oberdorf', 'Prappernitze', 'Thurn', 'Zauche', 'Zettersfeld'],
  },
  {
    postleitzahl: 9905,
    orte: ['Obergaimberg', 'Untergaimberg'],
  },
  {
    postleitzahl: 9906,
    orte: ['Lavant'],
  },
  {
    postleitzahl: 9907,
    orte: ['Tristach'],
  },
  {
    postleitzahl: 9908,
    orte: ['Amlach'],
  },
  {
    postleitzahl: 9909,
    orte: ['Burgfrieden', 'Leisach-Gries', 'Leisach'],
  },
  {
    postleitzahl: 9911,
    orte: [
      'Bannberg',
      'Bichl',
      'Burg',
      'Dörfl',
      'Herol',
      'Klausen',
      'Kosten',
      'Mittewald',
      'Oberassling',
      'Oberthal',
      'Penzendorf',
      'Schrottendorf',
      'St. Justina',
      'Thal-Aue',
      'Thal-Römerweg',
      'Thal-Wilfern',
      'Unterassling',
      'Vergein',
    ],
  },
  {
    postleitzahl: 9912,
    orte: [
      'Anras',
      'Asch',
      'Erlbrücke',
      'Gebreite',
      'Goll',
      'Kobreil',
      'Köden',
      'Kollreid',
      'Kolls',
      'Lehen',
      'Mairwiesen',
      'Margarethenbrücke',
      'Mittewald',
      'Oberried',
      'Planitzen',
      'Rain',
      'Raut',
      'Unterried',
      'Wiesen',
      'Winkl',
    ],
  },
  {
    postleitzahl: 9913,
    orte: ['Abfaltersbach'],
  },
  {
    postleitzahl: 9918,
    orte: ['Strassen'],
  },
  {
    postleitzahl: 9919,
    orte: ['Panzendorf', 'Tessenberg'],
  },
  {
    postleitzahl: 9920,
    orte: ['Arnbach', 'Sillian', 'Sillianberg'],
  },
  {
    postleitzahl: 9931,
    orte: ['Außervillgraten'],
  },
  {
    postleitzahl: 9932,
    orte: ['Innervillgraten'],
  },
  {
    postleitzahl: 9941,
    orte: ['Hollbruck', 'Kartitsch'],
  },
  {
    postleitzahl: 9942,
    orte: ['Bergen', 'Leiten', 'Obertilliach', 'Rodarm'],
  },
  {
    postleitzahl: 9943,
    orte: ['Untertilliach'],
  },
  {
    postleitzahl: 9951,
    orte: ['Ainet', 'Alkus', 'Gwabl'],
  },
  {
    postleitzahl: 9952,
    orte: ['St. Johann im Walde'],
  },
  {
    postleitzahl: 9954,
    orte: ['Schlaiten'],
  },
  {
    postleitzahl: 9961,
    orte: [
      'Dölach',
      'Hof',
      'Hopfgarten in Defereggen',
      'Lerch',
      'Plon',
      'Rajach',
      'Ratzell',
    ],
  },
  {
    postleitzahl: 9962,
    orte: ['Bruggen', 'Gassen', 'Görtschach', 'Gritzen', 'Gsaritzen', 'Moos'],
  },
  {
    postleitzahl: 9963,
    orte: ['Außerrotte', 'Feistritz', 'Innerrotte', 'Oberrotte', 'Unterrotte'],
  },
  {
    postleitzahl: 9971,
    orte: [
      'Berg',
      'Bichl',
      'Feld',
      'Ganz',
      'Glanz',
      'Gruben',
      'Hinterburg',
      'Hinteregg',
      'Huben',
      'Kaltenhaus',
      'Kienburg',
      'Klaunz',
      'Klausen',
      'Matrei in Osttirol',
      'Mattersberg',
      'Moos',
      'Proßegg',
      'Raneburg',
      'Seblas',
      'Tauer',
      'Waier',
      'Zedlach',
    ],
  },
  {
    postleitzahl: 9972,
    orte: [
      'Göriach',
      'Mellitz',
      'Mitteldorf',
      'Niedermauern',
      'Obermauern',
      'Virgen',
      'Welzelach',
    ],
  },
  {
    postleitzahl: 9974,
    orte: ['Bichl', 'Bobojach', 'Hinterbichl', 'St. Andrä', 'Wallhorn'],
  },
  {
    postleitzahl: 9981,
    orte: [
      'Arnig',
      'Burg',
      'Glor-Berg',
      'Großdorf',
      'Ködnitz',
      'Lana',
      'Lesach',
      'Oberpeischlach',
      'Staniska',
      'Unterburg',
      'Unterpeischlach',
    ],
  },
  {
    postleitzahl: 9990,
    orte: ['Debant', 'Debanttal', 'Nußdorf', 'Nußdorfer Berg'],
  },
  {
    postleitzahl: 9991,
    orte: ['Dölsach', 'Gödnach', 'Göriach', 'Görtschach', 'Stribach'],
  },
  {
    postleitzahl: 9992,
    orte: ['Iselsberg', 'Stronach'],
  },
];
